export default {
    scan: {
        title: 'Read the document',
        hint: 'Photograph the page with the two lines of characters at the bottom — the details go to the desk.',
        sending: 'Sending the picture …',
        taken: 'Photographs: {count}',
        read_count: 'Read: {count}',
        checks: '{passed} of {total} check digits proved.',
        again: 'Read — take one more',
        again_hint: 'The zone was read but has not proved itself. One more picture of the same side and the server will put the two together.',
        take_another: 'Take another photograph',
        live_hint: 'Hold the card inside the frame. One press takes three frames.',
        take_photo: 'Photograph the document',
        take_photo_hint: 'The camera opens. Keep the lines at the bottom whole and in focus.',
        reading: 'Reading …',
        done: 'Read',
        done_hint: 'The details are on the desk\'s screen. You may close this.',
        failed: 'The lines could not be read',
        failed_hint: 'Usually a thumb over them, a reflection, or too far away. Try again.',
        expired: 'This link is no longer valid',
        expired_hint: 'A code is good for ten minutes. Ask the desk for a new one.',
        privacy: 'The picture is used to read the document. It is kept only if the hotel has said so, and is deleted automatically.',
    },
    attention: {
        title: 'Notes for this stay',
        hint: 'What the housekeeper has to know before she opens the door: a cot, an hour, a product the room may not be cleaned with. It shows on her phone above the room.',
        guest_title: 'Standing notes for this guest',
        guest_hint: 'True of this guest on every stay — an allergy, a pillow they always ask for. Use the reservation for what is only true tonight.',
        add: 'Add',
        value: 'Detail',
        note: 'Note',
        vip: 'VIP',
        cot: 'Cot',
        extra_bed: 'Extra bed',
        pet: 'Pet',
        allergy: 'Allergy',
        products: 'Special products',
        extra_towels: 'Extra towels',
        extra_pillows: 'Extra pillows',
        clean_at: 'Clean at',
        do_not_enter_before: 'Do not enter before',
        language: 'Guest language',
        late_checkout: 'Late checkout',
        extension_request: 'Extension request',
        early_checkin: 'Early check-in',
        preferred_room: 'Preferred room',
        // The hint beside a room choice. Free/taken is for the dates in the form.
        wants_room: 'The guest wants room {room} ({state})',
        wants_room_free: 'free',
        wants_room_taken: 'taken for these dates',
        wants_room_unknown: 'availability not known yet',
        wants_room_assign: 'Assign that room',
        wants_room_here: 'Room {room} - this one',
        wants_room_elsewhere: 'Room {room} - the guest is in {actual}',
    },
    checklist: {
        tab: 'Checklists',
        title: 'Cleaning checklists',
        hint: 'What has to be true before a room is finished. The lists add up: the hotel standard, then the room type, then the kind of work.',
        add: 'New list',
        edit: 'Edit list',
        empty: 'This hotel has no checklists yet. Without them a room is finished as it always was.',
        name: 'List name',
        name_hint: 'Only management sees it — a housekeeper sees the steps of every list that applies as one list, because a room is cleaned once.',
        room_type: 'Room type',
        room_type_hint: 'Empty means every room in the hotel.',
        kind: 'Kind of work',
        kind_hint: 'Empty means every kind of work.',
        whole_house: 'Whole hotel',
        every_kind: 'Every kind',
        kind_departure: 'After a departure',
        kind_stayover: 'During a stay',
        kind_arrival: 'Before an arrival',
        kind_dirty: 'Room to prepare',
        steps: '{count} steps',
        steps_label: 'Steps',
        steps_hint: 'In the order a housekeeper walks the room. The asterisk marks a required step — a room cannot be finished until it is answered.',
        add_step: 'Add a step',
        required: 'Required',
        required_hint: 'A required step: the room cannot be finished until it is answered.',
        retire: 'Retire',
        restore: 'Put back',
        retired: 'Retired',
    },
    area: {
        tab: 'Cleaning',
        title: 'Common areas',
        hint: 'Corridors, the wellness, lifts, stairs — the work that is not a room. It writes itself into the daily sheet on the schedule you set.',
        add: 'New area',
        edit: 'Edit area',
        empty: 'This hotel has no common areas yet.',
        name: 'Area name',
        floor: 'Floor',
        floor_hint: 'So it sits with the rooms of that floor and the round is walked in one pass.',
        floor_n: 'floor {floor}',
        minutes: 'Norm (min)',
        minutes_hint: 'How long it is expected to take. Empty means no norm.',
        every: 'How often',
        every_day: 'Every day',
        every_week: 'Weekly',
        every_month: 'Monthly',
        every_month_on: 'Monthly, on the {day}th',
        weekdays: 'Days',
        day_of_month: 'Day of the month',
        day_of_month_hint: '1 to 28. Anything higher would silently skip five months a year.',
        steps: 'Steps',
        steps_hint: "This area's own list — the room checklists do not apply to it.",
        weekday_0: 'Sun',
        weekday_1: 'Mon',
        weekday_2: 'Tue',
        weekday_3: 'Wed',
        weekday_4: 'Thu',
        weekday_5: 'Fri',
        weekday_6: 'Sat',
    },
    dining: {
        title: 'Meals and entries',
        hint: 'Who may eat, who has come down, and how many people. Set it up in Settings (the gear) → Operations settings → Meals and entries.',
        no_property: 'Choose a property first.',
        not_set_up: 'No sittings configured yet',
        not_set_up_hint: 'Add a dining room and a sitting with its hours in Settings (the gear) → Operations settings → Meals and entries.',
        header: '{meal} · {restaurant} · {from}–{to}',
        expected: 'Expected',
        persons_rooms: 'people · {rooms} rooms',
        served: 'Served',
        not_arrived: 'Still to come',
        until: 'until {time}',
        extra_meals: 'Extra meals',
        extra_split: '{amount} · {folio} on the folio, {cash} at the till',
        decisions: 'Free / refused',
        decisions_hint: 'manual decisions, with reasons',
        device_offline: '{name} · offline {minutes} min',
        list: 'Operational list',
        empty: 'Nobody is expected at this sitting today.',
        occupancy: '{adults} ad. + {children} ch.',
        plus_extra: '+{count} bought',
        open_reservation: 'Open the reservation',
        arrivals: 'Arrivals, quarter by quarter',
        arrivals_hint: 'When people actually came.',
        arrivals_empty: 'Nobody has come through yet today.',
        arrivals_bar: '{time} · {persons} people',
        forecast: 'Meals ahead',
        forecast_hint: 'Counts PEOPLE from the reservations and their boards, not rooms.',
        forecast_empty: 'No reservations with a board in the days ahead.',
        filter_all: 'All · {count}',
        filter_expected: 'Still expected · {count}',
        filter_partial: 'Partly · {count}',
        filter_served: 'Served · {count}',
        filter_extra: 'Extra meal · {count}',
        state_expected: 'expected',
        state_partial: 'partly',
        state_served: 'served',
        state_extra: 'extra meal',
        kind_breakfast: 'Breakfast',
        kind_lunch: 'Lunch',
        kind_dinner: 'Dinner',
        restaurants: 'Dining rooms',
        restaurants_hint: 'Where the hotel serves. A sitting belongs to a room, and a tablet stands at its door.',
        restaurants_empty: 'No dining room yet.',
        restaurant: 'Dining room',
        restaurant_add: 'Add a dining room',
        restaurant_edit: 'Edit the dining room',
        restaurant_name: 'Name',
        greeting: 'Greeting on the tablet',
        greeting_hint: 'The line under the hotel logotype. Empty shows the name of the room.',
        greeting_house_hint: 'Used everywhere except where a room has one of its own.',
        greeting_sl: 'Dobro jutro!',
        greeting_en: 'Good morning!',
        greeting_en_label: 'Greeting (English)',
        no_greeting: 'no greeting',
        closed: 'closed',
        close: 'Close the room',
        reopen: 'Reopen the room',
        close_refused: 'A dining room with sittings on it cannot be closed. Retire the sittings first.',
        meals: 'Sittings',
        meals_hint: 'What is served, when, and what an extra helping costs somebody whose board does not include it.',
        meals_empty: 'No sitting yet.',
        meals_no_room: 'Add a dining room first.',
        meal_needs_room: 'Add a dining room first — a sitting is served in one.',
        go_to_rooms: 'Go to dining rooms',
        device_needs_room: 'Add a dining room first — a tablet is bound to one.',
        device_needs_open_room: 'Every dining room is closed — a tablet is bound to an open one.',
        meal_add: 'Add a sitting',
        meal_edit: 'Edit the sitting',
        meal_name: 'Name',
        meal_name_sl: 'Zajtrk',
        meal_name_en_label: 'Name (English)',
        kind: 'Meal of the day',
        kind_fixed: 'The meal of the day cannot be changed — it decides who was entitled. Write a new sitting instead.',
        from: 'From',
        to: 'To',
        tolerance: 'Tolerance (min)',
        tolerance_hint: 'How far either side of the hours the tablet still treats an arrival as ordinary.',
        tolerance_short: '±{minutes} min',
        boards: 'Boards that include this meal',
        boards_hint: 'Filled in from the hotel rule. Editing it can make this screen and the reservation chart disagree.',
        boards_none: 'no board',
        extra_price: 'Price of an extra meal (€)',
        extra_price_hint: 'Gross, per person. Zero means the hotel does not sell this meal separately.',
        extra_tax_rate: 'VAT rate',
        no_extra_price: 'not for sale',
        retired: 'retired',
        retire: 'Retire the sitting',
        restore: 'Bring the sitting back',
        access: 'Entry and extra meals',
        access_hint: 'What the tablet at the door may offer, and what sits behind a PIN.',
        allow_folio: 'Extra meal on the room',
        allow_folio_hint: 'The line goes onto the guest folio through the ordinary charge path.',
        allow_cash: 'Send to the till',
        allow_cash_hint: 'The guest is sent to the desk to pay. The amount stays on the desk’s list until a fiscalised receipt closes it — a dining door issues no document.',
        attention_title: 'Needs attention',
        entries: 'Entries',
        entries_empty: 'Nothing recorded for this room at this sitting.',
        entry_persons: '{count} people',
        entry_storno: 'Correct',
        entry_storno_prompt: 'What was wrong with this entry?',
        entry_stornoed: 'Corrected.',
        entry_cancelled: 'corrected away',
        entry_is_storno: 'correction',
        attention_hint: 'What the door could not settle by itself. Cash stays here until a fiscalised receipt closes it.',
        attention_served: '{persons} served on a board covering {entitled}',
        attention_invoice: 'Invoice identifier',
        attention_settle: 'Close against receipt',
        attention_resolve: 'Settle',
        attention_resolve_prompt: 'What was done about it?',
        attention_settled: 'Settled.',
        offline: 'offline',
        attention_kind: { overrun: 'Board overserved', offline_conflict: 'Offline conflict', unconfirmed_cash: 'Cash not yet reported' },
        allow_free: 'Free approval',
        allow_free_hint: 'A meal the hotel gives away. Needs dining:override and a written reason.',
        pin_required: 'Dietary details behind a PIN',
        pin_required_hint: 'The warning is always shown; only what exactly is wrong is hidden.',
        pin_missing: 'No PIN is set yet',
        pin_missing_hint: 'Until a PIN exists this cannot be switched on — the hotel would otherwise believe the details were hidden.',
        pin: 'PIN (4 digits)',
        pin_help: 'A hotel PIN, not a personal one. Nobody signs in to a tablet at a door.',
        pin_set: 'A PIN is set.',
        pin_not_set: 'No PIN is set.',
        pin_set_action: 'Set a PIN',
        pin_change: 'Change the PIN',
        pin_clear: 'Remove the PIN',
        pin_clear_refused: 'The PIN cannot be removed while the protection is switched on.',
        pin_dialog: 'PIN for the dietary details',
        pin_dialog_hint: 'Only a hash of the PIN is stored and it cannot be read back.',
        devices: 'Tablets',
        devices_hint: 'The machines at the doors. Enrolled with a code, revoked in one press.',
        devices_empty: 'No tablet yet.',
        device_add: 'Add a tablet',
        device_rename: 'Edit the tablet',
    },
    // What is the same about every enrolled device is said once: the same list draws
    // the tablets at the doors and the housekeepers' telephones, so these are neutral.
    staff_device: {
        name:         'Device name',
        add_hint:     'The code is worth five minutes and one scan.',
        code_hint:    'Scan the code with the application on the device.',
        code_make:    'Show the code',
        code_expires: 'The code is valid until {at}.',
        seen:         'last seen {at}',
        active:       'active',
        revoked:      'revoked',
        revoke:       'Revoke',
        restore:      'Bring back',
        remove:            'Remove',
        show_removed:      'Show removed',
        remove_confirm:    'Remove the device "{name}"?',
        remove_explain:    'If nothing refers to the device it is deleted. If something does, it is hidden from the list instead — the entries naming it are left untouched.',
        removed_deleted:   'The device has been deleted.',
        removed_archived:  'The device is hidden from the list. The entries naming it are still there.',
    },
    lost: {
        title: 'Lost property',
        hint: 'What a guest leaves behind. The housekeeper records the find on her own portal; everything else happens here — the call, the handover, the postage.',
        search: 'Search by description, number or guest',
        empty: 'Nothing found.',
        photo: 'Photograph',
        guest: 'Guest that night: {name}',
        stored_in: 'stored: {place}',
        handed_to: 'handed to: {name}',
        handle: 'Handle',
        what_happened: 'What happened',
        handed_over_to: 'Handed over to',
        handed_over_to_placeholder: 'Name of the person or courier',
        storage: 'Where it is kept',
        note: 'Note',
        note_hint_contact: 'How the guest was reached — telephone, email, message.',
        note_hint_handover: 'How it was handed over — in person, by post, tracking number.',
        needs_name: 'Say who took it. Without a name the record means nothing.',
        status_all: 'All',
        status_reported: 'Reported by guest',
        status_stored: 'In storage',
        status_contacted: 'Guest told',
        status_returned: 'Returned',
        status_shipped: 'Posted',
        status_disposed: 'Disposed of',
        origin_guest: 'Reported by the guest through Milo',
    },
    materials: {
        tab: 'Materials',
        module_title: 'Imprion Materials — materials and procurement',
        module_description: 'The module covers the stock and the buying of hotel operations: articles with barcodes and packagings, store rooms and trolleys, movements with FIFO/FEFO valuation, receipts and issues, counts, suppliers and their invoices with a ten-year archive, and the retail till. The ledger of quantities stays in the core — a minibar posting and a linen move work without the module.',
    },
    /**
     * The supplier catalogue and the contracts behind it (docs/MATERIALNO-KATALOG.md,
     * WP-M3a). Its own namespace and not part of `materials` for the reason
     * `materials_accounting` is: `materials` describes the module as a product, this is
     * the BUYING side — what each supplier charges, under which code, and until when.
     */
    materials_catalogue: {
        title: 'Catalogue and contracts',
        no_property: 'Choose a property first.',
        lead_title: 'What each supplier charges, and until when',
        lead: 'A catalogue row is one PAIR of supplier and article: their code, their packaging, the minimum order, the lead time and a price with a validity. The same article at two suppliers is two rows with two prices. A contract is an agreement for a period; activating it writes its prices into the catalogue with the contract’s own validity.',

        catalogue: 'Catalogue',
        catalogue_hint: 'Prices by supplier. A price whose validity has run out is marked — it reaches an order only with a deliberate acceptance and a reason (code 106).',
        contracts: 'Contracts',
        contracts_hint: 'Agreed prices for a period. A draft is still editable; activation writes the prices into the catalogue and closes the contract to edits.',

        empty: 'No catalogue rows yet.',
        contracts_empty: 'No contracts yet.',
        add_entry: 'New catalogue row',
        edit_entry: 'Edit catalogue row',
        add_contract: 'New contract',
        edit_contract: 'Edit contract',
        view_contract: 'Contract',
        saved: 'Saved.',

        filter_all: 'All',
        filter_supplier: 'Supplier',
        filter_supplier_help: 'Empty means every supplier.',
        filter_item: 'Article',
        filter_status: 'Status',
        filter_status_help: 'The status is resolved for today: a contract whose validity has passed reads as expired, even though it is stored as active.',

        supplier: 'Supplier',
        supplier_hint: 'Who sells it. Together with the article this is the row’s KEY — one pair has exactly one set of terms — so neither can be changed when editing.',
        item: 'Article',
        item_hint: 'What is being bought, under the house’s own name. The supplier’s wording goes in its own field below.',
        sku: 'Supplier code',
        sku_hint: 'Theirs, not ours. This is what goes on the order and comes back on the delivery note; their warehouse has never heard of the house SKU.',
        supplier_item_name: 'Their name for it',
        supplier_item_name_hint: 'What the supplier calls the thing. It stands beside our name rather than instead of it — a storekeeper checks a delivery against their wording.',
        price: 'Unit price',
        price_hint: 'The net price of ONE article unit, not of one pack. A price per pack would mean dividing by a number that is legitimately zero, and comparing two suppliers with differently sized boxes is the whole point of this row.',
        currency: 'Currency',
        pack_unit: 'Packaging',
        pack_unit_hint: 'Their word for the box — “karton”, “pallet”. Free text: nobody should pick from a list somebody else wrote.',
        quantity_per_pack: 'Units per pack',
        quantity_per_pack_hint: 'How many of the ARTICLE’s units are in one of those. Zero means they sell singly; the order suggestion rounds a quantity up to whole packs.',
        moq: 'Minimum order',
        moq_hint: 'The smallest quantity the supplier accepts, in the article’s units. Zero means they have never said. The suggestion lifts a quantity to this minimum FIRST and rounds to packs after — the other way round produces an order the supplier refuses.',
        lead_days: 'Lead time (days)',
        lead_days_hint: 'How many days pass between the order and the lorry. Informative; the forecast (WP-M6) will plan a reorder point against it.',
        price_from: 'Price valid from',
        price_from_hint: 'Empty means “as long as anybody remembers”. A price that has not started is not expired — that is a date in a diary, not a telephone call.',
        price_to: 'Price valid to',
        price_to_hint: 'This day included. Empty means no end has been named. After it the server refuses an order carrying this price (code 106), until somebody accepts the lapsed price with a reason.',
        per_pack: '{quantity} / {unit}',
        pack: 'pack',
        active_hint: 'An inactive row is offered nowhere — not even as expired. Use it when the supplier has stopped selling the article.',
        pair_is_the_key: 'The supplier and the article cannot be changed',
        pair_is_the_key_hint: 'The pair of supplier and article IS this row. Changing either is a different row, so it is done by writing a new one rather than by correcting this.',
        window_backwards: 'A price cannot be valid to a day before it starts.',

        expired: 'Price has lapsed',
        not_started: 'Price not yet in force',
        validity_open: 'no validity limit',
        validity_from: 'valid from {from}',
        validity_to: 'valid to {to}',
        validity_range: 'valid {from} – {to}',

        source_manual: 'Typed in',
        source_contract: 'From a contract',
        source_invoice: 'From the last invoice',

        contract_number: 'Contract number',
        contract_currency_hint: 'The currency applies to EVERY line of the contract. One per agreement and not one per line: a contract is signed in a currency, and lines in two of them would be a total nothing could add up.',
        contract_number_hint: 'The supplier’s own reference for the agreement, or the house’s where the paper carries none. Not unique: two properties of one chain sign the same agreement.',
        contract_supplier_hint: 'Who the agreement is with. On activation every article of the contract gets a catalogue row at this supplier.',
        valid_from: 'Valid from',
        valid_from_hint: 'This date is written onto every catalogue price the activation creates.',
        valid_to: 'Valid to',
        valid_to_hint: 'This day included. Once it passes the contract reads as expired and the prices STAY in the catalogue with a lapsed validity — so a refusal can name them rather than have them vanish with no explanation.',
        lines: 'Lines',
        lines_empty: 'A contract with no lines prices nothing.',
        lines_required: 'A contract needs at least one line with an article chosen.',
        line_twice: 'The same article is on two lines; which price applied would not be decided.',
        add_line: 'Add a line',
        lines_n: '{count} lines',
        read_only: 'An activated contract can no longer be edited',
        read_only_hint: 'This contract’s prices are already in the catalogue. An edit would leave those rows claiming terms the paper no longer carries — so a contract is cancelled and a new one written.',

        activate: 'Activate',
        activated: 'The contract is active; {count} prices were written into the catalogue.',
        cancel_contract: 'Cancel the contract',
        cancelled: 'The contract is cancelled.',
        confirm_activate: 'Activate contract {number}? Its prices are written into the catalogue with the contract’s validity, and the contract can no longer be edited.',
        confirm_cancel: 'Cancel contract {number}? The prices it wrote into the catalogue STAY — switch them off in the catalogue if that is what you want.',

        status_draft: 'Draft',
        status_active: 'Active',
        status_expired: 'Expired',
        status_cancelled: 'Cancelled',

        offers: 'Offers for the selected article',
        offers_empty: 'No offers for this article.',
        chain_offer: 'chain',
        supplier_missing: 'supplier missing at this property',
        not_offered: 'not offered',

        errors: {
            price_expired: 'Line {line}: the price for “{item}” at {supplier} was valid to {to}.',
            price_expired_more: 'Line {line}: the price for “{item}” at {supplier} was valid to {to}, and {more} more lines carry a lapsed price.',
            price_expired_plain: 'The order carries a price whose validity has run out.',
        },
    },
    /**
     * The accounting half of Imprion Materials (docs/MATERIALNO-KNJIGOVODSTVO.md,
     * WP-M2b). Its own namespace and not part of `materials` for the reason the
     * Slovenian file gives: `materials` describes the module as a product, this is the
     * chart of accounts, the cost centres and the hand-off of a period.
     */
    materials_accounting: {
        title: 'Accounting',
        no_property: 'Choose a property first.',
        lead_title: 'Accounts, cost centres and the hand-off to book-keeping',
        lead: 'Accounts sit on the article CATEGORY, with an override on the article itself. Cost centres are their own codebook, optionally defaulted from a department. The export hands a period’s posted supplier invoices to Minimax — each invoice exactly once.',

        cost_centres: 'Cost centres',
        cost_centres_hint: 'The codebook a purchase is split by. Its own codebook and not the departments: accounting has centres the staff structure has never heard of („banquet“).',
        cost_centres_empty: 'No cost centres yet.',
        add_cost_centre: 'New cost centre',
        edit_cost_centre: 'Edit cost centre',
        cost_centre: 'Cost centre',
        cost_centre_code_hint: 'The book-keeper’s own code. Stored without spaces and in upper case, and unique within the house. An invoice line refers to it, so changing a code is a new code rather than a correction of the old one.',
        department: 'Department',
        department_hint: 'The default mapping: this department’s purchases land here unless a line says otherwise. One direction only — deleting a department cannot orphan accounting data.',
        no_department: 'No department',
        from_department: 'default for: {name}',
        payroll_centre_differs: 'The department already has a cost centre',
        payroll_centre_differs_hint: 'Payroll has „{code}“ on this department (docs/OSEBJE-RACUNOVODSTVO.md). Two codes for one centre means wages in one place and purchases in another — align them.',

        accounts: 'Chart of accounts',
        accounts_hint: 'The accounts a purchase posts to. The chart belongs to the book-keeper: it is imported from Minimax (Settings (the gear) → Property and rooms → Properties → open a property → Materials tab → Book-keeping system → „Import the chart of accounts from Minimax“) and the traffic runs one way — nothing goes back. A row the book-keeper does not have is flagged, never deleted.',
        accounts_empty: 'No accounts yet.',
        add_account: 'New account',
        edit_account: 'Edit account',
        code: 'Code',
        account_code_hint: 'The account code as book-keeping spells it. A leading zero is kept — “0400” is not “400”.',
        kind: 'Kind',
        kind_hint: 'The kind says what the account is for. The category mapping offers the right accounts rather than the whole chart, and the server refuses an account of the wrong kind in the wrong column.',
        kind_inventory: 'Inventory',
        kind_consumption: 'Consumption',
        kind_cogs: 'Cost of goods sold',
        kind_input_vat: 'Input VAT',
        kind_payable: 'Supplier payable',
        active_hint: 'Retired rows stay readable — an export of a closed period names them — they are simply not offered on a new row.',
        too_long: 'Too long',

        categories: 'Categories and accounts',
        categories_hint: 'The category → accounts mapping. The category is the only level a hotel already maintains, and coarse enough that nobody forgets to correct it.',
        categories_empty: 'No categories yet.',
        category: 'Category',
        item_count: '{count} articles',
        none: '—',
        mapping_rule: 'Which account wins',
        mapping_rule_hint: 'The code typed on the invoice line first; then the article’s override; then this category mapping. A category with no account is not an error — the export flags it and does not stop the month.',

        overrides: 'Article overrides',
        overrides_hint: 'The handful of articles the category rule is wrong about. An empty field means “take the category’s” — emptying all four removes the override.',
        overrides_empty: 'No article overrides its category.',
        add_override: 'New override',
        override_title: 'Article account override',
        article: 'Article',
        article_hint: 'The article is chosen once; afterwards the override is edited, not the article.',
        from_category: 'From the category',
        category_would_give: 'The category would give',
        category_unmapped: 'This article’s category is not mapped.',
        override_empty_hint: 'Empty means “take the category’s”.',

        export: 'Export to book-keeping',
        export_hint: 'A period’s posted supplier invoices, handed to Minimax. The preview sends nothing; the same unchanged period always produces the same hash.',
        period_from: 'From',
        period_to: 'To',

        consumption: 'Consumption by cost centre',
        consumption_hint: 'What a period\'s issues cost the house, split by cost centre, department or reason. The values come off the movements\' FIFO snapshots, so a closed month answers the same figures after prices move.',
        consumption_empty: 'Nothing was issued in this period.',
        group_by: 'Group by',
        by_cost_centre: 'Cost centre',
        by_department: 'Department',
        by_reason: 'Reason',
        show: 'Show',
        quantity: 'Quantity',
        value: 'Value',
        total: 'Total',
        unattributed: 'Unattributed',

        preview: 'Preview',
        send: 'Send to Minimax',
        send_confirm: '{count} invoices for {from} – {to} will be sent to Minimax. Documents in somebody else’s books cannot be withdrawn from here. Continue?',
        sent: 'Sent: {sent}, already there: {skipped}.',
        sent_drafts: 'Sent: {sent} (of which drafts: {drafts}), already there: {skipped}.',
        drafts_title: '{count} invoices are at the book-keeper as drafts',
        drafts_hint: 'Minimax confirms a received invoice only once it carries an expense line with an account, and its API cannot send one. The book-keeper adds the expense on the draft (the account is in the invoice note) and confirms it. A repeated export does not send these again.',
        history_drafts: '{count} drafts',

        // The invoice is at the book-keeper but without its analytics: Minimax does not
        // know the cost centre on the document. The month cannot be split by department
        // until the house adds the centre in Minimax and exports again.
        unallocated_title: '{count} invoices were sent without analytics',
        unallocated_hint: 'The cost centre on the document does not exist in Minimax, so the invoice was sent without it — the expense lands on the account and nowhere else. Add the cost centre in Minimax under the same code and export again.',
        unallocated_toast: 'Without analytics: {count}.',
        history_unallocated: 'without analytics: {count}',
        not_configured: 'No credentials entered',
        not_configured_hint: 'Settings (the gear) → Property and rooms → Properties → open a property → Materials tab → Book-keeping system. Without a user name, password, application id, secret and organisation nothing can be sent.',
        invoices: 'Invoices',
        sendable: 'To send',
        already_sent: 'Already there',
        net: 'Net',
        vat: 'VAT',
        gross: 'Gross',
        hash: 'Hash (SHA-256)',
        invoice: 'Invoice',
        supplier: 'Supplier',
        issued_on: 'Issued',
        credit_note: 'Credit note',
        attentions: '{count} attentions',
        history: 'Export history',
        history_hint: 'Every export carries its hash, its counts and how many invoices were already at the book-keeper. The hash answers “is this the same month I sent you”.',
        history_empty: 'No exports yet.',
        history_counts: '{invoices} invoices · {lines} lines · {skipped} already there',
        refused_toast: 'Minimax refused {count} invoices.',
        refused_title: 'Refused invoices: {count}',
        refused_hint: 'Each of them stayed with us and is not in the books. Fix what the refusal says and send the period again — invoices already sent are never sent twice.',
        refused_show: 'Show refusals ({count})',
        refused_hide: 'Hide refusals',

        settings_title: 'Book-keeping system (Minimax)',
        settings_hint: 'The house’s own Minimax account, through which the export writes received invoices. The credentials are entered by the house, stored sealed, and never returned to a screen.',
        needs_title: 'What has to be prepared',
        need_account: 'A Minimax account the received invoices of this house are posted to.',
        need_client: 'An application id and secret — Minimax issues them to a developer on a support request.',
        need_app_password: 'An external-application password: in Minimax, “PASSWORDS FOR EXTERNAL APPLICATIONS” › “NEW APPLICATION”. Several failed sign-ins in a row lock the application.',
        need_organisation: 'The organisation id — which set of books should receive the documents.',
        no_test_host: 'The test environment is not a different address',
        no_test_host_hint: 'Minimax has one web address; what makes a run a rehearsal is the ORGANISATION. The connection test shows the organisation names — read the name before sending a first period.',
        organisations: 'Organisations of this account',
        verify: 'Test the connection',
        verified: 'The connection works.',
        check_accounts: 'Check the accounts',
        check_accounts_hint: 'Reads the chart of accounts at Minimax; nothing is written into the books.',
        check_accounts_summary: '{checked} accounts checked, {missing} missing, {notPostable} not open for posting',
        check_accounts_empty: 'No account code is configured anywhere — there is nothing to check.',
        check_accounts_name: 'Name (ours)',
        check_accounts_used_by: 'Where it is used',
        check_accounts_state: 'At Minimax',
        check_accounts_present: 'at Minimax',
        check_accounts_missing: 'missing',
        check_accounts_not_postable: 'posting not allowed',
        check_accounts_ok: 'All {count} accounts are in the chart of accounts at Minimax.',
        check_accounts_problems: '{missing} accounts are missing and {notPostable} do not allow posting. The book-keeper picks the account on the draft — one that is not there cannot be picked.',
        import_accounts: 'Import the chart of accounts from Minimax',
        import_accounts_done: '{created} new, {updated} updated, {missing} accounts the book-keeper does not have.',
        last_import: 'Last import {when}: {answer}',
        missing_at_minimax: 'not at the book-keeper',
        source_minimax: 'Minimax',
        source_house: 'by hand',
        base_url: 'API address',
        base_url_hint: 'https://moj.minimax.si/SI/API by default. Change it only if Minimax explicitly gives you another address.',
        organisation_id: 'Organisation id (Minimax: OrganisationId)',
        organisation_id_hint: 'The organisation number in Minimax. It is the only setting that decides whose books the export reaches.',
        username: 'External application user name (Minimax: Uporabniško ime)',
        username_hint: 'The API user of the Minimax account.',
        password: 'External application password (Minimax: Geslo)',
        password_hint: 'The external-application password. An empty box means “leave what is stored”; removing one is its own button.',
        client_id: 'Client ID (Minimax API)',
        client_id_hint: 'Half of the pair Minimax issues. Hidden like a secret, because a pair with one half in the open has one guess left in it.',
        client_secret: 'Client secret (Minimax API)',
        client_secret_hint: 'The other half of the pair. An empty box means “leave what is stored”.',
        secret_set: 'Stored',
        clear: 'Remove',
        sealed: 'Sealed',
        sealed_hint: 'All three secrets are stored sealed with the deployment key and never come back to a screen. The screen is told only whether each is set.',
        status_incomplete: 'The account is not set up yet',
        status_incomplete_hint: 'Fill in the user name, the application password, the application id and the secret; the organisation id is chosen after a successful connection check.',
        status_no_organisation: 'No organisation chosen yet',
        status_no_organisation_hint: 'The connection works. Enter the organisation id from the list below and save.',
        status_untested: 'The connection has not been tested',
        status_untested_hint: 'Press “Test the connection” — it reads the list of organisations and writes nothing into anybody’s books.',
        status_working: 'The connection works',
        status_checked: 'Last tested {when}: {answer}',

        tolerances_title: 'Match tolerances',
        tolerances_hint: 'How far a receipt may differ from its order and its invoice before the three-way match refuses.',
        tolerances_rule: 'Within tolerance it posts and records the difference',
        tolerances_rule_hint: 'A difference within the limit is posted and recorded; a difference outside it is refused, and the refusal names the line, the amount and what it was measured against (docs/MATERIALNO.md §10.7).',
        tolerance_amount: 'Amount (%)',
        tolerance_amount_hint: 'The allowed difference on the total. Zero refuses every rounding difference — a match that never passes.',
        tolerance_quantity: 'Quantity',
        tolerance_quantity_hint: 'The allowed difference in quantity, in the article’s own units.',
        tolerance_price: 'Price (%)',
        tolerance_price_hint: 'The allowed difference on the unit price.',
    },
    stock: {
        chain_item: 'Chain article: {code} — {name}',
        chain_item_hint: 'This article is on the chain codebook. The name, the unit and the tax rate are the chain\'s; they are changed in the chain codebook and carried from there. Everything else — price, minimum, supplier, place — stays yours.',
        chain_locked: 'Decided by the chain.',

        issue_reason: 'Issue reason',
        issue_reason_department: 'Department',
        issue_reason_consumption: 'Consumption',
        issue_department: 'Department',
        no_department: 'No department',
        cost_centre: 'Cost centre',
        cost_centre_help: 'A code from the cost-centre codebook. Picking a department proposes the centre it maps to.',
        no_cost_centre: 'No cost centre',
        same_as_document: 'Same as the document',

        document: 'Receipt',
        lot_trace_title: 'Where is a lot',
        lot_trace_lead: 'Type a lot number — it shows which store rooms still hold it and where the rest has gone. For a recall.',
        lot_trace_placeholder: 'Lot number …',
        lot_trace_search: 'Find',
        lot_trace_empty: 'Lot "{lot}" is on no delivery.',
        lot_trace_on_hand: 'Still on the shelf',
        lot_trace_gone: 'Already used',
        lot_trace_no_place: 'No store room',
        lot_trace_used: '{count} used',
        lot_trace_takes: 'Where it went',
        expires: 'Best before',
        gaps_title: 'Sold without cover',
        gaps_lead: 'Stock that left the hotel before any batch had paid for it. Each row waits until the next delivery of the same article into the same store room prices it.',
        gaps_empty: 'Nothing here.',
        gaps_open: 'Open',
        gaps_all: 'All',
        gaps_resolved: 'Priced',
        gaps_from_sale: 'sale',
        gaps_from_entry: 'quick entry',
        net_content: 'Net content',
        net_content_hint: 'What is inside one unit: 500 (g), 700 (ml), 1 (piece)',
        net_content_unit: 'Net content unit',
        comparative_price: 'Comparative price',
        content_none: '—',
        content_gram: 'g (price/kg)',
        content_millilitre: 'ml (price/l)',
        content_piece: 'piece (price/piece)',
        barcodes: 'Barcodes',
        barcodes_empty: 'No codes on this article yet.',
        barcode_add: 'New code …',
        price_history: 'Price history',
        price_now: 'now',
        labels_print: 'Print price labels',
        labels_none: 'Choose some articles first.',
        needs_manage: 'Editing articles, store rooms and suppliers needs the Stock (registers) permission.',
        needs_inventory: 'A stocktake is posted by somebody with the Stock (stocktake) permission — save the draft and they will post it.',
        invoice_title: 'Supplier invoice',
        invoice_number: 'Invoice number',
        invoice_number_hint: 'The supplier\'s own invoice number — a duplicate is recognised by it',
        invoice_issued_on: 'Invoice date',
        invoice_delivered_on: 'Delivery date',
        invoice_due_on: 'Payment due',
        invoice_due_on_hint: 'Optional',
        invoice_bases: 'Tax bases by rate',
        invoice_bases_empty: 'The lines carry no prices yet.',
        invoice_total: 'Total',
        invoice_declared_net: 'Net on the invoice',
        invoice_declared_gross: 'Due on the invoice',
        invoice_difference: 'The invoice total differs from the lines by {amount}. It may be carriage, packaging or a discount — check before posting.',
        invoice_attach: 'Attach the original',
        invoice_attached: 'The original is stored.',
        invoice_open: 'Open the original',
        invoice_archived: 'Archived',
        invoice_no_file: 'No original yet.',
        invoice_save_first: 'Save the draft first, then attach the original.',
        archive_title: 'Received invoice archive',
        archive_lead: 'Received invoices are kept for 10 years in the form they arrived. The hash proves the file has not been altered. The list covers originals kept on receipts and on standalone invoices.',
        archive_empty: 'No supplier invoices in this year.',
        archive_source: 'Source',
        archive_source_receipt: 'Receipt',
        archive_source_invoice: 'Invoice',
        archive_year: 'Year',
        archive_missing: 'No original',
        archive_open: 'Open',
        setup_title: 'Stock and minibar',
        setup_hint: 'What this hotel keeps and where. Housekeepers move these things between these places on their own portal; the minibar goes to the room bill by itself.',
        things: 'Items',
        places: 'Store rooms (places)',
        no_things: 'Nothing recorded.',
        no_places: 'Nothing recorded.',
        add_item: 'New item',
        edit_item: 'Edit item',
        add_place: 'New place',
        edit_place: 'Edit place',
        name: 'Name',
        kind: 'Kind',
        kind_hint: 'Linen is washed and comes back, supplies are used up, the minibar is charged to the guest.',
        kind_linen: 'Linen',
        kind_supply: 'Supplies',
        kind_minibar: 'Minibar',
        unit: 'Unit',
        minimum: 'Minimum stock',
        minimum_hint: 'Below this a warning appears. Empty means nobody is watching it.',

        // Decimal quantities (docs/MATERIALNO.md §9g). A quantity stays an integer;
        // the decimals only say how many tenths of the unit it is counted in.
        decimals:               'Decimals',
        decimals_hint:          '0 = pieces · 1 = 0.1 · 2 = 0.01 · 3 = 0.001. Quantities stay whole numbers; the decimals say how many tenths of the unit one of them is.',
        decimals_rescale_hint:  'Changing this rescales EVERY quantity of this article — movements, batches, document lines and stocktakes. Going coarser is refused if any quantity would lose a place.',
        decimals_0:             '0 — whole units (pieces)',
        decimals_1:             '1 — 0.1',
        decimals_2:             '2 — 0.01',
        decimals_3:             '3 — 0.001',
        decimals_refused:       'The article\'s scale could not be changed.',

        errors: {
            decimals_would_round: 'The scale cannot go from {from} down to {to} decimals: a quantity in {where} would lose a place. Correct that quantity, or pick a finer scale.',
            scale_changed: 'The article\'s scale changed meanwhile — reload the form and enter the quantity again',
        },
        min_n: 'min. {count}',
        price: 'Price',
        price_hint: 'What the guest pays. Copied onto the charge when it is posted — a later price change does not alter old bills.',
        tax_rate: 'VAT (%)',
        tax_rate_hint: 'For example 22 or 9.5.',
        place_kind: 'Kind of place',
        place_kind_hint: 'Linen in the laundry is not stock the hotel can use today.',
        place_store: 'Store',
        place_floor: 'Floor cupboard',
        place_trolley: 'Trolley',
        place_laundry: 'Laundry',
        place_rooms: 'In the rooms',
        mobility: 'Mobility',
        mobility_hint: 'A trolley moves around the hotel, a store room stands still.',
        mobility_mobile: 'Mobile',
        mobility_stationary: 'Stationary',
        place_default: 'Default store room - offered first on receipts and transfers',
        default_badge: 'default',
        documents_title: 'Deliveries and stock value',
        documents_hint: 'A receipt books a delivery and its purchase price into stock. The value column shows what the shelf is worth — oldest deliveries are used up first (FIFO).',
        documents: 'Documents',
        no_documents: 'No documents yet.',
        doc_receipt: 'Receipt',
        doc_issue: 'Issue',
        doc_transfer: 'Transfer',
        doc_writeoff: 'Write-off',
        doc_inventory: 'Stocktake',
        count_place: 'Counted place',
        line_counted: 'Counted',
        book_n: 'book {count}',
        status_draft: 'Draft',
        status_posted: 'Posted',
        post: 'Post',
        posted: 'Posted.',
        new_receipt: 'New receipt',
        supplier: 'Supplier',
        suppliers: 'Suppliers',
        no_suppliers: 'No suppliers yet.',
        suppliers_hint: "The hotel's supplier register. The tax number leads the form - Verify asks the EU VAT registry and fills in the rest.",
        tax_lookup_help: 'Type the tax number and press Verify - the rest fills itself.',
        address: 'Address',
        country: 'Country',
        web: 'Website',
        contacts: 'Contacts',
        contacts_n: '{count} contacts',
        add_contact: 'Add a contact',
        contact_role: 'Role',
        contact_role_hint: 'e.g. sales, delivery',
        rating_title: 'Supplier evaluation (ISO)',
        rating_quality: 'Quality',
        rating_delivery: 'Delivery',
        rating_price: 'Price',
        rating_cooperation: 'Responsiveness',
        rating_status: 'Approval status',
        rating_note: 'Justification',
        rating_status_approved: 'Approved',
        rating_status_conditional: 'Conditionally approved',
        rating_status_rejected: 'Not approved',
        rating_evaluated: 'Last evaluated: {date}',
        add_supplier: 'New supplier',
        edit_supplier: 'Edit supplier',
        tax_number: 'Tax number',
        reference: 'Delivery note no.',
        reference_hint: 'The supplier\'s own number, so the paper can be found again.',
        to_place: 'Into place',
        lines: 'Lines',
        line_item: 'Item',
        line_quantity: 'Quantity',
        line_unit_cost: 'Unit price',
        add_line: 'Add line',
        save_draft: 'Save draft',
        save_and_post: 'Save and post',
        value_title: 'Stock value',
        no_value: 'Nothing on the shelf yet.',
        value_total: 'Total',
        all_places: 'All store rooms',
        export_excel: 'Excel',
        export_pdf: 'PDF',
        pieces: 'pcs',
        new_document: 'New document',
        document_type: 'Document type',
        document_type_hint: 'A receipt books a delivery in, an issue and a write-off book stock out, a transfer moves it between places, a stocktake counts one place and books only the differences. A purchase order is a letter to a supplier — it moves nothing until its delivery is received.',
        from_place: 'From place',
        consumption: 'Material',
        consumption_total: 'Consumed value',
        consumption_reason_hint: 'In the period',
        consumption_by_item: 'By item',
        consumption_by_place: 'By place',
        consumption_by_room: 'By room',
        no_consumption: 'Nothing consumed in this period.',
        no_consumption_rooms: 'Nothing tied to a room in this period.',
        reason_sold: 'Minibar sold',
        reason_used: 'Used up',
        reason_damaged: 'Damaged',
        reason_delivery: 'Receipt',
        reason_transfer: 'Transfer',
        reason_soiled: 'To laundry',
        reason_washed: 'From laundry',
        reason_count: 'Stocktake difference',
        card_balances: 'By store room',
        card_ledger: 'Receipts, issues and transfers',
        card_suppliers: 'Suppliers and prices',
        open_item_catalogue: 'Open the catalogue for this article',
        open_catalogue: 'Catalogue',
        card_empty: 'This item has not moved yet.',
        card_date: 'Date',
        card_kind: 'Kind',
        card_route: 'From → to',
        card_value: 'Value',
        page_hint: 'Article levels, store rooms, movements and papers in one place.',
        // A read that did not happen. An empty table with "0 €" under it is a claim
        // about the stock — AppLoadError says there was no answer.
        load_failed:        'The stock could not be read.',
        layers_load_failed: 'This article\'s batches could not be read.',
        tab_overview: 'Overview',
        tab_warehouses: 'Store rooms',
        tab_movements: 'Movements',
        kpi_items: '{count} active articles',
        kpi_critical: '{count} critical',
        kpi_all_good: 'all good',
        kpi_open_documents: 'Open documents',
        kpi_drafts_hint: 'drafts awaiting posting',
        kpi_places_hint: '{count} mobile',
        attention_title: 'Needs attention',
        attention_open: '{count} open',
        attention_empty: 'Nothing waiting - the stock is in order.',
        attention_review: 'Review',
        warehouse_meta: '{count} articles · {value}',
        recent_documents: 'Recent documents',
        all_documents: 'All',
        quick_actions: 'Quick actions',
        quick_receipt: 'Goods receipt',
        quick_transfer: 'Transfer between store rooms',
        quick_inventory: 'Stocktake',
        all_items: 'All articles',
        all_reasons: 'All kinds',
        movements_empty: 'No movements for these filters.',
        movements_load_failed: 'The movements could not be read.',

        // Long lists are read a page at a time (docs/MATERIALNO.md §10). The line under
        // the list says which part of the whole is on the screen — without it a list cut
        // off at the cap looks exactly like a short one.
        list_range: 'Showing {from}–{to} of {total}',
        list_capped: 'there are more than the service counts — narrow the filters',
        list_previous: 'Back',
        list_next: 'Next',
        list_load_more: 'Load more',
        status_ok: 'OK',
        status_below: 'Below minimum',
        status_critical: 'Critical',
        status_inactive: 'Inactive',
        col_quantity: 'On hand',
        col_avg_cost: 'Purchase cost',
        unknown_item: 'Unknown item',
        unknown_place: 'Unknown place',
        unknown_room: 'Unknown room',
        ai_receipt: 'AI receipt',
        ai_drop_here: 'Drop the delivery note here',
        ai_drop_hint: 'Click, or drag a delivery note (image or PDF) anywhere onto the card.',
        tax_lookup: 'Verify',
        tax_lookup_failed: 'The VAT register is not answering - try again.',
        tax_lookup_invalid: 'This number is not in the VAT register.',
        parse_failed: 'The delivery note could not be read.',
        parse_concerns: 'The reader noticed',
        parse_new_supplier: '{name} is not in the supplier register yet — saving this receipt will add them.',
        parse_unmatched: 'On the paper: {name}',
        below_minimum: 'Below minimum',
        held_of_min: '{held} of min. {minimum}',
        order_n: 'order {count}',
        doc_order: 'Purchase order',
        status_ordered: 'Ordered',
        issue_order: 'Issue',
        to_receipt: 'To receipt',
        email_order: 'Email the order',
        compose_order: 'Compose order',
        line_tax: 'VAT %',
        from_order_note: 'From order {number}',
        order_mail_subject: 'Order {number}',
        order_mail_body: 'Hello,\n\nplease deliver:\n\n{lines}\n\nThank you.',
        last_supplier_hint: 'Last supplier: {name} · {price} €',
        doc_rfq: 'Request for quotation',
        status_sent: 'Sent',
        rfq_to_order: 'To order',
        from_rfq_note: 'From inquiry {number}',
        rfq_mail_subject: 'Request for quotation {number}',
        rfq_mail_body: 'Hello,\n\nplease quote for:\n\n{lines}\n\nThank you.',
        send_to_suppliers: 'Send to suppliers',
        line_needs_supplier: 'Every line needs a supplier.',
        sent_to_suppliers: 'Sent to suppliers: {list}',
        drafts_created: 'Drafts prepared: {list}',
        col_item_count: 'Articles',
        tab_consumption: 'Consumption',
        section_basic: 'Basics',
        section_prices: 'Prices and VAT',
        section_stock: 'Stock',
        section_retail: 'Retail',
        section_tracing: 'Traceability',
        sku: 'Code',
        sku_hint: 'The hotel\'s own code, unique within the property. Empty means we propose one.',
        sku_auto: 'ART-0001 (proposed)',
        ean: 'Barcode (EAN)',
        ean_hint: '8, 12, 13 or 14 digits.',
        ean_invalid: 'A barcode has 8, 12, 13 or 14 digits.',
        category: 'Category',
        brand: 'Brand',
        purchase_price: 'Purchase price',
        purchase_price_hint: 'Updated automatically by every posted receipt; you can still correct it by hand. What stock is worth still comes from FIFO.',
        col_last_cost: 'Last cost',
        pack_size: 'Pack size',
        pack_unit: 'Pack unit',
        pack_hint: 'For example 6 × 0.25 l. Informative — stock is still counted in the base unit.',
        size: 'Size',
        color: 'Colour',
        photo: 'Photo',
        photo_after_save: 'A photo can be added once the article has been saved.',
        primary_place: 'Primary location',
        primary_place_hint: 'Where the article normally lives; offered first on a receipt.',
        default_supplier: 'Default supplier',
        default_supplier_hint: 'An order form prefers this over the last-delivery history.',
        unit_mode: 'Sold by',
        unit_mode_hint: 'Weight and volume are counted in WHOLE base units — grams and millilitres (1.5 kg is 1500).',
        unit_mode_piece: 'The piece',
        unit_mode_weight: 'Weight (g)',
        unit_mode_volume: 'Volume (ml)',
        status: 'Status',
        status_hint: 'An unavailable article stays visible but the till will not sell it. A discontinued one is hidden everywhere except in history.',
        status_active: 'Active',
        status_unavailable: 'Unavailable',
        status_discontinued: 'Discontinued',
        track_lot: 'Track batches and expiry',
        track_lot_hint: 'A receipt of this article must name its batch and its expiry date.',
        storage_temp_min:  'Lowest storage temperature (°C)',
        storage_temp_max:  'Highest storage temperature (°C)',
        storage_temp_hint: 'Optional and independent. A reading taken at receiving outside this window quarantines the line; an empty box means the thermometer decides nothing about this article.',
        lot: 'Batch',
        no_lot: 'No batch',
        expires_at: 'Expires',
        open_layers: 'Open batches',
        expires_in_n_days: 'Expires in {count} days',
        expired_n_days: 'Expired {count} days ago',
        vat_existing: '{rate} (existing)',
        all_types: 'All',
        sort_by_date: 'By date',
        sort_by_type: 'By type',
        create_item_named: "Create '{name}'",
        expected_at: 'Expected delivery',
        expected_at_hint: 'The day the supplier promises. Without one an order cannot be chased.',
        ordered_title: 'On order',
        ordered_hint: 'What is still coming. Received is summed across every receipt booked against the order, even when it arrives in two deliveries.',
        no_ordered: 'Nothing is on order.',
        late_n_days: '{count} days late',
        due_on: 'Due {date}',
        no_due_date: 'No date promised',
        outstanding: 'Still to come',
        order_progress: '{received} of {ordered} received',
        receive_order: 'Receive',
        receipt_for_order: 'Receipt for order {number}',
        against_order: 'Against order {number}',
        variances: 'Variances',
        no_variances: 'No variances — the delivery matches the order.',
        variance_short: 'Short',
        variance_over: 'Over',
        variance_missing: 'Did not arrive',
        variance_extra: 'Not ordered',
        variance_price: 'Different price',
        variance_qty: 'ordered {ordered}, received {received}',
        variance_cost: 'price {ordered} → {received}',
        delivered_on_time: 'Delivered on the promised day',
        delivered_late: 'Delivered {count} days late',
        delivered_early: 'Delivered {count} days early',
        delivered_unpromised: 'The order promised no delivery day',
        pos_title: 'Bar and kitchen (POS)',
        pos_hint: 'Read live from the Imprion POS, which stays the only book for food and beverage. This screen only looks — receipts and stocktakes for the bar happen in the POS.',
        pos_empty: 'Nothing matches.',
        pos_no_category: 'No category',
    },
    guest_link: {
        button: 'Guest portal',
        title: 'Guest link',
        hint: 'The guest uses this link to see their stay, arrival directions and their bill. The link stays the same until you revoke it.',
        issue: 'Issue link',
        copy: 'Copy link',
        copied: 'Link copied.',
        revoke: 'Revoke link',
        revoked: 'Link revoked.',
        // See the Slovenian note above: the date is the end of the link's FIRST life
        // and not of the link.
        expires: 'Fully valid until {date}; after that the link stays open as a memory of the stay (with no personal data).',

        // Sending it on WhatsApp (docs/OBVESCANJE.md §10.9). The LIVE link goes out; a
        // new one is minted only where there is none.
        whatsapp: 'Send on WhatsApp',
        whatsapp_sent: 'The welcome and the link were sent to {number}.',
        whatsapp_failed: 'The welcome could not be sent.',
        whatsapp_not_ready: 'WhatsApp sending is not set up: enable WhatsApp through Twilio and the guest greeting template under Settings (the gear) → Integrations and communication → Notifications.',
        add_phone: 'Add the payer\'s phone number',
        add_phone_placeholder: '+386 40 123 456',
        phone_saved: 'The phone number is saved on the guest card.',
        whatsapp_no_phone: 'The payer has no telephone number - add one on the guest card.',

        // The same link by letter and by text message. The LIVE link goes out, exactly
        // as it does on WhatsApp; the letter is written in the guest's own language and
        // the text message is as short as what is left beside the link
        // (docs/OBVESCANJE.md §10.9).
        email: 'Send by e-mail',
        email_sent: 'The link was sent to {address}.',
        email_failed: 'The letter could not be sent.',
        email_no_address: 'The payer has no e-mail address - add one on the guest card.',
        add_email: 'Add the payer\'s e-mail address',
        add_email_placeholder: 'first.last@example.com',
        email_saved: 'The e-mail address is saved on the guest card.',

        sms: 'Send by SMS',
        sms_sent: 'The link was sent to {number}.',
        sms_failed: 'The text message could not be sent.',
        sms_not_ready: 'SMS is not set up: Settings (the gear) → Integrations and communication → Notifications.',
        sms_no_phone: 'The payer has no telephone number - add one on the guest card.',
    },
    general: {
        previous: 'Previous',
        next: 'Next',
        hint: 'Hint',
        clear: 'Clear',
        refresh: 'Refresh',
        // Reading again after a fault — AppLoadError.vue. Separate from "Refresh": this
        // is the button where data is MISSING, not on a list that was read.
        try_again: 'Try again',
        activate: 'Activate',
        deactivate: 'Deactivate',
        deleted: 'Deleted',
        saved: 'Saved',
        add:      'Add',
        edit:     'Edit',
        delete:   'Delete',
        cancel:   'Cancel',
        save:     'Save',
        close:    'Close',
        search:   'Search',
        confirm:  'Confirm',
        select_confirm: 'Confirm',
        selected_count: 'selected: {count}',
        yes:      'Yes',
        no:       'No',
        back:     'Back',
        actions:  'Actions',
        show_password: 'Show password',
        hide_password: 'Hide password',
        pick_date: 'Pick a date',
        no_data:  'No data',
        loading:  'Loading …',
        active:   'Active',
        inactive: 'Inactive',
        from:     'From',
        to:       'To',
        all:      'All',
        today:    'Today',
        name:     'Name',
        code:     'Code',
        description: 'Description',
        confirm_delete: 'Delete this record?',
        notes:    'Notes',
        status:   'Status',
        email:    'Email',
        phone:    'Phone',
    },
    business_register: {
        nav: 'Business register',
        no_property: 'Pick a property first.',
        title: 'AJPES — the Slovenian business register',
        hint: 'Who may legally represent a company: the director, the procurator, the liquidator. It is the only source of that — the tax authority\'s list of taxpayers holds no people at all.',
        needs_title: 'What the hotel has to arrange with AJPES',
        need_account: 'A user account at www.ajpes.si. It is the SAME account as for eTurizem — the portal user name and password.',
        need_order: 'The order form „Naročilo za uporabo podatkov PRS — SFTP ali restPrsInfo“, signed and sent to prs@ajpes.si. It requires a stated purpose for the data.',
        need_schema: 'A bought package of units. Representatives come only with the WIDER set (PRS_SN_E or PRS_SN_P); the narrow and minimal ones do not carry them. Every question is billed by the unit.',
        need_certificate: 'A qualified digital certificate registered in the AJPES profile. Without one AJPES returns no personal data — which means no representatives\' names.',
        status_unset: 'Not set up',
        status_unset_hint: 'Until there is a user name and a password the house cannot ask this register anything. Everything else carries on working.',
        status_working: 'Working',
        status_failing: 'Not working',
        status_never_checked: 'The connection has never been tested.',
        status_last: 'Last checked {date}: {message}',
        username: 'AJPES user name',
        username_hint: 'The same one as for signing in to www.ajpes.si.',
        password: 'AJPES password',
        password_hint: 'Type the password. It is stored encrypted and never comes back to the screen.',
        password_stored: 'A password is stored. Leave empty to keep it unchanged.',
        password_set: '••••••••  (stored)',
        clear_password: 'Remove the password',
        password_cleared: 'The password has been removed.',
        schema: 'Service code',
        schema_hint: 'The package the house ordered from AJPES. It decides how wide the answer is and what each question costs.',
        schema_set_wider: 'wider set',
        schema_set_narrow: 'narrow set',
        schema_set_minimal: 'minimal set',
        schema_kind_unit: 'unit',
        schema_kind_query: 'query',
        too_long: 'This value is too long.',
        schema_too_narrow: 'This package does not carry representatives',
        schema_too_narrow_hint: 'The narrow and minimal sets answer everything about a company except the people. That is not a fault and it does not mean the firm has no director — the question about people was simply not bought.',
        environment: 'Environment',
        environment_hint: 'The AJPES test service answers for three companies of one small municipality and takes its own user name, which AJPES sends by e-mail.',
        test: 'AJPES test environment',
        verify: 'Test the connection',
        verified: 'The AJPES account works: {account}',
        verified_found: 'The register answered: {name}',
        verified_not_found: 'The account works, but the register did not answer the test question: {reason}',
        no_certificate: 'No digital certificate is registered on the account. Without one AJPES returns no representatives\' names.',
        units_left: '{count} units left',
        verify_failed: 'The connection could not be tested',
        sealed: 'The password is encrypted',
        sealed_hint: 'It is stored with the deployment key and never comes back to a screen or into an API answer.',
        saved: 'The settings have been saved.',
        tax_list_title: 'The taxpayer list (FURS) is a different thing',
        tax_list_hint: 'Searching for a company by name, tax number and address runs off the public FURS list, downloaded every night. It is free, needs no account, and holds no people. What is set up here is only the register of representatives.',
        panel_title: 'Representatives (AJPES)',
        panel_hint: 'Who may sign for this company. The question goes to the state register when the button is pressed; the answer is stored nowhere.',
        panel_bizi: 'Look up on bizi.si',
        panel_ask: 'Ask AJPES',
        panel_idle: 'Not asked yet. Each question is billed by the unit against the house\'s package.',
        panel_failed: 'The register could not be asked',
        panel_nobody: 'The register names no representative',
        panel_since: 'entered {date}',
        panel_source: 'Source: {source} · asked {at}. Not stored on the company.',
        fact_registration: 'Registration number',
        fact_activity: 'Main activity',
        fact_seat: 'Registered seat',
        fact_entered: 'Date of entry',
    },
    crm: {
        tab_overview: 'Overview',
        tab_timeline: 'Timeline',
        tab_stays: 'Stays',
        tab_preferences: 'Preferences',
        tab_internal: 'Internal',
        // The one entry on this timeline that came from the guest rather than from
        // the house: a message written to Milo in the portal and confirmed there.
        event_guest_message: 'Guest message (Milo)',
        tag_new: 'New guest',
        tag_repeat: 'Repeat guest',
        tag_inactive: 'Inactive',
        tag_problem: 'Problematic',
        tag_add: 'Add tag',
        tag_remove: 'Click removes the tag',
        tag_placeholder: 'New tag …',
        marketing_yes: 'Marketing consent',
        marketing_no: 'No marketing consent',

        // Marketing consent (docs/MARKETING.md §13). Four states and not a checkbox:
        // "nobody asked" and "we asked and they said no" are not the same fact.
        consent_title:  'Marketing consent',
        consent_record: 'Record consent',
        consent_note:   'Note',
        consent_note_hint: 'what the guest actually said',
        consent_hint:   'Campaign letters go only to guests with a live consent and an address that is not on the suppression list.',
        consent_source_desk: 'Recorded as a consent taken at the desk. A tick the guest makes themselves cannot be entered on their behalf.',

        consent_granted:   'Granted',
        consent_refused:   'Refused',
        consent_withdrawn: 'Withdrawn',
        consent_none:      'Not asked',

        consent_source_check_in:         'at online check-in',
        consent_source_portal:           'in the guest portal',
        consent_source_import:           'from an import',
        consent_source_unsubscribe_link: 'through the link in a letter',
        new_reservation: 'New reservation',
        add_task: 'Add task',
        contact: 'Contact',
        stat_next: 'Next arrival',
        stat_last: 'Last stay',
        stat_stays: 'Stays',
        stat_nights: 'Nights',
        stat_spend: 'Spend',
        stat_average: 'Avg. stay',
        stat_open: 'Outstanding',
        stat_tasks: 'Open tasks',
        timeline_empty: 'No events yet — they appear with reservations, check-ins and invoices.',
        stays_empty: 'No stays yet.',
        preferences_standing: 'Standing preferences',
        preferences_sensitive: 'Sensitive information',
        preferences_sensitive_hint: 'Allergies and the like: for the room and the service only, never for marketing.',
        note_placeholder: 'Internal note about the guest …',
        note_add: 'Add',
        tasks: 'Tasks',
        crm: 'CRM overview',
        crm_group: 'CRM',
        crm_overview: 'CRM overview',
        crm_manager: 'CRM management',
        tasks_for_guest: 'Tasks for this guest',
        tasks_open: 'Open',
        tasks_all: 'All',
        tasks_empty: 'No tasks.',
        task_assigned: 'Owner',
        task_unassigned: 'No owner',
        task_overdue: 'Overdue',
        tasks_mine: 'My tasks',
        task_title: 'Title',
        task_note: 'Note',
        task_due: 'Due',
        task_done: 'Done',
        task_saved: 'The task is saved.',
        segments: 'Segments',
        segments_hint: 'All conditions must hold at once. Members are computed live — a segment is never a stale list.',
        back_to_manager: 'Back to the management overview',
        segments_saved: 'Saved segments',
        segments_none: 'No saved segments yet.',
        segment_add_condition: 'Add condition',
        segment_preview: 'Show members',
        segment_name: 'Segment name …',
        segment_saved: 'The segment is saved.',
        segment_members: 'Members ({count})',
        segment_empty: 'No guest matches the conditions.',
        field_marketing_consent: 'Marketing consent',
        field_email_consent: 'E-mail consent',
        field_min_stays: 'Number of stays',
        field_last_stay_days_ago: 'Last stay',
        field_stayed_within_days: 'Stayed within',
        field_total_spend_min: 'Total spend',
        field_country: 'Nationality',
        field_no_future_reservation: 'No future reservation',
        field_open_balance: 'Outstanding balance',
        field_tag: 'Tag',
        op_is: 'is',
        op_at_least: 'at least',
        op_more_than_days: 'more than (days) ago',
        op_within_days: 'within (days)',
        op_at_least_eur: 'at least (€)',
        op_equals: 'equals',
        opportunities: 'Opportunities',
        contacts: 'Contact people',
        contact_name: 'Full name',
        contact_role: 'Role',
        contact_add: 'Add contact',
        contracts: 'Contracts',
        contract_name: 'Contract name …',
        contract_terms: 'Agreed benefits …',
        contract_add: 'Add contract',
        credit_limit: 'Credit limit',
        payment_terms: 'payment terms {days} days',
        receivables_badge: 'Open receivables: {amount}',
        linked_guests: 'Linked guests',
        stat_reservations: 'Reservations',
        stat_revenue: 'Revenue',
        stat_receivables: 'Receivables',
        stat_deals: 'Open deals',
        stage_inquiry: 'Inquiry',
        stage_qualified: 'Qualified',
        stage_offer: 'Offer',
        stage_negotiation: 'Negotiation',
        stage_won: 'Won',
        stage_lost: 'Lost',
        stage_back: 'Step back',
        stage_forward: 'Step forward',
        type_contract: 'Corporate contract',
        type_group: 'Group reservation',
        type_event: 'Event',
        type_agency: 'Agency',
        type_private: 'Private visit',
        deal_title: 'Opportunity title …',
        deal_value: 'Value (€)',
        deal_guests: 'People',
        deal_rooms: 'Rooms',
        deal_room_types: 'Room types ...',
        deal_note: 'Inquiry details: extra activities, hall hire, bike hire ...',
        deal_guests_n: '{count} people',
        deal_rooms_n: '{count} rooms',
        deal_title_label: 'Title',
        deal_type_label: 'Type',
        deal_value_auto: 'Empty = computed from the lines.',
        deal_value_auto_short: 'automatic',
        deal_lines: 'Inquiry lines',
        deal_note_label: 'Details',
        line_room_type: 'Room type',
        line_nights: 'Nights',
        line_nights_short: 'n.',
        line_guests_short: 'p.',
        line_date: 'Date',
        line_facility: 'Facility',
        line_quantity: 'Quantity',
        line_note: 'Note',
        line_note_hint: 'e.g. registration plate',
        line_add_room: 'Add a room',
        deal_add: 'Add opportunity',
        desk_today: 'For the desk — today',
        today_notable: 'VIP and repeat guests today',
        today_incomplete: 'Arrivals without a document',
        numbers: 'Numbers',
        open_tasks: 'Open tasks',
        guests_with_balance: 'Guests with a balance',
        management: 'For management',
        guests_total: 'All guests',
        guests_new: 'New (1 stay)',
        guests_repeat: 'Repeat',
        revenue_total: 'Guest revenue',
        revenue_repeat: 'Repeat revenue',
        top_companies: 'Top companies',
        win_back: 'Worth re-approaching',
        win_back_hint: 'Stayed, nothing booked ahead, quiet for over 10 months.',
        birthdays: 'Upcoming birthdays',
        birthdays_hint: 'Only guests with marketing consent.',
    },
    crmm: {
        compare: 'Compare to last year',
        compare_on: 'Comparing to last year',
        tab_overview: 'Overview',
        tab_sales: 'Sales',
        tab_guests: 'Guests',
        tab_corporate: 'Companies',
        period_year: 'This year',
        period_90: 'Last 90 days',
        period_month: 'This month',
        title_overview: 'Management CRM overview',
        sub_overview: 'From the guest relationship to the sales result',
        title_sales: 'Sales and opportunities',
        sub_sales: 'Value, probability, speed and next steps',
        title_guests: 'Guests and loyalty',
        sub_guests: 'Retention, guest value and activation segments',
        title_corporate: 'Business partners',
        sub_corporate: 'Revenue, contracts, receivables and risks',
        guest_revenue: 'Guest revenue',
        repeat_share: 'Repeat guest share',
        weighted_pipeline: 'Weighted pipeline',
        company_receivables: 'Company receivables',
        open_deals_n: '{n} open opportunities',
        overdue_n: '{amount} overdue',
        revenue_split: 'Revenue from new and repeat guests',
        new: 'New',
        repeat: 'Repeat',
        needs_attention: 'Needs attention',
        open_pipeline: 'Open pipeline',
        win_rate: 'Win rate',
        avg_cycle: 'Average cycle',
        won_lost: 'won {won} · lost {lost}',
        days: '{n} days',
        funnel: 'Sales funnel',
        probability: 'probability',
        open_deals: 'Open opportunities',
        no_company: 'no company',
        active_guests: 'Active guests',
        repeat_guests: 'Repeat guests',
        avg_guest_value: 'Average guest value',
        reachable: 'Marketing-reachable',
        top_segments: 'Highest-potential segments',
        retention: 'Retention after first stay',
        retention_note: 'Retention uses the first-departure cohort, not all guests in the database.',
        corporate_revenue: 'Company revenue',
        active_partners: 'Active partners',
        with_contract: '{n} with a contract',
        company_adr: 'Company ADR',
        overdue_receivables: 'Overdue receivables',
        key_partners: 'Key partners',
        revenue: 'Revenue',
        nights: 'Nights',
        receivables: 'Receivables',
        contracts_risks: 'Contracts and risks',
        points: 'pp',
        vs_last_year: 'vs last year',
    },
    /**
     * „What is waiting for me“ — the operational overview of Imprion Materials
     * (docs/MATERIALNO.md §10.11).
     *
     * The rows arrive sorted and computed; these are only the words. `kind_*` is WHAT a
     * row is, `fig_*` and `total_*` are the figures beside it.
     */
    materialsOverview: {
        title: 'Materials — overview',
        lead: 'What is waiting for you: every row carries its amount or quantity, the person it waits on, how long it has waited, and a button onto the screen that closes it. Sorted by urgency, not by when it was written.',
        read_at: 'Read at {time}',
        no_panels: 'Your account holds no right in materials, so there is no panel here. That is not the same as „nothing is waiting“ — ask an administrator for access.',
        panel_empty: 'Nothing is waiting. This panel is empty because there is genuinely nothing open.',
        next_step: 'Open',
        due: 'Due',
        age_hours: '{count} h',
        age_days: '{count} days',
        more_n: 'and {count} more × {kind}',

        panel_storekeeper: 'Storekeeper',
        panel_buyer: 'Buyer',
        panel_head_of_department: 'Head of department',
        panel_accounting: 'Accounting',
        panel_director: 'Director',

        badge_late: '{count} days late',
        badge_escalated: 'escalated',
        badge_over_budget: 'over budget',
        badge_no_budget: 'no budget',
        badge_credit_note: 'credit note',

        kind_delivery_today: 'Delivery today',
        kind_receipt_draft: 'Unfinished receipt',
        kind_quarantine: 'Quarantine',
        kind_return_pending: 'Return in draft',
        kind_count_task: 'My stocktake',
        kind_expiring_lot: 'Expiring',
        kind_to_order: 'To order',
        kind_supplier_late: 'Supplier late',
        kind_rfq_open: 'Open request for quotation',
        kind_requisition_to_order: 'Approved, not ordered',
        kind_approval_pending: 'Waiting for my approval',
        kind_budget_remaining: 'Budget left',
        kind_invoice_unposted: 'Unposted invoice',
        kind_credit_note_expected: 'Credit note expected',
        kind_export_refusal: 'Export refused',
        kind_export_drafts: 'Drafts at the book-keeper',
        kind_accounts_check: 'Accounts do not match',
        kind_accounts_check_never: 'Accounts never checked',
        kind_stock_value: 'Stock value',
        kind_money_tied_up: 'Money tied up',
        kind_write_off: 'Write-off',
        kind_budget_deviation: 'Budget deviation',
        kind_top_supplier: 'Top supplier',

        fig_lines: 'lines',
        fig_ordered: 'ordered',
        fig_received: 'received',
        fig_lines_counted: 'counted',
        fig_lines_expected: 'lines in all',
        fig_days_left: 'days left',
        fig_on_hand: 'on hand',
        fig_on_order: 'on order',
        fig_minimum: 'minimum',
        fig_suppliers: 'suppliers',
        fig_remaining_cents: 'budget left',
        fig_planned_cents: 'planned',
        fig_actual_cents: 'spent',
        fig_consumption_cents: 'issued this month',
        fig_tolerance_breaches: 'out of tolerance',
        fig_invoices: 'invoices',
        fig_skipped: 'skipped',
        fig_days_cover: 'days of cover',
        fig_pct_used: 'used',

        total_incoming_value_cents: 'Incoming value',
        total_quarantine_open: 'Open issues',
        total_to_order_value_cents: 'To order',
        total_late_value_cents: 'Late',
        total_approved_value_cents: 'Approved, not ordered',
        total_pending_cents: 'Waiting for approval',
        total_pending_count: 'Papers',
        total_unposted_cents: 'Unposted',
        total_unposted_count: 'Invoices',
        total_credit_notes_expected_cents: 'Credit notes expected',
        total_export_refusals: 'Refusals',
        total_export_drafts: 'Drafts',
        total_stock_value_cents: 'Stock value',
        total_write_off_cents: 'Written off this month',
    },
    materialsOrder: {
        title: 'Purchase orders',
        lead: 'An order has a life of its own: draft → approved → sent → confirmed → partially delivered → closed or cancelled. What has arrived is summed from the receipts and never typed.',
        detail_lead: 'What was ordered, what came, and what has happened to the order.',
        heading: 'Order {number}',
        empty: 'No purchase orders.',
        not_found: 'No such order.',
        filter_status: 'State',
        filter_status_help: 'Open is everything from „sent“ to „partially delivered“ — that is when the house is waiting for something.',
        filter_all: 'All',
        lines: 'Lines',
        lines_n: '{count} lines',
        outstanding_lines_n: '{count} articles still to come',
        expected_at: 'Due',
        article: 'Article',
        ordered: 'Ordered',
        received: 'Received',
        outstanding: 'Outstanding',
        unit_cost: 'Unit price',
        from_rfq: 'From a request for quotation',
        timeline: 'Timeline',
        step_created: 'Written',
        step_approved: 'Approved',
        step_sent: 'Sent to the supplier',
        step_confirmed: 'Confirmed by the supplier',
        step_closed: 'Closed',
        sent_by_hand: 'no e-mail address (by telephone)',
        status_draft: 'Draft',
        status_approved: 'Approved',
        status_sent: 'Sent',
        status_confirmed: 'Confirmed',
        status_partially_delivered: 'Partially delivered',
        status_closed: 'Closed',
        status_cancelled: 'Cancelled',
        action_approve: 'Approve',
        action_send: 'Send to the supplier',
        action_confirm: 'Record the confirmation',
        action_close: 'Close',
        action_cancel: 'Cancel',
        done_approve: 'The order is approved.',
        done_send: 'The order has been sent to the supplier.',
        done_confirm: 'The supplier\'s confirmation is recorded.',
        done_close: 'The order is closed.',
        done_cancel: 'The order is cancelled.',
        sent_without_mail: 'The order is marked as sent — the supplier has no e-mail address, so no letter left.',
        confirmation_number: 'Confirmation number',
        confirmation_number_help: 'The supplier\'s own reference for the order. Optional — a small supplier confirms by telephone.',
        promised_on: 'Promised day',
        promised_on_help: 'The day the supplier promises. It stands beside our own due date and does not overwrite it.',
        reason: 'Reason',
        reason_help: 'Compulsory. An order closed or cancelled is money the house decided not to spend and goods a department is still waiting for — three weeks later somebody asks who stopped it.',
    },
    materialsRfq: {
        title: 'Requests for quotation',
        lead: 'One list of articles, sent to several suppliers, and one comparison table out of their answers. A choice writes an order carrying the quoted prices.',
        detail_lead: 'Who was asked, what they answered, and what we chose.',
        heading: 'Request {number}',
        add: 'New request',
        empty: 'No requests for quotation.',
        not_found: 'No such request.',
        created: 'The request has been created.',
        filter_status: 'State',
        filter_status_help: 'A draft is still being written, a sent one is waiting for quotes, and a closed one has every line ordered.',
        filter_all: 'All',
        status_draft: 'Draft',
        status_sent: 'Sent',
        status_closed: 'Closed',
        suppliers: 'Suppliers',
        suppliers_help: 'They all get THE SAME letter. Three suppliers answering three slightly different lists give three prices that cannot be compared.',
        suppliers_n: '{count} suppliers',
        due_on: 'Answer by',
        due_on_help: 'The day the house wants a quote by. Optional.',
        note: 'Note',
        lines: 'Articles',
        lines_n: '{count} articles',
        add_line: 'Add a line',
        no_lines: 'Add at least one article.',
        article: 'Article',
        quantity: 'Quantity',
        action_send: 'Send to the suppliers',
        action_quote: 'Enter a quote',
        action_choose: 'Create the orders',
        sent: 'The request has been sent ({count} letters).',
        sent_with_skipped: 'Sent ({count} letters). With no address: {names} — these have to be telephoned.',
        send_sent: 'Sent ({count} suppliers)',
        send_failed: 'Not sent ({count} suppliers)',
        send_no_address: 'no e-mail address',
        comparison: 'Comparison of the quotes',
        comparison_help: 'Per article: each supplier\'s price, the cheapest marked, the total per supplier and the missing lines. „Last price“ is the article\'s own last purchase price.',
        no_comparison: 'There is no comparison yet.',
        reference_price: 'Last price',
        no_answer: 'no answer',
        missing: 'not quoted',
        missing_n: '{count} lines missing',
        not_comparable: 'another currency',
        lead_days_n: '{count} days',
        moq_n: 'min. {count}',
        total: 'Total',
        chosen: 'Chosen',
        choose_line: 'Choose this line',
        choose_supplier: 'Supplier',
        choose_supplier_help: 'One press is one order at one supplier. The list may be split — choose the rest with a second press.',
        pick_cheapest: 'Mark the cheapest',
        chosen_done: 'Order {numbers} has been created.',
        quote_title: 'A supplier\'s quote',
        quote_supplier: 'Supplier',
        quote_supplier_help: 'A second quote from the same supplier replaces the first — a corrected price is one quote in two letters.',
        quote_received_on: 'Received',
        quote_received_on_help: 'The day the quote came in. Empty means today.',
        quote_note: 'Note',
        quote_price: 'Unit price',
        quote_packaging: 'Packaging',
        quote_lead_days: 'Lead time (days)',
        quote_moq: 'Minimum order',
        quote_no_lines: 'Enter at least one price.',
        quote_saved: 'The quote has been recorded.',
    },
    /**
     * Requisitions, approvals and the approval rules (docs/MATERIALNO-ZAHTEVKI.md, WP-M4).
     */
    materialsRequisition: {
        title: 'Requisitions',
        lead: 'A department writes down what it needs, whoever may commit the money approves it, and only then is a purchase order written. The estimate is the catalogue price at the moment the requisition was written.',
        detail_lead: 'What was asked for, whose desk the ask is on, and what it became.',
        heading: 'Requisition {number}',
        add: 'New requisition',
        edit: 'Edit requisition',
        empty: 'No requisitions.',
        not_found: 'No such requisition.',
        filter_all: 'All',
        filter_mine: 'Mine only',
        filter_mine_help: 'Shows only the requisitions you raised yourself. An approver sees all of them by default.',
        status_draft: 'Draft',
        status_submitted: 'Submitted',
        status_approved: 'Approved',
        status_rejected: 'Rejected',
        status_ordered: 'Ordered',
        status_cancelled: 'Cancelled',
        department: 'Department',
        department_help: 'Who will use the goods. Required — it is how anybody knows whom to ask when the requisition stalls.',
        cost_centre: 'Cost centre',
        cost_centre_help: 'The accounting codebook. Optional — without it the cost is split by the category rules.',
        no_cost_centre: 'No cost centre',
        needed_on: 'Needed by',
        needed_on_help: 'The day the goods have to be in the house. Optional; nothing is computed from it, but it is the first thing an approver looks at.',
        note: 'Note',
        note_help: 'Why it is needed. One sentence saves a telephone call.',
        lines: 'Lines',
        lines_n: '{count} lines',
        add_line: 'Add line',
        no_lines: 'Enter at least one article.',
        article: 'Article',
        quantity: 'Quantity',
        unit: 'Unit',
        unit_help: 'Taken from the article. Change it where the department counts differently from the store room.',
        line_note: 'Line note',
        estimated_unit: 'Estimate per unit',
        estimated: 'Estimate',
        estimated_total: 'Estimated value',
        waiting_on: 'waiting on {role} (level {level})',
        approvals: 'Approvals',
        no_approvals: 'The requisition has not been submitted, so nobody is waiting for it.',
        level_n: 'Level {level}',
        due_at: 'Due',
        escalated_at: 'Escalated to the deputy {at}',
        decision_pending: 'Waiting',
        decision_approved: 'Approved',
        decision_rejected: 'Rejected',
        decision_lead: 'Requisition {number}',
        decision_note: 'Note',
        decision_note_help: 'Optional. What you write stays on the requisition and is read by whoever raised it.',
        reason: 'Reason',
        reason_help: 'Required. "Rejected" with no reason means the same requisition is written again on Monday.',
        orders: 'Purchase orders',
        order_one: 'Purchase order',
        action_submit: 'Submit',
        action_edit: 'Edit',
        action_cancel: 'Withdraw',
        action_approve: 'Approve',
        action_reject: 'Reject',
        action_order: 'Create purchase orders',
        done_submit: 'The requisition has been submitted.',
        done_cancel: 'The requisition has been withdrawn.',
        done_approve: 'The requisition has been approved.',
        done_reject: 'The requisition has been rejected.',
        done_order: '{count} purchase orders have been created.',
        submit_failed: 'The draft is saved, but submitting it failed.',
        budget_exceeded: 'The requisition exceeds the budget',
        errors: {
            not_approved: 'Requisition {number} has not been approved yet — it is with {role} (level {level}, due {due}).',
            required: 'A purchase of this value needs a requisition.',
        },
    },
    materialsForecast: {
        title: 'Demand forecast',
        no_property: 'Choose a property first.',
        lead_title: 'What the house will get through, and when it runs out',
        lead: 'The forecast is built from what this PMS already holds: arrivals, room nights, cleanings, breakfasts and the guaranteed numbers of confirmed events. Every figure says what it is made of. A suggested order is a suggestion — the requisition is written by a person.',

        tab_forecast: 'Forecast',
        tab_profiles: 'Demand profiles',

        window_title: 'Forecast by article',
        window_lead: 'The days of the house above, what those days consume below. Open a row for the daily demand and the explanation.',
        window: 'Window',
        days: '{count} days',
        peak: '(peak {value})',
        drivers_title: 'The days of the house',
        events_title: 'Events in the window',
        guaranteed: 'guaranteed {count}',
        daily_demand: 'Daily demand',

        no_profiles: 'The forecast needs demand profiles — add them on the Profiles tab.',
        to_profiles: 'Open profiles',

        article: 'Article',
        on_hand: 'On hand',
        on_order: 'On order',
        demand: 'Demand in window',
        cover_days: 'Cover (days)',
        stockout_on: 'Runs out',
        suggestion: 'Suggestion',
        tick_all: 'Tick all',
        explain: 'Explanation',
        no_explain: 'The server sent no explanation for this article.',
        lead_safety: 'Lead time {lead} days · safety stock {safety} days · minimum {min}',
        lead_safety_short: 'lead {lead} d · safety {safety} d',

        create_requisition: 'Create requisition',
        requisition_title: 'New requisition from the forecast',
        requisition_lead: 'The quantities are the server\'s suggestion from the same forecast. The requisition takes the usual approval route.',
        requisition_items: 'Articles ({count})',
        needed_on: 'Needed by',
        needed_on_help: 'Defaults to the first day of the window plus the longest lead time among the ticked articles.',
        department: 'Department',
        department_help: 'Who needs the goods. It decides who approves the requisition.',
        cost_centre: 'Cost centre',
        cost_centre_help: 'Which budget the cost is measured against. Without one the budget says nothing about this requisition.',
        no_cost_centre: 'No cost centre',
        nothing_ticked: 'Tick at least one article.',
        requisition_created: 'Requisition {number} has been created.',

        profiles_title: 'Demand profiles',
        profiles_lead: 'One sentence about one article: what consumes it, and how much of it per one of those. Without profiles there is no forecast.',
        profiles_empty: 'No profiles yet.',
        add_profile: 'New profile',
        edit_profile: 'Edit profile',
        confirm_delete: 'Delete the profile for "{name}"?',
        per_unit: '{quantity} / {unit}',

        article_help: 'An article from the stock register. One article may have several profiles.',
        driver: 'Demand driver',
        driver_help: 'The fact about the house the consumption is proportional to.',
        quantity_per_unit: 'Quantity per unit',
        quantity_per_unit_help: 'How much of the article goes per one unit of the driver — two soaps per cleaning, say. Decimals are allowed.',
        quantity_positive: 'The quantity must be greater than zero.',
        lead_days: 'Lead time (days)',
        lead_days_help: 'How many days pass between ordering and receiving for this consumption.',
        safety_days: 'Safety stock (days)',
        safety_days_help: 'How many days of stock should be left on the day the delivery arrives.',
        active_help: 'A profile switched off stays written down but does not count in the forecast.',
        note: 'Note',

        driver_arrival: 'Arrival',
        driver_room_night: 'Room night',
        driver_guest_night: 'Guest night',
        driver_cleaning: 'Cleaning',
        driver_breakfast_cover: 'Breakfast cover',
        driver_event_cover: 'Event cover',
        driver_minibar_history: 'Minibar (history)',
        driver_consumption_history: 'Consumption (history)',
        driver_fixed_daily: 'The same every day',

        driver_arrival_hint: 'Arrivals from the reservations.',
        driver_room_night_hint: 'Occupied rooms per night from the reservations.',
        driver_guest_night_hint: 'People per night from the reservations.',
        driver_cleaning_hint: 'Cleanings from the housekeeping plan.',
        driver_breakfast_cover_hint: 'Breakfasts from Dining.',
        driver_event_cover_hint: 'People from the guaranteed numbers of confirmed event versions.',
        driver_minibar_history_hint: 'The average minibar consumption of the last 28 days, scaled by occupancy.',
        driver_consumption_history_hint: 'The average issue of the article over the last 28 days, scaled by occupancy.',
        driver_fixed_daily_hint: 'The same quantity every day, whatever the occupancy.',

        driver_unit_arrival: 'arrival',
        driver_unit_room_night: 'room night',
        driver_unit_guest_night: 'guest night',
        driver_unit_cleaning: 'cleaning',
        driver_unit_breakfast_cover: 'breakfast',
        driver_unit_event_cover: 'person',
        driver_unit_minibar_history: 'day',
        driver_unit_consumption_history: 'day',
        driver_unit_fixed_daily: 'day',
    },
    materialsKPI: {
        title: 'Materials indicators',
        no_property: 'Choose a property first.',
        lead_title: 'The six figures a store cupboard is run by',
        lead: 'Every amount comes off the movements’ FIFO snapshots, so a closed period answers the same numbers later. Where an indicator has no answer — an empty house has no cost per room-night, a shelf with no consumption has no cover — a dash is drawn rather than a nought.',

        period: 'Period',
        period_hint: 'Both dates are inclusive. Defaults to the last full month: a month in progress answers a cost that is true of eleven days.',
        from: 'From',
        to: 'To',
        show: 'Show',
        export_csv: 'Export CSV',
        table_empty: 'No rows in this period.',
        no_category: 'No category',
        days_count: '{count} days',
        never_issued: 'Never issued',

        card_cost_per_room_night: 'Cost per occupied room-night',
        card_cost_per_room_night_terms: '{consumption} of consumption over {nights} occupied room-nights',
        card_no_room_nights: 'No room-night was sold in this period, so the indicator has no answer.',
        card_cover: 'Days of stock cover',
        card_cover_terms: '{value} of stock at {daily} a day',
        card_no_consumption: 'Nothing was consumed in the last 30 days, so cover cannot be computed.',
        card_dead_stock: 'Dead stock',
        card_dead_stock_terms: '{count} articles with no issue in 90 days · {expiring} batches expire within 30 days ({value})',
        card_write_offs: 'Write-offs and shortages',
        card_write_offs_terms: '{count} movements · {share} of the period’s consumption',
        card_supplier_delays: 'Late deliveries',
        card_supplier_delays_terms: '{average} days late on average · {overdue} open orders past their day',
        card_price_variance: 'Agreed against actual price',
        card_price_variance_terms: '{lines} lines differ out of {priced} lines that had an agreed price',

        by_category: 'Cost by category',
        by_category_hint: 'The top eight categories by consumption value, with each one’s share of the period.',
        category: 'Category',
        consumption: 'Consumption',
        per_room_night: 'Per room-night',
        share: 'Share',

        by_place: 'Cover by store room and category',
        by_place_hint: 'Stock value against the average daily consumption of the last 30 days. Under 3 days is a warning, over 60 days is money standing still.',
        scope: 'Kind',
        scope_place: 'Store room',
        scope_category: 'Category',
        name: 'Name',
        stock_value: 'Stock value',
        daily: 'Daily consumption',
        cover: 'Cover',

        dead_stock: 'Dead stock and expiries',
        dead_stock_hint: 'Articles on the shelf with no issue in 90 days, dearest first. The expiry is the soonest among the live batches.',
        item: 'Article',
        quantity: 'Quantity',
        value: 'Value',
        last_issued: 'Last issued',
        expires: 'Expires',
        movements: 'Movements',

        write_offs: 'Write-offs and shortages',
        write_offs_hint: 'The period’s write-offs, breakages and stocktake shortages at FIFO cost. Stocktake surpluses are deliberately left out — a month that netted them off would report smaller losses than it had.',

        supplier_delays: 'Supplier delays',
        supplier_delays_hint: 'Only receipts whose order carried a promised day can be judged. Open orders past their day are measured against today.',
        supplier: 'Supplier',
        judged: 'Judged',
        late: 'Late',
        average_late: 'Average delay',
        worst_late: 'Worst',
        open_overdue: 'Open past due',

        price_variance: 'Agreed against actual price',
        price_variance_hint: 'For each receipt line of the period: the contract or catalogue price that was true on the day against the booked unit cost. The sign is kept — a negative row is a line the house was undercharged on.',
        document: 'Receipt',
        agreed: 'Agreed',
        booked: 'Booked',
        variance: 'Variance',
        source: 'Price source',
        source_contract: 'Contract',
        source_catalogue: 'Catalogue',
    },

    materialsClose: {
        title: 'Materials monthly close',
        no_property: 'Choose a property first.',
        lead_title: 'A month’s checklist, and the button that shuts it',
        lead: 'The checklist is computed on every read and never stored. What IS stored is the DECISION, with the sheet as it stood at the press. A closed month refuses every posting whose business date falls inside it; reopening asks for a reason and is written into the revision trail.',

        month: 'Month',
        month_hint: 'Defaults to last month: the month somebody closes is the one that has ended.',
        show: 'Refresh',

        stock_value: 'Stock value',
        stock_value_hint: 'The worth of the shelves from the FIFO layers at this read, split by store room. The close stores this figure in its snapshot.',
        place: 'Store room',
        value: 'Value',

        checklist: 'Checklist',
        checklist_hint: 'Each line carries a status, a count and an amount, and links to the screen where it is dealt with. Only lines marked “blocking” stop the close.',
        item: 'Item',
        status: 'Status',
        count: 'Count',
        amount: 'Amount',
        detail: 'Detail',

        status_ok: 'Clear',
        status_warning: 'Warning',
        status_blocking: 'Blocking',

        item_draft_documents: 'Draft papers dated in this month',
        item_uninvoiced_receipts: 'Receipts with no supplier invoice',
        item_open_invoices: 'Supplier invoices not posted',
        item_expected_credit_notes: 'Expected credit notes',
        item_ap_export: 'Hand-off to book-keeping',
        item_count_sessions: 'Stocktakes counted and not posted',
        item_budget_deviation: 'Budget overruns',

        state_open: 'Open',
        state_blocked: 'Blocked',
        state_closed: 'Closed',
        state_reopened: 'Reopened',
        state: 'State',

        blocked_title: 'This month cannot be closed',
        note: 'Note',
        close_month: 'Close the month',
        close_confirm: 'Close {month} at a stock value of {value}? After the close no paper with a business date in this month can be posted.',
        closed_toast: '{month} is closed.',
        closed_title: '{month} is closed',
        closed_lead: 'A posting with a business date in this month is refused. If something still has to go into it, reopen the month in the history below — with a reason.',

        history: 'Close history',
        history_hint: 'A reopened row is stamped and kept rather than deleted: the question a year later is not whether the month is open but who opened it and why.',
        history_empty: 'This property has not closed a month yet.',
        closed_at: 'Closed',
        reopen: 'Reopen',
        reopen_confirm: 'Reopen {month}? Book-keeping already holds this month’s figures.',
        reopen_reason: 'Why is the month being reopened?',
        reopen_needs_reason: 'A month cannot be reopened without a reason.',
        reopened_toast: '{month} is reopened.',
    },

    materialsBudget: {
        title: 'Budgets',
        no_property: 'Choose a property first.',
        lead_title: 'What the house meant to spend, and what it did',
        lead: 'A plan is one figure for one cost centre, one category and one month. Beside it stand what has been booked and what has been promised — an approved requisition and an open purchase order are money spent that is still waiting for its invoice.',

        overview_title: 'The year',
        overview_lead: 'A row is a cost centre and a category, a column is a month. The plan is edited in editing mode and saved in one press.',
        year: 'Year',
        category: 'Category',
        all_categories: 'All categories',
        cost_centre: 'Cost centre',
        cost_centre_help: 'From the cost centre register in Accounting.',
        category_help: 'From the article categories the accounts are mapped by.',
        year_total: 'Year total',
        legend: 'In a cell: the plan, the share used, booked + promised, and what is left. An exceeded budget is red.',

        planned: 'Planned',
        actual: 'Booked',
        committed: 'Promised',
        remaining: 'Remaining',

        empty: 'There is no plan for this year yet.',
        empty_hint: 'Turn on editing and add a row, or copy a plan from another month.',

        edit_plan: 'Edit plan',
        save_plan: 'Save plan',
        saved: 'Rows saved: {count}.',
        add_row: 'Add row',
        add_row_lead: 'The row is added to the screen only. It is written when you save the plan.',

        copy: 'Copy from month',
        copy_title: 'Copy budget',
        copy_lead: 'Takes every row of the source month and writes it into the target month, multiplied by the factor.',
        copy_from: 'From month',
        copy_from_help: 'The month whose plan is copied.',
        copy_to: 'To month',
        copy_to_help: 'The month that receives the plan. Existing rows are overwritten.',
        copy_same_month: 'The source and the target month are the same.',
        copied: 'The budget has been copied.',
        factor: 'Factor (%)',
        factor_help: '100 % is "the same again". 105 % is five per cent more.',
        factor_hint: '{percent} %',
    },
    materialsApprovals: {
        title: 'My approvals',
        lead: 'The requisitions waiting for you. Overdue ones come first — by then the deputy has already been let in.',
        empty: 'Nothing is waiting for you.',
        overdue: 'Overdue',
    },
    materialsApprovalRules: {
        title: 'Approval rules',
        lead: 'From which amount a signature is needed, whose it is and by when.',
        how_title: 'How the rules are read',
        how: 'A requisition matching no rule at all is approved the moment it is submitted. Where several match, the highest level decides — it says how many signatures are needed.',
        add: 'New rule',
        empty: 'No rules. Every requisition is approved the moment it is submitted.',
        threshold: 'Threshold (€)',
        threshold_help: 'The value FROM which the rule applies. Zero means every requisition.',
        category: 'Category',
        category_help: "The article's category. Empty means every category.",
        any_category: 'Every category',
        cost_centre: 'Cost centre',
        cost_centre_help: 'Empty means every cost centre.',
        any_cost_centre: 'Every cost centre',
        level: 'Level',
        level_help: 'Level 1 is the first signature, level 2 the second. A higher level means more signatures, not a different order.',
        level_n: 'Level {level}',
        approver: 'Approver',
        approver_help: 'A role, not a person: whoever holds it may approve. One person being away therefore does not stop the house.',
        deputy: 'Deputy',
        deputy_help: 'The role the server lets in once the deadline passes. Optional — without one the requisition simply keeps waiting.',
        no_deputy: 'No deputy',
        due_hours: 'Deadline (hours)',
        due_hours_help: 'How many hours the approver has before the requisition is handed to the deputy.',
        confirm_delete: 'Delete the rule "{name}"?',
    },
    /**
     * Receiving with tolerances, the quarantine and the decisions about it
     * (docs/MATERIALNO-PREVZEM.md, WP-M3c).
     */
    receiving: {
        title: 'Receiving — quarantine',
        lead: 'The delivery lines that did not match the order, the quality check or the thermometer. The goods are booked and stand in quarantine until somebody decides.',
        empty: 'Nothing is in quarantine.',

        filter_status: 'Status',
        filter_status_help: 'Open rows are the ones nobody has decided yet. That is what is shown by default.',
        filter_all: 'All',

        line_n: 'line {line}',
        figures: 'Ordered {ordered} · received {received} · limit {limit}',
        substituted_for: 'Instead of: {item}',
        measured_temperature: 'Measured: {value} °C',

        kind_quantity: 'Quantity',
        kind_price: 'Price',
        kind_quality: 'Quality',
        kind_temperature: 'Temperature',
        kind_substitution: 'Substitution',

        status_open: 'Open',
        status_accepted: 'Accepted',
        status_returned: 'Returned',
        status_written_off: 'Written off',

        accept: 'Accept',
        return: 'Return to supplier',
        write_off: 'Write off',
        open_return: 'Open the return',

        accepted: 'The goods have been moved onto the shelf.',
        returned: 'The return has been posted.',
        written_off: 'The goods have been written off.',

        confirm_accept: 'Accept out of quarantine',
        confirm_accept_lead: '{item} — {quantity} {unit} will move from quarantine into the receiving room.',
        confirm_return: 'Return to the supplier',
        confirm_return_lead: '{item} — {quantity} {unit} will go back to the supplier on a return document.',
        confirm_write_off: 'Write off out of quarantine',
        confirm_write_off_lead: '{item} — {quantity} {unit} will be written off; the goods leave stock with nothing coming back.',

        return_reason: 'Reason for the return',
        return_reason_help: 'The supplier\'s own report of returns is grouped by this reason.',
        expects_credit_note: 'A credit note is expected',
        decision_note: 'Note',
        decision_note_help: 'What somebody will read beside this row in three months. It is written into the audit trail too.',

        reason_damaged: 'Damaged',
        reason_expired: 'Past its date',
        reason_quality: 'Quality',
        reason_wrong_item: 'Wrong article',
        reason_over_delivery: 'Over-delivered',
        reason_temperature: 'Temperature',
        reason_other: 'Other',

        line_extras: 'Quality, temperature, substitute',
        line_ordered: 'Ordered: {quantity} {unit}',
        line_quantity_off: 'quantity past the limit ({limit})',
        line_price_off: 'price past the limit ({limit})',

        quality: 'Quality',
        quality_help: 'Empty means nobody looked. "Not fit" puts the line into quarantine.',
        quality_unsaid: 'Not said',
        quality_ok: 'Fit',
        quality_not_ok: 'Not fit',

        temperature: 'Temperature (°C)',
        temperature_help: 'What the thermometer said at the door. Empty means nobody measured — and that is not a refusal.',
        storage_min: 'Article: at least {min} °C',
        storage_max: 'Article: at most {max} °C',
        storage_range: 'Article: {min} to {max} °C',

        substitute: 'Substitute',
        substitute_help: 'The supplier sent something else. The line books WHAT CAME, and the row records what was ordered.',
        substituted: 'Substitute',
        no_substitute: 'No substitute',

        banner_title: 'In quarantine: {count} lines',
        banner_lead: 'Receipt {number} is posted, and some of the goods stand in quarantine until somebody decides.',
        banner_open: 'Open the quarantine',

        errors: {
            out_of_tolerance: 'Line {line} ({item}): ordered {ordered}, received {received}, the limit is {limit}.',
            out_of_tolerance_more: 'Line {line} ({item}): ordered {ordered}, received {received}, the limit is {limit}. There are {more} more such lines.',
            out_of_tolerance_plain: 'The delivery is outside this house\'s tolerances. Post without the strict check to have the line quarantined instead.',
        },
    },

    /** Returns to the supplier (docs/MATERIALNO-PREVZEM.md §6). */
    stockReturn: {
        title: 'Returns to the supplier',
        title_one: 'Return',
        lead: 'Documents with their own number series (VR) and a reverse movement out of the room.',
        empty: 'There are no returns.',
        back: 'Back to returns',
        not_found: 'The return could not be found.',

        filter_status: 'Status',
        filter_status_help: 'A draft has moved nothing; a posted return has left the room.',
        filter_all: 'All',

        status_draft: 'Draft',
        status_posted: 'Posted',
        status_cancelled: 'Cancelled',

        against_receipt: 'Against receipt {number}',
        lines_n: '{count} lines',
        awaiting_credit_note: 'Awaiting a credit note',
        awaiting_credit_note_help: 'The house expects a credit note from the supplier. Booking it among the supplier invoices points it at this return.',

        supplier: 'Supplier',
        receipt: 'Receipt',
        status: 'Status',
        total: 'Value',

        line_item: 'Article',
        line_quantity: 'Quantity',
        line_unit_cost: 'Purchase price',
        line_lot: 'Lot',
        line_reason: 'Reason',

        post: 'Post',
        cancel: 'Cancel',
        posted_toast: 'The return is posted and the goods have left the room.',
        cancelled_toast: 'The draft return has been cancelled.',
    },

    materialsInvoice: {
        title: 'Supplier invoices',
        lead: 'A supplier invoice is a document of its own: one invoice may cover several deliveries, and a credit note is its own kind. The three-way match holds it against the order and the delivery; posting carries its prices onto the shelves.',
        detail_lead: 'What the paper says, what arrived, and what was ordered.',
        empty: 'No supplier documents.',
        not_found: 'No such document.',
        no_number: 'No number',
        number: 'Document number',
        supplier: 'Supplier',
        status: 'Status',
        issued_on: 'Invoice date',
        due_on: 'Due date',
        stated_gross: 'Stated gross',
        derived_gross: 'Derived gross',
        exchange_rate: 'Exchange rate',
        credit_note_of: 'Credit note of',
        open_source: 'Open the source invoice',
        receipts_n: '{count} deliveries',
        heading_invoice: 'Supplier invoice {number}',
        heading_credit_note: 'Credit note {number}',
        filter_status: 'Status',
        filter_status_help: 'A draft is a typed paper, matched is a checked one, posted means the money has reached the shelves.',
        filter_supplier: 'Supplier',
        filter_all: 'All',
        status_draft: 'Draft',
        status_matched: 'Matched',
        status_posted: 'Posted',
        status_cancelled: 'Cancelled',
        intercompany: 'Intercompany',
        match_title: 'Three-way match',
        match_lead: 'Ordered ↔ received ↔ invoiced, by article. The colour says whether the difference is inside the house tolerances.',
        match_exact: 'Agrees',
        match_within_tolerance: 'Within tolerance',
        match_unmatched: 'Does not agree',
        article: 'Article',
        ordered: 'Ordered',
        received: 'Received',
        invoiced: 'Invoiced',
        variance: 'Variance',
        verdict: 'Verdict',
        tolerance_quantity: 'quantity',
        tolerance_price: 'price',
        tolerance_amount: 'amount',
        fault_quantity: 'Quantity: {expected} arrived, {actual} invoiced (variance {variance}, limit {limit}).',
        fault_price: 'Price: {expected} agreed, {actual} invoiced (variance {variance}, limit {limit}).',
        fault_amount: 'Amount: delivery {expected}, invoice {actual} (variance {variance}, limit {limit}).',
        action_match: 'Match',
        action_post: 'Post',
        action_credit_note: 'Credit note',
        action_cancel: 'Cancel document',
        matched: 'The match is recorded.',
        posted: 'The document is posted.',
        credited: 'The credit note is raised.',
        original_title: 'Original',
        original_lead: "The supplier's paper as it arrived. Kept for 10 years in its original form; the hash proves the file has not been altered.",
        original_drop: 'Drag a file here, or choose one.',
        original_choose: 'Upload original',
        original_none: 'PDF, image or e-SLOG XML. It can be uploaded after posting too — the paper often follows the goods.',
        original_file: 'File',
        original_unnamed: 'Unnamed',
        original_size: 'Size',
        original_archived_at: 'Archived',
        original_sha256: 'Hash (SHA-256)',
        original_open: 'Open original',
        original_kept: 'The original has been stored and archived.',
        original_failed: 'The invoice was entered but its original could not be stored. Upload it on the invoice screen.',
        credit_note_title: 'New credit note',
        credit_note_rule: 'The source invoice is never changed. A credit note is a new document with negative lines, and its cost of sales falls on the CREDIT NOTE DATE.',
        credit_number_help: 'The number on the supplier credit note. It may be the same as the invoice — a credit note has an index of its own.',
        credit_issued_help: 'This day carries the cost of sales. The period of the delivery may be closed for tax, so posting back into it is not possible.',
        credit_lines: 'Lines',
        credit_quantity: 'Credited',
        credit_quantity_help: 'At most {max} — that is how many were invoiced.',
        credit_no_lines: 'Enter at least one quantity.',
        credit_quantity_over: '{item}: at most {max} — that is how many were invoiced.',
        delivered_on: 'Delivery date',
        currency: 'Currency',
        exchange_rate_on: 'Rate date',
        exchange_rate_source: 'Rate source',
        create_title: 'New supplier invoice',
        create_lead: 'Enter the supplier’s paper. Tick the receipts it covers and correct whatever the invoice says differently.',
        create_action: 'New supplier invoice',
        created: 'The invoice has been entered.',
        create_supplier_help: 'Once a supplier is chosen, their posted receipts that no invoice covers yet are offered below.',
        create_number_help: 'The number on the supplier’s invoice. It may be empty — a paper without one carries no duplicate key.',
        create_issued_help: 'The day the invoice carries. The due date is proposed from it.',
        create_delivered_help: 'When the goods arrived. Ticking receipts proposes the latest of them.',
        create_due_help: 'Proposed as 30 days from the invoice date. The supplier record carries no payment terms, so this is a proposal and not a rule.',
        create_currency_help: 'Empty means the house currency ({currency}). Three letters, e.g. CHF.',
        create_rate_help: 'How much {currency} one unit of the invoice’s currency buys. A rate of zero converts nothing — the match would hold two currencies against each other and call the difference a variance.',
        create_rate_on_help: 'The day the rate stood on.',
        create_rate_source_help: 'Where the rate came from — the ECB or the Bank of Slovenia, say.',
        create_receipts: 'Receipts this invoice covers',
        create_receipts_help: 'One invoice may cover several deliveries. Only this supplier’s posted receipts that no invoice covers yet are offered — a draft has no goods on the shelf for the invoice to be matched against.',
        create_receipts_pick_supplier: 'Choose a supplier first.',
        create_receipts_empty: 'This supplier has no uncovered posted receipts.',
        create_receipt_lines_n: '{count} lines',
        create_lines: 'Invoice lines',
        create_no_lines: 'An invoice must carry at least one line.',
        create_line_no_item: 'Every line must name an article.',
        create_line_no_quantity: '{item}: the quantity cannot be 0.',
        create_line_vat: '{item}: the VAT rate must be between 0 and 100.',
        create_quantity: 'Quantity',
        create_unit_price: 'Unit price',
        create_vat: 'VAT %',
        create_add_line: 'Add a line',
        create_vat_bases: 'VAT recapitulation',
        create_vat_bases_help: 'As printed on the paper, one row per rate. The proposal from the lines is only a starting point — the supplier’s arithmetic is what an auditor holds the paper up against.',
        create_base_net: 'Base',
        create_base_tax: 'VAT',
        create_bases_from_lines: 'Derive from the lines',
        create_stated_net: 'Stated net',
        create_stated_net_help: 'The net as printed on the paper. Kept beside the derived figure, never instead of it.',
        create_stated_gross_help: 'The gross as printed on the paper. A disagreement with the lines shows here; the server only refuses it at posting (code 105), not on entry.',
        create_difference: 'Difference to the lines',
        create_unbalanced: 'The stated gross does not agree with the lines. The draft still saves — check the lines or add a line for carriage or a discount, or the posting will not go through.',
        create_currency_length: 'A currency is three letters.',
        read_xml: 'Read from an e-invoice (XML)',
        read_xml_action: 'Upload a file',
        read_xml_help: 'e-SLOG or UBL XML is read as the supplier’s own arithmetic; a photograph or a PDF is read by the model. Nothing is written — every field below stays yours.',
        read_reviewed: 'Everything read is a proposal; check it against the paper.',
        read_source_eslog: 'Read from e-SLOG XML',
        read_source_ubl: 'Read from UBL XML',
        read_source_ai: 'Read from a picture by the model',
        read_duplicate: 'This supplier’s invoice number is already booked on document {document}. Going on would pay for the same goods twice.',
        read_failed: 'The document could not be read.',
        read_done: 'The document has been read. Check the fields against the paper.',
        errors: {
            out_of_tolerance: 'Line {line} ({item}): {kind} is off by {variance}, the limit is {limit}.',
            out_of_tolerance_more: 'Line {line} ({item}): {kind} is off by {variance}, the limit is {limit}. {more} more lines like it.',
            out_of_tolerance_plain: 'The invoice does not match the delivery within this house tolerances.',
            already_matched: 'This document has already been matched.',
            not_balanced: 'The paper says {stated} and its lines come to {derived}. Check the lines, or add a line for carriage or a discount.',
        },
    },
    retail: {
        uncovered_title: 'The shelf does not cover this sale',
        uncovered_hint: 'A manager with retail management rights may allow it. The reason is kept with the receipt for good, and the shortfall waits in the list until the next delivery prices it.',
        uncovered_reason: 'Reason',
        uncovered_placeholder: 'e.g. the delivery note is not booked yet',
        uncovered_confirm: 'Allow and sell',
        done_room_title: 'Charged to the room',
        done_room_hint: 'There is no receipt for this sale — the guest settles it on the hotel bill at departure, which is where it is fiscalised. There is nothing to print.',
        done_print_blocked: 'The browser blocked the new window — allow popups for this site and print the copy from the invoice list.',
        done_print_failed: 'Receipt {number} could not be loaded for printing. The sale is complete; try again, or print a copy from the list.',
        page_hint: 'Selling over the counter. Every till is bound to its own store room — what it sells comes out of that room.',
        tills: 'Tills',
        till: 'Till',
        select_till: 'Choose a till',
        no_tills: 'No tills yet. Open the first one and give it a store room.',
        load_failed: 'The counter could not be read.',
        manage_tills: 'Manage tills',
        needs_sell: 'You have no permission for the till',
        needs_sell_hint: 'Signing in at a till, opening a shift and selling over the counter need the Retail (sell) permission. Ask your manager to grant it.',
        needs_price_right: 'This article has no price yet. Somebody with the Stock (registers) permission can set it.',
        needs_manage_tills: 'Setting up tills needs the Retail (manage) permission.',
        needs_manage_shifts: 'Reading the shift history needs the Retail (manage) permission.',
        add_till: 'New till',
        edit_till: 'Edit till',
        till_name: 'Till name',
        till_place: 'Store room',
        new_place: 'Add store room',
        till_place_hint: 'The till takes its stock out of this room. Two tills may point at the same one.',
        assortment: 'What this till sells',
        assortment_hint: 'Tick the categories this till sells. Nothing ticked means every category.',
        assortment_all: 'Every category',
        assortment_all_hint: 'Nothing ticked: the till shows whatever is in stock in its own store room — articles with no category included.',
        assortment_no_categories: 'No article carries a category yet, so there is nothing to tick. The till sells whatever is in stock in its own store room.',
        assortment_uncategorised: '{count} articles with no category will not be shown',
        assortment_uncategorised_hint: 'A till that ticks categories sells only those. Articles filed under nothing drop off this counter — give them a category, or leave the selection empty.',
        till_inactive: 'This till is closed.',
        articles: 'Articles',
        set_price: 'Set a price',
        less: 'Fewer',
        more: 'More',
        locked: 'The till is locked',
        locked_hint: 'Choose a till and enter your PIN.',
        locked_out: 'The till locked itself. Enter your PIN again.',
        enter_pin: 'Enter PIN',
        pin_wrong: 'Wrong PIN, or this till is not yours. Check the till chosen above.',
        category_all: 'All',
        category_none: 'Other',
        pin_too_many: 'Too many attempts. Wait a moment.',
        pin_unavailable: 'The till cannot be reached just now ({reason}). Your PIN is still in the field — try again.',
        pin_backspace: 'Delete',
        sign_in: 'Sign in',
        lock_hint: 'Lock the till / change seller',
        no_price: 'No price',
        no_price_hint: 'This article has no price — set one on its card in Stock.',
        no_articles: 'No article carries a price. Prices are set on the article in Stock.',
        search: 'Search',
        in_stock: 'In stock: {count}',
        basket: 'Basket',
        basket_empty: 'The basket is empty. Tap an article.',
        remove: 'Remove',
        total: 'To pay',
        payment: 'Payment',
        payment_room: 'Room',
        room: "Guest's room",
        pick_room: 'Choose a room',
        find_room: 'Room number or guest name',
        no_room_found: 'No room or guest by that name.',
        no_rooms_in_house: 'Nobody is checked in.',
        payment_cash: 'Cash',
        payment_card: 'Card',
        confirm: 'Complete sale',
        sold: 'Sold · {number} · {total}',
        // Shift
        shift_none:             'No shift is open',
        shift_none_hint:        'The till cannot sell until a shift is open. Enter what is in the drawer.',
        shift_float:            'Opening float',
        shift_float_hint:       'What is in the drawer before the first sale. Zero is fine.',
        shift_open:             'Open shift',
        shift_drawer:           'Drawer',
        shift_opened_by:        'Opened by {name}',
        shift_expected:         'Expected',
        shift_pay_in:           'Pay in',
        shift_pay_out:          'Pay out',
        shift_pay_ins:          'Pay-ins',
        shift_pay_outs:         'Pay-outs',
        shift_cash_refunds:     'Cash refunds',
        shift_card_refunds:     'Card refunds',
        shift_amount:           'Amount',
        shift_reason:           'Reason',
        shift_reason_hint:      'Required. It appears on the close-out.',
        shift_movements:        'Pay-ins and pay-outs',
        shift_close:            'Close shift',
        shift_close_title:      'Count the drawer',
        shift_counted:          'Counted',
        shift_counted_hint:     'What is actually in the drawer.',
        shift_short:            'Short',
        shift_over:             'Over',
        shift_variance_reason:  'Reason for the difference',
        shift_variance_hint:    'Required. It is recorded — nothing is adjusted to make it balance.',
        shift_close_confirm:    'Close',
        shift_closed_title:     'Shift closed',
        shift_print:            'Print close-out',
        shift_unreferenced:     'Cards without a reference: {count}',
        shift_unreferenced_print: 'Approved without a reference',
        shift_pending:          'Awaiting terminal: {count}',
        shift_pending_hint:     'These are not money yet. Finish or abandon them.',
        shift_counts:           'Sales: {sales} · Returns: {returns}',
        // Closing screen
        done_title:            'Sale complete',
        done_print:            'Print receipt',
        done_next:             'New sale',
        done_copy:             'Copy',
        done_copy_hint:        'Prints a copy marked KOPIJA with its own sequential number, as FURS requires.',
        done_copy_made:        'Copy printed.',
        done_copy_unavailable: 'A copy of this invoice cannot be issued — it was issued before the system kept the original record.',
        // Card — waiting on the terminal
        card_waiting:           'Waiting for the terminal',
        card_waiting_hint:      'The receipt is issued only once the terminal approves. Until then the sale holds nothing.',
        card_auth_code:         'Approval code',
        card_auth_code_hint:    'From the terminal. Required.',
        card_transaction:       'Transaction reference',
        card_transaction_hint:  'Optional — only if the slip shows one.',
        card_no_reference:      'The terminal approved but I cannot read the code',
        card_have_code:         'I have the approval code',
        card_no_reference_title: 'Approved without a reference',
        card_no_reference_hint: 'Only use this if the terminal REALLY approved the payment. It appears on the day\'s settlement and somebody will check it.',
        card_reason:            'Reason',
        card_reason_placeholder: 'e.g. the slip did not print',
        card_confirm:           'Confirm payment',
        card_abandon:           'Abandon sale',
        card_pending:           'Awaiting terminal',
        card_abandoned:         'Abandoned',
        card_finish:            'Finish',

        // Returns
        return_action:     'Return',
        return_title:      'Return · {number}',
        return_credits:    'A credit note will be issued against invoice {number}.',
        return_sold:       'sold {count}',
        return_already:    'already returned {count}',
        return_less:       'Less',
        return_more:       'More',
        return_nothing_left: 'Everything on this receipt has already come back.',
        return_refund:     'Refund',
        return_reason:     'Reason',
        return_reason_hint: 'Optional. It goes on the credit note.',
        return_total:      'To refund',
        return_confirm:    'Confirm return',
        return_room_sale:  'A sale charged to a room cannot be returned here — the money would have to go back onto the stay.',
        return_needs_approval: 'This refund is over the hotel limit. A manager signed in to the portal can approve it.',
        returned:          'Returned · {number} · {total}',
        todays_returns:    "Today's returns",
        day_refunded:      'Refunded today',
        todays_sales: "Today's sales",
        no_sales: 'No sales today yet.',
        day_total: 'Total today',
        fiscal_now: 'A tax-certified invoice is issued when the sale is completed.',
        fiscal_room: "It goes on the guest's card and is certified on the hotel invoice at departure.",
        buyer_name: 'Customer (optional)',
        buyer_name_hint: 'If the customer wants a name on the receipt.',
        fiscal_note: 'Version 1 issues an internal MP document; fiscal certification of the receipt is not switched on yet.',
    },
    chainItem: {
        title: 'Codebook',
        lead: "The chain's shared codebook of articles. Each house links its own article to a codebook row — from then on the match is stored rather than computed from a name.",
        add: 'New chain article',
        edit: 'Edit chain article',
        empty: 'The chain has no codebook yet.',
        search: 'Search by code or name',

        code: 'Chain code',
        code_hint: 'The code the chain uses for this article — e.g. "KAVA-1KG". Unique within the chain; always upper case.',
        name: 'Name',
        unit: 'Unit',
        unit_hint: 'What one of it is — "piece", "l", "kg". Free text, as on the house article.',
        decimals: 'Decimals',
        decimals_hint: 'How finely the chain counts this article. It means what it means on a house article: the quantity stays an integer in 10^n of the unit.',
        decimals_locked: 'The scale can no longer be changed — {count} houses are linked. It is changed by rescaling each house separately.',
        decimals_n: 'decimals: {count}',
        category: 'Category',
        tax_rate: 'Tax rate',
        tax_rate_hint: 'The rate the article carries in every member house. Saving writes it onto every linked house article.',
        net_content: 'Net content',
        net_content_hint: 'What is inside one unit — 500 g, 700 ml. Whole units of the smallest measure.',
        net_content_unit: 'Content unit',
        barcodes: 'Barcodes',
        barcodes_hint: 'The codes the chain knows the article by. Adoption matches on these FIRST — a code printed on the packaging is the only match that is not a guess.',
        barcodes_n: 'codes: {count}',
        active_hint: 'An inactive row stays recorded and stays linked; adoption simply no longer offers it.',

        houses: 'Houses',
        houses_n: 'houses: {count}',
        houses_empty: 'The chain has no properties.',
        not_adopted: 'Not adopted',

        range: 'Showing {from}–{to} of {total}',
        capped: 'The list is capped — narrow the search.',

        saved: 'Saved.',
        saved_propagated: 'Saved. The correction was carried to {count} linked house articles.',
        deleted: 'Deleted.',
        confirm_delete: 'Really delete {code} — {name}? If the chain no longer buys it, deactivate it instead: the row, the links and the history all stay.',

        filter_all: 'All rows',
        filter_active: 'Active only',
        filter_inactive: 'Inactive only',

        adoption: 'Adoption',
        adoption_lead: 'Which of the chain articles are already ours and which are not. A person confirms every link — automatic matching by name is deliberately absent.',
        unmatched: 'Not adopted yet',
        unmatched_empty: 'Every active chain article is adopted.',
        linked: 'Already linked',
        linked_empty: 'This house has not adopted any chain article yet.',
        our_article: 'Our article',
        no_link: '— do not link —',
        no_candidate: 'No suggestion — you can create the article here.',
        create_here: 'Create here',
        link_selected: 'Link selected',
        selected_n: 'selected: {count}',
        candidate_scale: '{name} (counts to {decimals} decimals — not possible)',
        adopted_n: 'Linked: {count}.',
        unlink: 'Unlink',
        unlinked: 'Unlinked.',
        confirm_unlink: 'Really unlink our article from {code} — {name}? The article keeps all its stock and history; it only loses the chain identity.',

        match_barcode: 'Found by barcode.',
        match_sku: 'Found by code.',
        match_name: 'Found by name — check before confirming.',
    },
    chain: {
        nav: 'Chains',
        title: 'Chain',
        settings_lead: 'A chain is a group of properties that buy as one house: shared catalogue prices, shared contracts and pooled enquiries. A property belongs to exactly one chain.',
        no_permission: 'You do not have access to this screen.',
        no_permission_hint: 'Chains are edited by an account holding “chains:manage”. Who is in the chain is shown on Procurement and stock → Chain → Chain tab.',
        no_property: 'Select a property first.',
        not_in_chain: 'This property is not in any chain',
        not_in_chain_hint: 'An administrator builds the chain in Settings (the gear) → Integrations and communication → Chains. Until the property is in one there is no central catalogue, no pooled demand and no transfers.',
        lead: 'Shared prices, shared contracts and the demand every house of the chain adds up to. Members are read-only — the chain itself is edited in settings.',

        chains: 'Chains',
        chains_hint: 'Each chain has its properties and two switches: central catalogue and pooled procurement.',
        empty: 'No chains yet.',
        add: 'New chain',
        edit: 'Edit chain',
        saved: 'Saved.',
        members_n: 'properties: {count}',
        houses_n: 'properties: {count}',
        no_members: 'No properties.',
        members_read_only: 'The properties of the chain. The list is edited in Settings (the gear) → Integrations and communication → Chains.',
        this_property: 'this property',

        name: 'Name',
        name_hint: 'The chain’s name as the house uses it — e.g. “Portorož Group”.',
        members: 'Members',
        members_hint: 'The properties that buy together.',
        members_help: 'At least two; a property belongs to exactly one chain.',
        two_members: 'A chain needs at least two properties.',
        central_catalogue: 'Central catalogue',
        central_catalogue_hint: 'The chain’s prices and contracts apply to every member. A property keeps its own catalogue — offers say which is which.',
        pooled_procurement: 'Pooled procurement',
        pooled_procurement_hint: 'Requisitions from several properties may be gathered into one request for quotation.',

        catalogue: 'Chain catalogue',
        catalogue_hint: 'Prices that apply to every property of the chain. The supplier is identified by TAX NUMBER rather than by one property’s register — the same wholesaler is a different card at each member.',
        catalogue_empty: 'No chain catalogue yet.',
        add_entry: 'New catalogue row',
        edit_entry: 'Edit catalogue row',
        tax_number: 'Tax number',
        tax_number_hint: 'Every property of the chain finds the same supplier by it. Where a member has no card for them, the offer says so.',
        supplier_name: 'Supplier',
        supplier_name_hint: 'The name a person reads. The tax number is what links them.',
        item: 'Article',
        item_hint: 'This property’s article. The server folds the members together by its own key.',
        sku: 'Supplier code',
        sku_hint: 'The code that goes on the order — never the house’s own SKU.',
        price: 'Price',
        price_hint: 'The net price of ONE article unit, not of one pack.',
        currency: 'Currency',
        pack_unit: 'Pack unit',
        pack_unit_hint: 'The supplier’s own word for the box — “carton”, “pallet”.',
        quantity_per_pack: 'Per pack',
        quantity_per_pack_hint: 'How many article units are in one pack. Zero means sold singly.',
        moq: 'Minimum order',
        moq_hint: 'The smallest quantity the supplier accepts.',
        lead_days: 'Lead time (days)',
        lead_days_hint: 'Days from order to delivery.',
        price_from: 'Price from',
        price_to: 'Price to',
        price_to_hint: 'The last day the price is valid. Empty means no end has been named.',
        active_hint: 'An inactive row stays on file but is not offered on an order.',
        per_pack: '{quantity} / {unit}',
        pack: 'pack',
        expired: 'Expired',
        not_started: 'Not yet valid',
        validity_open: 'valid with no end',
        validity_from: 'valid from {from}',
        validity_to: 'valid to {to}',
        validity_range: 'valid {from} – {to}',
        window_backwards: 'A price cannot end before it begins.',

        contracts: 'Chain contracts',
        contracts_hint: 'Agreed prices for a period, valid at every property of the chain. A draft is still edited; activation writes its prices into the chain catalogue.',
        contracts_empty: 'No chain contracts yet.',
        add_contract: 'New contract',
        edit_contract: 'Edit contract',
        view_contract: 'Contract',
        contract_number: 'Contract number',
        contract_number_hint: 'As written on the paper both sides signed.',
        contract_currency_hint: 'One currency for the whole contract — lines in two of them are a total nothing can add up.',
        valid_from: 'Valid from',
        valid_to: 'Valid to',
        valid_to_hint: 'The last day of validity. Empty means no end was agreed.',
        lines: 'Lines',
        add_line: 'Add line',
        lines_empty: 'The contract has no lines yet.',
        lines_n: 'lines: {count}',
        lines_required: 'A contract with no lines writes no price at all.',
        line_twice: 'The same article is on the contract twice.',
        read_only: 'This contract can no longer be edited',
        read_only_hint: 'An activated or cancelled contract is read-only. The prices it wrote stay in the chain catalogue.',
        activate: 'Activate',
        activated: 'Activated. Prices written: {count}.',
        confirm_activate: 'Activate contract {number}? The prices are written into the catalogue of EVERY property of the chain.',
        cancel_contract: 'Cancel contract',
        confirm_cancel: 'Cancel contract {number}? The prices it wrote stay in the catalogue, with their own validity.',
        cancelled: 'Cancelled.',
        status_draft: 'Draft',
        status_active: 'Active',
        status_expired: 'Expired',
        status_cancelled: 'Cancelled',

        demand: 'Pooled demand',
        demand_hint: 'What the properties of the chain need together, added up per article. Under each row: whose quantity it is and which requisition it comes from.',
        demand_empty: 'No open pooled demand.',
        pooling_off: 'Pooled procurement is switched off',
        pooling_off_hint: 'The demand is shown, but the server may refuse a pooled enquiry. The switch is in Settings (the gear) → Integrations and communication → Chains.',
        rfq_suppliers: 'This property’s suppliers',
        rfq_suppliers_hint: 'From this property’s own register.',
        rfq_chain_suppliers: 'Chain suppliers',
        rfq_chain_suppliers_hint: 'From the chain catalogue, by tax number — including firms this property has no card for.',
        rfq_due_on: 'Answer by',
        rfq_due_on_hint: 'When the suppliers should answer by.',
        create_pooled_rfq: 'Create pooled enquiry',
        selected_n: 'selected rows: {count}',
        nothing_selected: 'Select at least one row.',
        pooled_rfq_created: 'The pooled enquiry has been created.',
    },
    materialsTransfer: {
        title: 'Transfers',
        lead: 'Goods moving from one house to another inside the chain. A draft is still edited; sending takes the stock off the shelf and receiving puts it on another.',
        detail_lead: 'What is on the transfer, what it is worth and what has happened to it.',
        heading: 'Transfer {number}',
        not_found: 'The transfer cannot be found.',
        add: 'New transfer',
        created: 'The draft transfer has been created.',
        empty: 'No transfers.',

        outgoing: 'Outgoing',
        incoming: 'Incoming',
        filter_all: 'All',
        filter_status: 'Status',
        filter_status_help: 'Empty means every status.',

        lines: 'Lines',
        lines_n: 'lines: {count}',
        lines_empty: 'The transfer has no lines yet.',
        lines_required: 'A transfer with no lines moves nothing.',
        add_line: 'Add line',
        article: 'Article',
        quantity: 'Quantity',
        lot: 'Lot',
        lot_hint: 'The batch, where the house keeps them. Empty is ordinary.',
        unit_cost: 'Unit cost',
        line_total: 'Total',
        mapped_to: 'Receiver’s article',
        unmapped: 'not mapped',
        unmapped_n: 'not mapped: {count}',

        to_property: 'Receiving property',
        to_property_hint: 'A property of the same chain. A transfer outside the chain is refused by the server.',
        from_place: 'From place',
        from_place_hint: 'Which shelf the goods leave from.',
        to_place: 'To place',
        to_place_hint: 'Where the goods arrive. Not necessarily the store the house buys into.',
        no_members: 'The chain has no other property',
        no_members_hint: 'A transfer only goes to another property of the same chain. Members are edited by an administrator in Settings (the gear) → Integrations and communication → Chains.',

        other_currency: 'The two properties keep different currencies',
        other_currency_hint: 'Switch on where the sender keeps a different currency than this property. Where the register of properties knows both, the rate appears by itself.',
        exchange_rate: 'Exchange rate',
        exchange_rate_hint: 'How many units of this property’s currency one unit of the sender’s is.',

        unmapped_first: 'Some lines are not mapped yet',
        unmapped_first_hint: 'Lines with no receiver’s article: {count}. Goods that land on no article arrive and are counted nowhere.',
        mapping_lead: 'Which of this property’s articles each line is',
        mapping_lead_hint: 'Each house keeps its own register, so the sender’s article means nothing on this shelf until somebody gives it a name.',
        mapping_required: 'Choose at least one article.',

        cancel_reason: 'Reason',
        cancel_reason_hint: 'Why the transfer is not happening. The reason is stored on the document — both houses read it.',

        action_send: 'Send',
        action_receive: 'Receive',
        action_mapping: 'Map articles',
        action_cancel: 'Cancel',
        done_send: 'Sent.',
        done_receive: 'Received.',
        done_mapping: 'Mapped.',
        done_cancel: 'Cancelled.',

        timeline: 'Timeline',
        timeline_empty: 'Nothing has happened yet.',
        sent: 'Sent',
        received: 'Received',
        cancelled: 'Cancelled',
        sent_at: 'sent',
        received_at: 'received',
        by: 'by: {who}',

        status_draft: 'Draft',
        status_sent: 'Sent',
        status_received: 'Received',
        status_cancelled: 'Cancelled',

        intercompany_invoice: 'Intercompany invoice',
        intercompany_draft: 'draft',
        intercompany_issued: 'issued',
        intercompany_missing: 'missing',
        intercompany_cancelled: 'cancelled',

        errors: {
            outside_chain: 'A transfer is only possible between properties of the same chain.',
        },
    },
    stay_request: {
        title: 'Guest requests',
        answered_title: 'Answered in the last 7 days',
        no_guest: 'Guest',
        rooms: 'room {rooms}',
        departure: 'departs {date}',
        kind_late_checkout: 'Late check-out',
        kind_extension: 'Extension by {count} night | Extension by {count} nights',
        source_assistant: 'Milo',
        source_portal: 'Guest portal',
        no_quote: 'The extension could not be priced.',
        quote_room: 'Room {room} → until {date}',
        not_available: 'not available',
        check_price: 'check the price',
        hour: 'Until what time',
        no_hour: 'No time',
        answer_placeholder: 'Reply to the guest (optional)',
        confirm: 'Confirm',
        confirm_extension: 'Confirm extension',
        decline: 'Decline',
        confirm_extension_question: 'Extend the stay until {date} for a total of +{amount}?',
        confirmed: 'Request confirmed',
        declined: 'Request declined',
        decide_failed: 'The answer to the request could not be saved.',
        status_pending: 'waiting',
        status_confirmed: 'confirmed',
        status_declined: 'declined',
    },
    today: {
        title: 'Today',
        lead: 'What is happening in the house today, and what waits for you.',

        greeting_morning: 'Good morning',
        greeting_day: 'Good afternoon',
        greeting_evening: 'Good evening',
        greeting_morning_named: 'Good morning, {name}',
        greeting_day_named: 'Good afternoon, {name}',
        greeting_evening_named: 'Good evening, {name}',

        no_sections: 'This account has not been given a screen this page can speak about. Permissions are set by the house administrator.',
        open_settings: 'Open settings',
        open_reception: 'Open Reception',
        open_housekeeping: 'Open Housekeeping',
        open_maintenance: 'Open Maintenance',
        open_events: 'Open Events',
        open_dining: 'Open Dining',
        open_materials: 'Open Materials',
        open_staff: 'Open Staff',
        open_crm: 'Open CRM',
        open_registrations: 'Open AJPES reporting',
        section_quiet: 'Nothing waiting.',
        section_failed: 'This cannot be read at the moment.',
        all_clear: 'All clear',
        attention_title: 'Needs attention today',
        attention_waiting: '1 waiting | {count} waiting',
        no_room: 'no room',

        section_reception: 'Reception',
        section_registrations: 'AJPES reporting',
        section_housekeeping: 'Housekeeping',
        section_maintenance: 'Maintenance',
        section_events: 'Events',
        section_dining: 'Dining',
        section_materials: 'Materials',
        section_staff: 'Staff',
        section_crm: 'CRM',

        count_arrivals: 'Arrivals',
        count_arrivals_unassigned: 'No room',
        count_departures: 'Departures',
        count_in_house: 'In house',
        count_occupancy_pct: 'Occupancy',
        count_unconfirmed: 'Unconfirmed',
        count_reminders_due: 'Reminders',
        count_unregistered: 'Unfiled',
        count_departures_due: 'Departures',
        count_failed: 'Refused',
        count_pending: 'Queued',
        count_dirty: 'To make up',
        count_priority: 'Priority',
        count_clean: 'Clean',
        count_inspected: 'Inspected',
        count_lost_items_open: 'Lost items',
        count_open: 'Open',
        count_urgent: 'Urgent',
        count_today: 'Today',
        count_next_7_days: 'Next 7 days',
        count_covers_today: 'Covers today',
        count_approvals_pending: 'To approve',
        count_receiving_today: 'Deliveries today',
        count_orders_open: 'Open orders',
        count_below_minimum: 'Below minimum',
        count_invoices_unmatched: 'Unmatched invoices',
        count_on_shift_today: 'On shift',
        count_absent_today: 'Absent',
        count_pending_requests: 'Awaiting decision',
        count_tasks_due: 'Tasks due',
        count_opportunities_open: 'Open opportunities',

        sub_arrivals_unassigned: 'arriving with no room assigned',
        sub_priority: 'arriving today, room not ready',
        sub_unregistered: 'in the house and not filed',
        sub_departures_due: 'departure not reported yet',

        status_draft: 'draft',
        status_confirmed: 'confirmed',
        status_checked_in: 'checked in',
        status_checked_out: 'checked out',
        status_cancelled: 'cancelled',
        status_no_show: 'no show',
        status_clean: 'clean',
        status_dirty: 'dirty',
        status_inspected: 'inspected',
        status_occupied: 'occupied',
        status_out_of_order: 'out of order',
        status_out_of_service: 'out of service',
        status_blocking: 'blocking',
        status_normal: 'normal',
        status_cosmetic: 'cosmetic',
        status_inquiry: 'inquiry',
        status_option: 'option',
        status_in_progress: 'in progress',
        status_completed: 'completed',
        status_lost: 'lost',
        status_sent: 'sent',
        status_absence_request: 'leave',
        status_time_correction: 'time correction',
        status_shift_change: 'shift change',
    },
    nav: {
        today: 'Today',
        events: 'Events',
        collapse_menu: 'Collapse menu',
        expand_menu: 'Expand menu',
        marketing: 'Marketing',
        groups: 'Groups',
        offers: 'Offers',
        stock: 'Stock',
        retail: 'Till',
        suppliers: 'Suppliers',
        materials_accounting: 'Accounting',
        materials_forecast: 'Demand forecast',
        materials_budgets: 'Budgets',
        materials_kpi: 'Indicators',
        materials_period_close: 'Monthly close',
        sales_group: 'Sales',
        materials_catalogue: 'Catalogue and contracts',
        materials_invoices: 'Supplier invoices',
        materials_orders: 'Purchase orders',
        materials_rfqs: 'Requests for quotation',
        materials_requisitions: 'Requisitions',
        materials_approvals: 'My approvals',
        materials_approval_rules: 'Approval rules',
        materials_receiving: 'Receiving',
        materials_returns: 'Returns',
        materials_mobile: 'Mobile',
        materials_counts: 'Stocktakes',
        materials_chain: 'Chain',
        materials_transfers: 'Stock transfers',
        materials_overview: 'Overview',
        materials_group: 'Materials',
        // The sub-headings inside the Materials fold — the order the work is done in:
        // what is on the shelf, what the house buys, what arrives, what it is charged
        // for, and the chain around it.
        materials_group_stock:      'Stock',
        materials_group_purchasing: 'Purchasing',
        materials_group_receiving:  'Receiving',
        materials_group_accounting: 'Invoices and books',
        materials_group_chain:      'Chain',
        // No `assistant` here any more: Milo is not a menu entry but the orb
        // in the top bar (AssistantOrb.vue). The screen's own name is `assistant.title`.
        crm_group: 'CRM',
        crm_overview: 'Overview',
        crm_manager: 'Management',
        segments: 'Segments',
        opportunities: 'Opportunities',
        tasks: 'Tasks',
        lost_items: 'Lost & found',
        users:        'Users',
        roles:        'Roles',
        appearance:   'Appearance',
        companies: 'Companies',
        chessboard:   'Room plan',
        availability: 'Availability',
        reservations: 'Reservations',
        guests:       'Guests',
        properties:   'Properties',
        rooms:        'Rooms',
        rate_plans:   'Rate plans',
        channels:     'Channels',
        invoices:     'Invoices',
        facilities:   'Facilities',
        dining:       'Meals and entries',
        housekeeping: 'Housekeeping',
        housekeeping_overview: 'Housekeeping overview',
        maintenance:  'Maintenance',
        reports:      'Reports',
        finance: 'Finance',
        settings:     'Settings',
        staff_group:  'Staff',
        staff_personal:   'Personal',
        staff_management: 'Management',
        staff_hr:         'HR',
        me:           'Me',
        staff_today:  'Today',
        vacations:    'Leave',
        rota:         'Rota',
        my_rota:      'My rota',
        my_time:      'My clock',
        time_record:  'Time record',
        time_corrections: 'Corrections',
        absences:     'Absences',
        employments:  'Personnel records',
        coverage:     'Coverage',
        staff_catalogue: 'Departments and posts',
        staff_org_chart: 'Org chart',
        staff_settings:  'Working-time record',
        logout:       'Log out',
        menu:         'Menu',
        theme:        'Appearance',
        theme_light:  'Light',
        theme_dark:   'Dark',
        theme_system: 'System',
        language:     'Language',
        language_sl:  'Slovenian',
        language_en:  'English',
        reminders:    'Reminders',
        // The eTurizem filing screen. It was a tab of Finance until 14. 9. 2026 and is
        // its own page under Reception, because a guest is filed within twelve hours.
        registrations: 'AJPES reporting',
        // "Transfers" stood beside "Transfers" — the guests' cars and the stock
        // between houses — and the two were read as the same word. Both say what they
        // move now.
        transfers:    'Guest transfers',
        // The seven groups of the new menu (phase 1 of the menu redesign).
        group_reception:   'Reception',
        group_sales:       'Sales and guests',
        group_events:      'Events and dining',
        group_house:       'Operations',
        group_procurement: 'Procurement and stock',
        group_finance:     'Finance',
        // The materials books stand under Finance now, with the reader who opens them.
        materials_group_bookkeeping: 'Materials accounting',
        // The seven groups behind the gear.
        settings_property:   'Property and rooms',
        settings_people:     'Users, roles and security',
        settings_finance:    'Finance and compliance',
        settings_guest:      'Guest experience, Milo and screens',
        settings_operations: 'Operations settings',
        settings_links:      'Integrations and communication',
        settings_browser:    'This browser',
        back_to_app:      'Back to the app',
        // The screen search (Ctrl+K).
        search:             'Find a screen …',
        search_placeholder: 'Where to? Find a screen …',
        search_hint:        'Every screen you may open — type a few letters of its name.',
        search_empty:       'No screen by that name.',
        // Favourites.
        favourites:           'Favourites',
        favourites_reset:     'reset',
        favourites_reset_hint: 'Restore the default favourites',
        favourites_max:       'At most {count} favourites',
        favourites_reorder_hint: 'Drag a favourite to another place, or move it with the arrows on the row.',
        favourite_add:        'Add to favourites',
        favourite_remove:     'Remove from favourites',
        favourite_move_up:    'Move up',
        favourite_move_down:  'Move down',
        // The switch between the new menu and the classic one.
        menu_style:      'Menu',
        menu_new:        'New menu (groups, search, favourites)',
        menu_classic:    'Classic menu',
        menu_style_hint: 'The classic menu stays available for a transition period, so nobody has to relearn the app overnight.',
    },
    table: {
        rows_per_page: 'Rows per page',
        showing:       'Showing {from}–{to} of {total}',
        filter:        'Filter',
        clear_filters: 'Clear filters',
        row_actions:   'Actions',
    },
    // The door the group console opens this reception through (docs/UPRAVA.md §9).
    // The presentation server's entry page (views/demo, Logic/Demo.go).
    demo_entry: {
        group_haccp: 'HACCP',
        group_rez: 'Bookings',
        role_haccp_upravljalec: 'Portal manager',
        shows_haccp_upravljalec: 'Operator console · choose “Administrator”',
        role_haccp_lastnik: 'Owner',
        shows_haccp_lastnik: 'Management portal · choose Marjeta Kovač',
        role_haccp_vodja: 'Manager',
        shows_haccp_vodja: 'Management portal · choose Andrej Zupan',
        role_haccp_zaposleni: 'Employee',
        shows_haccp_zaposleni: 'Shift app · choose Špela Novak',
        role_rez_upravljalec: 'Portal manager',
        shows_rez_upravljalec: 'Partners, portal settings',
        role_rez_lastnik: 'Owner',
        shows_rez_lastnik: 'Own services, slots, prices',
        role_rez_zaposleni: 'Employee',
        shows_rez_zaposleni: "Today's slots and bookings",
        role_rez_stranka: 'Customer',
        shows_rez_stranka: 'Booking a slot',
        group_mac: 'iPhone, watch and iPad — on a Mac',
        mac_title: "The room attendant's phone and watch, the iPad at the dining room door",
        mac_shows: "The real iPhone, Apple Watch and iPad apps run in Apple's simulator on a Mac with Xcode. The file builds them, opens them and connects them to the presentation server.",
        mac_step_download: 'Download the file and, in Downloads, double-click “Imprion-simulatorji.command” (in the Imprion simulatorji folder).',
        mac_step_allow: 'First time only: if macOS refuses it, open System Settings → Privacy & Security and press “Open Anyway”.',
        mac_step_wait: 'The first build takes a few minutes; then the iPhone, the watch and the iPad open already connected. After that it takes half a minute.',
        mac_download: 'Download for Mac',
        subtitle:          'Presentation',
        warning:           'Demo environment — for presentations only',
        title:             'Who are you today?',
        lead:              'One click and you are signed in as a role — no usernames or passwords to type during a presentation.',
        loading:           'Loading …',
        unavailable:       'This is not a presentation server',
        unavailable_hint:  'One-click sign-in works only on the presentation server.',
        enter:             'Enter',
        signing_in:        'Signing in …',
        sign_in_failed:    'This server has no such role.',
        back:              'Back to the roles',
        group_desk:        'Management and front desk',
        group_floor:       'Housekeeping and staff',
        group_guest:       'Guest, room and chain',
        role_direktor:        'Director',
        shows_direktor:       'Everything: reports, settings, users',
        role_vodja_recepcije: 'Front office manager',
        shows_vodja_recepcije:'Today, guest requests, room chart',
        role_receptor:        'Receptionist',
        shows_receptor:       'Arrivals and departures, folio, ordering PIN',
        role_marketing:       'Marketing',
        shows_marketing:      'Campaigns, offers, publishing',
        role_zajtrk:          'Breakfast room',
        shows_zajtrk:         'Meals and entries at the dining room door',
        role_vodja_ciscenja:  'Head housekeeper',
        shows_vodja_ciscenja: 'Room plan, teams, inspections',
        role_sobarica:        'Room attendant',
        shows_sobarica:       'My rooms today, on the phone',
        role_vzdrzevalec:     'Maintenance',
        shows_vzdrzevalec:    'Faults and work orders',
        role_zaposleni:       'Employee',
        shows_zaposleni:      'Rota, leave, time record',
        role_gost:            'Guest',
        shows_gost:           'The guest phone in room 404',
        role_tv:              'Room TV',
        shows_tv:             'The television in room 404',
        role_veriga:          'Chain management',
        shows_veriga:         'Several hotels in one place',
        role_book:            'Online booking',
        shows_book:           'The hotel\'s booking engine',
    },
    handoff: {
        opening: 'Opening the house …',
        failed:  'This link has expired or is not valid. Open the house again from the group console.',
    },
    login: {
        title:    'Sign in',
        username: 'Username',
        password: 'Password',
        submit:   'Sign in',
        failed:   'Wrong username or password',
    },
    // Events — the two answers a house owes (docs/DOGODKI.md §6, decisions 5 and 6).
    property_events: {
        title: 'Events',
        hint: 'When the guaranteed headcount is final, and what is billed if fewer turn up.',
        cutoff_days: 'Guarantee deadline (days before)',
        cutoff_days_hint: 'Empty or 0 means the product\'s own default — three days. Past it the figure moves only through a new version.',
        charge_below: 'If fewer turn up',
        charge_below_hint: 'What the house does when the actual figure is below the guaranteed one.',
        charge_below_default: 'As the trade does (on the guarantee)',
        charge_below_on: 'Bill on the guaranteed figure',
        charge_below_off: 'Bill on the actual figure',
    },
    property: {
        details_tab:  'Property details',
        details_hint: 'Every setting of this property. Edit unlocks them right here.',
        section_basic:      'Basics',
        section_time_money: 'Time and money',
        section_sales:      'Sales and till',
        child_until_age_none:            'No rule',
        retail_return_approval_default:  'Default (€50)',
        document_scan: 'Document photographs',
        document_scan_hint: 'What becomes of the picture the desk takes while reading a guest\'s document.',
        document_scan_keep: 'Keep the photographs',
        document_scan_keep_hint: 'By default the picture is thrown away once it has been read. Turn this on only if you need them for disputes.',
        document_scan_days: 'Keep for (days)',
        document_scan_days_hint: 'Counted from the capture. The picture is deleted automatically after that (90 days at most).',
        document_scan_ai: 'Read the document with a model as well (AI)',
        document_scan_ai_hint: 'Beside the reader on the server, a language model reads the picture. It reads poor photographs, documents with no machine-readable zone, and the address from the front. Every reading is settled by the document\'s own check digits.',
        document_scan_ai_notice: 'The photograph of the document is sent to an external processor (Anthropic). The hotel states this in its own privacy notice and puts a data-processing agreement in place. The picture is not retained there; the guest\'s name and the reservation are not sent.',
        vat_rates: 'VAT rates',
        vat_rates_hint: 'The codebook a charge picks its rate from. Enter percentages (22, 9.5, 5, 0).',
        vat_rate_add: 'Add a rate',
        vat_rates_default: 'With none entered the ordinary Slovenian set applies: 22 %, 9.5 %, 5 % and 0 %.',
        accommodation_tax_rate: 'VAT on accommodation (%)',
        accommodation_tax_rate_help: 'The rate a night is invoiced at — 9.5 % in Slovenia. Every posted night carries it.',
        street: 'Street',
        properties:       'Properties',
        property:         'Property',
        add:              'Add property',
        edit:             'Edit property',
        timezone:         'Timezone',
        night_audit_hour: 'Night audit hour',
        check_out_hour:      'Check-out hour',
        check_out_hour_hint: 'When a departing guest is expected to be out of the room. Not a rule anybody is refused by: past this hour a room nobody released is treated as free so the morning can go on, and the house says so with a row in "needs attention".',
        retail_card_confirmation:      'Card payment confirmation',
        retail_card_confirmation_hint: 'The receipt is issued only after the terminal approves. Turn on if the hotel takes cards.',
        site_published:      'Website published',
        site_published_hint: 'Whether the house\'s own website is publicly reachable. Separate from the booking engine — a house without one still gets a page, just with no "Book now" button.',
        retail_return_approval:      'Return limit without approval',
        retail_return_approval_hint: 'Above this a manager approves the refund. Empty or 0 means the default of 50 €.',
        currency:         'Currency',
        address:          'Address',
        city:             'City',
        postal_code:      'Postal code',
        country:          'Country',
        default_language: 'Default language',
        child_until_age: 'A child until age',
        cancellation_charge: 'Cancellation charge',
        cancellation_charge_hint: 'How a cancellation charge is posted. Left as it is, it is posted exactly as it always has been - and the VAT question stays open for your accountant.',
        child_until_age_hint: 'A person younger than this on the day of arrival is a child on the reservation. Zero: no rule, and everybody is an adult.',
        in_use:           'The property cannot be deleted while it has rooms',
    },
    room_type: {
        sleeps: 'sleeps {count}',
        occupancy_exceeded: 'This room type sleeps {count} at most. Pick a larger one or reduce the guests.',
        room_types:         'Room types',
        room_type:          'Room type',
        add:                'Add room type',
        edit:               'Edit room type',
        standard_occupancy: 'Standard occupancy',
        max_occupancy:      'Maximum occupancy',
        beds:               'Beds',
        extra_beds:         'Extra beds',
        code_taken: 'Another room type already uses this code.',
        code_taken_error: 'Code {code} cannot be used — another room type already has it. Choose another.',
        display_order_taken: 'Taken: {taken}',
        display_order:      'Display order',
        reorder:            'Reorder',
        move_up:            'Move up',
        move_down:          'Move down',
        no_rooms:           'This room type has no rooms yet. Add them on the property.',
        in_use:             'The room type cannot be deleted while it has rooms',
        group_category:        'Group category',
        group_category_hint:   'Which of the head office\'s central room categories this room type belongs to. Central rate templates are pushed to this property by category.',
        group_category_none:   'No category',
        group_category_failed: 'The group category could not be saved. The room type is saved.',
    },
    room: {
        rooms:        'Rooms',
        room:         'Room',
        add:          'Add room',
        edit:         'Edit room',
        number:       'Number',
        floor:        'Floor',
        floor_number: 'Floor {floor}',
        ground_floor: 'Ground floor',
        block:        'Room block',
        block_reason: 'Block reason',
        occupied_cannot_delete: 'An occupied room cannot be deleted',
        named:      'Room {room}',
    },
    // The label says what has to be done to the room, or what the room IS for sale —
    // not what it looks like. The stored codes (dirty/clean/inspected) are unchanged.
    // Reasoning: docs/HOUSEKEEPING.md §3.2.
    room_status: {
        clean:          'Cleaned',
        dirty:          'To prepare',
        inspected:      'Ready',
        occupied:       'Occupied',
        out_of_order:   'Out of order',
        out_of_service: 'Out of service',
    },
    room_screen: {
        back: 'Board',
        simulated: 'Simulated equipment',
        arriving_at: 'arriving at {hour}',
        nobody_tonight: 'Free tonight',
        unavailable: 'This room cannot be shown',
        unavailable_hint: 'It belongs to another property, it has been removed, or this account may not see what the rooms are doing.',
        no_system: 'This hotel has no guest room system',
        no_system_hint: 'Nothing is being read from this room and nothing can be told to it. The rest of the room works as it always has.',
        no_sensors: 'This room is not fitted with anything that reports.',
        prepare: 'Prepare for arrival',
        prepare_title: 'What will be done',
        prepare_hvac: 'Heating to comfort, target {value}°',
        prepare_until_arrival: 'holds until the guest arrives at {hour}',
        prepare_until_half_hour: 'holds for half an hour — this guest named no arrival time',
        prepare_not_housekeeping: 'the cleaning status is NOT changed — a warm room is not a made-up room',
        prepare_not_keys: "the guest's key is NOT part of this — it is activated at check-in",
        prepare_confirm: 'Confirm',
        live: 'Live',
        temperature: 'Temperature',
        target: 'target {value}°',
        window: 'Window',
        window_open: 'open · {minutes} min',
        window_closed: 'closed',
        presence: 'Occupancy',
        presence_in: 'occupied · since {minutes} min ago',
        presence_out: 'empty · since {minutes} min ago',
        signs: 'Signs',
        make_up: 'MAKE UP ROOM',
        humidity: 'Humidity',
        energy: 'Spent today',
        control: 'Control',
        no_control: 'This room does not accept orders.',
        driver_no_control: 'This guest room system reads the rooms and will not be written to.',
        halted: 'The heating is stopped',
        halted_hint: 'The guest room system stopped it itself because the window is open. It is that system’s rule, not ours, and it will start again when the window is shut.',
        mode: 'Mode',
        mode_comfort: 'Comfort',
        mode_eco: 'Eco',
        mode_off: 'Off',
        setpoint: 'Target temperature',
        holds_for: 'Holds for',
        duration_30m: '30 minutes',
        duration_until_arrival: 'until the guest arrives',
        duration_until_automation: 'until the next schedule',
        duration_permanent: 'permanently',
        command_sending: 'sending…',
        command_confirmed: 'the room confirmed it · {time}',
        command_confirmed_short: 'the room confirmed it',
        preparation_warming: 'warming {from}° → {to}° · arrival at {hour}',
        preparation_warming_plain: 'warming {from}° → {to}°',
        preparation_ready: 'ready {value}°',
        preparation_failed: 'the preparation was not carried out',
        preparation_assumed: 'the house’s assumed hour',
        command_unconfirmed: 'not confirmed — the order was sent and no answer came',
        command_expired: 'the manual override has run out',
        command_failed: 'The order could not be sent.',
        retry: 'Try again',
        automations: 'Schedules of the hotel',
        preheat: 'warm the room {hours} h before a named arrival',
        eco_on_checkout: 'drop to eco when the guest leaves',
        automations_hint: 'The hotel’s own switch is set on its settings screen. What this room may say is whether the hotel’s decision applies to it.',
        automation_on: 'runs for this room',
        automation_off: 'does not run for this room',
        automation_house_on: '(the hotel has it on)',
        automation_house_off: '(the hotel has it off)',
        automation_inherit: 'Follow the hotel',
        automation_force_on: 'Always',
        automation_force_off: 'Never',
        automation_failed: 'The setting could not be saved.',
        reservation: 'Reservation and keys',
        keys: 'Keys',
        keys_hint: 'The card buttons arrive with the lock integration. Until then a key is issued at check-in, as it always has been.',
        timeline: 'What has happened',
        timeline_empty: 'Nothing has been recorded for this room yet.',
        lane_all: 'All',
        lane_guest: 'Guest',
        lane_housekeeping: 'Cleaning',
        lane_hvac: 'Heating',
        lane_access: 'Access',
        lane_alarm: 'Alarms',
    },
    room_event: {
        window_opened: 'Window opened',
        window_closed: 'Window closed after {minutes} min',
        presence_arrived: 'Somebody is in the room',
        presence_left: 'The room is empty',
        hvac_mode_changed: 'Mode {from} → {to}',
        setpoint_changed: 'Target {from}° → {to}°',
        hvac_halted: 'The heating was stopped — the window is open',
        hvac_resumed: 'The heating started again',
        command_sent: 'Order sent: {to}',
        command_confirmed: 'The room confirmed it',
        command_unconfirmed: 'No answer came — it is not known whether the room did it',
        command_expired: 'The manual override ran out',
        proposal_confirmed: "Milo's proposal was accepted: {from} → {to}",
        setting_changed: 'Setting {from} → {to}',
        sensor_silent: 'The room stopped reporting',
        sensor_returned: 'The room is reporting again',
        attention_raised: 'Temperature {from}° → {to}°',
        stay_state_sent: 'The room was reported as {to}',
        simulator_scenario: 'Demonstration: {to}',
        hk_generated: 'Put on the morning sheet',
        hk_assigned: 'Given to somebody',
        hk_reassigned: 'Handed to somebody else',
        hk_started: 'Cleaning started',
        hk_deferred: 'Put off',
        hk_resumed: 'Picked up again',
        hk_finished: 'Cleaning finished',
        hk_finished_again: 'Cleaned again',
        hk_inspection_failed: 'Sent back',
        hk_rework_started: 'Put right',
        hk_inspected: 'Accepted',
        hk_skipped: 'Skipped',
        // The name sits at the right of the row and the hour at its left, so the
        // sentence names neither: the line reads "09:41 · Put first · Ana".
        hk_prioritised: 'Put first',
        hk_prioritised_by_guest: 'The guest asked for the room — put first',
        hk_deprioritised: 'Priority removed',
        scenario_window_open: 'a window was opened',
        scenario_window_close: 'the window was shut',
        scenario_hvac_fault: 'the heating was broken',
        scenario_hvac_repair: 'the heating was mended',
        scenario_sensor_silent: 'the sensors were silenced',
        scenario_sensor_return: 'the sensors were brought back',
        scenario_all_normal: 'everything back to normal',
        stay_vacant: 'not sold',
        stay_sold: 'sold',
        stay_checked_in: 'checked in',
        stay_checked_out: 'checked out',
        note_preheat: 'warming up before the arrival',
        note_eco_on_checkout: 'eco when the guest left',
        note_simulator: 'simulated equipment',
        unknown: 'Recorded: {event}',
    },
    // The Demo desk: staging the guest-room demonstration. The screen exists only in a
    // hotel running the simulator — a hotel with real equipment has none of it.
    room_control: {
        open: 'Set room {room}',
        title: 'Room {room}',
        cooler: 'Lower by 0.5 °C',
        warmer: 'Raise by 0.5 °C',
        holds_until_arrival: 'holds until the guest arrives',
        no_reading: 'This room has not reported yet, so nothing can be said to it.',
        room_cannot: 'This room is not fitted to be commanded. Its readings come through; orders do not.',
        driver_cannot: 'This house’s guest-room system reports readings and does not accept orders.',
        no_permission: 'Changing a temperature needs the “Comfort control” permission.',
        open_room: 'Open the room page',
    },
    grms: {
        nav: 'GRMS integration',
        no_property: 'Choose a property first.',

        connection: 'Connection',
        connection_hint: 'Which system reads this house\'s rooms and where its equipment stands. Filled in once, at installation.',
        connection_note: 'What the interface said',

        automation: 'Preparing rooms by itself',
        automation_hint: 'What the equipment should do on its own: warm a room before the guest arrives, and drop it to the setback after they leave. The thresholds and durations of the attention rules are not here — those are the house’s opinion about a warm room and are set separately.',
        automation_no_permission: 'Editing the schedules needs the “Telemetry automation” permission.',
        automation_saved: 'The schedules have been saved.',

        preheat: 'Prepare the room before arrival',
        preheat_hint: 'A room a guest is arriving into today is put on comfort at the target temperature by the house itself. One order per stay, never a room without control, and a room already on comfort is left alone.',
        preheat_hours: 'How many hours before arrival',
        preheat_hours_hint: '3 hours is what a cold room with an ordinary radiator takes. 0 means off.',
        preheat_arrival_time: 'Assumed arrival hour',
        preheat_arrival_time_hint: 'For guests who named no hour, which is most of them. This hour is the house’s decision and not a guess: the row and the timeline both say the hour was not the guest’s.',
        preheat_zero_hint: 'Nought hours means off. Saving will switch it off.',

        eco_on_checkout: 'Drop to eco after departure',
        eco_on_checkout_hint: 'Once the room has been given back, the house drops the heating to the setback. A room somebody is holding by hand is left alone until that override runs out.',

        comfort_target: 'Comfort target (°C)',
        comfort_target_hint: 'What the house asks for when it names a target itself — the pre-arrival warm-up. What “comfort” means otherwise is the guest-room system’s business.',
        eco_target: 'Eco target (°C)',
        eco_target_hint: 'The setback level between stays.',

        driver: 'Guest-room system',
        driver_hint: 'The choice belongs to this house. A demonstration hotel and a hotel with real equipment can run side by side.',
        driver_none: 'No guest-room system',
        driver_simulator: 'Simulator (for demonstrations)',
        driver_knx: 'KNX (interface in the cupboard)',
        driver_modbus: 'Hotel agent — Smarteh Modbus',
        driver_interel: 'Interel (cloud)',
        driver_nomadix: 'Nomadix (cloud)',

        not_built: '{driver} is not available in this release yet',
        not_built_hint: 'The choice can be saved, but no room will be read until the driver ships. An empty live column is that, and not a fault.',

        base_url: 'Service address',
        username: 'Username',
        secret: 'Password or token',
        secret_hint: 'Stored encrypted and never sent back to the screen.',
        secret_stored: 'A password is stored. Leaving this blank keeps it.',
        secret_set: 'stored',

        note_not_configured: 'No interface address has been entered yet.',
        note_no_free_channel: 'The interface has no free channel. Most often an installer\'s ETS session is holding it — close that and the connection comes back on its own.',
        note_secure_required: 'The interface requires KNX IP Secure, which is not supported in this release.',
        note_unreachable: 'The interface cannot be reached. Check the address, the cable and the network to the cupboard.',
        agent_connected: 'The interface is reachable',
        agent_offline: 'The interface is not reachable',
        last_seen: 'Last heard {at}',
        never_seen: 'Nothing has been heard yet.',

        interface_address: 'KNXnet/IP interface address',
        interface_address_hint: 'The address of the interface in the cupboard. Port 3671 is added for you.',
        knx_mode: 'Mode',
        knx_mode_hint: 'Tunnelling works with the cheapest interface and asks nothing of the hotel network. Routing arrives with the first installation that needs it.',
        knx_tunnelling: 'Tunnelling (default)',
        physical_address: 'Our own address on the bus',
        physical_address_hint: 'The individual address we borrow. 15.15.250 by default, which is free in almost every installation.',

        secure_unsupported: 'KNX Secure is not supported in this release',
        secure_unsupported_hint: 'An interface that requires KNX IP Secure refuses the connection in plain words rather than failing quietly. Most hotel installations do not have it.',

        simulator_title: 'This house will be shown invented numbers',
        simulator_hint: 'The simulator is for demonstrations. Nothing moves in any room, and every number on the screen is made up.',

        capabilities: 'Capabilities',
        capabilities_hint: 'What the house actually gets, worked out from the confirmed mapping. Not a setting: a room that measures again says so itself by sending a value.',
        capabilities_none: 'Until a room is confirmed, the house has no capabilities.',
        capability_temperature: 'Temperature',
        capability_humidity: 'Humidity',
        capability_window_contact: 'Window',
        capability_occupancy: 'Occupancy',
        capability_energy_meter: 'Energy',
        capability_hvac_control: 'Heating control',
        capability_door_access: 'Door',
        capability_control_mode: 'Command: mode',
        capability_control_setpoint: 'Command: target temperature',

        rooms_mapped: 'Rooms confirmed: {mapped} of {total}.',

        ets: 'ETS import',
        ets_hint: 'Addresses need not be retyped. The installer exports the group addresses from ETS; we read them and propose which room is which.',
        ets_file: 'File (.knxproj or CSV)',
        ets_import: 'Read',
        ets_failed: 'The file could not be read',
        ets_read: '{file}: {count} addresses read, {rooms} rooms recognised, {skipped} addresses skipped.',
        ets_confirm: 'Confirm the chosen rooms ({count})',
        ets_discard: 'Discard the proposal',

        unassigned: 'Unassigned ({count})',
        unassigned_hint: 'Addresses that could not be placed in a room. They stay here — most often it is a naming convention we have not met yet.',

        mapping: 'Room mapping',
        mapping_hint: 'The confirmed rooms. A room without a confirmed mapping has no telemetry — not half of it.',
        mapping_none: 'No room has been confirmed yet.',
        mapping_remove: 'Remove room',
        mapping_saved: 'Rooms confirmed: {count}.',
        mapping_removed: 'The room has been removed from the mapping.',

        direction_read: 'read',
        direction_write: 'write',
        direction_both: 'both',

        point_temperature: 'Temperature',
        point_setpoint: 'Target temperature',
        point_hvac_mode: 'Mode',
        point_humidity: 'Humidity',
        point_window: 'Window',
        point_presence: 'Occupancy',
        point_dnd: 'Do not disturb',
        point_mur: 'Make up room',
        point_energy: 'Energy',
        point_stay_state: 'Stay state',

        read_now: 'Read now',
        read_failed: 'The read could not be sent.',
        read_nothing: 'no answer',

        state_accepted: 'Accepted',
        state_executed: 'Executed',
        state_failed: 'Failed',
        commands: 'Command log',
        commands_hint: 'The last fifty commands put on the bus. "Accepted" means the bus took the telegram; "executed" only that the device reported the new value.',
        commands_none: 'Nothing has been commanded yet.',
        command_at: 'Time',
        command_room: 'Room',
        command_kind: 'What',
        command_address: 'Address',
        command_value: 'Value',
        command_state: 'State',

        saved: 'The connection has been saved.',
    },
    demo: {
        nav: 'Demo desk',
        no_property: 'Choose a property first.',
        unavailable: 'This property has real guest-room equipment',
        unavailable_hint: 'The Demo desk exists only where the rooms are reported by the simulator. In a hotel with real equipment there is nothing to stage — and that is deliberate.',
        honest_title: 'Everything on this screen is simulated',
        honest_hint: 'These buttons move invented values inside the guest-room simulator. Nothing in any room moves. Every press is written into the room\'s timeline as a demonstration act, with the name of whoever pressed it.',

        scene: 'The whole scene',
        scene_hint: 'Sets up the story that tells itself: a guest arriving in two hours into a room with its window open, the hotel\'s pre-arrival warm-up switched on, a heating fault in an empty room, and a third room that has gone quiet. The attention row then appears by itself, with nobody pressing anything.',
        scene_stage: 'Set the whole scene',
        scene_clear: 'Put it away',
        scene_none: 'No scene is up. The rooms below can also be staged one at a time.',
        scene_up: 'The scene is up: an arrival in room {arrival} at {hour} (window open), a heating fault in room {fault}, silent sensors in room {silent}.',
        scene_booking: 'Reservation {number}',
        scene_by: 'set by {name}',
        scene_clear_hint: '"Put it away" clears everything staged, restores the hotel\'s settings exactly as they were found, and cancels this one reservation — nothing else.',
        scene_staged: 'The scene is up.',
        scene_cleared: 'The scene has been put away.',
        scene_failed: 'The scene could not be set.',
        scene_clear_failed: 'The scene could not be put away.',

        rooms: 'Rooms',
        rooms_hint: 'Each room says what it is doing right now and carries the switches to stage it. Pressing a switch again puts that one thing back.',
        rooms_empty: 'This property has no rooms with simulated equipment yet.',
        no_match: 'No room matches the search.',
        search: 'Room number',
        floor: 'Floor {floor}',
        reading_age: 'read {age}',

        control_window: 'Window',
        control_window_hint: 'Leaves a window open and holds it open. A simulated airing closes itself; this does not.',
        control_hvac: 'Fault',
        control_hvac_hint: 'The plant sticks on and the room climbs past its target. Orders are accepted and never carried out — which is the "not confirmed" state.',
        control_sensor: 'Go quiet',
        control_sensor_hint: 'The room stops reporting. Its values stay where they were and get older — the screen greys them and no rule may fire from them.',
        control_dnd: 'DO NOT DISTURB',
        control_dnd_hint: 'The sign on the door, until somebody takes it off.',
        control_mur: 'MAKE UP ROOM',
        control_mur_hint: 'The guest asks to be cleaned. The round gets an attention row — unless the do-not-disturb sign is up as well, which suppresses it.',
        control_prepare: 'Arrival',
        control_prepare_hint: 'Leaves the room cold (12°) on the setback — as the house finds it before a guest arrives. When the schedule or the desk warms it, that shows on screen in minutes rather than in an hour. Switching it off returns the room to an ordinary warm one.',

        stage_failed: 'That scenario could not be staged.',
    },
    telemetry: {
        age_seconds: '{count} s ago',
        age_minutes: '{count} min ago',
        age_hours: '{hours} h {minutes} min ago',
        chip_window: 'window {minutes} min',
        chip_temperature: '{value}°',
        chip_halted: 'heating stopped',
        chip_dnd: 'DO NOT DISTURB',
        chip_mur: 'MAKE UP ROOM',
        chip_silent: 'no reading · {age}',
        chip_preparing: 'warming {from}° → {to}° · arrival {hour}',
        chip_preparing_plain: 'warming {from}° → {to}°',
        chip_prepared: 'ready {value}°',
        chip_preparation_failed: 'preparation failed',
        chip_preparation_failed_note: 'preparation failed — {note}',
    },
    board_attention: {
        kind_arrival_room_not_ready: 'Room not ready for an arrival',
        kind_unpaid_departure: 'Leaving with an open balance',
        kind_blocked_room_occupied: 'Closed room with nights booked',
        kind_window_open_before_arrival: 'Window open before an arrival',
        kind_window_open_vacant: 'Window left open',
        kind_temperature_out_of_bounds: 'Room outside the temperature bounds',
        kind_temperature_unreached: 'Room will not be warm in time',
        kind_room_preparation_failed: 'The room could not be prepared',
        kind_telemetry_room_silent: 'Room has stopped reporting',
        kind_telemetry_unreachable: 'The guest room system is not answering',
        kind_room_not_released: 'Room was not released',
        kind_guest_message: 'Guest message (Milo)',
        kind_unknown: 'Needs attention',
        title: 'Needs attention · {count}',
        critical_count: '{count} critical',
        show_all: 'Show all ({count})',
        open_list: 'Settle these',
        show_fewer: 'Show fewer',
        // A departure, not "open the reservation": the button does exactly what the
        // desk would do with the guest standing there — the standard check-out, even
        // though the stay's departure day has gone.
        check_out: 'Check out',
        check_out_hint: 'Opens the check-out for the booking in room {room}',
        settle: 'Settled',
        settle_title: 'Mark as dealt with',
        settle_resolution: 'What did you do?',
        settle_help: 'The note stays on the record. This changes nothing about the room, the bill or the reservation — it says somebody looked, and what they did.',
        settled: 'The row is marked as dealt with.',
        settle_failed: 'The row could not be marked.',
        // "status: {state}" rather than "the room is {state}": since v1.333.0 a state
        // label names a job ("To prepare"), not an adjective, and "the room is To
        // prepare" is not a sentence.
        arrival_room_not_ready: 'Room {room} — arriving at {hour}, status: {state}',
        unpaid_departure: 'Room {room}, {guest} — leaving with {amount} outstanding',
        blocked_room_occupied: 'Room {room} is {state} but has nights booked',
        window_open_before_arrival: 'Room {room} — window open {minutes} min, guest arriving today',
        window_open_vacant: 'Room {room} — window open {minutes} min, nobody coming',
        temperature_out_of_bounds: 'Room {room} — {value}°, target {target}°, empty for {minutes} min',
        temperature_unreached: 'Room {room} — {value}°, target {target}° — will not get there by {hour}',
        room_preparation_failed: 'Room {room} — the equipment did not carry out the warm-up for {hour}; {value}°, target {target}°',
        telemetry_room_silent: 'Room {room} has said nothing for {minutes} min',
        telemetry_unreachable: 'The guest room system is not answering — {count} rooms have gone quiet',
        room_not_released: 'Room {room} - checked out and not given back by {hour}; treated as free',
        guest_message: 'Room {room}, {guest} through Milo: "{text}"',
        unknown_kind: 'Room {room} — needs attention',
        unknown_state: 'unknown state',
        room_unknown: 'no room',
        guest_unknown: 'guest unknown',
    },
    // "Označi za čiščenje" — a room the calendar says nothing about, onto today's round
    // at once (docs/HOUSEKEEPING.md §17).
    mark: {
        title: 'Mark for cleaning',
        room_named: 'Room {room}',
        reason: 'Reason',
        note: 'Note',
        note_placeholder: 'E.g. the guest spilled wine, room shown at eleven …',
        submit: 'Mark for cleaning',
        marked_message: 'Room {room} is on today\'s cleaning round.',
        reason_guest_request: 'The guest asked',
        reason_complaint: 'A complaint about the room',
        reason_soiled: 'Soiled after cleaning',
        reason_after_use: 'After a viewing or work in the room',
        reason_other: 'Other',
        already_open_title: 'This room is already on today\'s round',
        nobody: 'unassigned',
        due_by: 'by {hour}',
        status_pending: 'waiting',
        status_awaiting_release: 'waiting for the room to be given back',
        status_in_progress: 'being cleaned',
        status_done: 'cleaned',
        status_inspected: 'accepted',
        status_skipped: 'not cleaned today',
        status_deferred: 'put off',
        status_rework_required: 'sent back',
        refused_out_of_service: 'The room is out of sale. Put it back in use first, and it can then go on the cleaning round.',
        failed: 'The room could not be marked for cleaning.',
    },
    housekeeping: {
        require_inspection: 'Require room inspection',
        require_inspection_hint: 'On: a room stays “Cleaned” after the clean until a supervisor accepts it (“Ready”). Off: finishing the clean accepts the room on its own — no separate inspection.',
        allow_self_inspection: 'Let the person who cleaned a room accept it',
        allow_self_inspection_hint: 'Off (the default): a room has to be accepted by somebody other than the person who cleaned it — that is what an inspection is worth. Turn it on in a hotel with one housekeeper on a shift; otherwise acceptance will be refused all day.',
        supervisor_skips_inspection: 'A supervisor\'s own work needs no acceptance',
        supervisor_skips_inspection_hint: 'Off (the default): a room the supervisor cleaned waits to be accepted like any other. On: a room started by somebody holding “Accept a room inspection” is ready the moment it is finished — a supervisor answers to the management, not to a colleague\'s sign-off. It covers only her own rooms; every other room still goes to inspection.',
        // The same words the housekeeping portal uses — one product must not name the
        // same work twice.
        kind_departure: 'Departure',
        kind_stayover:  'Stayover',
        kind_arrival:   'Arrival',
        kind_dirty: 'To prepare',
        cleaning_now:   'Being cleaned',
        cleaning_legend: 'The room is being cleaned — the hour beside it is when it should be ready.',
        cleaning_by:    '{name} is cleaning it',
        ready_by:       'Ready by {time}',

        kind_departure_help: 'The guest has left — the room is stripped and made up in full.',
        kind_stayover_help:  'The guest is staying — daily service around their own things.',
        kind_arrival_help:   'The room is empty and a guest arrives today — prepare it and look it over.',

        norms:               'Housekeeping norms',
        norms_hint:          'How many minutes the work is expected to take. An empty field means no norm is set — no target is then shown anywhere.',
        norms_written_hint:  'The norm is written onto each task when the day\'s housekeeping sheet is generated. A change applies from the next sheet on and does not alter what earlier days were measured against.',
        norms_override:      'Housekeeping norms for this room type',
        norms_override_hint: 'An empty field means “as the property”. Enter a figure only where this room type differs from the hotel.',

        norm_as_property: 'As the property: {minutes} min',
        norm_not_set:     'Not set',
        minutes_short:    'min',

        // Teams: two or three housekeepers on one room (docs/HOUSEKEEPING.md §15).
        team_factor:       'Team factor',
        team_factor_default: '{percent} (default)',
        team_factor_hint:  'What share of the norm a team spends on a room. Two people are faster than one and not twice as fast — they hand each other things and wait for the bathroom. Empty is the house default: 60 % for a pair, 45 % for three or more.',
        team_factor_pair:  'Two people (%)',
        team_factor_group: 'Three or more (%)',

        recommended_team_size:            'Recommended team size',
        recommended_team_size_none:       'Not set',
        recommended_team_size_inherit:    'As the room type',
        recommended_team_size_n:          '{count} people',
        recommended_team_size_room_hint:  'How many housekeepers it makes sense to send into this room. Empty means "as the room type". It is a recommendation and not a rule — nothing stops one person doing it.',
        recommended_team_size_type_hint:  'How many housekeepers it makes sense to send into a room of this type — an apartment with two bathrooms, a suite over two floors. A single room may override it.',
        recommended_team_size_area_hint:  'How many housekeepers it makes sense to send into this space — a wellness suite, a banqueting floor. An area has no type to inherit from, so what it says here is what there is.',

        no_property: 'Choose a property first.',

        // The telephones and the watches. A housekeeping device belongs to a PERSON —
        // that is what lets the application have no sign-in at all.
        devices:      'Devices',
        devices_hint: 'The telephones and watches the housekeepers carry. Enrolled with a code, revoked with one press.',
        devices_empty: 'No device yet.',
        device_add:    'Add device',
        device_rename: 'Edit device',
        device_person: 'Belongs to',
        device_needs_person: 'No housekeeper yet — a device is enrolled onto a person.',
        device_needs_permission: 'You cannot read this property’s housekeepers.',
    },

    // "Housekeeping overview" — the morning on the floor as the desk and management
    // read it (docs/HOUSEKEEPING.md "Pregled za recepcijo in vodstvo"). The words are
    // the housekeeping portal's own: one product must not name one job twice.
    hk_overview: {
        title: 'Housekeeping overview',
        hint:  'How the cleaning is going today: who has what, when each round finishes, and which rooms are not ready. Read-only.',
        read_only: 'The round is arranged in the housekeeping application — that is where the supervisor hands out rooms, accepts them and sets the order.',
        no_property: 'Pick a property first.',

        date:      'Day',
        date_hint: 'The house’s business date, not the calendar one. Empty means the day the hotel is currently working on.',

        load_failed:      'The cleaning day could not be read.',
        load_failed_hint: 'Try again. If it keeps happening it is most likely the “Read housekeeping” permission or the Operations module.',
        empty:            'There is no cleaning work for this day.',

        read_now: 'Read just now',
        read_ago: 'Read {value} ago',

        rooms_heading:  'Rooms',
        tasks_heading:  'Tasks',
        people_heading: 'People',

        being_cleaned:      'Being cleaned',
        rooms_blocked:      'Not for sale',
        rooms_not_visible:  'Needs “Read property”',

        tasks_open:      'Open',
        tasks_open_hint: 'Everything not yet finished.',
        tasks_in_progress: 'In progress',
        tasks_done:        'Finished',
        tasks_awaiting_inspection:      'Awaiting inspection',
        tasks_awaiting_inspection_hint: 'Cleaned, not yet accepted by the supervisor.',

        people_empty:      'Nobody is rostered for today.',
        people_teams_note: 'A team’s rooms count for each of its members — the row says what one person has in front of her, and is not a column to add up.',
        person_progress:   '{done} done · {left} left',
        on_absence:        'Away',

        round_title:   'When each round finishes',
        round_summary: 'The house should be ready at {time}; rounds: {count}.',
        lanes_title:   'By housekeeper',
        lanes_hint:    'The rooms in the order each housekeeper will actually walk them. The order is the supervisor’s and is not changed here.',

        unassigned_title: 'Unassigned rooms',
        unassigned_hint:  'Work nobody holds yet. Until a room is assigned it has no predicted hour.',

        inspection_title: 'Awaiting inspection',
        inspection_hint:  'Cleaned rooms the supervisor has not accepted yet. The longest wait first.',
        waiting_for:      'waiting {value}',

        blocked_title: 'Rooms not for sale',
        blocked_hint:  'Out of order or out of service — with the block’s reason where one is written.',

        finishes:   'finishes at {time}',
        rooms_left: '{count} rooms',
        no_shift:   'Shift unknown',
        norm:       'norm {value}',
        due_by:     'ready by {time}',
        priority:   'Priority',
        after_shift: 'After the end of the shift',
        dnd:        'Do-not-disturb sign',

        legend_working:     'Being cleaned',
        legend_late:        'Will not be in time',
        legend_after_shift: 'After the end of the shift',
        legend_now:         'Now',

        room_is:        'room: {state}',
        room_unknown:   'Unknown room',
        team:           'Team',
        somebody_else:  'Somebody else',

        status_awaiting_release: 'Awaiting release',
        status_pending:          'Waiting',
        status_in_progress:      'In progress',
        status_done:             'Finished',
        status_inspected:        'Inspected',
        status_skipped:          'Skipped',
        status_deferred:         'Deferred',
        status_rework:           'Sent back',

        kind_dirty_done: 'Made up',
        kind_area:       'Common area',

        minutes: '{value} min',
        hours:   '{value} h',
    },
    reservation: {
        contract_company:      'Firm with a negotiated rate',
        contract_company_none: 'No negotiated rate',
        contract_line:         'Contract: {name} ({source}) · {count} offers',
        contract_none:         'This firm has no negotiated rate in this house for these dates',
        contract_source_group: 'group',
        contract_source_house: 'house',
        moved_from:             'Moved from “{house}” (reservation {number})',
        moved_to:               'Moved to “{house}” (reservation {number})',
        package: 'Package components',
        package_included: 'included',
        package_worth: 'internal value {amount}',
        package_planned: 'planned',
        package_posted: 'on the folio',
        package_created: 'booked',
        package_failed: 'failed',
        package_kind_room_service: 'Room service',
        package_kind_dining: 'Meal',
        package_kind_facility: 'Facility',
        package_kind_parking: 'Parking',
        package_kind_service: 'Service',
        package_kind_product: 'Product',
        package_when_arrival: 'on arrival',
        package_when_each_night: 'every night',
        package_when_departure: 'on departure',
        rooms: 'Rooms',
        confirm_hint: 'Confirm the reservation — a draft becomes a promise, and the room is held.',
        cancel_hint: 'Cancel the reservation — the rooms are released and go back on sale.',
        open_hint: 'Open the reservation — guests, rooms, the card and the invoice.',
        spending: 'Spending',
        search_placeholder: 'Number or guest name',
        spending_hint: 'What this reservation has consumed besides the room — the bar from the point of sale, wellness, hire, the tourist tax.',
        spending_empty: 'Nothing besides the room yet.',
        spending_total: 'Total spending',
        spending_paid: 'Paid',
        spending_due: 'Outstanding',
        spending_no_folio: 'This reservation has no card yet — add one with “New card”.',
        spending_group_folio: 'The room and the tourist tax are posted to the card of group {group}, which opens at its first posting. A card of this reservation is only for its extras — add one with “New card”.',
        spending_open_folio: 'Open the card',
        spending_bar_label: 'Spending by source',
        spending_items: 'items: {count}',
        spending_receipts: 'receipts: {count}',
        spending_person_nights: 'person-nights: {count}',
        spending_per_night: '{amount} / night',
        spending_more: '+ {count}',
        spending_tax_note: 'Collected for the municipality · not house revenue',
        spending_tax_excluded: 'the tourist tax is not counted in',
        spending_tax_excluded_hint: 'The tax is collected on the municipality’s behalf, so it says nothing about where the house earned. It is out of the proportion and in both the total and what is outstanding.',
        spending_refund: 'Refund',
        spending_refund_tooltip: 'Give a payment on this folio back — an overpaid card offers the difference',
        spending_refund_none: 'This folio has no payment to refund',
        spending_refund_closed: 'The folio is closed — nothing can be refunded on it',
        spending_refund_pick: 'Which payment goes back?',
        spending_refund_pick_hint: 'This folio has more than one payment. Pick the one being refunded — the amount shown is what can still be given back.',
        facility_pending: 'Booked from the hotel offer, not on a card yet',
        stay: 'Stay',
        nights_count: '{count} nights',
        expected_arrival: 'Expected arrival',
        expected_arrival_help: 'The hour the guest gave. Housekeeping puts that room before the others.',
        reservations:     'Reservations',
        reservation:      'Reservation',
        add:              'New reservation',
        edit:             'Edit reservation',
        number:           'Number',
        arrival:          'Arrival',
        departure:        'Departure',
        nights:           'Nights',
        nights_hint: 'Type the nights and the departure follows from the arrival.',
        adults:           'Adults',
        children:         'Children',
        source:           'Source',
        campaign:         'Campaign',
        payer:            'Payer',
        extras:            'Parking and other extras',
        extras_hint:       'What the guest takes for the whole stay. It goes on the room\'s card.',
        extras_per_day:    '{price} a day',
        extras_per_hour:   '{price} an hour',
        extras_unclear:    '{price} · pick the resources on the service, or it is sold by the day',
        extras_no_hours:   'Nothing free on this day.',
        extras_per_days:   '{price} for {days} days',
        extras_days:       '{days} days ·',
        extras_free:       'Free that day: {count}',
        extras_none_free:  'Nothing free that day',
        extras_plate_nth:  'Plate {number}',
        extras_plate:      'Registration',
        extras_full_days:  'Nothing free on {days} — those days are not included.',
        extras_failed:     'Nothing free for \'{name}\' — the room is booked, the extra is not.',
        extras_failed_count: 'Not {count} free for \'{name}\' — the room is booked, the extra is not.',
        extras_quantity:   'How many',
        mail_wishes:       'The guest also asked for',
        total:            'Total',
        special_requests: 'Special requests',
        internal_notes:   'Internal notes',
        confirm:          'Confirm',
        confirm_on_hint: 'The reservation is created as confirmed — the room is taken and the guest is expected.',
        confirm_off_hint: 'The reservation is created as a draft — the room is held all the same, until it is confirmed or deleted.',
        cancel:           'Cancel',
        no_show:          'No show',
        check_in:         'Check in',
        check_in_needs_confirmation: 'The booking is still a draft. Confirm it first, then guests can be checked in.',
        check_in_not_possible: 'Check-in is not possible: the booking is {status}.',
        check_out:        'Check out',
        // Checking out and releasing the room are two events (docs/HOUSEKEEPING.md §16).
        release_room:     'Room released',
        released_at:      'Room released: {value}',
        released:         'Room {room} has been released.',
        released_already: 'Room {room} had already been released.',
        release_failed:   'The room could not be released.',
        change_room:      'Change room or dates',
        confirm_cancel:   'Cancel this reservation? Its rooms go back on sale.',
        confirm_no_show:  'Mark as no show? Its rooms go back on sale.',
        room_taken:       'The room is already taken for those dates. Nothing was changed.',
        arrivals:         'Arrivals',
        departures:       'Departures',
        in_house:         'In house',
        checked_in_count:      '{done} of {total} checked in',
        checked_in_count_page: '{done} of {total} on this page checked in',
        restricted: 'The rate plan\'s restrictions do not allow this stay.',
        override_restrictions: 'Book despite the restrictions',
        override_restrictions_hint: 'The exception stays on the reservation.',
        override_reason: 'Reason for the exception',
        override_reason_hint: 'Write it for the person who asks a month from now why a closed weekend was sold.',
        override_forbidden: 'Making an exception needs a permission — ask the front-office manager.',
    },
    reservation_status: {
        draft:       'Draft',
        confirmed:   'Confirmed',
        checked_in:  'Checked in',
        checked_out: 'Checked out',
        cancelled:   'Cancelled',
        no_show:     'No show',
    },
    /**
     * A group that grows (docs/SKUPINE.md §9). Until now it could only be made
     * smaller — a company ringing on the Tuesday to say four more are coming meant
     * cancelling the group and booking it again.
     */
    growth: {
        increase:       'Add rooms',
        increase_title: 'Add rooms to the block',
        rooms_to_add:   'Rooms to add',
        add_block:      'Add a room type',
        add_block_title: 'Add a room type',
        will_hold:      'The rooms are held at once — this group already holds its rooms.',
        grown:          'The block grew: +{rooms}.',
        grown_held:     'The block grew: +{rooms} · {held} held.',
    },
    ladder: {
        remove: 'Remove tier',
        title: 'Cancellation ladder',
        days: 'days before',
        add: 'Tier',
        reduce: 'Reduce',
        reduce_title: 'Reduce the block',
        rooms_to_release: 'Release rooms:',
        quote_fee: 'Per the ladder: {pct} % at {days} days before arrival -> a {fee} € cancellation fee on the group folio.',
        quote_free: 'At {days} days before arrival the reduction is free.',
        waive: 'Waive the fee (exception)',
        charge_title: 'Cancellation charge',
        tax_unset: 'VAT: awaiting the accountant (posts as today)',
        tax_outside: 'VAT: not subject to VAT',
        tax_zero: 'VAT: taxed at 0 %',
        tax_taxed: 'VAT: taxed at',
        reduction_label: 'Name for a reduction',
        cancellation_label: 'Name for a cancellation',
        revenue_group: 'Revenue group',
        reduced: 'The rooms were released and recorded.',
        reduced_fee: 'Rooms released; a {fee} € cancellation fee was posted to the group folio.',
        fee: 'fee',
        waived: 'fee waived',
    },
    offers: {
        title: 'Offers',
        hint: 'Every rich offer the hotel has issued - for reservations and groups. Clicking a row opens the offer as the client sees it.',
        empty: 'No offers issued yet. Issue one with the Offer button on a reservation or a group.',
        col_number: 'Number',
        col_for: 'For',
        col_rooms: 'Rooms',
        col_nights: 'Nights',
        col_unit: 'Price/night',
        col_total: 'Total',
        col_vat: 'VAT',
        col_valid: 'Valid until',
        source_reservation: 'Reservation',
        source_group: 'Group',
        status_issued: 'Issued',
        status_opened: 'Opened',
        status_confirmed: 'Confirmed',
        status_expired: 'Expired',
        status_all: 'All statuses',
        source_all: 'All sources',
        period_this_month: 'This month',
        period_last_30_days: 'Last 30 days',
        period_this_quarter: 'This quarter',
        period_this_year: 'This year',
        period_all: 'All time',
        search: 'Search by number or client',
        empty_filtered: 'No offer matches the chosen filters.',
        expires_soon: 'Expires soon',
        kpi_open: 'In circulation',
        kpi_confirmed: 'Confirmed',
        kpi_expiring: 'Expiring within 7 days',
        kpi_conversion: 'Conversion',
        kpi_amount: '{amount} in total',
        kpi_expiring_hint: 'Issued and opened offers',
        kpi_conversion_hint: '{won} of {decided}',
        // The pipeline: stages, columns and the row's own actions.
        stage_all:      'All stages',
        stage_offer:    'Offer',
        stage_proforma: 'Pro forma',
        stage_prepaid:  'Prepayment',
        stage_invoice:  'Invoice',
        col_proforma:   'Pro forma',
        col_prepaid:    'Prepayment',
        col_invoice:    'Invoice',
        open_folio:      'Open card',
        issue_proforma: 'Issue pro forma',
        record_receipt: 'Record payment',
        cancel_proforma: 'Cancel pro forma',
        documents:      'Documents',
        open_subject:   'Open the group or the reservation',
    },
    proforma: {
        group_needs_company_title: 'The group has no ordering company',
        group_needs_company_hint:  'A group\'s pro forma is written against the ordering company\'s card. Open the group, pick the company under Client, then issue the pro forma.',
        group_needs_routing_title: 'The group has no routing rules',
        group_needs_routing_hint:  'Set what the group pays (nights, tourist tax …) on the group first, so its card knows what it takes.',
        group_open:                'Open group',
        language:      'Pro forma language',
        language_hint: 'The pro forma is printed in this language, whatever the reader\'s interface language. The advance invoice issued on receipt inherits it.',
        title: 'Pro forma',

        status_issued:      'Issued',
        status_partly_paid: 'Partly paid',
        status_paid:        'Paid',
        status_expired:     'Expired',
        status_superseded:  'Superseded',
        status_cancelled:   'Cancelled',

        issue_title:      'Issue a pro forma',
        issue_hint_title: 'A pro forma is not a tax document',
        issue_hint:       'It is how the house asks for money before it has done anything. VAT falls due only when the money arrives — that is when the advance invoice is issued. The value of the deal is worked out by the server from the group\'s blocks or the reservation\'s rooms.',
        supersedes_title: 'Replaces pro forma {number}',
        supersedes_hint:  'The earlier pro forma is marked superseded. Only possible while no money has arrived against it.',

        ask_title:       'What the pro forma asks for',
        ask:             'How',
        ask_hint:        'A share of the whole value of the deal, or an exact figure.',
        ask_percent:     'Share (%)',
        ask_amount:      'Amount (€)',
        mode_percent:    'Share',
        mode_amount:     'Amount',
        valid_days:      'Valid (days)',
        valid_days_hint: '0 means no deadline.',
        note:            'Note on the pro forma',
        issue:           'Issue pro forma',
        issued:          'Pro forma {number} issued.',
        issue_failed:    'The pro forma could not be issued.',

        receipt_title:          'Payment received against a pro forma',
        requested:              'Requested',
        received:               'Received',
        remaining:              'Remaining',
        receipt_amount:         'Amount received (€)',
        receipt_method:         'Payment method',
        receipt_reference:      'Bank reference',
        receipt_reference_hint: 'The reference from the statement. The pro forma number is written onto the payment automatically.',
        receipt_note:           'Note',
        receipt_mail:           'Send the advance invoice by e-mail',
        receipt_mail_hint:      'To the buyer at the address on the pro forma.',
        receipt_will_happen:    'The payment will be posted to the folio and an advance invoice issued.',
        received_done:          'Payment recorded, advance invoice {number} issued.',
        receipt_failed:         'The payment could not be recorded.',
        lower_to_remaining:     'Lower to the remaining amount',
        not_payable:            'This pro forma cannot take a payment — it is cancelled, superseded, expired or paid in full. Issue a new one, or open the advance invoice that already exists.',
        amount_exceeded:        'The amount is more than the pro forma still asks for. {remaining} is outstanding.',

        documents_title:        'Documents of the deal',
        document_proforma:      'Pro forma {number} (PDF)',
        document_advances:      'Advance invoices',
        document_advance:       'Advance invoice {number} (PDF)',
        document_invoice:       'Invoice {number}',
        cancel_title:           'Cancel the pro forma',
        cancel_reason:          'Reason for cancelling',
        cancel_credits_advance: 'Money has been received against this pro forma. Cancelling the paper does NOT return it and does not credit the advance invoice - a refund is a separate act on the payer folio ("Credit part" under prepayments).',
        cancel_done:            'Pro forma {number} was cancelled.',
        cancel_failed:          'The pro forma could not be cancelled.',
        pdf_failed:             'The document could not be downloaded.',
    },
    goffer: {
        button_reservation: 'Offer',
        button: 'Client offer',
        copied: 'The rich offer link is on the clipboard and shown below - AI intro composed, page printable to PDF.',
        minted: 'The rich offer is ready - the link is shown below.',
        link_label: 'Rich offer',
        copy_failed: 'Copying to the clipboard failed - select and copy the link by hand.',
        confirmed_badge: 'Client confirmed {date}',
        hold_failed:     'Rooms could not be held: {reason}',
        download_pdf: 'Download PDF',
        send_mail: 'Send by e-mail',
        mail_sent: 'The offer has been e-mailed.',
        mail_failed: 'The offer could not be sent.',
    },
    gmail: {
        // One window for both send buttons on a group card - the offer's and the
        // rooming list's. The question is the same, who the letter is for; only what
        // the recipient receives differs, which is why the title and the description
        // are the only doubled lines.
        offer_title:   'Send the offer by e-mail',
        offer_hint:    'The recipients get the offer as a PDF - the same one the group screen shows, rendered as it is sent.',
        rooming_title: 'Send the rooming list by e-mail',
        rooming_hint:  'The recipients get the link they enter the guests through. The live link is sent; a new one is minted only if the group has none.',

        recipients:  'Recipients',
        placeholder: 'Type an e-mail address and press Enter…',
        help:        'Enter, a comma or leaving the field adds the address. At most {count} recipients.',
        invalid:       '{email} is not a valid e-mail address.',
        invalid_short: 'Not a valid e-mail address.',
        limit:         'At most {count} recipients.',
        duplicate:   '{email} is already on the list.',
        none:        'Add at least one recipient.',
        send:        'Send',
        sent:        'Sent to {emails}.',
        failed:      'The message could not be sent.',
    },

    gfinance: {
        proforma: 'Pro forma',
        proforma_failed: 'The pro forma could not be prepared - the group has no value yet (a block without a price or held rooms).',
        title: 'Group money',
        balance: 'Group folio balance',
        no_folio: 'The group folio opens on the first collect.',
        collect: 'Collect by rules',
        collected: 'Moved {count} lines ({amount} €) to the group folio.',
        skipped: '{count} lines skipped - see the stay folios.',
        routing: 'The group pays',
        unrouted: '{count} charges of {amount} € are still on the guests’ own folios',
        sources: { room: 'nights', tourist_tax: 'tourist tax', pos: 'POS', service: 'services', facility: 'facilities', manual: 'manual' },
    },
    gpayer: {
        title: 'Group payer',
        payer: 'Payer',
        hint: 'The company that orders and pays. The group folio is opened against it; without one there is no pro forma and no invoice.',
        none: 'No payer',
        missing: 'No payer set - without one there is no group folio and no pro forma.',
        unnamed: 'Set (the name could not be read)',
        set: 'Set the payer',
        change: 'Change',
        saved: 'The group payer has been saved.',
        failed: 'The payer could not be saved.',
    },
    gcancel: {
        title: 'Cancel the whole group',
        held: 'Still held',
        picked_up: 'Picked up (own reservations)',
        contract_value: 'Contract value',
        keep: 'Cancellation charge ({pct} %, {days} days before arrival)',
        already_charged: 'Already on the group card',
        prepaid: 'Paid in advance',
        refund: 'To refund',
        due: 'Still to pay',
        confirm: 'Cancel the group',
        whole_group: 'Whole group',
        members_warning: 'The {rooms} rooms already picked up will be cancelled with the group — their guests lose their reservations.',
        blocked_title: 'The group cannot be cancelled yet',
        blocked_hint: 'These reservations have a guest in the hotel or already checked out: {numbers}. Deal with them first — nothing here will put a guest out of their room.',
        done: 'The group is cancelled; rooms released.',
        done_fee: 'The group is cancelled ({rooms} reservations) and a cancellation charge of {fee} € was posted.',
    },
    // A group's agreed period (docs/SKUPINE.md §12 and §13). Two acts behind one window:
    // the same length is a SHIFT and reprices nothing, a different length buys or gives
    // back nights at the block's agreed price.
    gdates: {
        button: 'Change the dates',
        title: "Change the group's dates",
        hint: 'Every held room and every stay already picked up gains or gives back the nights the new dates say. Before you confirm, below is what happens to each room and what the deal is then worth.',
        mode_dates: 'Changed dates — the length changes',
        mode_dates_hint: "Added nights are charged at the block's agreed price and removed ones come off at the same price. The new day's rate calendar is never read.",
        mode_shift: 'Shifted group — the same number of nights',
        mode_shift_hint: 'The same nights on different days. Nothing is repriced and nothing is posted to a folio.',
        reason: 'Reason',
        reason_help: 'In your own words — "they arrive a day earlier", "the seminar was extended by a night". Required: the agreed number of rooms does not move, so the reason is the only thing that says why the week is different.',
        planning: 'Checking the rooms …',
        value_delta: 'Value of the deal',
        rooms_summary: 'Rooms checked: {rooms} · refused: {blocked}',
        release_note: "The option's release date follows the arrival: {date}",
        nights_added: 'nights more: {count}',
        nights_removed: 'nights fewer: {count}',
        nights_both: 'nights more: {added}, nights fewer: {removed}',
        nights_none: 'no change in the number of nights',
        what_held: 'held room',
        what_stay: 'reservation {number}',
        ok: 'OK',
        ok_unchanged: 'OK — no change',
        ok_added: 'OK — nights more: {count}, {amount} €',
        ok_removed: 'OK — nights fewer: {count}, {amount} €',
        ok_both: 'OK — nights more: {added}, nights fewer: {removed}, {amount} €',
        blocked_title: 'The dates cannot be changed yet ({blocked} of {rooms} rooms)',
        blocked_hint: 'The whole group moves or none of it. Release or move the rooms in the way and try again — nights behind a guest who is already checked in or checked out do not move.',
        confirm: 'Confirm',
        needs_change: 'Enter the new dates — at least one of them has to be different.',
        needs_nights: 'The departure has to be after the arrival — a group with not one night is not a period.',
        needs_reason: 'Enter a reason.',
        needs_plan: 'The plan could not be read.',
        needs_free_rooms: 'Some rooms cannot take the new dates.',
        done: 'The dates are changed: {held} held rooms, {picked_up} reservations. The deal is now {amount} € different.',
        done_shift: 'The group is shifted: {held} held rooms, {picked_up} reservations. The price is unchanged.',
    },
    rooming: {
        plan_title: 'Rooms and the block',
        plan_total: 'Now {now} · after the change {then}',
        plan_unknown_type: 'Unknown room type',
        plan_counts: 'needed {needed} · free in the block {held}',
        plan_short_house: 'short {count} · the house has {available} free',
        plan_per_night: '€/night',
        plan_add: 'Add {count} rooms at {amount}/night',
        plan_add_capped: 'Only {count} are free in the house — there are no more for these dates.',
        plan_none_available: 'The house has none of this type free for these dates.',
        plan_only_available: 'Only {count} rooms are free — add fewer, or pick another room type.',
        // The other rooms the house does have, where one type runs out (docs/SKUPINE.md §16).
        plan_alt_title: 'Instead:',
        plan_alt: '{count} × {name} · {amount}/night ({delta}) · {available} free',
        plan_alt_unpriced: '{count} × {name} · list price · {available} free',
        plan_alt_rest: '{count} rooms still have no type free',
        plan_alt_applied: '{count} rooms are now {name}. Check the price and add them to the block.',
        plan_spare: '{count} rooms are left unused',
        plan_release: 'Release',
        plan_matches: 'matches',
        plan_grown: 'The block is {count} rooms bigger.',
        plan_released: 'Rooms released: {count}.',
        plan_reason_grow: 'the rooming list needs more rooms',
        plan_reason_shrink: 'the rooming list needs fewer rooms',
        plan_fee_title: 'Releasing {count} rooms costs {amount}',
        plan_fee_hint: 'The release date ({date}) has passed, so the contract\'s cancellation ladder applies. The amount is posted to the group folio.',
        plan_fee_hint_ladder: 'The contract\'s cancellation ladder keeps part of the value. The amount is posted to the group folio.',
        plan_fee_title_free: 'Releasing {count} rooms after the release date — confirm',
        plan_fee_confirm: 'Agree and release',
        proforma_reissued: 'A new pro forma {number} was issued; the previous one is superseded.',
        failed_room_taken: 'The block\'s room is no longer available — it has been sold in the meantime. Pick the guest up into another room, or check availability.',
        failed_no_hold: 'The block has no rooms left to pick up. There are more rows in the list than the group booked — add rooms to the block, or put guests together.',
        failed_guest: 'The guest could not be written into the guest book. Check the first and last name.',
        failed_guests: 'The row has no guests, or too many (at most 10 per room).',
        failed_operation: 'This row was sent without its own identifier, so a repeated commit could book it twice. Reload the screen and read the list again.',
        failed_repeat: 'This room is already being booked under the same press of the button. Wait a moment and reload the group — it may already have its reservation.',
        failed_stay: 'The chosen room is not one of this group\'s, or its booking is cancelled or finished. Reload the group and pick another room.',
        no_register: 'No register details - a passport will have to be typed at check-in.',
        occupancy: 'Occupancy',
        occupancy_auto: 'Worked out from the dates of birth — correct it where the list is wrong.',
        link_button: 'Client link',
        link_copied: 'The guest-entry link was copied - send it to the client.',
        load_pending: 'Check the client\'s entries',
        no_pending: 'The client has not entered any guests yet.',
        button: 'Rooming list',
        title: 'Rooming list import',
        placeholder: 'Paste the guest list - Excel/CSV rows or email text…',
        drop_hint: 'Or drop a .csv/.txt file here.',
        parse: 'Parse',
        parse_failed: 'The list could not be parsed.',
        concerns: 'Check before confirming',
        room: 'Room',
        existing: 'existing guest',

        // NOT "new guest". The tag is about the GUEST BOOK and not about the group: on
        // a party whose rooms are all picked up, the person arriving is a member of it.
        new: 'not in the guest book yet',
        new_title: 'The house does not have this person in its guest book yet. A profile is created on confirm.',
        pick_candidate: 'Pick existing…',
        as_new: '→ create as new guest',
        confirm_note: 'Nothing is booked yet. A row with a new room becomes a reservation at the block\'s agreed price; a row with an existing room only adds the guests to it. New guests are created on confirm.',

        // WHERE one row's people go: a room the group already has, or a new one off the
        // block — offered only while the block is still holding one.
        where:        'Where',
        new_room:     'New room',
        free_places:  '{count} free',
        full:         'full',
        no_holds:     'The group holds no more rooms — place the guests in the rooms it already has.',
        placed_count: 'placed: {count}',

        commit: 'Create {count} reservations',
        commit_place: 'Place {count} guests',
        commit_mixed: 'Create {rooms} reservations, place {guests} guests',
        close: 'Close',

        // The ROOMING LISTA row on an expanded group card. Interpolated rather than
        // pluralised, the same as its Slovenian twin — the two have to read as one
        // line, and the number does the work in both.
        row_title:     'Rooming list',
        filled_of:     '{filled} of {total} rooms filled · {guests} guests',
        open:          'Open the list',
        no_link:       'No client link has been issued yet.',
        pending_badge: 'unreviewed: {count}',
        send_mail:     'Send by e-mail',

        // The arrangement editor (docs/SKUPINE.md §17).
        people_title:     'Participants',
        people_search:    'Search by name or company …',
        unassigned:       'No room',
        unassigned_empty: 'Everyone has a room. Drag somebody here to take them out of one.',
        room_empty:       'Empty',
        no_stay_fits: 'No room of the group has {count} free places — drag a person into a room with a free bed.',
        stay_has_places: 'Already {booked}/{capacity} in the room — {free} free. Drag a person here.',
        room_empty_hint:  'This room is empty — drag somebody into it or close it.',
        room_remove:      'Close the room (its people go back to the roster)',
        capacity:         '{guests}/{capacity} guests',
        new_room_zone:    'New room — drag somebody here or click',
        move:             'Move',
        move_to:          'Move to …',
        move_new:         '→ to a new room',
        move_none:        '→ no room',
        occupancy_split:  '{adults} adults, {children} children',

        arrange:                'Arrange automatically',
        arrange_result:         'How it was arranged',
        arrange_done:           'Arranged into {count} rooms. Nothing is booked yet.',
        arrange_failed:         'The list could not be arranged automatically.',
        arrange_hint_title:     'How it arranges',
        arrange_hint_wish:      'A wish in the note wins: "sam" or "enoposteljna" means a room of one, "skupaj z Ano" means a shared room. The words are quoted as an agency writes them.',
        arrange_hint_vip:       'A VIP gets a room of their own unless the note says otherwise.',
        arrange_hint_company:   'Then the same company, and within it the same sex. A man and a woman are never put together — only an explicit wish does that.',
        arrange_hint_capacity:  'No room is ever fuller than its room type allows.',
        arrange_hint_block:     'Room types the block still holds are used first, so the shortfall in "Rooms and block" goes down.',
        arrange_hint_nothing:   'Nothing is booked — you can correct the suggestion by dragging.',
    },
    // Events (docs/DOGODKI.md §3.3). „BEO“ stays BEO — the trade says it in English too.
    event: {
        errors: {
            venue_taken: '{venue} is taken at {at}: {by}. Nothing was saved — pick another time or hall.',
            venue_not_open_range: 'The hall {venue} has no term at {at}: its diary that day only runs from {from} to {to}, and the part (preparation and clearing down included) reaches past it. Nothing was saved. Extend the hall\'s opening hours under Settings → Facilities; the diary publishes itself on save.',
            venue_not_open_day: 'The hall {venue} has no terms at all on the day of {at}: that weekday is closed in its opening hours, or its diary is not published that far ahead. Nothing was saved. Set the opening hours under Settings → Facilities; a missing diary is repaired with "Publish diary".',
            venue_closed: 'The hall {venue} is closed at {at} (a closure in Facilities). Nothing was saved — choose another time or another hall.',
            venue_taken_unnamed: 'The hall {venue} is taken at {at} by a booking with no name on it. Nothing was saved — look it up in Facilities or choose another time.',
            setup_overlap: '{venue} is free, but its setup and teardown ({preparation} + {teardown} min) overlap {by} ({held}). Move the part or shorten the turnaround on the facility.',
            guarantee_locked: 'The guaranteed headcount of {part} ({guaranteed} → {requested}) changes only through a new version once confirmed. Use “New version”.',
            guarantee_past_cutoff: 'The guarantee deadline for {part} has passed ({cutoff}); {guaranteed} → {requested} can no longer be lowered. A raise goes through a new version.',
            version_superseded: 'Version {seen} you are looking at no longer stands — version {standing} does. Reload the event and try again.',
            lines_unbalanced: 'The lines do not add up to the package (difference {difference} €) on: {parts}. Fix the lines before confirming the version.',
            not_settled: 'The event cannot be closed: the folio has an open balance of {balance} € and {unposted} unposted lines.',
        },
        title: 'Events',
        hint: 'Seminars, conferences, weddings and banquets: from enquiry to close.',
        add: 'New event',
        edit: 'Edit event',
        open: 'Open',
        not_found: 'No such event.',
        empty: 'No events in this scope.',
        column_empty: 'Empty',
        count: 'showing {shown} of {total}',
        hidden: 'hidden: {count}',
        search_placeholder: 'Number, name, client, owner …',

        number: 'Number',
        name: 'Name',
        public_name: 'Public name',
        public_name_help: 'What may go on the lobby wall. Empty means „do not publish“, not „use the internal name“.',
        kind: 'Kind',
        source: 'Source',
        source_unknown: 'Not stated',
        client: 'Client',
        no_client: 'No client',
        any_client: 'All clients',
        option_title: 'Option',
        option_hint: 'An option holds the hall, so it has a deadline. Without one the hall is held for ever.',
        option_until: 'Option valid until',
        option_confirm: 'Take the option',
        owner: 'Owner',
        no_owner: 'No owner',
        any_owner: 'All owners',
        dates: 'Dates',
        start: 'Start',
        end: 'End',
        dates_required: 'Choose a start and an end.',
        budget: 'Value',
        minimum_spend: 'Minimum spend',
        notes: 'Notes',
        publish: 'Show on screens',
        publish_help: 'The public name, the hall and the time — never the client, the price or the headcount.',
        guarantee_cutoff: 'Guarantee deadline',
        guarantee_cutoff_help: 'Past it the guaranteed headcount moves only through a new version.',
        filter_from: 'From',
        filter_to: 'To',

        status: 'Status',
        status_inquiry: 'Enquiry',
        status_option: 'Option',
        status_confirmed: 'Confirmed',
        status_in_progress: 'In progress',
        status_completed: 'Completed',
        status_lost: 'Lost',
        status_cancelled: 'Cancelled',
        status_changed: 'The status is now „{status}“.',
        status_failed: 'The status could not be changed.',
        confirm: 'Confirm',
        move_to: 'Move to „{status}“',

        scope_live: 'Live stages',
        scope_all: 'All',
        scope_lost: 'Lost',
        scope_cancelled: 'Cancelled',
        scope_completed: 'Completed',
        view_table: 'Table',
        view_pipeline: 'Pipeline',

        kind_conference: 'Conference',
        kind_seminar: 'Seminar',
        kind_meeting: 'Meeting',
        kind_wedding: 'Wedding',
        kind_banquet: 'Banquet',
        kind_party: 'Party',
        kind_other: 'Other',

        source_mail: 'E-mail',
        source_phone: 'Telephone',
        source_web: 'Web',
        source_crm: 'CRM',
        source_desk: 'Reception',
        source_walk_in: 'Walk-in',

        lost_title: 'Lost',
        lost_hint: 'An enquiry that went nowhere. The reason is mandatory and comes from the codebook — a funnel with free-text losses cannot be added up.',
        lost_reason: 'Reason',
        lost_note: 'Note',
        lost_note_help: 'Optional. What somebody would jot down after the call.',
        lost_confirm: 'Mark as lost',
        lost_done: 'The event is marked as lost.',
        lost_failed: 'The event could not be marked as lost.',
        lost_price: 'Price',
        lost_availability: 'Nothing free',
        lost_dates: 'Dates',
        lost_competitor: 'Competitor',
        lost_capacity: 'Capacity',
        lost_no_reply: 'No reply',
        lost_called_off: 'Called off',
        lost_other: 'Other',

        headcount: 'Headcount',
        headcount_hint: 'Planned is the working figure, guaranteed is the contractual one, actual is what turned up.',
        headcount_triple: 'plan. {planned} · guar. {guaranteed} · act. {actual}',
        headcount_short: '{count} people',
        headcount_inherited: 'A part with no figures of its own reads the event\'s.',
        headcount_inherited_short: 'inherited from the event',
        headcount_guarantee_locked: 'The guarantee deadline has passed — only a new version moves it.',
        headcount_actual_locked: 'The actual figure is entered once the event is running.',
        planned: 'Planned attendees',
        planned_help: 'The working figure. It moves freely until there is a signature.',
        guaranteed: 'Guaranteed attendees',
        guaranteed_help: 'The figure the house bills against.',
        actual: 'Actual attendees',

        tab_programme: 'Programme',
        tab_catering: 'Lines and menu',
        tab_rooms: 'Rooms and participants',
        tab_staff: 'Staff',
        tab_offer: 'Offer',
        tab_versions: 'Versions',
        tab_beo: 'BEO',
        tab_money: 'Financial agreement',

        programme_hint: 'Every part claims its hall for its own window. Setup and teardown are inside the claim and outside the printed programme.',
        programme_empty: 'The programme is still empty.',
        part_add: 'Add part',
        part_edit: 'Edit part',
        part_title: 'Part name',
        part_kind: 'Part kind',
        part_order: 'Order',
        part_order_help: 'For two parts at the same hour.',
        part_date: 'Date',
        part_from: 'From',
        part_to: 'To',
        part_date_required: 'Choose the part\'s date.',
        part_outside_event: 'The part must fall on the event\'s own days: {from} – {to}. For another day, change the event\'s dates first.',
        part_venues: 'Halls',
        part_venues_help: 'The claim is all or nothing: a hall that cannot be had refuses the whole save.',
        part_no_venue: 'No hall',
        part_no_venue_yet: 'No hall claimed yet',
        part_layout: 'Layout',
        part_department: 'Department',
        part_responsible: 'Responsible',
        part_claimed: 'claimed {from}–{to}',
        part_turnaround: 'Preparation and teardown',
        part_turnaround_manual: 'Set manually',
        part_turnaround_preparation: 'Preparation (min)',
        part_turnaround_teardown: 'Teardown (min)',
        part_turnaround_automatic: 'automatic: preparation {preparation} min · teardown {teardown} min',
        part_turnaround_automatic_none: 'automatic: the chosen hall declares no preparation or teardown',
        part_turnaround_automatic_no_venue: 'automatic: choose a hall to see its own minutes',
        part_turnaround_hint: 'Applies to the first or the last part in the hall; between parts of the same event it is not counted.',
        part_turnaround_manual_hint: 'A manual figure holds even when another part of the same event precedes this one.',
        part_turnaround_line: 'preparation {preparation} min · teardown {teardown} min',
        part_turnaround_manual_badge: 'manual',
        part_turnaround_auto_badge: 'automatic',
        part_shared_badge: 'shared hall',
        part_shared_own: 'The hall {venue}: this part overlaps the part „{part}“ of the same event ({from}–{to}) — both are in the hall at once.',
        part_shared_own_turnaround: 'The hall {venue}: the setup or teardown overlaps the part „{part}“ of the same event ({from}–{to}).',
        part_shared_sentence: 'The hall {venue} is also in event {event} at this time ({from}–{to}) — used simultaneously.',
        part_shared_turnaround: 'The hall {venue} is also in event {event} at this time ({from}–{to}) — the setup or teardown overlaps.',
        part_lines: 'lines: {count}',
        part_release: 'Remove',
        part_release_confirm: 'Remove the part „{part}“ and release its hall?',
        part_released: 'The part is removed and the hall released.',
        part_failed: 'The part could not be saved.',
        part_untitled: 'Untitled part',

        part_kind_arrival: 'Arrival',
        part_kind_registration: 'Registration',
        part_kind_session: 'Session',
        part_kind_break: 'Break',
        part_kind_lunch: 'Lunch',
        part_kind_dinner: 'Dinner',
        part_kind_reception: 'Reception',
        part_kind_ceremony: 'Ceremony',
        part_kind_party: 'Party',
        part_kind_setup: 'Setup',
        part_kind_teardown: 'Teardown',
        part_kind_other: 'Other',

        layout_none: 'No layout',
        layout_theatre: 'Theatre',
        layout_school: 'Classroom',
        layout_u_shape: 'U-shape',
        layout_banquet: 'Banquet',
        layout_cocktail: 'Cocktail',
        layout_boardroom: 'Boardroom',
        layout_custom: 'Custom',

        catering_title: 'Lines and menu — {part}',
        catering_hint: 'What is on these two cards after Save IS the agreement for this part: the menu, and everything else it is billed for. An empty card means there is none.',
        catering_hint_short: 'The menu and the other lines, by part of the programme.',
        catering_edit: 'Edit lines and menu',
        card_menu: 'Menu',
        card_menu_hint: 'This part\'s food and drink, with its diets.',
        card_menu_add: 'Add a dish or a drink',
        card_menu_empty: 'The menu is empty.',
        card_other: 'Other lines',
        card_other_hint: 'Hall hire, equipment, staff, outside suppliers and the rest.',
        card_other_empty: 'No other lines.',
        card_subtotal: 'Total: {amount}',
        hire_offer: 'The hall {venue} is priced at {price}.',
        hire_add: 'Add the hall hire',
        hire_title: 'Hire — {venue}',
        catering_add_line: 'Add line',
        catering_empty: 'No lines.',
        catering_none: 'This part has neither a menu nor other lines.',
        catering_saved: 'The lines and the menu are saved.',
        catering_failed: 'The menu could not be saved.',
        diets: 'Diets',
        per_head: 'per head',

        line_title: 'Line',
        line_kind: 'Kind',
        line_per: 'Per',
        line_quantity: 'Quantity',
        line_unit: 'Unit price',
        line_discount: 'Discount (%)',
        line_tax: 'VAT',
        line_price_mode: 'Mode',
        line_covered_by: 'Included in',
        line_posting: 'Posting',
        line_untitled: 'Untitled line',

        line_kind_venue: 'Hall',
        line_kind_food: 'Food',
        line_kind_drink: 'Drink',
        line_kind_equipment: 'Equipment',
        line_kind_staff: 'Staff',
        line_kind_external: 'External',
        line_kind_other: 'Other',

        per_per_event: 'per event',
        per_per_person: 'per person',
        per_per_hour: 'per hour',
        per_per_item: 'per item',

        price_mode_included: 'Included',
        price_mode_surcharge: 'Surcharge',
        price_mode_free: 'Free',

        posting_on_confirmation: 'On confirmation',
        posting_on_completion: 'On completion',
        posting_none: 'Not posted',

        covered_by_none: 'On its own',
        covered_by_package: 'Package',
        covered_by_board: 'Board',
        covered_by_rate_plan: 'Rate plan',

        diet_vegetarian: 'Vegetarian',
        diet_vegan: 'Vegan',
        diet_gluten_free: 'Gluten free',
        diet_lactose_free: 'Lactose free',
        diet_halal: 'Halal',
        diet_kosher: 'Kosher',
        diet_child: 'Child',
        diet_other: 'Other',

        balance_ok: 'The lines add up: {total}.',
        balance_off: 'The lines do not add up',
        balance_off_hint: 'The difference is {difference}, lines at fault: {count}. A version cannot be frozen until it balances.',

        kitchen_preview: 'Kitchen sheet',
        kitchen_empty: 'Nothing to draw.',
        kitchen_confirmed: 'From confirmed version {version}.',
        kitchen_draft: 'Working state — not the contract.',
        kitchen_covers: '{count} covers',
        kitchen_estimate: 'estimate',
        kitchen_on_actuals: 'on actuals',
        kitchen_use_contract: 'Confirmed version',
        kitchen_use_draft: 'Working state',
        section_kitchen: 'Kitchen',
        section_service: 'Service',
        section_department: 'Department',

        rooms: 'Rooms',
        rooms_none: 'This event has no rooms. A block of rooms is a group — the event points at it.',
        rooms_linked: 'This event\'s rooms are held by a group.',
        rooms_open: 'Open the group',
        rooms_create: 'Add rooms',
        rooms_new_name: 'Group name',
        rooms_link: 'Link an existing group',
        rooms_link_do: 'Link',
        rooms_pick: 'Choose a group',
        rooms_type: 'Room type',
        rooms_count: 'Rooms',
        rooms_price: 'Price/night',
        rooms_add_block: 'Add a room type',
        rooms_arrival: 'Arrival',
        rooms_departure: 'Departure',
        rooms_nights_help: 'The nights the rooms are held for; by default the event day and the morning after.',
        rooming_import: 'Into the group\'s rooming list',
        rooming_copy: 'Copy stayers for rooming',
        rooming_copied: '{count} people copied — open the group, Rooming list, Paste.',
        rooming_copy_failed: 'Copy failed; select the list by hand.',
        rooms_release: 'Release date',
        rooms_release_help: 'Until when the house holds the rooms. Empty means no deadline.',
        rooms_unlink: 'Unlink the group',
        rooms_saved: 'Saved.',
        rooms_failed: 'The link could not be saved.',

        participants: 'Participants',
        participants_empty: 'No participants.',
        participants_counts: 'total {total} · staying {staying} · external {external}',
        diet_none: 'No diet',
        participant_add: 'Add a participant',
        participant_add_failed: 'The participant could not be added.',
        participant_first_name: 'First name',
        participant_last_name: 'Surname',
        participant_name: 'Name',
        participant_company: 'Company',
        participant_role: 'Role',
        participant_diet: 'Diet',
        participant_staying: 'Staying',
        participant_has_bed: 'has a bed',
        participant_wants_bed: 'wants a bed',
        participant_delete_failed: 'The participant could not be removed.',

        role_delegate: 'Delegate',
        role_speaker: 'Speaker',
        role_vip: 'VIP',
        role_staff: 'Staff',
        role_supplier: 'Supplier',

        import_title: 'Import participants',
        import_hint: 'Paste the list. The model reads it and shows what it understood — nothing is written until you confirm.',
        import_placeholder: 'First name, surname, company, e-mail, staying, diet …',
        import_parse: 'Read',
        import_parse_failed: 'The list could not be read.',
        import_row: 'Row',
        import_match: 'Match',
        import_match_new: 'new',
        import_match_existing: 'in the register',
        import_match_ambiguous: 'ambiguous ({count})',
        import_counts: 'total {total} · staying {staying} · external {external}',
        import_linked: 'linked: {count}',
        import_concerns: 'What was unclear',
        import_replace: 'Replace the existing list',
        import_replace_help: 'The organiser sent a corrected list. The old one is emptied.',
        import_back: 'Back',
        import_confirm: 'Import',
        import_done: 'Added {added}, removed {removed}.',
        import_failed: 'The import failed.',

        needs_title: 'Staffing need — {part}',
        needs_edit: 'Edit needs',
        needs_add: 'Add a need',
        needs_none: 'This part asks for no staff.',
        needs_people: 'People',
        needs_position: 'Position',
        needs_saved: 'The staffing needs are saved.',
        needs_failed: 'The staffing needs could not be saved.',
        any_position: 'Any position',
        no_department: 'No department',
        all_departments: 'All departments',

        staffing: 'Cover from the rota',
        staffing_day: 'Day',
        staffing_need: 'Need',
        staffing_scheduled: 'Scheduled',
        staffing_draft: 'draft',
        staffing_shortfall: 'Short',
        staffing_empty: 'Nothing to show.',
        staffing_no_rota: 'The rota for these days is not published yet.',

        offer_hint: 'The offer link is minted only where there is none: a second press answers the same link, because a new one would invalidate the address sales has already sent.',
        offer_needs_version: 'An offer is a frozen version, not a draft. Freeze a version first — what is in the programme and the catering now becomes the agreement — then mint the link.',
        offer_none: 'No offer link yet.',
        offer_issue: 'Mint a link',
        offer_issued: 'Issued',
        offer_issued_done: 'The link is ready.',
        offer_expires: 'Expires',
        offer_viewed: 'Viewed',
        offer_not_viewed: 'Not viewed yet',
        offer_copy: 'Copy',
        offer_copied: 'The link is copied.',
        offer_copy_failed: 'The link could not be copied.',
        offer_open: 'Open',
        offer_pdf: 'Offer PDF',
        offer_revoke: 'Revoke the link',
        offer_revoked: 'The link is revoked.',
        offer_failed: 'That could not be done.',
        offer_client: 'The client\'s confirmation',
        offer_client_confirmed: 'The client confirmed version {version} ({at}).',
        offer_client_waiting: 'The client has not confirmed yet.',

        version: 'Version',
        diff_field: {
            title: 'Title',
            kind: 'Kind',
            per: 'Unit',
            quantity: 'Quantity',
            unit_amount: 'Price per unit',
            discount: 'Discount',
            tax_rate: 'VAT',
            price_mode: 'Mode',
            covered_by: 'Included in',
            posting: 'Posting',
            diets: 'Diets',
            start_at: 'Start',
            end_at: 'End',
            facility_id: 'Halls',
            layout: 'Layout',
            department_id: 'Department',
            responsible_user_id: 'Responsible',
            notes: 'Notes',
        },
        versions_hint: 'A frozen version is a snapshot of the agreement. The difference is computed on read and never stored.',
        versions_empty: 'No version has been frozen yet.',
        version_when: 'Frozen',
        version_reason: 'Reason',
        version_total: 'Total',
        version_acknowledged: 'Acknowledged by',
        version_nobody: 'nobody yet',
        version_standing: 'standing',
        version_standing_short: 'version {version}',
        version_compare: 'Compare',
        diff_from: 'From version',
        diff_to: 'To',
        diff_working: 'Working state',
        diff_none: 'No difference.',
        diff_added: 'added',
        diff_removed: 'removed',
        diff_changed: 'changed',
        diff_headcount: 'Headcount: planned {planned}, guaranteed {guaranteed}, actual {actual}',
        acknowledge: 'Acknowledge',
        acknowledge_title: 'Acknowledge version {version}',
        acknowledged: 'The acknowledgement is recorded.',
        acknowledge_failed: 'The acknowledgement could not be recorded.',

        change_title: 'New version',
        change_hint: 'Version {version} stands. A change to a confirmed event is a new version, not a correction.',
        change_hint_first: 'The first version: what is in the programme now becomes the agreement.',
        change_reason: 'Reason',
        change_reason_help: 'What changed and why. It goes into the letter to the departments.',
        change_needs_reason: 'A reason is required.',
        change_confirm: 'Freeze the version',
        change_done: 'Version {version} is frozen.',
        change_failed: 'The version could not be frozen.',
        impact: 'What this means',
        impact_loading: 'Working out the difference …',
        impact_value: 'Change in value',
        impact_headcount: 'Headcount',
        impact_headcount_same: 'unchanged',
        impact_parts: 'Parts of the programme',
        impact_parts_count: 'changed: {count}',
        impact_acknowledgements: 'These acknowledgements will be reset:',
        impact_capacity: 'Check the figures',
        impact_capacity_guarantee: 'The guaranteed figure ({guaranteed}) is above the planned one ({planned}).',

        beo_view: 'View',
        beo_view_all: 'All',
        beo_view_kitchen: 'Kitchen',
        beo_view_service: 'Service',
        beo_view_technical: 'Technical',
        beo_version: 'Version',
        beo_contract: 'Confirmed (the contract)',
        beo_working: 'Working state',
        beo_since: 'Difference since',
        beo_since_help: 'On a change the difference is sent, not a new sheet.',
        beo_since_none: 'No difference',
        beo_confirmed: 'Confirmed version {version}',
        beo_draft: 'Working state — not the contract.',
        beo_generated: 'drawn {at}',
        beo_change: 'What changed between versions {from} and {to}',
        beo_setup: 'claimed {from}–{to}',
        beo_sections: 'Acknowledgements by department',
        beo_taken: 'taken by {who} ({at})',
        beo_not_taken: 'not taken yet',
        beo_pdf_failed: 'The sheet could not be printed.',
        beo_pdf: 'Print',
        beo_empty: 'Nothing to draw.',
        basis_actual: 'on the actual figure',
        basis_guaranteed: 'on the guaranteed figure',
        basis_planned: 'on the planned figure',

        tasks: 'Tasks',
        tasks_empty: 'No tasks.',
        tasks_generate: 'Rebuild from the programme',
        tasks_generated: 'New {created}, refreshed {refreshed}, withdrawn {withdrawn}.',
        tasks_generate_failed: 'The tasks could not be rebuilt.',
        task_open: 'Open',
        task_done: 'Done',
        task_cancelled: 'Withdrawn',
        task_stale: 'from an older version',
        task_failed: 'The task could not be changed.',

        folio: 'Event folio',
        folio_is_group: 'the group\'s folio',
        folio_none: 'No folio has been opened.',
        folio_create: 'Open a folio',
        folio_created: 'The folio is open.',
        folio_failed: 'The folio could not be opened.',
        folio_open: 'Open the folio',
        folio_charges: 'Charges',
        folio_payments: 'Payments',
        folio_balance: 'Balance',
        folio_unbilled: 'Not yet posted',
        post_charges: 'Post the charges',
        post_pending: 'unposted: {count}',
        post_done: 'Posted {posted}, unchanged {unchanged}, total {amount}.',
        post_failed: 'The charges could not be posted.',

        proformas: 'Pro formas',
        proformas_state: 'issued {count} · requested {requested} · paid {prepaid}',
        proforma_again_confirm: 'The event already has an open pro forma, {number}, still waiting to be paid. Issue another one?',
        proforma_pdf: 'PDF',
        proforma_row_dates: 'issued {issued} · valid until {valid}',
        proformas_last: 'last: {number}',
        proforma_share: 'Share (%)',
        proforma_share_help: 'Empty or 100 % means the whole value.',
        proforma_valid: 'Valid (days)',
        proforma_issue: 'Issue a pro forma',
        proforma_done: 'Pro forma {number} is issued.',
        proforma_failed: 'The pro forma could not be issued.',

        ladder: 'Cancellation ladder',
        ladder_hint: 'How much the house keeps if the event is called off that many days ahead. Ordered from the longest lead time down.',
        ladder_days: 'Days before',
        ladder_keep: 'Keep (%)',
        ladder_add: 'Add a tier',
        ladder_saved: 'The ladder is saved.',
        ladder_failed: 'The ladder could not be saved.',

        ending: 'Ending the event',
        cancel_open: 'Cancel the event',
        cancel_title: 'Cancelling the event',
        cancel_contract: 'Contract value',
        cancel_tier: 'Tier ({days} days ahead, {percent} %)',
        cancel_prepaid: 'Already paid',
        cancel_refund: 'To refund',
        cancel_due: 'Still owing',
        cancel_venues: 'Halls released: {count}.',
        cancel_reason: 'Reason for cancelling',
        cancel_waive: 'Waive the cancellation fee',
        cancel_waive_help: 'The house gives up its share. That it was waived is recorded.',
        cancel_confirm: 'Cancel the event',
        cancel_done: 'The event is cancelled.',
        cancel_failed: 'The event could not be cancelled.',
        cancel_quote_failed: 'The ladder could not be read.',
        close: 'Close the event',
        close_done: 'The event is closed. Balance: {balance}.',
        close_failed: 'The event could not be closed.',

        calendar: 'Hall calendar',
        calendar_empty: 'No events in this period.',
        calendar_venue: 'Hall',
        calendar_claimed: 'Claimed window (setup and teardown)',
        calendar_shared: 'Hall shared with another event',
        all_venues: 'All halls',
        today: 'Today',
        range_previous: 'Previous period',
        range_next: 'Next period',
        view_day: 'Day',
        view_week: 'Week',
        view_month: 'Month',

        warn_unclaimed: 'No hall is claimed for {count} parts of the programme (e.g. „{part}“).',
        warn_shared_own: 'The hall {venue}: the part „{part}“ overlaps the part „{other}“ ({from}–{to}) of the same event.',
        warn_shared_venue: 'The hall {venue} is shared with event {event} ({from}–{to}) for the part „{part}“.',
        warn_no_version: 'The event is confirmed but nothing is frozen — every department is working from a draft.',
        warn_guarantee_due: 'The guaranteed headcount is not set · the deadline is in {days} days.',
        warn_guarantee_passed: 'The guarantee deadline has passed ({date}) and no figure is set.',
        warn_unbalanced: 'The lines do not add up: {difference} € out, {count} at fault. A version cannot be frozen.',
        warn_stale: 'The instructions are stale — the event has changed since version {version}. The money, the pro forma and the departments\' sheets still show version {version}: freeze a new version, then post the lines on the finance tab.',
        warn_not_acknowledged: 'Version {version} has not been taken by: {departments}.',
        warn_rooms_changed: 'The room block changed after confirmation — check the offer and the version.',
        warn_no_payer: 'No payer — without one there is no folio and no pro forma.',
        warn_unposted: 'Contract lines not yet posted: {count}.',
        warn_folio_open: 'The event folio is not settled.',
    },
    group: {
        // The list a desk works from is the LIVE one. A cancelled group and a completed
        // one are over, and a list opening on all five states grows a tail of finished
        // business that pushes the next arrival off the screen.
        scope_live:      'Live groups',
        scope_all:       'All',
        scope_cancelled: 'Cancelled',
        scope_completed: 'Completed',
        search_placeholder: 'Number, name, company, contact, dates, rooms, state',
        search_matches:     'found: {shown} of {total}',
        hidden:          'hidden: {count}',
        sort_by:         'Sort by: {column}',
        actions_menu:    'Actions',
        group: 'Group',
        pickup: 'Pick up room',
        pickup_title: 'Pick up a room from the block',
        pickup_room_note: "The block hands out its next held room of this type, which need not be the one you pressed on the board. Which it was shows on the board straight after.",
        pickup_payer_group: 'The group pays - {payer}',
        pickup_payer_guest: 'The guest pays',
        pickup_guests_hint: "One line per bed. The pickers offer this group's own people; anybody new is added from inside them.",
        pickup_check_in_now: 'Reservation {number} exists. Check the guest in now?',
        pickup_payer_none: "This group has no payer of its own - there is no ordering company and its contact is not one of the house's guests. The room is therefore paid for by the guest you pick below.",
        pickup_needs_room_type: "The block is not known, so nothing can be picked up. Open the group and pick the room up from its own page.",
        pickup_needs_payer_group: 'The group has no payer the room could be billed to. Pick a guest.',
        pickup_needs_payer_guest: 'Pick the guest who pays for the room.',
        pickup_needs_people: 'The room must hold at least one person.',
        pickup_hint: 'One held room leaves the block and becomes a confirmed reservation at the block\'s agreed price. The market never touches the room - its nights are atomically relabelled onto the new reservation.',
        picked_up: 'Reservation {number} was created from the block.',
        title: 'Group reservations',
        hint: 'A group holds a room block: on entering Option the system takes concrete rooms per type - the chessboard, sales and channels see the truth at once.',
        add: 'New group',
        create: 'Create',
        created: 'The group was created as an inquiry.',
        number: 'Number',
        name: 'Name',
        period: 'Period',
        rooms: 'Rooms',
        rooms_short: 'rooms',
        night: 'night',
        status: 'Status',
        release: 'Release',
        release_help: 'The option holds until this day; unclaimed rooms then return to sale by themselves.',
        released: 'Released',
        held: 'holding {count}',
        holding: 'holding {count} rooms',
        not_holding: 'not holding yet',
        contact: 'Contact',
        notes: 'Notes',
        blocks: 'Room block',
        add_block: 'Add type',
        price_from_plan: 'Price list',
        no_plan: 'Manual / no price list',
        manual_price: 'manual',
        available_short: 'available: {count}',
        block_total: 'Block total',
        grand_total: 'Grand total',
        block_shortage: '{type}: only {available} rooms free (asked for {requested}); the tightest night is {night}.',
        empty: 'No groups yet. Create the first with New group.',
        // The units beside the block row's two number boxes. Without them they are two
        // figures nobody can say what they are per.
        discount_unit: '% discount',
        price_unit:    '€ / night / room',
        not_found: 'There is no such group - it may have been deleted, or the link points at another hotel.',
        statuses: { inquiry: 'Inquiry', option: 'Option', confirmed: 'Confirmed', completed: 'Completed', cancelled: 'Cancelled' },
        actions: { option: 'To option', confirmed: 'Confirm', completed: 'Complete', cancelled: 'Cancel' },
        done: {
            option: 'Rooms are taken - the option holds the block.',
            confirmed: 'The group is confirmed.',
            completed: 'The group is completed; unclaimed rooms released.',
            cancelled: 'The group is cancelled; rooms released.',
        },
    },
    // The house's rota rules (docs/OSEBJE.md §7, §16). The defaults are the statutory
    // floor (ZDR-1); the form writes none of them — empty means "whatever the law says".
    staff_today: {
        title: 'Today',
        hint:  'Six things about today that need a decision or a telephone call. Nothing is decided here — every row leads to the screen where it is closed. It refreshes itself every two minutes while the tab is open.',

        date_hint:    'A calendar day in the house\u2019s own clock. Today by default.',
        generated_at: 'Refreshed at {time}',

        not_visible:      'Not visible to you',
        not_visible_hint: 'This section needs the {permission} permission. Empty and „you may not see it“ are not the same thing, so nothing is shown here.',

        empty:     'Nothing.',
        truncated: 'Showing {shown} of {total}.',

        unnamed_department: 'Unnamed department',
        unnamed_person:     'Unnamed person',
        channel_unknown:    'unknown channel',

        section_coverage_gaps:      'Not covered',
        section_coverage_gaps_hint: 'Departments today\u2019s published rota does not cover. Drafts are listed separately — those are closed by pressing Publish, not by finding somebody.',

        section_missing_stamps:      'Missing stamps',
        section_missing_stamps_hint: 'The rota is an intention and the clock is a fact. A row is a question worth asking and never an accusation.',

        section_waiting_approval:      'Waiting for a decision',
        section_waiting_approval_hint: 'Leave, corrections to the record and shift changes nobody has confirmed. Oldest first.',

        section_documents_expiring:      'Documents expiring',
        section_documents_expiring_hint: 'Papers on personnel cards that expire within 30 days, or already have.',

        section_failed_notifications:      'Failed notifications',
        section_failed_notifications_hint: 'What the house tried to tell staff in the last 7 days and could not. A wrong number or a blocked channel is not mended by waiting.',

        section_in_house:      'In the house',
        section_in_house_hint: 'Who is clocked in right now, and who is away today.',

        row_coverage_gap:        'short by {minutes}, even counting drafts',
        row_coverage_draft:      'short by {minutes}; the drafts would close it — publish',
        row_no_arrival:          'shift running {minutes} with no arrival',
        row_still_in:            'shift ended {minutes} ago, still clocked in',
        row_open_stamp:          'an arrival {days} days ago that was never closed',
        row_absence_request:     '{kind} — waiting {days} days',
        row_time_correction:     'correction to the record — waiting {days} days',
        row_shift_change:        'shift change not acknowledged — {days} days',
        row_document_expiring:   'expires in {days} days',
        row_document_expired:    'expired {days} days ago',
        row_delivery_failed:     'the message did not get through ({channel})',
        row_clocked_in:          'in the house {minutes}',
        row_on_absence:          'away — {kind}',
    },

    staff_rules: {
        title: 'Rota rules',
        hint:  'What this house allows when a week is planned. An empty field means the statutory floor, shown as the hint. None of this refuses a shift — the rota warns, and the trail records that the supervisor saved anyway. The one thing that IS refused is two shifts of one person over the same hours.',

        daily_rest:      'Daily rest between two shifts (min)',
        daily_rest_hint: 'ZDR-1: 11 hours. Empty = 11 hours.',

        weekly_rest:      'Weekly rest within seven days (min)',
        weekly_rest_hint: 'ZDR-1: 24 uninterrupted hours. Empty = 24 hours.',

        max_consecutive_days:      'Most consecutive working days',
        max_consecutive_days_hint: 'Empty = 6.',

        max_daily_minutes:      'Most hours in a day (min)',
        max_daily_minutes_hint: 'ZDR-1: 10 hours including overtime. Empty = 10 hours.',

        max_weekly_overtime:      'Allowed over the weekly obligation (min)',
        max_weekly_overtime_hint: 'Measured against the obligation on that person\'s own personnel card, never against a house-wide forty. ZDR-1: 8 hours a week. Empty = 8 hours.',

        late_stamp:      'Wait before a stamp counts as missing (min)',
        late_stamp_hint: 'This long after a shift has started with nobody clocked in, the person appears on the Today screen. The threshold decides only whether somebody is asked — the hours are counted either way. Empty = 15 min.',

        days_value: '{days} days',
    },

    // Payroll Connect — how a closed month leaves the house (docs/EVIDENCA-CASA.md
    // § „Payroll Connect“). Nothing here says what an hour is worth: that is accounting's
    // answer.
    staff_payroll: {
        title: 'Payroll',
        hint:  'Where a closed month goes and in what shape. None of this changes a number — it names the program that takes the file, the company code it belongs under, and how an hour is spelled. What an hour is worth stays accounting\'s answer.',

        provider:      'Payroll program',
        provider_hint: 'A record of which program takes the file. Every one of them gets the same rows out of the same snapshot.',

        provider_generic:  'Generic (plain file)',
        provider_vasco:    'Vasco',
        provider_saop:     'SAOP',
        provider_pantheon: 'Pantheon',
        provider_minimax:  'Minimax',

        company_code:      'Company code',
        company_code_hint: 'This house\'s own code in the payroll program. It is written into the first column of every row.',

        export_format:      'Default export format',
        export_format_hint: 'XLSX is recorded as a preference and not offered as a file: this service cannot write one, and the export refuses it by name. Adding a spreadsheet library is a decision about the approved-dependency list.',

        format_csv:  'CSV',
        format_xlsx: 'XLSX (not available)',

        hours_as:      'How hours are written',
        hours_as_hint: 'A spelling and never a rounding: 455 minutes is 7.58 hours or 7:35, and either can be turned back into minutes. The monthly sheet a person signs is always h:mm.',

        hours_decimal: 'Decimal (7.58)',
        hours_hhmm:    'Hours and minutes (7:35)',

        decimal_comma:      'Slovenian number format',
        decimal_comma_hint: 'A decimal comma, and semicolons between columns — which is what Excel on a Slovenian Windows opens. One switch and not two: a file with commas in its decimals AND between its columns has no columns.',

        absence_codes:      'Absence wage codes',
        absence_codes_hint: 'Your own wage codes for our kinds of absence. Deliberately empty: which of our kinds falls under which code is a question for accounting (docs/OSEBJE-RACUNOVODSTVO.md, question 1) and we do not guess it. Left empty, the export carries our own name for the kind and the file is still complete.',
        absence_code_placeholder: 'e.g. D01',
        absence_codes_count: 'Codes filled in: {count}',
        absence_codes_empty: 'No codes filled in',

        export:       'Payroll export',
        export_draft: 'Payroll export (draft)',

        export_csv:                'CSV — one row per person',
        export_csv_detail:         'CSV — with the day-by-day section',
        export_xlsx_unavailable:   'XLSX — not available',

        sheet:          'Employee sheet (PDF)',
        my_sheet:       'My monthly sheet (PDF)',
        my_sheet_draft: 'My monthly sheet (draft)',
    },

    ai_settings: {
        events_enable: 'Read local events',
        title: 'Milo - AI assistant',
        hint: 'What Milo may read about the town.',
        events_url: 'Local events source (URL)',
        events_url_help: 'The town events calendar page - e.g. the tourist board calendar. Empty means Milo does not answer about events.',
        events_sources: 'Events sources',
        events_sources_hint: 'The calendars and feeds Milo reads and parses into a day-by-day list. A town is rarely one publisher — add as many as it has.',
        events_sources_empty: 'No sources. Until there are, Milo reads the address above if one is set.',
        events_source_add: 'Add source',
        events_source_label: 'Name',
        events_source_label_placeholder: 'Visit Ljubljana',
        events_source_kind: 'Kind',
        events_source_url: 'Address',
        events_kind_ics: 'ICS calendar',
        events_kind_feed: 'RSS / Atom feed',
        events_kind_visitljubljana: 'Visit Ljubljana (Ljubljana only)',
    },
    tv_channels: {
        url_insecure: 'This address is http:// — the screen is served over https and a browser will not load such a stream into it (blocked mixed content). Use an https:// address, or the picture stays black.',
        epg_url: 'TV guide (XMLTV source)',
        epg_url_help: 'One or more XMLTV addresses, one per line — from your IPTV provider or public sources; the guide is their union (.gz accepted). Empty = no guide; screens then show channel names only.',
        epg_id: 'Guide id (XMLTV)',
        epg_id_help: "The channel's id from the XMLTV source (e.g. slo1.tv). Empty = no guide for this channel.",
        title: 'TV channels (IPTV)',
        hint: "Channels guests may watch in their room — stream addresses from the hotel's IPTV contract. The product ships no channels.",
        add: 'Add channel',
        edit: 'Edit channel',
        empty: 'No channels entered yet.',
        empty_hint: 'Enter a name and a stream address (HLS/IPTV) from your provider contract. Channels play on room screens only — a lobby panel never sees them.',
        name: 'Name',
        note: 'Note',
        category: 'Category',
        category_help: 'The group on the screen — "National", "Sport", "Kids". Channels with the same category sit under one heading on the room screen. Empty means the "Other" group.',
        url: 'Stream address',
        url_help: "An http(s) address — a Samsung plays HLS natively; a desktop browser does not (a browser limitation, not the screen's).",
        order: 'Order',
        active: 'Active',
        confirm_delete: 'Delete channel “{name}”?',
    },
    music: {
        url_insecure: 'This address is http:// — the screen is served over https and a browser will not load such a stream into it (blocked mixed content). Use an https:// address, or the radio stays silent.',
        tab: 'Music & TV',
        title: 'Music stations',
        hint: "What guests may play in their room and what the lobby plays by itself. The product ships no stations — what a hotel may lawfully play is the hotel's own knowledge.",
        add: 'Add station',
        edit: 'Edit station',
        empty: 'No stations entered yet.',
        empty_hint: 'Enter a name and a stream or file address. A guest station plays in bedrooms; a hotel station in public spaces — SAZAS and IPF apply to it.',
        name: 'Name',
        note: 'Note (one line under the name)',
        url: 'Address',
        url_help: 'An http(s) address of a stream or an audio file. Whether it answers is only found out on the television.',
        source: 'Kind',
        source_stream: 'Live stream',
        source_file: 'Recording (file)',
        audience: 'For whom',
        audience_help: "Guests: played in the room, no public-performance licence. Hotel: public spaces, the hotel's own licence.",
        audience_guest: 'Guests (rooms)',
        audience_house: 'Hotel (public spaces)',
        ambience: 'Lobby ambience',
        ambience_help: 'A panel with no room starts this station by itself. One per hotel — switching it on here switches it off elsewhere.',
        ambience_badge: 'ambience',
        active: 'Active',
        confirm_delete: 'Delete station “{name}”? The screens will stop offering it.',
    },
    display: {
        item_signup: 'Sign-up point',
        item_signup_help: 'Guests join with OK on the television or a button on their phone; the sheet of names gathers below.',
        signup_sheet: '{count} signed up',
        signup_none: 'No signups yet — they count once the programme is published.',
        nav: 'In-room TV screens',
        program_tab: 'The day\'s programme',
        waiting_tab: 'Waiting to be approved',
        devices_tab: 'Screens',
        waiting_count: 'Waiting to be approved: {count}',
        waiting_banner_hint: 'Somebody is standing in front of a television showing a code, waiting to be let in.',
        waiting_open: 'Open the queue',
        program_title: 'The day\'s programme',
        program_hint: 'What the screens will say. Nothing reaches a television until you press Publish.',
        program_empty: 'Nothing on this day yet.',
        publish: 'Publish to screens',
        published_now: 'Published — {count} points are on the screens.',
        published_at: 'published {at}',
        published_stale: 'published {at} · unpublished changes',
        never_published: 'not published yet',
        today: 'Today',
        tomorrow: 'Tomorrow',
        add_item: 'Add a point',
        edit_item: 'Edit the point',
        confirm_item: 'Accept',
        proposed_by_ai: 'AI proposal — waiting to be accepted',
        from: 'From',
        to: 'To',
        to_hint: 'may be empty',
        item_title: 'Title',
        item_note: 'Note',
        standing_info: 'Standing information on the screen',
        standing_info_hint: 'e.g. Breakfast until 10.30 · check-out by 10.00 · reception: press 0',
        offer_note: 'The offer of the week down the side is read from marketing automatically — the active offer running out soonest.',
        no_property: 'Pick a property first.',
        waiting_title: 'Screens waiting to be approved',
        waiting_hint: 'A screen announces itself and shows a code. Find the code you can see on the television and approve it.',
        waiting_empty: 'No screen is waiting at the moment.',
        waiting_empty_hint: 'That is as it should be. A television you plug in announces itself and appears here with the code it shows on the wall — there is nowhere to add one by hand.',
        waiting_since: 'asking since {at}',
        unknown_model: 'unknown device',
        approve: 'Approve',
        approve_hint: 'You are approving the screen showing {code}. Check that this is the code on the television in front of you.',
        approved: 'The screen is approved. The television switches over by itself.',
        dismiss: 'Dismiss',
        name: 'Screen name',
        place: 'Where it stands',
        place_room: 'Room',
        place_venue: 'Venue',
        place_venue_named: 'Venue · {venue}',
        place_public: 'Public area',
        venue: 'Venue',
        venue_hint: 'A screen at a venue’s door shows what is in it — never the client, the price or the headcount.',
        venue_search: 'Search venues …',
        room: 'Room',
        room_search: 'Search rooms…',
        devices: 'Registered screens',
        devices_hint: 'Screens already connected. One press revokes one — the television then shows a code again.',
        open_app:        'Open the screen application',
        open_app_hint:   'Open it on the television or in a browser; the screen shows a code you approve on the Waiting for approval tab.',
        copy_app_url:    'Copy the address',
        tizen_launcher:  'Samsung (Tizen) URL launcher: {url}',
        copy_tizen_url:  'Copy the Samsung address',
        url_copied:      'The address is on the clipboard.',
        url_copy_failed: 'Copying failed — select the address and copy it by hand.',
        devices_empty: 'No screen yet.',
        devices_empty_hint: 'A screen is not added from here — a television on a bracket cannot scan a code. Plug it in; it shows a code and appears among the ones waiting.',
        live: 'live',
        quiet: 'no connection for {minutes} min',
        lost: 'lost — {hours} h without a connection',
        b2b_capable: 'Samsung TV',
        // The code the screen showed while it was being let in, kept on the device
        // (docs/DISPLAY.md §2). A label rather than a secret, which is why it is shown.
        pairing_code_hint:        'The code this screen showed while it was being paired. Click to copy.',
        pairing_code_copied:      'Code copied.',
        pairing_code_copy_failed: 'Copying failed — select the code and copy it by hand.',
        device_rename: 'Edit screen',
        orientation: 'Screen orientation',
        orientation_hint: 'Automatic: follows the window; Portrait: the picture is turned for a television mounted at 90°.',
        orientation_auto: 'Automatic (follow the window)',
        orientation_landscape: 'Landscape',
        orientation_portrait: 'Portrait (turned clockwise)',
        orientation_portrait_flipped: 'Portrait (turned anticlockwise)',
        needs_rooms: 'The hotel has no rooms yet — a screen binds to a room or to the general mode.',
    },
    publishing: {
        nav: 'Publishing',
        no_property: 'Pick a property first.',
        meta_title: 'Facebook and Instagram',
        meta_hint: 'Approved texts are posted straight to the hotel\'s page. Only somebody with Marketing (publish) may post.',
        meta_needs_title: 'What the hotel has to obtain',
        meta_need_page: 'The hotel\'s Facebook PAGE (not a personal profile) and its numeric ID — Page settings → About.',
        meta_need_app: 'An app at developers.facebook.com with pages_manage_posts and pages_read_engagement; for Instagram also instagram_basic and instagram_content_publish.',
        meta_need_token: 'A Page access token. Recommended: a system user in Meta Business Suite — that token does not expire. A short-lived token from the Graph Explorer expires within hours.',
        meta_need_ig: 'For Instagram: a BUSINESS or creator account LINKED to that page. Get its ID with GET /{page-id}?fields=instagram_business_account.',
        page_id: 'Facebook page ID',
        page_id_hint: 'Digits only.',
        instagram_id: 'Instagram account ID',
        instagram_id_hint: 'Optional. Without it the hotel posts to the page only.',
        page_token: 'Page token',
        page_token_hint: 'Paste the token. It is stored encrypted and never returned to the screen.',
        token_stored: 'A token is stored. Leave empty to keep it unchanged.',
        token_set: '••••••••  (stored)',
        clear_token: 'Remove token',
        token_cleared: 'The token has been removed.',
        verify: 'Check connection',
        verified: 'Connected to the page "{name}".',
        verify_failed: 'The connection could not be checked',
        sealed: 'Tokens are encrypted',
        sealed_hint: 'They are stored with this deployment\'s key and never returned to the screen. A deployment without a key cannot store one.',
        saved: 'Publishing settings saved.',
        google_title: 'Google Business Profile',
        google_hint: 'Fields for Google posts — fill them in as the hotel obtains them.',
        google_not_yet: 'Publishing to Google does not work in this release',
        google_not_yet_hint: 'The fields are here so the hotel can write down what it gets while going through the process. Nothing is sent yet.',
        google_needs_title: 'What the hotel has to obtain',
        google_need_verified: 'A VERIFIED Google Business Profile location (postcard, telephone or video) — the hotel\'s own process, and it takes weeks.',
        google_need_api: 'Approved access to the Business Profile API through Google\'s access request form (a review, not a key somebody generates).',
        google_need_oauth: 'An OAuth 2.0 client in a Google Cloud project with the business.manage scope, and a refresh token from an account that manages the location.',
        google_need_ids: 'The account ID (accounts/…) and the location ID (locations/…).',
        google_account: 'Account ID',
        google_account_hint: 'e.g. accounts/123456789',
        google_location: 'Location ID',
        google_location_hint: 'e.g. locations/987654321',
        google_token: 'Refresh token (OAuth)',
        google_token_hint: 'Unused until the connection exists. Stored encrypted.',
        publish: 'Publish',
        publish_facebook: 'Publish to Facebook',
        publish_instagram: 'Publish to Instagram',
        published: 'Published to {platform}.',
        published_no_photo: 'Published to {platform} — without a picture (the offer has none).',
        publish_failed: 'Publishing failed',
        not_configured: 'Publishing is not set up — see Settings (the gear) → Guest experience, Milo and screens → Publishing.',
        only_approved: 'Only an approved text can be published.',
        published_list: 'Published',
        open_post: 'Open the post',
    },
    /*
     * Settings → Milo for guests (plan §11a).
     *
     * One decision on this card: whether the house's assistant answers a GUEST, and what
     * he may prepare for them. Off by default — a new feature must never switch itself
     * on for anybody.
     */
    settings_guest_portal: {
        nav: 'Guest portal',
        title: 'Guest portal appearance',
        hint: 'What the house looks like to a guest: the name, the tagline, two colours, the theme and the monogram. The guest portal, the public site and the room screens all read this one record.',
        no_property: 'Select a property first.',
        needs_permission: 'Viewing the guest portal appearance needs the Property (read) permission.',
        display_name: 'Name on the portal',
        display_name_hint: 'What the guest is welcomed to. Empty means the property name.',
        tagline: 'Tagline under the name',
        tagline_hint: 'The small line under the name — NOT the town. The address comes from the property and the guest reads it on "Arrival".',
        tagline_placeholder: 'HOTEL & SPA',
        address_notice: 'This house is at',
        primary: 'Primary colour',
        primary_hint: 'The welcome panel, links and the header. Empty means the portal default.',
        accent: 'Accent',
        accent_hint: 'The house mark and the main buttons. Empty means the portal default.',
        colour_clear: 'Clear colour',
        theme: 'Theme',
        theme_hint: 'System means the guest device decides.',
        theme_system: 'system',
        theme_light: 'light',
        theme_dark: 'dark',
        radius: 'Corners',
        radius_hint: 'Rounded or square card corners.',
        radius_rounded: 'rounded',
        radius_square: 'square',
        typeface: 'Typeface',
        typeface_hint: 'Only the room screens honour it today; the portal and the public site draw in the product type.',
        typeface_system: 'default (system)',
        typeface_trirong: 'Trirong + Montserrat',
        monogram: 'Monogram',
        monogram_hint: 'One or two letters in the mark, while the house has no logotype.',
        logo: 'Logotype',
        logo_hint: 'The logotype is uploaded with the property photos; it is only shown here.',
        logo_set: 'The portal draws this logotype; the monogram is used only without one.',
        logo_none: 'The house has uploaded no logotype — the portal draws the monogram.',
        address: 'Public portal address',
        address_hint: 'The base of every link a guest is sent.',
        address_none: 'This deployment has no guest portal.',
        copy: 'Copy',
        copied: 'Address copied.',
        used_where: 'Where it shows',
        used_guest: 'Guest portal (the link from a reservation)',
        used_site: "The house's public site",
        used_display: 'Room screens',
        preview: 'Preview',
        preview_note: 'An approximation of the welcome panel in the guest portal.',
        preview_note_system: 'An approximation of the welcome panel. With the "system" theme the guest device decides; this shows yours.',
        preview_no_name: 'HOUSE',
        preview_eyebrow: 'YOUR STAY',
        preview_greeting: 'Welcome to {name}',
        preview_subtitle: 'Everything about the stay in one place.',
        preview_card_title: 'Online check-in',
        preview_card_text: 'Guest details, document and payment — before arrival.',
        preview_card_button: 'Finish check-in',
        summary_theme: 'theme {theme}',
        saved: 'The guest portal appearance is saved.',
    },
    milo_settings: {
        nav: 'Milo for guests',
        title: 'Milo for guests',
        hint: 'The assistant in the guest portal: he answers from the house\'s own data and prepares proposals the guest confirms. He takes no payments and issues no invoices.',
        no_property: 'Choose a property first.',
        enabled: 'Milo for guests',
        enabled_hint: 'The guest sees him as a button in their portal. He answers about their own booking, the house and the surroundings; about other guests, the staff or the hotel\'s finances he says nothing.',
        actions: 'What he may prepare',
        action_late_checkout: 'Late checkout request',
        action_late_checkout_hint: 'A request and not a promise — the desk decides.',
        action_services: 'Service booking',
        action_services_hint: 'Only from the house catalogue and at the catalogue price; needs the Groups and events module.',
        action_room_requests: 'Room requests',
        action_room_requests_hint: 'Make up the room, do not disturb until an hour. It goes the housekeeping way — Milo presses no button by the bed.',
        action_messages: 'Message to the reception',
        action_messages_hint: 'The guest writes a message or asks for a person; a row appears on the attentions list and on the guest\'s file.',
        action_room_service: 'Room-service order',
        action_room_service_hint: 'The guest orders from the house menu at the till\'s own price. It is the one action that is finished by the press — the kitchen starts and the amount goes on the room bill. Outside the serving hours Milo refuses and gives the hours.',
        action_lost_items: 'Report of something left behind',
        action_lost_items_hint: 'The guest says what they lost; a record opens in the lost-property register as "Reported by guest", with them as the contact. Nothing has been found — somebody still has to go and look.',
        action_transfers: 'Transfer request',
        action_transfers_hint: 'The guest asks for a car; the request is written on to Transfers and is NOT sent to a provider. Reception confirms the time and the price, and the portal carries no transfer price list.',
        daily_turn_limit: 'Daily question limit',
        daily_turn_limit_hint: 'Per reservation, per hotel day. 0 means the default (30).',
        max_turns: 'Context length',
        max_turns_hint: 'How many past messages the model is handed. 0 means the default (20).',
        retention_days: 'Kept after departure (days)',
        retention_days_hint: 'The conversation is deleted after this; bookings, charges and the file entries stay. 0 means the default (30).',
        see_usage: 'See the usage',
        see_attentions: 'Where the messages land',
        saved: 'Milo settings saved.',
        summary_on: 'On for guests',
        summary_off: 'Off for guests',
        summary_limit: 'limit {count} questions/day',
        summary_retention: 'kept for {days}',
        summary_days_one: '{count} day',
        summary_days_two: '{count} days',
        summary_days_few: '{count} days',
        summary_days_other: '{count} days',
    },
    order_pin: {
        nav: 'Ordering PIN',
        title: 'Ordering PIN',
        hint: 'A four-digit code the guest enters before ordering room service or booking a service.',
        no_property: 'Choose a property first.',
        how_title: 'How it works',
        how_issued: 'The PIN is issued at check-in and holds for the stay.',
        how_reception: 'Reception always sees it — in the check-in window and on the reservation.',
        how_asked: 'The guest enters it before every order or booking, wherever it is switched on below.',
        how_wrong: 'After three wrong tries the guest has to wait: 30 seconds first, doubling each time, up to 15 minutes.',
        doors: 'Where the PIN is asked for',
        portal: 'On the guest\'s phone (portal)',
        portal_hint: 'The guest portal asks for the PIN before an order or a booking.',
        display: 'On the room television',
        display_hint: 'The screen in the room asks for the PIN before an order or a booking.',
        email: 'E-mail the PIN at check-in',
        email_hint: 'The booking\'s payer receives the PIN by e-mail when the room is checked in.',
        email_needs_door: 'Available once the PIN is on for the phone or the television.',
        saved: 'Ordering PIN settings saved.',
        reservation_label: 'Ordering PIN',
        send_mail: 'Send by e-mail',
        mail_sent: 'Sent to {to}',
        mail_failed: 'The PIN could not be sent.',
        check_in_title: 'Tell the guest their ordering PIN',
        check_in_mailed: 'Sent to {to}',
    },
    city_pulse: {
        nav: 'City right now',
        title: 'City right now',
        hint: 'Whether the town is busy — the desk\'s Milo and the guest portal\'s Milo answer from one reading. Four sources, each optional; whatever could not be read, Milo says out loud.',
        no_property: 'Choose a property first.',
        enabled: 'City right now',
        enabled_hint: 'While this is off, Milo answers honestly that the hotel does not offer this rather than guessing at the town.',
        parts: 'What it may read',
        part_events: 'Events today',
        part_events_hint: 'From the events sources the house already has — the same reading as the „what is on in town“ tool. It costs nothing.',
        part_traffic: 'Traffic outside the hotel',
        part_traffic_hint: 'Current speed against the usual on the road by the hotel, and incidents within about 5 km. Read through TomTom on the house\'s own key; every question spends two requests of the daily allowance.',
        part_parking: 'Car parks',
        part_parking_hint: 'Public parking occupancy where the operator publishes it. Most towns in Slovenia have no such source, and Milo says so.',
        part_weather: 'Weather now',
        part_weather_hint: 'One hour out of the same forecast the room screens draw. It is here because being outdoors depends on it — not as a substitute for the forecast.',
        events_not_ready: 'The events reading is switched off',
        events_not_ready_hint: 'This part would be on and silent. Switch the events on and set the sources on the property, under „Milo — AI assistant“.',
        parking_town_uncovered: 'No parking source is known for {town}',
        parking_towns: 'Occupancy can be read for: {towns}. Milo will say honestly that it cannot check this for your town.',
        key_section: 'The traffic key',
        needs_title: 'What you need',
        need_account: 'A free developer account at developer.tomtom.com.',
        need_key: 'A new API key with the Traffic API on it (free up to 2,500 requests a day).',
        need_paste: 'Paste the key below, save, and press „Check the connection“.',
        tomtom_key: 'TomTom API key',
        key_hint: 'Stored sealed, and never shown back.',
        key_stored: 'A key is stored. An empty field means leave it alone.',
        key_set: 'stored',
        clear_key: 'Remove',
        key_cleared: 'The key has been removed.',
        verify: 'Check the connection',
        check_ok: 'The connection works',
        check_failed: 'The connection does not work',
        saved: 'The „City right now“ settings are saved.',
        summary_on: 'On for {town} · reads: {parts}',
        summary_off: 'Off',
        summary_no_parts: 'On, but no source is chosen — Milo has nothing to read.',
    },
    audit: {
        kinds: {
            chat_conversation: 'conversation', chat_operation: 'proposal', guest_chat_operation: 'guest proposal', guest_chat_thread: 'guest conversation', staff_time_correction: 'time correction', staff_shift_change: 'shift change', staff_absence: 'absence', rota: 'rota', settings_card: 'settings card',
            reservation: 'reservation', folio: 'folio', invoice: 'invoice', guest: 'guest', group: 'group',
            conversation: 'conversation', guest_conversation: 'guest conversation', operation: 'proposal', property: 'property',
            user: 'user', device: 'device', display_device: 'screen', staff_employment: 'employment record',
            shift: 'shift', absence: 'absence', housekeeping_task: 'housekeeping task', settings: 'settings',
            company: 'company', proforma: 'pro forma', notification: 'message', playlist: 'loop',
        },
        nav: 'Audit trail',
        title: 'Audit trail',
        description: 'Who did what in this house - per person and per event, including everything anybody asked Milo to do.',
        no_property: 'Pick a property first.',
        needs_permission: 'Reading the audit trail needs the Audit trail (read) permission.',
        retention: 'The trail is never pruned: rows stay for as long as the hotel exists. Nothing can change or delete one - not even this screen.',
        from: 'From',
        to: 'To',
        who: 'Who',
        everybody: 'Everybody',
        action: 'Action',
        action_group: 'Kind of action',
        all_actions: 'All actions',
        search: 'Search',
        search_hint: 'By summary or name',
        entity: 'Subject',
        summary: 'Summary',
        when: 'Time',
        address: 'IP address',
        request: 'Request',
        detail: 'Detail',
        detail_title: 'Audit trail row',
        open_detail: 'Open the detail',
        export: 'Export CSV',
        verify: 'Check the chain',
        chain: 'Chain',
        sequence: 'Sequence',
        previous_hash: 'Previous hash',
        hash: 'Hash',
        chain_intact: 'The chain is intact',
        chain_intact_hint: '{checked} rows checked, from sequence {from} to {to}.',
        chain_broken: 'The chain is broken',
        chain_broken_hint: 'The first break is at sequence {sequence}: {reason}',
        break_hash: "the row's content no longer matches its hash - the row was edited.",
        break_link: 'the row does not link onto its predecessor - it was replaced or inserted.',
        break_gap: 'a sequence number is missing - a row was deleted.',
        assistant_text: 'Text',
        assistant_arguments: 'Arguments of the {tool} tool',
        kind_user: 'user',
        kind_guest: 'guest',
        kind_system: 'system',
        kind_assistant: 'assistant',
        group_reservation: 'Reservations',
        group_folio: 'Folios',
        group_invoice: 'Invoices',
        group_guest: 'Guests',
        group_group: 'Groups',
        group_housekeeping: 'Housekeeping',
        group_staff: 'Staff',
        group_settings: 'Settings',
        group_notification: 'Notifications',
        group_auth: 'Sign-ins',
        group_display: 'Devices',
        group_assistant: 'Milo (reception)',
        group_guest_assistant: 'Milo (guest)',
    },
    ai_usage: {
        nav: 'AI usage',
        title: 'AI usage',
        description: 'What the hotel spent on models - by month and by feature. No prices: quantities only.',
        no_property: 'Pick a property first.',
        needs_permission: 'Reading AI usage needs the Finance (read) or Property (write) permission.',
        measuring_since: 'Measuring since {date}. This hotel\'s first recorded call: {first}. There is no data from before that.',
        measuring_since_empty: 'Measuring since {date}. This hotel has spent no models since then. There is no data from before that.',
        calls: 'Calls',
        failed: 'Failed',
        failed_hint: 'An outage or a refusal by the provider.',
        input_tokens: 'Input tokens',
        output_tokens: 'Output tokens',
        tokens_hint: 'As the provider reported them.',
        images: 'Images',
        feature: 'Feature',
        by_feature: 'By feature',
        nothing_this_month: 'No calls were made this month.',
        no_prices: 'No prices and no billing here (yet) - these are honest quantities, the basis for any surcharge.',
        feature_chat: 'Milo (the reception assistant)',
        feature_guest_chat: 'Milo (the guest portal)',
        feature_mail_parse: 'Email reading',
        feature_rooming_parse: 'Rooming list reading',
        feature_delivery_parse: 'Delivery note reading',
        feature_document_scan: 'Guest document reading',
        feature_marketing_text: 'Marketing text',
        feature_marketing_image: 'Marketing image',
        feature_reservation_offer: 'Offer covering note',
        feature_group_offer: 'Group offer covering note',
    },
    yield: {
        moved: 'Dynamic pricing has moved to the rate plans — where you work with prices.',
        on: 'On',
        off: 'Off',
        saved: 'Dynamic pricing saved.',
        must_rise: 'Each step has to be higher than the one before it.',
        title: 'Dynamic pricing',
        hint: 'At higher occupancy the nightly price rises automatically - the highest reached step applies. The stored base prices stay unchanged.',
        enable: 'Enable occupancy-driven pricing',
        occupancy_at_least: 'Occupancy ≥',
        uplift: 'uplift',
        add_rule: 'Add step',
    },
    assistant: {
        history:           'Conversation history',
        history_search:    'Search titles…',
        new_conversation:  'New conversation',
        all_conversations: 'All conversations (oversight)',
        read_only:         'Another person\'s conversation - read only.',
        confirm:   'Confirm',
        decline:   'Decline',
        executed:  'Executed',
        op_failed: 'Failed',
        declined:  'Declined',
        already_decided: 'Already decided - this reached the proposal after it had already been settled.',
        title:        'Milo',
        greeting:     'I am Milo, the assistant at your front desk.',
        intro:        'Ask anything about the hotel - reservations, occupancy, rooms, guests, analytics. Milo reads live data; anything it would change, it proposes first and you confirm.',
        placeholder:  'Ask…',
        thinking:     'Milo is checking the data…',
        still_working: 'Milo is working… (this can take up to a minute)',
        failed:       'Milo could not answer. Try again.',
        // A failed turn is now drawn in the thread and not only as a toast (§20).
        // Its own sentence for the case where the service is simply not there - a
        // deploy, a restart, a gateway answering in its place - because then the
        // answer is to wait, not to reword; every other reason the server states.
        failed_unreachable: 'Milo could not answer: the server is not reachable right now - try again in half a minute.',
        failed_timeout:     'Milo took too long for this question. Ask a narrower one, or split it in two.',
        failed_lost:        'Milo was interrupted while answering (a service update). Send the question again.',
        retry:        'Send again',
        disclaimer:   'Milo reads live data; anything it would change, it proposes first and you confirm. Verify numbers on the proper screen before acting.',
        example_arrivals:     'Who arrives tomorrow?',
        example_availability: 'How many rooms are free this weekend?',
        example_revenue:      'What is the revenue this month?',
        waits_for_step:       'waits for step {step}',
        step_prepared_below:  'Milo is preparing it below',
        continued:            'Step done - Milo is carrying on with the next one.',
        // The top-bar orb, the drawer and page awareness.
        shortcut:       'Alt+J',
        orb_attention:  'Something is waiting for you',
        // The poster's alternative text while the 3D head loads (MiloHead.vue).
        head_loading:   'Milo is loading…',
        open_full:      'Open full screen',
        on_page:        'On this page: {subject}',
        on_page_hint:   'Milo knows what you have open. Click if the question is not about it.',
        on_page_drop:   'Drop "{subject}" from the question',
        // Links in an answer and in the outcome line (libs/linkify.ts).
        copy_link:        'Copy link',
        link_copied:      'The link is on the clipboard.',
        link_copy_failed: 'Copying failed - select and copy the link by hand.',
    },
    // What an execution did. The server sends a code and a count
    // (ChatOperationOutcome) and the screen builds the sentence, because the server's
    // own sentence is an English audit line and not desk copy. Codes that count
    // nothing carry only the `other` form.
    assistant_result: {
        nights_priced: {
            one:   'priced 1 night',
            other: 'priced {count} nights',
        },
        rooms_closed: {
            one:   'closed 1 room',
            two:   'closed {count} rooms',
            few:   'closed {count} rooms',
            other: 'closed {count} rooms',
        },
        rooms_reopened: {
            one:   'returned 1 room to sale',
            two:   'returned {count} rooms to sale',
            few:   'returned {count} rooms to sale',
            other: 'returned {count} rooms to sale',
        },
        guests_retagged: {
            one:   'updated the tags of 1 guest',
            other: 'updated the tags of {count} guests',
        },
        tasks_assigned: {
            one:   'assigned 1 task',
            two:   'assigned {count} tasks',
            few:   'assigned {count} tasks',
            other: 'assigned {count} tasks',
        },
        round_assigned: {
            one:   'assigned 1 room',
            two:   'assigned {count} rooms',
            few:   'assigned {count} rooms',
            other: 'assigned {count} rooms',
        },
        // The housekeeping teams (HOUSEKEEPING.md 15). Four codes rather than one
        // "team saved", because the line has to say WHICH way it went — and three of
        // them change what a room is worth, since the factor follows the size.
        team_formed: {
            one:   'formed the team with 1 member - {detail}',
            two:   'formed the team with {count} members - {detail}',
            few:   'formed the team with {count} members - {detail}',
            other: 'formed the team with {count} members - {detail}',
        },
        team_member_added: {
            one:   'added 1 member to the team - {detail}',
            two:   'added {count} members to the team - {detail}',
            few:   'added {count} members to the team - {detail}',
            other: 'added {count} members to the team - {detail}',
        },
        team_member_removed: {
            one:   'took 1 member out of the team - {detail}',
            two:   'took {count} members out of the team - {detail}',
            few:   'took {count} members out of the team - {detail}',
            other: 'took {count} members out of the team - {detail}',
        },
        team_changed: {
            one:   'changed the team; 1 member remains - {detail}',
            two:   'changed the team; {count} members remain - {detail}',
            few:   'changed the team; {count} members remain - {detail}',
            other: 'changed the team; {count} members remain - {detail}',
        },
        team_dissolved: {
            other: 'dissolved the team; the rooms it cleaned go on naming it - {detail}',
        },
        stays_moved: {
            one:   'moved 1 stay',
            two:   'moved {count} stays',
            few:   'moved {count} stays',
            other: 'moved {count} stays',
        },
        group_hold_moved: {
            other: 'moved the held room - {detail}',
        },
        group_hold_restructured: {
            other: "moved the held room and restructured the group's block - {detail}",
        },
        group_hold_released: {
            other: 'released the held room back to the shop; the agreed number is unchanged - {detail}',
        },
        group_room_picked_up: {
            other: 'picked the room up out of the group - {detail}',
        },
        group_shifted: {
            one:   'moved the group, 1 room shifted - {detail}',
            two:   'moved the group, {count} rooms shifted - {detail}',
            few:   'moved the group, {count} rooms shifted - {detail}',
            other: 'moved the group, {count} rooms shifted - {detail}',
        },
        group_dates_changed: {
            one:   "changed the group's dates, 1 room resized - {detail}",
            two:   "changed the group's dates, {count} rooms resized - {detail}",
            few:   "changed the group's dates, {count} rooms resized - {detail}",
            other: "changed the group's dates, {count} rooms resized - {detail}",
        },
        group_status_changed: {
            other: "changed the group's status - {detail}",
        },
        // The guest welcome with the portal link. Nothing is counted - there is one
        // message - and {detail} is the masked telephone number.
        guest_link_sent: {
            other: 'sent the portal link on WhatsApp - {detail}',
        },
        rooming_link_issued: {
            other: 'issued the rooming link - {detail}',
        },
        rooming_entries_written: {
            one:   'wrote 1 guest into the rooming list - {detail}',
            two:   'wrote {count} guests into the rooming list - {detail}',
            few:   'wrote {count} guests into the rooming list - {detail}',
            other: 'wrote {count} guests into the rooming list - {detail}',
        },
        rooming_pending_taken: {
            one:   'took the pending entries, 1 guest written - {detail}',
            two:   'took the pending entries, {count} guests written - {detail}',
            few:   'took the pending entries, {count} guests written - {detail}',
            other: 'took the pending entries, {count} guests written - {detail}',
        },
        rooming_pending_cleared: {
            one:   'cleared 1 pending entry, nobody booked - {detail}',
            two:   'cleared {count} pending entries, nobody booked - {detail}',
            few:   'cleared {count} pending entries, nobody booked - {detail}',
            other: 'cleared {count} pending entries, nobody booked - {detail}',
        },
        mappings_saved: {
            one:   'saved 1 mapping',
            two:   'saved {count} mappings',
            few:   'saved {count} mappings',
            other: 'saved {count} mappings',
        },
        program_proposed: {
            one:   'proposed 1 programme point for {detail}',
            two:   'proposed {count} programme points for {detail}',
            few:   'proposed {count} programme points for {detail}',
            other: 'proposed {count} programme points for {detail}',
        },
        display_config_saved: {
            other: 'saved the room screens configuration (revision {detail})',
        },
        channel_linked: {
            other: 'linked the channel booking to an existing reservation - {detail}',
        },
        channel_placed: {
            other: 'made reservation {detail}',
        },
        channel_replayed: {
            other: 'reservation {detail} was already made by an earlier press; no second one was created',
        },
        full_sync_accepted: {
            other: 'the full sync ({detail}) is accepted and runs in the background',
        },
        comfort_confirmed: {
            other: 'the equipment has confirmed it - room {detail}',
        },
        comfort_sent: {
            other: 'the order was sent to room {detail}; the equipment has not confirmed it yet',
        },
        comfort_unconfirmed: {
            other: 'the order went and is NOT confirmed - {detail}',
        },
        issue_reported: {
            other: 'raised a maintenance work order - {detail}',
        },
        issue_appended: {
            other: 'added to the open work order "{detail}"; no second one was raised',
        },
        issue_already_added: {
            other: 'the work order "{detail}" already carried this addition; nothing was written',
        },
        message_sent: {
            other: 'sent to {detail}',
        },
        checked_in: {
            one:   'checked in 1 room',
            two:   'checked in {count} rooms',
            few:   'checked in {count} rooms',
            other: 'checked in {count} rooms',
        },
        checked_out: {
            one:   'finalised the bill and checked out 1 room',
            two:   'finalised the bill and checked out {count} rooms',
            few:   'finalised the bill and checked out {count} rooms',
            other: 'finalised the bill and checked out {count} rooms',
        },
        room_prioritised: {
            other: 'room {detail} is at the top of today\'s round',
        },
        room_released: {
            other: 'room {detail} is free and waiting to be prepared',
        },
        reservation_created: {
            other: 'made the reservation - {detail}',
        },
        offer_created: {
            one:   'drafted the offer for 1 room - {detail}',
            two:   'drafted the offer for {count} rooms - {detail}',
            few:   'drafted the offer for {count} rooms - {detail}',
            other: 'drafted the offer for {count} rooms - {detail}',
        },
        offer_sent: {
            other: 'sent the offer - {detail}',
        },
        // Two codes and not one: "saved" over a record that already existed hides the
        // one thing worth reading — whether the hotel now has a SECOND account for one
        // legal entity. The correction counts fields, so it carries only `other`.
        company_created: {
            other: 'opened the corporate account - {detail}',
        },
        company_updated: {
            other: 'corrected the corporate account - {detail}',
        },
        // Counts FIELDS and not things, because a correction to a guest card may be one
        // telephone number or half the record, and somebody reading the thread a week
        // later wants to know how much moved. The guest's name is in {detail}.
        guest_updated: {
            one:   'corrected the guest card - 1 field changed - {detail}',
            two:   'corrected the guest card - {count} fields changed - {detail}',
            few:   'corrected the guest card - {count} fields changed - {detail}',
            other: 'corrected the guest card - {count} fields changed - {detail}',
        },
        // A discount is TWO codes and the difference is the whole answer: inside the
        // ceiling the money is already off, over it NOTHING is off and a request is
        // waiting. One line for both would be a price quoted to a guest that the house
        // has not agreed to.
        discount_applied: {
            other: 'discount applied - {detail}',
        },
        discount_pending: {
            other: 'the discount request is waiting for approval; nothing has come off the bill - {detail}',
        },
        line_removed: {
            other: 'line removed as a storno - {detail}',
        },
        line_moved: {
            other: 'line moved whole - {detail}',
        },
        line_split: {
            other: 'line split - {detail}',
        },
        overpayment_refunded: {
            other: 'overpayment refunded - {detail}',
        },
        payment_transferred: {
            other: 'payment moved between the cards; the house paid out nothing - {detail}',
        },
        absence_approved: {
            one:   'absence approved — 1 day written into the record · {detail}',
            two:   'absence approved — {count} days written into the record · {detail}',
            few:   'absence approved — {count} days written into the record · {detail}',
            other: 'absence approved — {count} days written into the record · {detail}',
        },
        absence_rejected: {
            other: 'absence rejected; no day was written into the record — {detail}',
        },
        correction_approved: {
            other: 'time correction approved — {detail}; the entry it replaces is marked corrected',
        },
        correction_rejected: {
            other: 'time correction rejected; the record is unchanged — {detail}',
        },
        notice_queued: {
            other: 'message queued — {detail}',
        },
        shift_changed: {
            other: 'shift moved — {detail}',
        },
        // Events (WP-E11), thirteen codes. See the Slovenian file for why each count
        // counts what it does.
        event_created: {
            one:   'event created with 1 part of the programme — {detail}',
            two:   'event created with {count} parts of the programme — {detail}',
            few:   'event created with {count} parts of the programme — {detail}',
            other: 'event created with {count} parts of the programme — {detail}',
        },
        event_part_added: {
            other: 'part of the programme added and its venues taken — {detail}',
        },
        event_part_moved: {
            other: 'part of the programme moved with its venues — {detail}',
        },
        event_headcount_set: {
            other: 'headcount set to {count} — {detail}',
        },
        event_version_frozen: {
            other: 'version {count} frozen — every department acknowledgement is reset · {detail}',
        },
        event_shifted: {
            one:   'event shifted, 1 part of the programme moved with its venues — {detail}',
            two:   'event shifted, {count} parts of the programme moved with their venues — {detail}',
            few:   'event shifted, {count} parts of the programme moved with their venues — {detail}',
            other: 'event shifted, {count} parts of the programme moved with their venues — {detail}',
        },
        event_status_changed: {
            other: 'event moved to {detail}',
        },
        event_lost: {
            other: 'event recorded as lost — reason: {detail}',
        },
        event_cancelled: {
            other: 'event cancelled, the ladder charged {count} (in cents) — {detail}',
        },
        event_task_opened: {
            other: 'task opened on the event — {detail}',
        },
        event_catering_set: {
            one:   '1 food and drink line written — {detail}',
            two:   '{count} food and drink lines written — {detail}',
            few:   '{count} food and drink lines written — {detail}',
            other: '{count} food and drink lines written — {detail}',
        },
        event_offer_issued: {
            other: 'offer link issued over version {count}; nothing was sent — {detail}',
        },
        event_offer_sent: {
            one:   'offer sent to 1 recipient — {detail}',
            two:   'offer sent to {count} recipients — {detail}',
            few:   'offer sent to {count} recipients — {detail}',
            other: 'offer sent to {count} recipients — {detail}',
        },
        // Materials (WP-M8). Six codes rather than one "saved", for the reason the event
        // manager has thirteen: the line says WHAT the press did.
        requisition_raised: {
            one:   'requisition with 1 line — {detail}',
            two:   'requisition with {count} lines — {detail}',
            few:   'requisition with {count} lines — {detail}',
            other: 'requisition with {count} lines — {detail}',
        },
        requisition_approved: {
            other: 'requisition approved — {detail}',
        },
        requisition_rejected: {
            other: 'requisition rejected — {detail}',
        },
        orders_raised: {
            one:   '1 purchase order raised — {detail}',
            two:   '{count} purchase orders raised — {detail}',
            few:   '{count} purchase orders raised — {detail}',
            other: '{count} purchase orders raised — {detail}',
        },
        count_opened: {
            one:   'count opened over 1 store room; no snapshot taken yet — {detail}',
            two:   'count opened over {count} store rooms; no snapshot taken yet — {detail}',
            few:   'count opened over {count} store rooms; no snapshot taken yet — {detail}',
            other: 'count opened over {count} store rooms; no snapshot taken yet — {detail}',
        },
        ap_export_sent: {
            one:   '1 invoice sent to the book-keeper as a draft — {detail}',
            two:   '{count} invoices sent to the book-keeper as drafts — {detail}',
            few:   '{count} invoices sent to the book-keeper as drafts — {detail}',
            other: '{count} invoices sent to the book-keeper as drafts — {detail}',
        },
    },
    mail_import: {
        button:       'Import from email',
        title:        'Import a reservation from email',
        placeholder:  'Paste the email text here…',
        drop_hint:      'Or drop an .eml, .msg or .txt file here.',
        decoding:       'Reading the file…',
        decode_failed:  'The file could not be read.',
        mail_from:      'From',
        mail_to:        'To',
        mail_subject:   'Subject',
        mail_date:      'Date',
        parse:        'Parse',
        parse_failed: 'The email could not be parsed.',
        concerns:     'Check before confirming',
        guest:        'Guest',
        contact:      'Contact',
        party:        'Party',
        adults:       'adults',
        children:     'children',
        rooms:        'rooms',
        room_wish:    'Requested room',
        company:      'Company',
        notes:        'Notes',
        known_guest:  'A guest with this email already exists - the reservation will attach to them.',
        confirm_note: 'Nothing is booked yet. The new-reservation form opens prefilled from the email - review, correct and confirm.',
        back:         'Back',
        prepare:      'Prepare reservation',
        guest_failed: 'The guest could not be created.',
        wishes:            'Asked for besides the room',
        wish_daily:        'by the day — ticked on the form',
        wish_appointment:  'appointment — book it in Facilities',
        wish_unknown:      'not in the hotel catalogue',
        attentions:        'Standing notes for this guest',
        attentions_hint:   'True of the guest and not of this reservation: it goes on their card and follows them to their next stay. Untick only what was read wrongly.',
        attentions_failed: 'The notes could not be written to the guest\'s card — the reservation is prepared; put them on the card by hand.',
    },
    booking_settings: {
        payment_mode: 'Online payment',
        payment_mode_hint: 'Whether the guest pays by card when they book.',
        payment_off: 'Off — payment on arrival',
        payment_optional: 'Optional — the guest may pay now',
        payment_required: 'Required — payment before arrival',
        prepayment_percent: 'Prepayment share (%)',
        prepayment_percent_hint: '100 means the whole stay. The guest settles the rest at reception.',
        required_note: 'The booking is made and holds its room even if the guest does not pay — it simply carries an "awaiting payment" mark. Nothing deletes it automatically; that decision is yours.',
        tab: 'Web',
        title: 'Online booking',
        hint: 'What the hotel sells on its own website. It sells the codebook you already keep — room types, descriptions, photographs and rate plans; this decides only what is on offer and on what terms.',
        enabled: 'Accept bookings from the web',
        enabled_hint: 'While this is off the hotel is not reachable online — the public site does not know it exists.',
        no_plan_title: 'No rate plan to sell on',
        no_plan_hint: 'Choose at least one rate plan, or mark one as the default. Without it the website will offer no rooms at all.',
        rate_plans: 'Rate plans for the web',
        rate_plans_hint: 'A rate plan sells only the room types it covers. The same room on two plans appears twice — with breakfast and without are two different offers.',
        rate_plans_default: "The hotel's default rate plan",
        on_sale: 'Will be on sale online',
        all_types: 'all room types',
        uncovered: 'On no rate plan, and therefore not online: {types}',
        max_nights: 'Longest stay (nights)',
        max_nights_hint: '0 means the default (21 nights).',
        terms: 'Hotel terms',
        terms_hint: 'The guest accepts them before booking, and they are repeated in the confirmation email.',
        terms_placeholder: 'E.g. payment on arrival at reception. Free cancellation up to 3 days before arrival. Check-in from 14:00, check-out by 10:00. Tourist tax is not included in the price.',
        terms_default_required: "The terms must be written at least in the hotel's own language ({language}).",
        live_title: 'The hotel accepts bookings from the web',
        live_hint: 'Bookings from the website arrive in reception as ordinary reservations with the source Web.',
    },
    res_rooming: {
        button: 'Guest entry',
        title: 'Guest entry (fellow travellers)',
        link_title: 'The guest\'s link',
        link_hint: 'Through this link the guest enters their fellow travellers with everything the register needs. It is valid until the day after arrival, and a new link retires the old one. Nothing entered through it books anything.',
        issue: 'Issue a link',
        reissue: 'Issue a new one',
        copy: 'Copy',
        copied: 'The link was copied.',
        expires: 'Valid until {date}',
        pending_title: 'Entered, awaiting confirmation',
        check: 'Check for new entries',
        no_pending: 'The guest has entered nobody yet.',
        pick_stay: 'Choose a stay',
        unassigned: 'Unassigned',
        commit: 'Confirm and add ({count})',
        commit_note: 'Confirming puts the people on their stays and creates the guest profiles that are missing. A document the guest typed stays unverified — check it against the original at the desk on arrival.',
        discard: 'Discard the list',
        added: 'added: {count}',
        overfilled: 'One of the rooms has more people than were booked into it. Correct the assignment.',
    },
    shift_history: {
        title: 'Shift history',
        lead: 'When a till was open, who worked it, what was in the drawer and by how much it differed from what was expected.',
        till: 'Till',
        all_tills: 'All tills',
        empty: 'No shifts in this period.',
        open: 'Open',
        closed: 'closed',
        counted: 'counted',
        balanced: 'Balanced',
        opening_float: 'Opening float',
        cash_sales: 'Cash sales',
        cash_refunds: 'Cash refunds',
        pay_ins: 'Pay-ins',
        pay_outs: 'Pay-outs',
        expected: 'Expected in the drawer',
        card_sales: 'On cards',
        room_sales: 'On rooms',
        movements: 'Pay-ins and pay-outs',
        pay_in: 'Pay-in',
        pay_out: 'Pay-out',
        variance_reason: 'Reason for the difference',
        print: 'Print',
    },
    forecast: {
        title: 'Day-by-day forecast',
        lead: 'Arrivals and departures, how many people sleep here, and the meals expected in the days ahead. Counts confirmed, checked-in and checked-out reservations; not cancellations or no-shows.',
        window: 'Window',
        days: 'Next {count} days',
        empty: 'No reservations in this window.',
        turnover: 'Arrivals and departures',
        arrivals: 'Arrivals',
        departures: 'Departures',
        guests: 'Overnight — people per night',
        guests_series: 'People',
        meals: 'Meals by kind',
        breakfast: 'Breakfast',
        lunch: 'Lunch',
        dinner: 'Dinner',
        no_board: 'No rate plan in this window states its board, so meals cannot be forecast. Board is set on the rate plan (Sales and guests → Rate plans).',
        drill_hint: 'Press a column or the figure under it for that day\'s reservations.',
        drill_turnover: 'Arrivals and departures on this day',
        drill_guests: 'Stays sleeping this night',
        drill_meals: 'Meals on this day, by reservation',
        drill_empty: 'Nothing on this day.',
        drill_no_guest: 'Guest not yet named',
        drill_people: '{count} people',
    },
    reservation_source: {
        email:   'Email',
        direct:  'Direct',
        web:     'Web',
        phone:   'Phone',
        walk_in: 'Walk-in',
        ota:     'OTA',
        agency:  'Agency',
        corporate: 'Corporate',
        group:   'Group',
    },
    check_in: {
        action: 'Check in',
        action_hint: 'Check the guest in — opens the arrival procedure and the report to the register.',
        several_rooms: 'This reservation has several rooms; arrivals are done room by room inside the reservation.',
        title:                        'Guest check-in',
        deadline:                     'The registration must be filed within 12 hours of the guest\'s arrival.',
        submit:                       'Check in and report',
        submit_without_reporting:     'Check in without reporting',
        submit_partial:               'Check in {count} of {total} guests',
        register_now:                 'Check in now',
        arrives_later_hint:           'Arrives later — this guest is not checked in now and stays on the stay as not arrived.',
        nobody_arriving:              'Nobody is marked as arriving. Tick at least one guest who is here.',
        register_remaining:           'Check in the rest ({count})',
        registered:                   'Checked in',
        not_registered_yet:           'Not checked in yet',
        result_room_partial:          'The room is checked in. Still to arrive: {count}.',
        result_guest_later:           'Arrives later. Not checked in and still on the stay as not arrived — check them in when they get here.',
        check_in_failed:              'The room could not be checked in. No guest was filed for reporting.',
        no_guests:                    'This stay has no guests. Add them to the stay before checking the room in.',
        reporting_note:               'Checking the room in is a fact at the desk and happens at once. Reporting to eTurizem is queued — a background worker submits it and retries if needed.',
        reporting_incomplete:         'These guests will not be filed for reporting',
        reporting_not_set_up:      'Reporting to eTurizem is not set up yet',
        reporting_not_set_up_note: 'The room is checked in and the registration is kept, but this server does not submit to eTurizem — it is waiting for AJPES access. Once that is in place the system files what has been kept.',
        result_room:                  'The room is checked in.',
        result_filed:                 '{filed} of {total} guests were filed for reporting.',
        result_guest_filed:           'Filed for reporting. A background worker submits it to eTurizem and retries if needed.',
        result_guest_already_filed:   'This guest is already filed for this stay; a second filing is not made.',
        result_guest_failed:          'The registration was not created, so no reporting has started for this guest. Fix the data and try again — the deadline is 12 hours after arrival.',
        result_guest_skipped:         'Not filed for reporting because the data is incomplete. The guest is checked into the room.',
        ready:                        'Reporting data is complete',
        incomplete:                   'Missing: {fields}',
        complete:                     'Complete',
        hide:                         'Hide',
        sex:                          'Sex',
        sex_male:                     'Male',
        sex_female:                   'Female',
        sex_unknown:                  'Not stated',
        sex_unknown_hint:             'eTurizem does not accept "not stated" — only M and F. The guest will be checked into the room but not reported.',
        mrz:                          'Machine-readable zone (MRZ)',
        mrz_hint:                     'Click in the field and swipe the document through the reader, or type the lines from the bottom of the document: a passport has two lines of 44 characters, an identity card three of 30.',
        mrz_placeholder:              'P<SVNNOVAK<<JANEZ<<<<<<<<<<<<<<<<<<<<<<<<<<<',
        mrz_applied:                  'Data taken from the document ({format}). All check digits match.',
        mrz_applied_unverified:       'Data taken despite check digits that do not match. Verify it against the document in hand.',
        printed_applied: 'Filled in from the front of the document — not proved by check digits.',
        chip_applied: 'Filled in from the document\'s chip — signed.',
        mrz_apply_anyway:             'Take it anyway',
        holder_mismatch_title: "The document is not this person's",
        holder_mismatch_hint: 'The document names {document}, and this card is for {guest}. Nothing has been written into the fields. Check that the right document was read.',
        holder_mismatch_clear: 'Discard the reading',
        holder_mismatch_apply: 'Use it for this guest anyway',
        mrz_clear:                    'Clear the zone',
        mrz_check_failed:             'Check digits do not match: {fields}',
        mrz_check_failed_hint:        'The document was most likely misread, so nothing was taken. Read: {read}. Scan again or type the data in.',
        mrz_check_document_number:    'document number',
        mrz_check_date_of_birth:      'date of birth',
        mrz_check_expiry:             'expiry date',
        mrz_check_composite:          'composite check digit',
        mrz_error_empty:              'The zone is empty. Scan the document with the reader, or type the lines from the bottom of the document.',
        mrz_error_unsupported_format: 'The zone could not be read. Supported are a passport (2 × 44 characters) and an identity card (3 × 30 characters).',
        mrz_error_invalid_characters: 'The zone contains characters an MRZ cannot hold. Scan the document again.',
        mrz_unknown_country:          'The country code "{code}" is not in the ISO codelist — choose the nationality by hand.',
        document_valid_until:         'The document is valid until {date}.',
        document_expired:             'The document expired on {date}.',
    },
    check_out: {
        action_hint: 'Check the guest out — opens the statement with what is owed.',
        result_owed: 'Left with {amount} still open',
        result_owed_hint: 'The amount stays on the folio and is recorded on the reservation. A bill can be settled after the guest has gone.',
        open_card_hint:             'Every charge and payment on this folio.',
        back_to_checkout:           'Back to check-out',
        step_bill:        'Review the final bill',
        step_pay:         'Take the payment and issue the invoice',
        add_charge:       'Add charge',
        take_payment:     'Take payment',
        step_confirm_issue: 'Confirm the bill and issue the invoice',
        step_confirm_a:   '2a · Confirm the bill',
        step_confirm_b:   '2b · Cards: payment and invoice',
        order_title:      'The order',
        order_hint:       '1. Confirm the bill · 2. Take the payment on each card · 3. Issue the invoices · 4. Check the guests out.',
        separate_folio:   'Separate folio',
        per_folio_hint:   'Each folio is a separate account — close it with its own payment and invoice.',
        pay_all:          'Take payment for the whole balance · {amount}',
        pay_all_title:    'Pay the whole balance',
        pay_all_total:    'Total to pay',
        pay_all_folios:   'Settles {count} open folios, each by its own balance.',
        pay_all_confirm:  'Record payment for all',
        pay_all_done:     'The whole balance is settled.',
        pay_all_failed:   'Some folios could not be settled — check the open ones.',
        confirm_and_issue: 'Confirm & issue invoice · {amount}',
        confirmed_issued: 'The bill is confirmed and the invoice issued.',
        step_depart:      'Check the guests out',
        finalize:         'Confirm the bill · {amount}',
        finalized:        'The bill is confirmed — the books match it',
        finalize_failed:  'The bill could not be confirmed',
        finalize_done_hint:      'The bill is confirmed. Next comes the invoice on each card.',
        finalize_no_permission:  'Confirming the bill needs the right to post to a folio.',
        issue_needs_finalize:    'Confirm the bill first.',
        bill_accommodation: 'Accommodation',
        bill_nights_count:  'nights: {count}',
        bill_breakdown:     'Break down',
        bill_collapse:      'Hide',
        bill_night:         'night',
        bill_tax_sub:       'guests: {guests} · nights: {nights}',
        bill_footer_rate:   'VAT {rate} %: base {base} · VAT {tax}',
        bill_footer_exempt: 'Tourist tax is outside the VAT base',
        bill_tourist_tax:   'Tourist tax',
        bill_tax_nights:    'Nights',
        bill_tax_unnamed:   'Unnamed guest',
        tax_routing:        'Tourist tax on confirmation',
        tax_routing_hint:   'Confirming the bill posts the tourist tax onto the chosen folio. The choice holds only until it is posted — after that the money is moved between folios.',
        tax_routing_to:     'Posted to: {folio}',
        tax_routing_posted: 'Already posted to: {folio}',
        tax_routing_group:  'The group pays the tax — it goes onto the group folio under its own charge routing.',
        projected_balance:   'After posting',
        pending_tourist_tax: 'tax {amount}',
        pending_nights:      'nights {amount}',
        remaining_due:      '{amount} on {folio}',
        remaining_overpaid: 'overpayment {amount} on {folio}',
        action:                     'Check out',
        title:                      'Close the stay',
        departure_on:               'departing {date}',
        guests_registered:          'Registered guests: {count}',
        summary:                    'Summary',
        summary_services:           'Other services',
        summary_total:              'Total',
        summary_paid:               'Already paid',
        aside_note:                 'Confirm the bill first, then record the payment and issue the invoice. Departure is possible with an open balance too — it is recorded on the reservation.',
        ready_title:                'Ready to depart',
        ready_owing_title:          'Open balance',
        ready_hint:                 'The balance is settled · the guests will be checked out.',
        ready_uninvoiced_hint:      'The balance is settled · folios without an invoice: {count} · the guests will be checked out.',
        ready_owing_hint:           'The open amount stays recorded on the reservation and can be settled later.',
        owed:                       'Still owed',
        balance_all_cards:          'Balance, all cards',
        receivable:                 'Receivable',
        receivable_hint:            'A company card with {days} days to pay. It is a receivable, not an unpaid bill, and it does not hold the departure up.',
        invoiced:                   'Invoice issued',
        not_invoiced:               'No invoice',
        open_card:                  'Open the folio',
        no_cards:                   'This reservation has no folio',
        no_cards_hint:              'Nothing has been charged and nothing paid. Check the stay was ever posted before letting it go.',
        open_items:                 'Still open',
        no_open_items:              'Nothing else is outstanding.',
        registrations_hint:         'Their departure is filed with eTurizem in the background as part of this check-out. Nothing is waited on.',
        rooms_leaving:              'Rooms leaving',
        no_rooms:                   'No room of this reservation is in the hotel',
        already_out:                'The guest checked out {at} — the stay is closed.',
        no_rooms_hint:              'Every room has already been checked out, or none was ever checked in. There is nothing to check out.',
        blocked_title:              'The departure is refused — {amount} is still owed',
        blocked_hint:               'Take the payment on the folio, or, if the hotel is letting the guest go anyway, use the override below. Company cards with payment terms are not counted here.',
        blocked_hint_no_override:   'Take the payment on the folio. Letting a reservation leave unpaid needs a permission this account does not hold — ask somebody who does. Company cards with payment terms are not counted here.',
        blocked_button:             'Cannot check out — {amount} owed',
        submit:                     'Check the guests out and close the stay',
        done:                       'The reservation is checked out',
        refused:                    'The departure was refused: {amount} is still owed.',
        refused_override:           'This account may not let a reservation leave unpaid, or the reason was missing. Nothing was checked out.',
        failed:                     'The departure could not be carried out',
        override_open:              'Let it leave unpaid',
        override_title:             'Departure without payment',
        override_hint:              'The hotel is letting this reservation leave owing {amount}. This is written onto the reservation together with the amount and your name, and it stays there.',
        override_reason:            'Reason',
        override_reason_hint:       'Write it for the person who asks a month from now why this reservation left without paying.',
        override_reason_placeholder: 'Agreed with the manager, the company is paying by transfer …',
        override_reason_too_long:   'The reason is too long — write it in a sentence or two.',
        override_submit:            'Check out despite {amount}',
        result_title:               'Rooms checked out: {done} of {total}',
        result_all:                 'Every room of this reservation is released.',
        result_partial:             'Some rooms were not released. They are still in the hotel.',
        result_checked_out:         'Checked out',
        result_failed:              'Not checked out',
        result_failed_hint:         'The room is still in the hotel. Fix the cause and check the reservation out again.',
        result_nights:              'Nights charged at the door: {count}',
        result_registrations:       'Departures filed with eTurizem: {count}',
        result_housekeeping:        'The rooms are ready to be serviced.',
        result_overridden:          'This reservation left with money still owed',
        result_overridden_hint:     'The override is recorded in the reservation notes with the amount and the reason.',

        // Prepayments: what the guest has already paid, and what the invoice comes to.
        advance_line:          'Prepayment {number} — {amount}',
        invoice_after_advance: 'The invoice will come to {invoice} (stay {service} − prepayment {advance}).',
    },
    device: {
        app_version: 'app {version}',
        outdated: 'out of date',
        expected: 'Expected app release: {version}.',
        ask_update: 'Ask to update',
        ask_update_hint: 'Sends a request to update to {version}. Whoever holds the telephone installs it.',
        ask_update_failed: 'The update request could not be sent.',
        update_asked: 'An update request was sent to {name}.',
        event_update_asked: 'Update requested: {from} → {to}',
        online: 'here now',
        reads: 'documents read: {count}',
        history: 'Device history',
        history_empty: 'Nothing has been recorded for this device yet.',
        event_paired: 'Paired ({desk})',
        event_revoked: 'Revoked',
        event_restored: 'Restored',
        event_renamed: 'Renamed: {from} → {to}',
        event_moved: 'Moved: {from} → {to}',
        desk: 'Reception',
        desk_hint: 'The telephone is offered beside the field only at the reception it lies on.',
        desk_this: 'This reception (this computer)',
        desk_all: 'Every reception',
        desk_other: 'Another reception (leave it there)',
        this_desk: 'this desk',
        other_desk: 'another desk',
        whole_house: 'every desk',
        name: 'Device name',
        name_hint: 'What the button at the desk says when a document is sent to this telephone.',
        name_placeholder: 'Reception — iPhone 1',
        rename: 'Rename the device',
        paired: 'The telephone "{name}" is paired.',
        tab: 'Devices',
        title: 'Reading devices',
        hint: 'The telephones that read guests\' documents for this hotel. Paired once, and from then on the desk sends a document to one of them with a single press.',
        pair: 'Pair a telephone',
        pair_steps: 'In the application choose "Pair with the PMS" and photograph this code.',
        pair_expires: 'The code is good for {minutes} minutes.',
        empty: 'This hotel has no paired telephone yet.',
        last_seen: 'last seen: {when}',
        revoked: 'Revoked',
        revoke: 'Revoke the device',
        restore: 'Allow again',
        confirm_revoke: 'Revoke "{name}"? The telephone loses access to this hotel\'s documents at once.',
        send_to: 'Send to a paired telephone',
        called: 'Sent to {name} — hold the document against the telephone.',
        call_failed: 'The device could not be called.',
    },
    guest_merge: {
        title: 'Merge guests',
        action: 'Merge with another guest',
        conflict_merge: 'Merge into the existing profile',
        disappears: 'This record disappears',
        stays_label: 'This record stays',
        pick_survivor: 'Find the record to keep',
        swap: 'Swap direction',
        no_details: 'no birth date and no document',
        moves_title: 'What moves to the record that stays',
        moves_none: 'This record carries nothing — only the name moves.',
        taken_title: 'What the surviving record takes (empty fields only)',
        kept_title: 'What stays unchanged on the surviving record',
        collisions_title: 'Some records stay behind',
        collisions_text: '{count} record(s) cannot move because the surviving guest already has one for the same stay. They stay on the old record and are not lost.',
        unchanged_title: 'What the merge does not change',
        unchanged_text: 'Issued invoices ({invoices}) are never rewritten, chat proposals are left as they were, and consents are never carried upwards — a consent is evidence of what a person did, not a property of a record.',
        confirm: 'Merge the records',
        done: 'The records are merged. References moved: {stays}.',
        merged_title: 'This profile was merged into another',
        merged_text: 'The stays, folios and registrations are on the record that absorbed it. This one is kept so that older references still resolve, and is not deleted.',
        merged_open: 'Open the surviving record',
        blocked_title: 'This merge cannot be carried out',
        counts: {
            stays: 'Stays',
            reservations_as_payer: 'Reservations as payer',
            folios: 'Folios',
            registrations: 'Registrations',
            tourist_tax_records: 'Tourist tax records',
            facility_bookings: 'Facility bookings',
            lost_items: 'Lost items',
            crm_interactions: 'Diary entries',
            crm_tasks: 'Tasks',
            crm_opportunities: 'Opportunities',
        },
        fields: {
            email: 'E-mail',
            phone: 'Telephone',
            nationality: 'Nationality',
            language: 'Language',
            notes: 'Notes',
            date_of_birth: 'Date of birth',
            document: 'Document',
            address: 'Address',
            company_id: 'Company',
            tourist_tax_relief_code: 'Tourist-tax status',
        },
        blockers: {
            same_guest: 'A record cannot be merged into itself.',
            duplicate_already_merged: 'This record has already been merged into another profile.',
            survivor_already_merged: 'The record you chose to keep has itself been merged into another — pick one that is still in use.',
            identity_taken: 'After the merge the surviving record would carry the same identity as a third existing profile.',
        },
    },

    guest: {
        slot: 'Guest {number}',
        slot_empty: 'Not chosen',
        slots_hint: 'One line per adult and child on this room. Blank ones can be filled in later, or by the guest at web check-in.',
        slots_over_count: 'The room holds more guests than the {count} it is booked for. Lowering the count removed nobody.',
        tourist_tax: 'Tourist tax',
        tourist_tax_status: 'Tourist-tax status',
        tourist_tax_status_hint: 'It applies to every stay of this person. A stay may name a different exemption, and that one wins.',
        tourist_tax_none: 'No exemption (full tax)',
        conflict_title: 'The hotel already has this person',
        conflict_use_existing: 'Use the existing profile',
        conflict_open_existing: 'Open the existing record',
        conflict_replaced: 'The room now points at the existing profile. Neither record was merged or deleted.',
        scan_with_phone: 'Photograph the document with a telephone',
        scan_title: 'Read a document with a telephone',
        scan_description_device: 'The telephone reads the document and the fields are filled in here.',
        scan_description: 'Photograph the code with a telephone, then the document. The details land here.',
        scan_steps: 'Open the camera on the telephone, point it at the code and follow the link.',
        scan_waiting: 'Waiting for the document …',
        scan_expires: 'The code is good for {minutes} minutes.',
        scan_new_code: 'New code',
        scan_reading: 'Processing the document …',
        scan_open_app: 'Scan with the application',
        scan_open_app_hint: 'Opens the reading application on this device and takes over this capture. Without the application, use the code below.',
        scan_printed: 'The zone could not be read, but the front of the document can be',
        scan_printed_hint: 'Read from the front: {name} · no. {number}. There are no check digits, so check it against the document.',
        scan_printed_take: 'Take the reading',
        printed_applied: 'Filled in from the front of the document — not proved by check digits.',
        chip_applied: 'Filled in from the document\'s chip — signed.',
        scan_failed: 'The picture could not be read',
        scan_failed_hint: 'Take another on the telephone — the code is still good.',
        scan_unavailable: 'Reading pictures is not available on this server',
        scan_unavailable_hint: 'The zone can still be typed or scanned with a reader.',
        mrz: 'MRZ (machine-readable zone)',
        mrz_hint: 'Optional. Scan or copy the two lines under the photograph — the fields below fill themselves in.',
        self_entered: 'Details typed by the guest',
        self_entered_hint: 'Check them against the document — the eTurizem filing waits for your confirmation.',
        verify_document: 'Document verified',
        mrz_placeholder: 'P<SVNSURNAME<<NAME<<<<<<<<<<<<<<<<<<<<<<<<<<\nP12345678SVN8001011M3001012<<<<<<<<<<<<<<06',
        mrz_repaired: 'The zone was corrected against its check digits ({count} character). The data is filled in — check the document number.',
        mrz_applied: 'The document has been read in.',
        mrz_applied_unverified: 'Read in although the check digits do not add up. Compare it against the document.',
        mrz_check_failed: 'The check digits do not add up: {fields}. Usually one character was misread.',
        mrz_apply_anyway: 'Use it anyway',
        mrz_error_empty: 'Nothing to read yet.',
        mrz_error_invalid_characters: 'That contains characters an MRZ never has.',
        mrz_error_unsupported_format: 'Unknown shape — 2 × 44 (passport) or 3 × 30 (identity card) is expected.',
        complete: 'Complete',
        incomplete: 'Incomplete',
        details: 'Details',
        reportable_hint: 'The details are complete — this guest can be reported. Click to edit.',
        missing_hint: 'The register is still missing: {fields}. Click to fill it in.',
        add_named: 'Add guest “{name}”',
        guests:            'Guests',
        guest:             'Guest',
        add:               'Add guest',
        edit:              'Edit guest',
        first_name:        'First name',
        last_name:         'Last name',
        nationality:       'Nationality',
        document_type:     'Document type',
        document_number:   'Document number',
        date_of_birth:     'Date of birth',
        address:           'Address',
        consents:          'Consents',
        marketing_consent: 'Marketing consent',
        consent_email: 'E-mail',
        consent_sms: 'SMS',
        consent_phone: 'Telephone call',
        consent_offers: 'Personalised offers',
        consent_revoked: 'Revoked {at}',
        missing_for_check_in: 'Check-in needs the details eVisitor requires: nationality, document and date of birth.',
    },
    rate: {
        board_type: 'Board',
        board_none: 'No meals',
        board_breakfast: 'Breakfast',
        board_half_board: 'Half board',
        board_full_board: 'Full board',
        board_all_inclusive: 'All inclusive',
        legacy_included_services: 'This plan used to say',
        legacy_included_services_hint: 'The old free text, kept for reading only. Carry it into the board type and the extras; when it is carried over, this block disappears.',
        rate_plans:        'Rate plans',
        rate_plan:         'Rate plan',
        add:               'Add rate plan',
        edit:              'Edit rate plan',
        rates:             'Rates',
        restrictions:      'Restrictions',
        parent:            'Parent rate plan',
        offset:            'Offset',
        offset_percentage: 'Percentage offset',
        offset_hint_cheaper: 'Where the parent plan charges {reference}, this one charges {result} — cheaper.',
        offset_hint_dearer:  'Where the parent plan charges {reference}, this one charges {result} — dearer. Enter a negative value for a discount.',
        offset_amount:     'Amount offset',
        offset_amount_per_person: 'Amount per person per night',
        offset_per_person_suffix: '{amount} per person per night',
        offset_hint_per_person_cheaper: 'Where the parent plan charges {reference}, a room for {occupancy} charges {result} — cheaper.',
        offset_hint_per_person_dearer:  'Where the parent plan charges {reference}, a room for {occupancy} charges {result} — dearer. Enter a negative value for a reduction.',
        early_booking:             'Early booking',
        early_booking_hint:        'Book this many days ahead and the whole stay is reduced by this much. Rungs are ordered from the longest lead time down and the best one that fits applies. It changes no stored price: the rate grid and the channels keep the list price, and the reduction is applied when a stay is priced.',
        early_booking_days:        'Days ahead',
        early_booking_percent:     'Discount (%)',
        early_booking_add:         'Add a tier',
        early_booking_remove:      'Remove',
        early_booking_none:        'No early-booking discount.',
        early_booking_order:       'Each tier must be further ahead than the one below it.',
        early_booking_badge:       'Early booking −{percent} %',
        early_booking_quote:       'Early booking −{percent} %, {amount} off.',
        derived:           'Derived',
        standard:          'Standard',
        refundable:        'Refundable',
        is_default:        'Default',
        is_default_hint:   'The plan a reservation gets when nobody picks one. Only one plan can be the default — this one takes it from the previous.',
        price:             'Price',
        price_from_plan:   'From the rate plan, {nights} nights. You can still change it.',
        price_per_night:   '{amount} a night',
        price_per_night_average: '{amount} a night on average',
        price_partial:     'From the rate plan for {priced} of {nights} nights — the rest have no price.',
        no_price_for_dates: 'This rate plan has no prices for these dates. Enter the price by hand or add it to the plan.',
        extra_adult:       'Extra adult',
        weekdays:          'Weekdays',
        bulk_edit:         'Bulk edit',
        min_stay:          'Minimum stay',
        max_stay:          'Maximum stay',
        stop_sell:         'Stop sell',
        closed_to_arrival:   'Closed to arrival',
        closed_to_departure: 'Closed to departure',
        outside_sales_window: 'The date is outside the 18-month sales window.',
        type:                'Type',
        included_services:   'Included services',
        min_advance_booking: 'Minimum days in advance',
        child_prices:        'Child prices',
        fields:              'What this edit sets',
        fields_hint:         'Restrictions you do not tick stay untouched on those dates.',
        whole_row_hint:      'The whole price row is written — extra adult and child prices included.',
        derived_readonly:    'A derived plan has no prices of its own. Edit the parent plan.',
        derived_source:      'Derived from {plan} ({offset}).',
        restrictions_not_derived: 'Restrictions are never inherited. An empty grid means this plan has no rules, not that the parent’s apply.',
        clear_prices:        'Clear prices',
        clear_restrictions:  'Clear restrictions',
        confirm_clear_prices: 'Delete the prices for the selected period?',
        confirm_clear_restrictions: 'Delete the restrictions for the selected period?',
        confirm_delete:      'Delete this rate plan?',
        no_plan_for_room_type: 'No rate plan covers this room type, so it cannot be sold. Add a rate plan, or add this room type to an existing one.',
        in_use:              'The rate plan cannot be deleted while it has derived plans, prices or restrictions',
    },
    // About: what is running, which release, and what it brought.
    about: {
        update_available: 'New version - refresh',
        update_toast: 'A new portal version is available. Click "New version - refresh" in the menu to get it.',
        title:        'About',
        version:      'Version',
        build:        'Build (commit)',
        vendor:       'Vendor',
        vendor_name:  'IT TEAM d.o.o.',
        product_hint: 'Imprion PMS is a property management system for hotels — reservations, the front desk, housekeeping, invoices and channels. Part of the Imprion range (POS, KDS).',
        changelog:    "What's new",
    },
    chessboard: {
        search_placeholder: 'Room, guest, group, company',
        move_refused: 'The move could not be made. The reservation is where it was.',
        move_done: 'The stay was moved to room {room}.',

        // Resizing a stay: the strip's two edges add and remove whole nights.
        resize_arrival:    'Drag to change the arrival',
        resize_departure:  'Drag to change the departure',
        resize_group_hold: 'A group block: the dates come from the group and are changed there.',
        resize_nights:     '1 night | {count} nights',
        resize_added:      '+1 night | +{count} nights',
        resize_removed:    '−1 night | −{count} nights',
        resize_refused:    'The stay could not be resized. It is exactly as it was.',
        resize_done:       'The stay now runs {range} · {nights}.',
        resize_done_plain: 'The stay was changed.',
        group_type_change_confirm: 'Room {room} is a {to}, and group "{group}"\'s block holds it under {from}. Adjust the group\'s block — one fewer {from}, one more {to}?',

        // The move confirmation: what is about to happen, before it happens.
        board_settings:      'Board settings',
        confirm_moves:       'Confirm moves',
        confirm_moves_hint:  'Dragging a reservation or a stay\'s edge asks first. A group block\'s room type change always asks.',
        confirm_move_title:  'Move reservation',
        confirm_resize_title: 'Change stay',
        confirm_group_title: 'Move held room',
        confirm_room:        'Room',
        confirm_arrival:     'Arrival',
        confirm_departure:   'Departure',
        confirm_nights:      'Nights',
        confirm_type_change: 'Different room type: {from} → {to}.',
        // A room move does NOT reprice (Logic.ChangeReservationRoom) — an edge pull does.
        confirm_price_kept:  'The stay\'s price is not recomputed for the new type\'s rate — it stays as agreed. Adjust it on the reservation if it should change.',
        confirm_checked_in:  'The guest has already checked in — this is a physical move to another room.',
        confirm_room_closed: 'Room {room} is closed (out of service) for part of this period.',
        confirm_room_taken:  'Room {room} is already held by somebody else for these nights — the service will refuse the move.',
        confirm_nights_priced: 'The added nights are charged at the reservation\'s rate.',
        confirm_nights_dropped: 'The dropped nights come off the stay\'s price.',
        confirm_arrival_locked: 'The guest has already checked in — the arrival can no longer be moved and the service will refuse the change.',
        action_check_in: 'Check in',
        action_check_out: 'Check out',
        action_add_guest: 'Add a guest',
        // A block is not a reservation: a held room's card offers the pickup and
        // the group, never a check-in. The group's own word is `group.group`.
        action_pickup: 'Pick up from block',
        // Checking out and releasing the room are two events (docs/HOUSEKEEPING.md §16).
        action_release:   'Room released',
        released:         'Room {room} has been released.',
        released_already: 'Room {room} had already been released.',
        release_failed:   'The room could not be released.',
        checked_out_still_occupied: 'Checked out, room still occupied',
        action_move: 'Move room',
        action_note: 'Note',
        action_folio: 'Folio',
        action_housekeeping: 'Priority cleaning',
        more_actions: 'More actions',
        outstanding: 'Outstanding',
        prioritised: 'Room {room} is at the top of today\'s round — now.',
        column_state: 'State',
        column_work: 'Work',
        column_live: 'Room live',
        collapse_columns: 'Collapse to room numbers',
        expand_columns: 'Show the columns again',
        open_room: 'Open room {room}',
        action_open_room: 'Open the room page',
        block_window: 'from {from} to {to}',
        block_window_open: 'from {from} until further notice',
        column_cleaning_at: 'Cleaning at',
        cleaning_at_now: 'now',
        cleaning_at_unassigned: 'unassigned',
        cleaning_at_after_shift: 'The round reaches this room after the published shift ends.',
        column_cleaner: 'Being cleaned by',
        column_ready: 'Ready by',
        column_faults: 'Faults',
        view_reservations: 'Reservations',
        view_availability: 'Availability',
        view_housekeeping: 'Cleaning',
        view_telemetry: 'Rooms',
        view_occupied: 'occupied',
        view_empty: 'empty',
        work_cleaning: 'being cleaned',
        work_cleaning_until: 'clean by {hour}',
        work_repair: 'fault',
        grouping: 'Grouping',
        group_by_floor: 'By floor',
        group_by_type: 'By room type',
        group_all_rooms: 'All rooms',
        group_by_none: 'No grouping',
        filters: 'Filters',
        filters_n: 'Filters · {count}',
        filter_remove: 'Remove filter: {filter}',
        filter_arrivals_today: "Today's arrivals",
        filter_departures_today: "Today's departures",
        filter_not_checked_in: 'Not checked in',
        filter_room_not_ready: 'Rooms not ready',
        filter_unpaid: 'Unpaid',
        filter_conflict: 'Conflict',
        filter_groups: 'Groups',
        filter_late_checkout: 'Late checkouts',
        filter_free_only: 'Free only',
        filter_problems_only: 'Problems only',
        density_comfortable: 'Comfortable',
        density_compact: 'Compact',
        density_ultra: 'Very compact',
    },
    availability: {
        title: 'Availability',
        hint: 'How many rooms are left, by type and by day. Press a number and pick a room to book.',
        room_type: 'Room type',
        days: '{count} days',
        no_types: 'The hotel has no room types.',
        pick_room: 'Pick a room — the reservation opens with the room and the night filled in.',
        free_of_total: '{name}: {free} free of {total}',
        free_rooms_caption: 'free of all',
        book_type: '{free} free — click to book {name}',
        full_on: '{name}: full on {date}',
        expand_all:   'Open all',
        collapse_all: 'Close all',
        availability: 'Availability',
        chessboard:   'Room plan',
        legend:       'Legend',
        free:         'Free',
        occupied:     'Occupied',
        blocked:      'Blocked',
        room_state_legend: 'The dot beside a number is how the room stands now. At the roomiest density the word is beside it; otherwise hover.',
        occupancy:    'Occupancy',
        no_rooms:     'No rooms are free for those dates',
        previous_period: 'Previous period',
        next_period:     'Next period',
        window_days:     '{count} days',
        select_property: 'Choose a property first',
    },
    folio: {
        folio:               'Folio',
        cards:               'Folios',
        add:                 'New folio',
        label:               'Folio label',
        owner:               'Folio owner',
        company_owner:       'Company',
        status_open:         'Open',
        status_closed:       'Closed',
        charges_total:       'Charges total',
        payments_total:      'Payments total',
        balance:             'Balance',
        balance_due:         'Due',
        balance_overpaid:    'Overpaid',
        balance_pending_posting: 'Tax awaits posting',
        balance_settled:     'Settled',
        split_bill:          'Split bill',
        split_bill_hint:     'A second folio on the same reservation — somebody else pays for part of the stay. Charges can be moved between folios afterwards.',
        close:               'Close folio',
        confirm_close:       'Close this folio? A closed folio cannot be reopened, and no charge or payment can be added to it.',
        closed:              'The folio is closed',
        close_failed:        'The folio could not be closed',
        closed_notice:       'This folio is closed',
        closed_at:           'Closed {date}. No new charges can be added, changed or reversed — a correction is a credit note against the invoice. Payment is still possible: a bill is often settled after it has been printed.',
        closed_hint:         'A closed folio takes no new charges: the invoice issued from it quotes exactly these lines, and a correction is a credit note. Payment is still possible — a bill is often settled after it is printed.',
        target_card:         'Target folio',
        // The folio's owner: companions first, the wider search behind a switch.
        owner_companion_placeholder: 'Pick somebody on this booking',
        other_payer:      'Somebody else pays',
        other_payer_hint: 'Turn on when the card is paid by somebody who is not on this booking - a company, an agency, a parent.',
        owner_guest:      'Guest',
        owner_company:    'Company',
        no_target_card:      'No folio to move the charge to',
        no_target_card_hint: 'A charge can only be moved to another open folio of the same reservation in the same currency. There is none — add one first with “New folio”.',

        // Prepayments on the card: what arrived before the stay, and on which paper.
        advances:                'Prepayments',
        advances_hint:           'Money that arrived before the stay and already has an advance invoice. The payment itself is in the table below — this says which paper it is on and how much of it the final invoice can still deduct.',
        advances_total:          'Left to deduct',
        advance:                 'Prepayment',
        advance_standing:        'Left to deduct',
        advance_standing_hint:   'The advance invoice less every credit note already issued against it.',
        advance_fully_credited:  'Credited in full',
        advance_open_document:   'Open document',
        advance_storno:          'Credit part of the prepayment',
        advance_storno_tooltip:  'Credit part of it — issue a credit note against the advance invoice.',
        advance_storno_denied:   'A credit note needs the "Invoice storno" right (invoice:credit). Ask your manager.',
        advance_storno_amount:   'Credit note amount',
        advance_storno_amount_hint: 'The VAT splits across the rates by itself, in the proportion they stand in on the advance invoice.',
        advance_storno_whole:    'The whole {amount}',
        advance_storno_too_much: 'More than what is left of the prepayment.',
        advance_storno_explanation_title: 'A credit note does not delete the advance invoice',
        advance_storno_explanation:       'Advance invoice {number} stays valid and unchanged. A new document is created beside it — a credit note with the amounts negated, its own number and today\'s business date.',
        advance_storno_money_title:       'This does not hand the money back',
        advance_storno_money_hint:        'The credit note is the paper. If the guest is getting money back, refund the payment on this card as well — otherwise the drawer will be short at the end of the day.',
        advance_confirm_storno:  'Issue a credit note of {amount} against advance invoice {number}? The invoice stays valid; the credit note is final.',
    },
    transfer_split: {
        button:  'Transfer / split',
        title:   'Transfer and split',
        hint:    'Part of this bill goes onto another card of the same booking. Nothing is deleted: the original line is reversed and the two shares are posted afresh, so both cards read as what happened.',
        what:    'What is split',
        whole_card: 'The whole card',
        nothing_to_move: 'This card has no line that can be split.',
        split:   'Split',
        mode_percent: 'Percentage',
        mode_amount:  'Amount',
        mode_persons: 'By people',
        // Opened from the button on a line: the same split, narrowed to one charge.
        move_title: 'Move or split',
        line_hint:  'The line goes onto another card of the same booking — whole, or a share of it. A whole line is moved; a share is posted afresh: the original is reversed and both shares are visible.',
        how:        'How',
        mode_whole_line: 'Whole line',
        percent: 'Percentage (%)',
        amount:  'Amount to transfer',
        numerator:   'Parts transferred',
        denominator: 'Of parts in total',
        selected: 'Selected total',
        moves_to: 'Moves to "{card}"',
        stays:    'Stays on this card',
        // Always rounded down; the remainder stays with whoever was already paying.
        remainder: 'Rounding down leaves {value} more here than rounding to the nearest cent would.',
        confirm:  'Transfer',
        done:     '{moved} transferred to "{card}".',
        failed:   'The transfer could not be carried out.',
        quote_failed: 'The preview could not be worked out.',
    },
    charge: {
        discount: 'Discount',
        edit_failed: 'The line could not be changed — the folio may already be closed.',
        edit_tooltip: 'Edit the line (description, quantity, price)',
        delete_title: 'Remove line',
        delete_confirm: 'The line "{description}" will be removed without a trace — before the invoice the folio is a working document. Continue?',
        delete_failed: 'The line could not be removed — the folio may already be closed.',
        deleted: 'The line has been removed.',
        delete_tooltip: 'Remove the line',
        discount_hint: 'Enter an amount in euros or switch to % — what is stored is always the amount, computed at entry.',
        discount_percent_preview: '{amount} comes off this line.',
        charges:                'Charges',
        add:                    'Add charge',
        business_date:          'Business date',
        source:                 'Source',
        source_room:            'Accommodation',
        source_pos:             'POS',
        source_service:         'Service',
        source_manual:          'Manual entry',
        source_tourist_tax:     'Tourist tax',
        source_facility:        'Hotel facility',
        source_dining:          'Meal at the door',
        quantity:               'Quantity',
        unit_price:             'Unit price',
        tax_rate:               'VAT rate',
        tax_rate_hint:          'A percentage, for example 9.5 or 22.',
        amount:                 'Amount',
        external_ref:           'External reference',
        external_ref_hint:      'The line’s identifier in the system it came from — the POS bill number, for example.',
        reverse:                'Reverse',
        storno:                 'Reversal',
        reversed:               'Reversed',
        reverses_line:          'Reverses line {line}',
        reversed_by_line:       'Reversed by line {line}',
        reverse_line:           'Line {line} · {amount}',
        reverse_hint:           'A reversal does not delete the charge: the line stays on the folio and a mirror line with the same amount in the negative is posted underneath it. The folio therefore still shows what was billed, what was taken back and why.',
        reason:                 'Reason',
        confirm_reverse:        'Reverse this charge? The charge stays on the folio and a mirror line is posted beside it.',
        reverse_success:        'The charge has been reversed',
        reverse_failed:         'The charge could not be reversed',
        move:                   'Move',
        move_tooltip:           'Move or split the line to another folio',
        moved:                  'The charge has been moved',
        move_failed:            'The charge could not be moved',
        room_charge:            'Post accommodation',
        room_charge_hint:       'The price of the stay is transferred to the folio exactly as agreed on the reservation, so it cannot be restated here. Each stay is posted once.',
        stay:                   'Stay',
        transfer:               'Transfer',
        transferred:            'The accommodation has been transferred to the folio',
        transfer_failed:        'The accommodation could not be transferred',
        room_charge_none:       'No stay to post',
        room_charge_none_hint:  'Every stay of this reservation is already on the folio. Cancelled and no-show stays are never transferred.',
        room_charge_other_card: 'The accommodation landed on the reservation’s first open folio, not on this one. Switch to that folio or move the charge across.',
    },
    payment: {
        take: 'Take payment',
        payments:                'Payments',
        add:                     'Add payment',
        occurred_at:             'Received at',
        method:                  'Payment method',
        method_cash:             'Cash',
        method_card:             'Card',
        method_bank_transfer:    'Bank transfer',
        method_voucher:          'Voucher',
        method_deposit:          'Deposit',
        method_ota_virtual_card: 'OTA virtual card',
        amount:                  'Amount',
        reference:               'Reference',
        reference_hint:          'The provider’s identifier for the payment — transaction, authorisation or transfer number.',
        no_card_data:            'Card details are never stored. Only the method, the amount and the provider’s reference are recorded.',
        terminal_title:          'This entry does not take a payment',
        terminal_hint:           'Take the payment on the physical POS terminal first. This records a payment already made — enter the reference from the terminal slip.',
        terminal_reference_hint: 'Recommended: the slip number from the POS terminal, so the terminal\'s records and the PMS agree.',
        record_terminal:         'Record a terminal payment',
        stripe_start:            'Or: a Stripe payment link · {amount}',
        stripe_waiting:          'Waiting for the payment … Have the guest scan the code and pay on their own phone.',
        stripe_booked:           'The payment is booked onto the folio.',
        stripe_hint:             'The server bounds the amount and books the money only when Stripe confirms it. The guest\'s card never touches the PMS.',
        stripe_copy:             'Copy the link',
        stripe_copied:           'Link copied.',
        stripe_failed:           'The payment link could not be created. Check that Stripe is configured.',
        refund_stripe_title:     'The money goes back to the card through Stripe',
        refund_stripe_hint:      'The PMS sends the refund to Stripe and waits for its confirmation; only then is the negative line written. If Stripe refuses, nothing is recorded here.',
        refund_terminal_title:   'Refund on the POS terminal first',
        refund_terminal_hint:    'This system cannot reach the terminal. Make the refund on the terminal first, then record it here with the slip reference.',
        refund:                  'Refund',
        refund_tooltip:          'Refund this payment — part or all; a negative payment is written under it',
        refund_denied:           'Refunding needs the “Reverse a posted charge” permission',
        transfer_tooltip:        'Move this payment onto another folio of the same booking — part or all; the money stays in the house',
        transfer_denied:         'Moving money needs the “Reverse a posted charge” and “Post charges and payments to a folio” permissions',
        refund_tag:              'Refund',
        refunded_tag:            'Refunded',
        refunds_line:            'Refunds line {line}',
        refunded_by_line:        'Refunded by line {line}',
        refund_line:             'Line {line} · {amount}',
        refund_hint:             'The payment stays on the folio and a refund with a negative amount is posted underneath it. Never more can be given back than the folio has actually been settled.',
        refund_too_large:        'The amount is more than can still be refunded.',
        confirm_refund:          'Refund this payment? The payment stays on the folio and a refund is posted beside it.',
        refunded:                'The refund has been recorded',
        refund_failed:           'The refund could not be recorded',
        refund_overpayment:      'Refund the overpayment',
        refund_no_payment:       'This folio holds no payment that could be refunded.',
        transfer_overpayment:    'Move the overpayment to another folio',
        transfer_title:          'Move an overpayment to another folio',
        transfer_hint:           'The money stays in the house — a negative row on the source folio and a positive one on the target. Nothing is edited and nothing is deleted.',
        transfer_from_payment:   'From which payment',
        transfer_payment_option: 'Line {line} · {method} · {amount}',
        transfer_target:         'To folio',
        transfer_amount_hint:    'At most {amount} — that is what this folio has actually been settled.',
        transfer_submit:         'Move',
        transfer_too_large:      'The amount is more than this folio has actually been settled.',
        transfer_not_covered:    'This folio does not hold that much. Lower the amount or choose another payment.',
        transferred:             'The overpayment has been moved to the other folio.',
        transfer_failed:         'The overpayment could not be moved',
        transfer_no_target:      'No other open folio',
        transfer_no_target_hint: 'An overpayment can only move onto another open folio of the same reservation. Open the folio and add one, or refund the money to the guest.',
        transfer_no_payment:     'No payment on this folio to move',
        transfer_no_payment_hint: 'What moves is part of a payment that has already been recorded. This folio holds no positive payment.',
    },
    payment_method: {
        cash:             'Cash',
        card:             'Card',
        bank_transfer:    'Bank transfer',
        voucher:          'Voucher',
        deposit:          'Deposit',
        ota_virtual_card: 'OTA virtual card',
    },
    without_room: {
        title: 'Taken, but not in a room yet',
        hint: 'These guests are holding a confirmation from us and have not been given a room. They are not on the board — a reservation nobody has placed holds no room, so there is no row to draw it on.',
        guest: 'Guest',
        stay: 'Stay',
        rooms: 'Rooms',
        why: 'Why it has no room',
        source: 'Came from',
        assign: 'Give a room',
        no_name: '(the channel sent no name)',
        not_placed_yet: 'Not placed yet',
    },
    channel: {
        skip_photos_not_reachable: '{count} photographs were not published: this deployment has no public address a channel could fetch them from.',
        skip_room_type_not_mapped: 'Not mapped to this channel: {names}',
        skip_photo_failed: '{count} photographs could not be published.',
        publish_content: 'Publish content',
        content_published: 'Published: {roomTypes} room types, {photos} photographs.',
        channels: 'Channel manager',
        description: 'Distribution to Booking.com, Expedia, Airbnb and the rest through the aggregator.',
        no_access: 'No access to the channel manager',
        no_access_hint: 'Ask an administrator for the channel permission.',
        none_yet: 'No channel connection yet',
        none_yet_hint: 'Connect this property to the aggregator to start selling through the channels.',
        add: 'Add connection',
        add_hint: 'The connection is created as a draft. Nothing is sent to the channels until you connect it.',
        edit: 'Edit connection',
        refresh: 'Refresh',
        provider: 'Aggregator',
        provider_channex: 'Channex',
        provider_groups_hint: 'We connect to an aggregator; the channels are what it reaches.',
        group_aggregators: 'Aggregators — what we connect to',
        group_aggregators_hint: 'One contract and one integration that reaches every channel.',
        group_channels: 'Channels — reached through the aggregator',
        group_channels_hint: 'Where the guest actually books. Nothing here is connected to directly.',
        provider_channex_hint: '60 channels, REST/JSON. The only one with an open sandbox — recommended.',
        provider_siteminder_hint: 'A large network, SOAP and OTA XML. A contract before development starts.',
        provider_staah_hint: '250+ PMS. Requires that we expose the endpoints.',
        provider_dedge_hint: '300+ distribution sites. No public developer path.',
        provider_rategain_hint: '450+ channels. No public developer path.',
        provider_hotelrunner_hint: 'XML. Partnership titles come from indirect sources, unverified.',
        provider_webbookingpro_hint: 'Croatia. 50+ OTA and GDS, white label, price on request.',
        channel_booking_com_hint: 'The most important one here. Not directly: they have paused taking on new connectivity providers.',
        channel_expedia_hint: 'Directly requires a contract and PCI compliance.',
        channel_airbnb_hint: 'No public developer portal; access only through an approved partnership.',
        channel_agoda_hint: 'Reached through the aggregator.',
        channel_hostelworld_hint: 'Hostels and youth travel. Through the aggregator.',
        channel_hrs_hint: 'The German business guest. Through the aggregator.',
        channel_hotelbeds_hint: 'Tour operator and bedbank traffic. Through the aggregator.',
        channel_trip_com_hint: 'Reached through the aggregator.',
        channel_feratel_hint: 'A destination system, strong in the Alps. Through the aggregator.',
        channel_google_hotel_hint: 'Free booking links. Support at the aggregator is unconfirmed.',
        external_property_id: 'Property id at the aggregator',
        external_property_id_hint: 'The identifier the aggregator uses for this hotel.',
        connection: 'Connection',
        connection_hint: 'The state of the link to the aggregator, both directions, and the last error.',
        state_draft: 'Draft',
        state_connected: 'Connected',
        state_suspended: 'Suspended',
        state_error: 'Error',
        last_synced_at: 'Last pushed',
        last_polled_at: 'Last collected',
        full_sync: 'Send everything',
        full_sync_success: 'The full synchronisation has been ordered',
        confirm_full_sync: 'Every channel will be told the availability, prices and restrictions for the whole sales window. Continue?',
        last_full_sync_at: 'Last full synchronisation',
        last_error: 'Last error',
        last_error_at: 'Reported at',
        last_error_past:      'Last error (since recovered)',
        last_error_recovered: 'The connection has sent or fetched successfully since — this is a record, not the current state.',
        never: 'Never',
        just_now: 'just now',
        minutes_ago: '{count} min ago',
        hours_ago: '{count} h ago',
        days_ago: '{count} d ago',
        pending_ari: 'Waiting to be pushed',
        pending_ari_hint: 'Prices and availability changed here and not yet sent to the channels.',
        pending_ari_open: 'Click to see which dates.',
        waiting_title: 'Waiting to be sent',
        waiting_description: 'The dates the aggregator does not know about yet, and why each of them is still here.',
        waiting_none: 'Everything has been sent',
        waiting_none_hint: 'The channels hold the current prices and availability.',
        waiting_date: 'Date',
        waiting_room_type: 'Room type',
        waiting_rate_plan: 'Rate plan',
        waiting_reason: 'Why it waits',
        waiting_attempts: 'Attempts',
        waiting_unknown: 'Unknown',
        waiting_availability_only: 'availability only',
        waiting_reason_unmapped: 'Not mapped',
        waiting_reason_retrying: 'Retrying',
        waiting_reason_sending: 'Sending',
        waiting_reason_waiting: 'Queued',
        waiting_unmapped_hint: '{count} dates have no mapping for their room type or rate plan. They will never be sent until the mapping is finished on the Mapping tab.',
        waiting_truncated: 'The first {count} dates are shown.',
        needs_attention: 'Needs attention',
        needs_attention_hint: 'Bookings that arrived from the channels and could not be filed on their own.',
        connect: 'Connect',
        resume: 'Resume',
        retry: 'Try again',
        suspend: 'Suspend',
        disconnect: 'Disconnect',
        confirm_suspend: 'Suspend this channel? Nothing is sent or collected until it is resumed.',
        confirm_disconnect: 'Disconnect this channel? The hotel stops selling through every channel and the mapping is lost.',
        connect_success: 'The channel is connected',
        suspend_success: 'The channel is suspended',
        disconnect_success: 'The channel is disconnected',
        mapping: 'Mapping',
        mapping_hint: 'What we sell, next to what the aggregator calls it. Anything not mapped is sold through no channel.',
        kind_room_type: 'Room types',
        kind_room_type_hint: 'one row per room type',
        kind_rate_plan: 'Rate plans by room type',
        kind_rate_plan_hint: 'one row per room type + rate plan pair',
        local_room_type: 'Our room type',
        local_rate_plan: 'Our rate plan',
        external_id: 'Id at the aggregator',
        external_id_placeholder: 'Id at the aggregator',
        propose: 'Suggest mappings',
        proposed: '{filled} identifiers filled in. Not matched: {ours} of ours, {theirs} of theirs. Nothing is saved until you press Save.',
        sell: 'On sale',
        mapped: 'Mapped',
        unmapped: 'Not mapped',
        switched_off: 'Switched off',
        mapped_count: '{mapped} of {total} on sale',
        no_local_items: 'There is nothing to map yet.',
        no_rate_plans_here: 'no rate plan',
        no_rate_plans_here_hint: 'No rate plan covers this room type, so it can be sold on no channel. Give it one under Rate plans.',
        expand_all: 'Expand all',
        collapse_all: 'Collapse all',
        pairs_none_mapped: 'No pair carries an id at the aggregator yet ({count} in total)',
        pairs_none_mapped_hint: 'This is not a fault. A rate plan mapping is now the pair room type + rate plan; the earlier rows were keyed by the plan alone and could not say which room type they were for, so they were removed rather than guessed at. Each pair now needs its own id at the aggregator. Nothing was deleted at the aggregator.',
        nothing_unmapped_here: 'Everything here is on sale.',
        only_unmapped: 'Show only what is not on sale ({count})',
        plans_without_room_type: 'Rate plans that cover no room type: {count}',
        plans_without_room_type_hint: 'These plans name no room type, so they can be mapped nowhere and are sold nowhere. Give them room types under Rate plans. Affected: {plans}',
        cannot_clear: 'Ids that have been emptied: {count}',
        cannot_clear_hint: 'An id at the aggregator cannot be removed — the API only writes and switches off. Switch the row off with the “On sale” switch instead; on save an emptied field returns to the stored value.',
        unmapped_warning: '{count} of {total} are not sold through the channels',
        unmapped_warning_hint: 'An unmapped room type, or an unmapped room type + rate plan pair, is offered on no channel at all.',
        all_mapped: 'Everything is mapped',
        all_mapped_hint: 'Every room type and every room type + rate plan pair is sold through the channels.',
        save_mapping: 'Save mapping',
        mapping_saved_count: 'Mappings saved: {count}',
        bookings: 'Bookings',
        bookings_hint: 'What arrived through the channels, and what is left to do with it.',
        booking: 'Booking from the channel',
        booking_details: 'Booking from the channel',
        booking_status_received: 'Received',
        booking_status_applied: 'Filed',
        booking_status_needs_attention: 'Needs attention',
        booking_status_cancelled: 'Cancelled',
        booking_status_ignored: 'Set aside',
        ota_reference: 'OTA reference',
        channel_code: 'Channel',
        received_at: 'Received',
        revision: 'Revision',
        revision_n: 'revision {revision}',
        reason: 'Reason',
        attention_count: '{count} need attention',
        linked_reservation: 'Linked reservation',
        open_reservation: 'Open the reservation',
        payload: 'What the channel sent',
        payload_empty: 'The channel sent nothing with it.',
        resolve: 'Resolve',
        resolve_title: 'Point at a reservation',
        resolve_hint: 'Point it at the reservation it belongs to. The search starts on the reference the guest is holding.',
        resolve_note: 'Note (optional)',
        search_reservation: 'Booking number or guest name',
        no_reservation_found: 'No reservation found. Try the guest name or the booking number.',
        resolve_success: 'The booking has been linked to the reservation',
        place: 'Create reservation',
        place_title: 'Create a reservation from this',
        place_hint: 'The guest, the dates, the number of people and the price are taken from the channel. Choose only a room type and a room; the channel booking links itself.',
        place_pick_room: 'Choose a free room',
        place_no_free_room: 'No room of this type is free for these dates.',
        place_channel_quote: 'The channel quoted the guest',
        place_exchange_rate: 'Exchange rate ({from} → {to})',
        place_house_amount: 'Amount in {currency}',
        place_exchange_hint: 'The suggestion is the ECB reference rate (the official list); you may correct it. The stay keeps the original amount and the rate as entered; the invoice is in the hotel\'s currency.',
        place_rate_suggest: 'Suggest rate (ECB)',
        place_rate_suggested: 'ECB reference rate of {date}: 1 {from} = {rate} {to}',
        place_rate_suggest_failed: 'The ECB rate could not be fetched.',
        place_rate_required: 'Type an exchange rate.',
        place_success: 'Reservation {number} created and linked to the channel',
        place_replayed: 'The button was pressed twice — the first reservation {number} stands. There is no second one.',
        ignore: 'Set aside',
        ignore_title: 'Set aside',
        ignore_reason: 'Reason',
        ignore_reason_duplicate: 'Duplicate',
        ignore_reason_test: 'Test booking',
        ignore_reason_entered_by_hand: 'Already entered by hand',
        ignore_reason_cancelled_by_ota: 'Cancelled at the channel',
        ignore_reason_other: 'Other',
        ignore_success: 'The booking has been set aside',
        reason_unmapped_room_type: 'The room type on this booking is not mapped to ours.',
        reason_unmapped_rate_plan: 'The rate plan on this booking is not mapped to ours.',
        reason_no_rooms: 'The booking names no rooms.',
        reason_invalid_dates: 'The arrival and departure cover no nights.',
        reason_no_room_free: 'No room of that type is free for these nights.',
        reason_overbooking: 'The rooms were sold in the meantime — this booking would overbook the hotel.',
        reason_reservation_refused: 'The booking could not be turned into a reservation — check the dates, the occupancy and the price.',
        reason_missing_guest_name: 'The booking carries no complete guest name.',
        reason_guest_refused: 'The guest details could not be stored — enter the guest by hand.',
        reason_changed_after_placement: 'The channel changed a booking that is already in the hotel.',
        reason_cancellation_failed: 'The channel cancelled this booking and the reservation could not be cancelled.',
        reason_system_error: 'This booking could not be placed automatically.',
    },
    content: {
        room_type_hint: 'The description of this room type, its fittings and its photographs, in the languages the hotel sells in. Saved separately from the room settings.',
        room_type_action: 'Description and fittings',
        room_type_action_hint: 'The description, the fittings and the photographs of this room type.',
        content: 'Content',
        property_hint: 'The description of the hotel and what a guest must know, in the languages the hotel sells in.',
        description: 'Description',
        description_hint: 'What a guest reads about the hotel or the room before booking.',
        description_placeholder: 'A short description …',
        important_information: 'Important information',
        important_information_hint: 'What a guest must know before arriving — parking, key collection, house rules.',
        important_information_placeholder: 'What a guest must know before arriving …',
        add_language: 'Add a language',
        remove_language: 'Remove language',
        remove_language_confirm: 'Remove this language? Its text is deleted.',
        default_language_tab: 'Hotel language',
        default_language_required: 'The hotel language must be written while any other is — a translation with no original behind it is a blank page for everyone who does not read that language.',
        characters: '{count} characters',
        discard: 'Discard changes',
    },
    photo: {
        photos: 'Photographs',
        photos_hint: 'What a channel shows a guest. The first picture is the cover.',
        count: '{count} of {max}',
        upload: 'Upload',
        upload_failed: '"{name}" could not be uploaded.',
        too_large: '"{name}" is too large (10 MB at most).',
        full_title: 'The gallery is full',
        full_hint: 'At most {max} photographs per property or room type. Delete one to add another.',
        none: 'No photographs yet',
        none_hint: 'Channels barely sell a room without pictures. Upload as many as the hotel has.',
        cover: 'Cover',
        make_cover: 'Make cover',
        cover_set: 'The cover has been set',
        move_earlier: 'Move earlier',
        move_later: 'Move later',
        confirm_delete: 'Delete this photograph?',
        deleted: 'The photograph has been deleted',
        details: 'Photograph details',
        caption: 'Caption',
        caption_hint: 'What appears under the picture on a channel, per language.',
        caption_placeholder: 'e.g. The view from the terrace',
        author: 'Author',
        author_hint: 'The photographer, where crediting them is part of the agreement.',
    },
    policy: {
        policies: 'Cancellation policies',
        add: 'Add a policy',
        edit: 'Edit policy',
        what_it_is: 'Cancellation policy',
        what_it_is_hint: 'How long a guest may cancel free of charge, and what is charged afterwards.',
        name_hint: 'The name the desk recognises it by — e.g. \"Free until 18:00 on the day of arrival\".',
        description_hint: 'An optional note for the desk.',
        free_cancellation: 'Free cancellation',
        free_cancellation_hint: 'Switched off means non-refundable: charged from the moment of booking.',
        free_window: 'Free until',
        deadline: 'Deadline',
        deadline_hint: 'The time in the hotel\'s own local time.',
        days_before_arrival: 'Days before arrival',
        days_before_arrival_hint: '0 means the day of arrival.',
        penalty: 'Charged',
        penalty_hint: 'What the hotel charges when a guest cancels after the deadline.',
        penalty_none: 'Nothing',
        penalty_first_night: 'The first night',
        penalty_percentage: 'A share of the stay',
        penalty_full_stay: 'The whole stay',
        penalty_percent: 'Percentage',
        penalty_percent_hint: 'A share of the whole stay.',
        free_needs_penalty: 'A policy with a free window has to say what is charged after it.',
        is_default: 'The hotel default',
        is_default_hint: 'Applies to rate plans that name none of their own.',
        default_short: 'Default',
        in_use: 'In use',
        confirm_delete: 'Delete this policy?',
        summary: 'Summary',
        summary_never_free: 'Non-refundable',
        summary_arrival_day: 'Free until {time} on the day of arrival',
        summary_days_before: 'Free until {time}, {days} days before arrival',
    },
    extra: {
        extras: 'Extras',
        hint: 'What the hotel charges beside the room — final cleaning, a registration fee, pets. A rate plan may include some of them.',
        add: 'Add an extra',
        edit: 'Edit extra',
        code_hint: 'The lasting handle for lines, reports and channels.',
        charging: 'Charged',
        charging_hint: 'How often one unit is counted over a stay.',
        price: 'Price (incl. VAT)',
        price_hint: 'The gross price of one unit — the number a guest is quoted.',
        tax_rate: 'VAT (%)',
        included: 'Included',
        included_in_room_price: 'Included in the room price',
        included_in_room_price_hint: 'An included extra is never charged again.',
        in_use: 'This extra cannot be deleted — at least one rate plan includes it. Retire it instead.',
        confirm_delete: 'Delete "{name}"?',
        none: 'No extras yet',
        none_hint: 'Enter what the hotel charges beside the room, so every stay is billed the same way.',
        charging_per_stay: 'Once per stay',
        charging_per_night: 'Per night',
        charging_per_person: 'Per person',
        charging_per_person_per_night: 'Per person per night',
        vat_of: 'VAT {rate}',
    },
    tax: {
        tax_sets: 'Tax sets',
        hint: 'How a price is built: VAT and levies, each inside the price or added to it. A rate plan may name its own set; otherwise the default applies.',
        add: 'Add a set',
        edit: 'Edit set',
        levies: 'Levies',
        levies_hint: 'A percentage is entered as a percentage, an amount in money. No tax is ever charged on another tax.',
        add_levy: 'Add a levy',
        remove_levy: 'Remove',
        kind: 'Kind',
        percent: 'Percentage',
        amount: 'Amount',
        included: 'Included in the price',
        is_default: 'The hotel default',
        is_default_hint: 'Applies to rate plans that name none of their own.',
        default_short: 'Default',
        in_use: 'This set cannot be deleted — at least one rate plan names it. Retire it instead.',
        confirm_delete: 'Delete the set "{name}"?',
        empty_set: 'No levies',
        none: 'No tax sets yet',
        none_hint: 'Enter the VAT and levies the hotel charges, so a price is built the same way everywhere.',
        tourist_tax_title: 'The tourist tax lives elsewhere',
        tourist_tax_hint: 'The statutory rates and the reliefs are in Settings under Tourist tax (that is what eTurizem is told); how it appears on a quoted price is on the tax set. Do not create a third place for it.',
        tourist_tax_open: 'Open Tourist tax',
        kind_percentage: 'Percentage',
        kind_per_night: 'Per night',
        kind_per_person_per_night: 'Per person per night',
    },
    /**
     * The municipality's rate card and the grounds on which a guest does not pay it
     * (docs/ETURIZEM.md §6). The relief DESCRIPTIONS are not here: the statutory list
     * comes from the service, which is also what seeds it into a house's settings, and
     * a relief's description has never been a translated string — it is one line of the
     * hotel's own text, stored in its settings and printed on a bill.
     */
    tourist_tax: {
        nav: 'Tourist tax',
        intro: 'What the hotel collects for the municipality, and who does not pay it. The rate comes from the municipal ordinance and the reliefs from ZSRT-1; check both before the first assessment.',
        no_property: 'Choose a property first',
        no_property_hint: 'The tax is set per property. Open one under Properties and come back.',
        no_permission: 'No compliance permission',
        no_permission_hint: 'Viewing the tax needs compliance:read; editing it needs compliance:write.',
        rates: 'Rates',
        rates_hint: 'Both amounts are per person per night, as the municipal ordinance sets them.',
        rate: 'Tourist tax',
        per_person_per_night: 'Per person per night',
        promotion_rate: 'Promotion levy',
        promotion_rate_hint: 'Per person per night. By law 25 % of the tourist tax.',
        promotion_suggestion: 'The promotion levy is not 25 %',
        promotion_suggestion_hint: 'ZSRT-1 art. 17 puts the promotion levy at 25 % of the tourist tax — {amount} at this rate. If the municipality says otherwise, keep your own amount.',
        promotion_apply: 'Set to 25 %',
        rate_too_high: 'That amount is too high — enter it in euros, not in cents.',
        reliefs: 'Reliefs',
        reliefs_hint: 'The grounds on which a guest pays less or nothing. The code belongs to the house and stays written on every assessed stay, so do not rename it later.',
        add_relief: 'Add a relief',
        add_statutory: 'Add the statutory reliefs (ZSRT)',
        remove_relief: 'Remove',
        confirm_remove: 'Remove the relief "{name}"? Stays already assessed do not change.',
        no_reliefs: 'No reliefs yet',
        no_reliefs_hint: 'Until there are, every guest pays the full tax and the guest card shows no exemption field. Start from the statutory set and reconcile it with the municipal ordinance.',
        code: 'Code',
        description: 'Name',
        relief_percent: 'Relief (%)',
        relief_percent_hint: '100 is a full exemption.',
        reporting_code: 'AJPES code',
        reporting_code_hint: 'The ground the exemption is filed under in eTurizem.',
        age_from: 'Age from',
        age_to: 'Age to',
        age_hint: 'Whole years at arrival, both bounds inclusive.',
        age_needed: 'An automatic relief needs an age bound.',
        age_order: 'The upper bound cannot be below the lower one.',
        automatic: 'Automatic, by age',
        automatic_hint: 'The system grants it from the date of birth alone. Switch it on only where no certificate is needed.',
        duplicate_code: 'That code is already used.',
        percent_range: 'Enter a value between 1 and 100.',
        saved: 'The tourist tax has been saved',
        statutory_unavailable: 'The statutory list could not be read. Try again, or enter the reliefs by hand.',
        reporting_0: 'Full tourist tax',
        reporting_1: 'Exempt - child under 7',
        reporting_2: 'Exempt - medical referral',
        reporting_3: 'Exempt - disability, physical impairment',
        reporting_4: 'Exempt - child with special needs',
        reporting_5: 'Exempt - educational programme',
        reporting_6: 'Exempt - pupils and students in halls of residence',
        reporting_7: 'Partial - persons on temporary work',
        reporting_8: 'Exempt - international treaty',
        reporting_9: 'Exempt - mountain hut (Alpine Association members)',
        reporting_10: 'Exempt - municipal ordinance',
        reporting_11: 'Half rate - person aged 7 to 18',
        reporting_12: 'Half rate - IYHF youth hostels',
        reporting_13: 'Half rate - tourists in campsites',
        reporting_14: 'Half rate - municipal ordinance',
        reporting_15: 'Partial - municipal ordinance',
        reporting_16: 'No charge - no overnight service',
        reporting_17: 'Exempt - holidays organised by societies in the public interest',
        reporting_18: 'Exempt - volunteers in disaster relief',
        reporting_19: 'Exempt - police officers on duty',
    },
    amenity_category: {
        general: 'General',
        in_room: 'In the room',
        bathroom: 'Bathroom',
        kitchen: 'Kitchen',
        view: 'View',
        outside: 'Outside',
        security: 'Security',
        accessibility: 'Accessibility',
    },
    amenity: {
        scope: 'Where it applies',
        scope_hint: 'A room fitting, something the hotel offers, or both. What the hotel offers goes to the channels as a property facility.',
        scope_room: 'Room fitting',
        scope_property: 'Hotel facility',
        scope_both: 'Both',
        property_offers: 'What the hotel offers',
        property_offers_hint: 'Pool, sauna, restaurant, bar, bicycle hire … What is ticked goes to the channels as a property facility and is shown to the guest.',
        property_offers_empty: 'Nothing is marked as a hotel facility yet. Mark it in the list below.',
        property_offers_saved: 'The hotel facilities have been saved.',
        more: '+{count}',
        none_on_room_type: 'No fittings named',
        amenities: 'Fittings',
        hint: 'What a room has. The catalogue is the hotel\'s own: an aggregator\'s codes are its own, and your list survives changing supplier.',
        add: 'Add a fitting',
        edit: 'Edit fitting',
        code: 'Code',
        code_hint: 'The lasting handle that exports and channel mappings carry. A rename does not move it.',
        code_invalid: 'A code may hold lower-case letters, digits and underscores, and starts with a letter.',
        code_taken: 'That code is already used in this property.',
        category: 'Category',
        install_starter: 'Install the standard list',
        installed: '{count} added',
        in_use: 'This fitting cannot be deleted — at least one room type still has it. Untick it there first.',
        confirm_delete: 'Delete "{name}"?',
        none: 'No fittings yet',
        none_hint: 'Install the standard nineteen and adjust them, or add your own.',
        room_type_hint: 'Tick what this room type has. Saved separately from the room settings.',
    },
    company: {
        company: 'Company',
        companies: 'Companies',
        hint: 'The firms that pay for reservations. They belong to the whole tenant rather than to one property — the agreement is one.',
        add: 'Add a company',
        edit: 'Edit company',
        legal_name: 'Legal name',
        tax_number: 'Tax number',
        tax_number_hint: 'The firm\'s tax number.',
        tax_number_taken: 'A company with that tax number already exists.',
        vat_number: 'VAT identification',
        vat_number_hint: 'Only for a registered payer — this is the number that goes on the invoice.',
        lookup:             'Look up by VAT number',
        lookup_done:        'The register’s details were put into the empty fields.',
        lookup_not_found:   'This number is not in the European VAT register. The company may not be registered for VAT — type the details in.',
        lookup_unavailable: 'The register did not answer. Type the details in.',
        lookup_invalid:     'That is not a VAT number. Enter the 8-digit Slovenian tax number (e.g. 40978273) or a VAT ID with its country prefix (SI40978273, DE…).',
        register:                'Find in the register',
        register_hint:           'The Slovenian register of taxpayers (FURS). Type the company\u2019s name — the tax number, the VAT identification and the address are taken from the register.',
        register_search:         'Company name',
        register_placeholder:    'e.g. Mercator',
        register_town:           'Town (optional)',
        register_min:            'Type at least three letters of the name.',
        register_none:           'No company of that name is in the register. The register holds the REGISTERED name, which is often not the one on the letterhead — try another word, or type the details in.',
        register_failed:         'The register could not be read. Type the details in.',
        register_taken:          'Taken from the register. The name is the registered one — correct it if the house calls the company something else.',
        register_empty:          'The register has not been downloaded on this installation yet, so the search finds nothing. It refreshes itself every night.',
        register_vat_payer:      'VAT payer',
        register_not_vat_payer:  'not registered for VAT',
        register_sole_trader:    'sole trader',
        register_state:          'FURS register: refreshed {when}, {count} taxpayers',
        register_state_never:    'FURS register: not downloaded yet',
        register_state_problem:  'FURS register: the last download failed — {note}',
        contact: 'Contact',
        payment_terms: 'Payment terms',
        payment_terms_hint: 'How many days after an invoice the firm pays. Zero means on the spot — and only with terms does an outstanding balance stop blocking a departure.',
        days: '{count} days',
        pos_buyer_id: 'Buyer id in the till',
        pos_buyer_id_hint: 'Optional. The buyer has to exist in Imprion POS; this only points at it.',
        active_hint: 'A switched-off company is no longer offered, and the invoices already issued to it are untouched.',
    },
    // What happened to the invoice. An invoice is never edited, so this is not a list
    // of versions but a list of the moments the document took part in.
    invoice_history: {
        title:     'History',
        hint:      'When the invoice was issued, confirmed by the tax authority, paid, and possibly cancelled.',
        issued:    'Issued',
        fiscal:    'Protective mark (ZOI)',
        confirmed: 'Confirmed by the authority (EOR)',
        payment:   'Payment',
        storno:    'Cancelled by credit note',
        storno_of: 'Cancels invoice',
    },
    // The printed invoice. Its words are for the guest and the accountant, not the screen.
    invoice_print: {
        reservation: 'Reservation',
        room:        'Room',
        not_subject_to_vat: 'Not subject to VAT',
        total_without_vat:  'Total without VAT',
        discount:            'discount',
        paper_a4: 'A4',
        paper_receipt: '80 mm roll',
        invoice:             'INVOICE',
        credit_note:         'CREDIT NOTE',
        issued_at:           'Issued',
        service_period:      'Period of service',
        payment_method:      'Payment method',
        due_date:            'Due',
        buyer:               'Buyer',
        buyer_tax_number:    'Tax number',
        tax_number:          'Tax number',
        vat_number:          'VAT ID',
        registration_number: 'Company number',
        description:         'Description',
        quantity:            'Qty',
        unit_price:          'Price',
        tax_rate:            'VAT',
        amount:              'Amount',
        tax_base:            'Base',
        tax_amount:          'VAT',
        total:               'Total',
        total_due:           'TOTAL DUE',
        remaining:           'Remaining',
        operator:            'Operator',
        eor_pending:         'No identifier yet — the invoice was issued while the tax authority was unreachable and will be confirmed afterwards.',
        storno_of:           'Credit note for invoice {number}',
        tourist_tax:         'Tourist and promotion tax',
        tourist_tax_note:    'Collected in the name and for the account of the municipality. Not included in the VAT base.',
        reference:           'Reference',

        // Prepayments: the document's own heading, the pro forma it answers, the block.
        advance_invoice:     'ADVANCE INVOICE',
        by_proforma:         'Against pro forma: {number}',
        advance_deductions:  'Prepayment deducted',
        advance_deducted:    'Prepayment on invoice {number} of {date}',
    },
    // The head of an invoice: who issues it and under which numbers.
    identity: {
        vat_payer: 'VAT payer',
        vat_payer_label: 'The hotel is registered for VAT',
        vat_payer_help: 'The tax number and the VAT ID are the same number - the ID is derived (SI + tax number).',
        vat_payer_derived: 'VAT ID: {vat}',
        title:                    'Issuer details',
        hint:                     'Printed on every invoice. These belong to the company rather than to the document — a reprint of an old invoice shows the address and account the hotel has today.',
        legal_name:               'Legal name',
        legal_name_help:          'Leave empty when it is the same as the hotel name.',
        tax_number:               'Tax number',
        vat_number:               'VAT ID',
        vat_number_help:          'For example SI12345678. Leave empty when the hotel is not registered for VAT.',
        registration_number:      'Company register number',
        iban:                     'IBAN',
        bic:                      'BIC / SWIFT',
        email:                    'Email',
        phone:                    'Phone',
        payment_terms: 'Payment terms (days)',
        payment_terms_help: 'How many days from issue the buyer has to pay an invoice not settled at issue. 0 means payable on issue.',
        vat_exemption_note:       'VAT exemption note',
        vat_exemption_note_help:  'The sentence printed in place of a rate when the hotel does not charge VAT.',
    },
    integration: {
        connection: 'Settings for the till',
        copy_connection: 'Copy all',
        title: 'Tills and connections',
        hint: 'The keys the hotel’s own machines use to put spending on a room — the till in the bar, the restaurant, the wellness desk. A key is not a user account: it may only post a bill to the card of somebody in a room.',
        issue: 'Issue a key',
        name_hint: 'What this machine is called in the hotel — “Bar terrace”, “Restaurant”. The name is printed beside every line the till posts.',
        issued_title: 'The key has been issued',
        issued_hint: 'Copy it into the till now — only its hash is stored, so it cannot be shown again. If it is lost, issue another and revoke this one.',
        copy: 'Copy',
        copied: 'Copied',
        copy_failed: 'The key could not be copied — select it and copy it by hand.',
        prefix: 'Key begins with',
        last_used: 'Last used',
        never_used: 'never',
        revoked: 'Revoked',
        revoke: 'Revoke',
        revoke_confirm: 'Revoke the key “{name}”? From this moment that till can no longer charge a room.',
        restore: 'Restore',
        empty: 'This property has no keys yet.',
    },
    invoice: {
        issued_for:     '{buyer} · {amount}',
        show_and_print: 'Show and print',
        storno_fiscal_title: 'The credit note is reported to the tax authority',
        storno_fiscal_hint: 'This hotel reports its own invoices, so the credit note gets its own number on the same device, its own protective mark and its own confirmation. Nothing has to be entered by hand.',
        paid:                     'Paid',
        language: 'Invoice language',
        language_hint: 'The document is printed in this language, whatever language the reader\'s interface is in.',
        to_company: 'Invoice to a company',
        to_company_hint: 'Choose the firm from the register — its name, address and tax number are taken from the record.',
        pdf:                      'PDF / print',
        invoices:                 'Invoices',
        invoice:                  'Invoice',
        document:                 'Document',
        number:                   'Number',
        issued_from_folio_hint:   'An invoice is issued from a guest folio. An issued invoice is never edited or deleted — the only correction is a storno with a credit note.',
        business_date:            'Business date',
        business_date_from:       'Business date from',
        business_date_to:         'Business date to',
        issued_at:                'Issued at',
        buyer:                    'Buyer',
        buyer_name:               'Buyer name',
        tax_number:               'Tax number',
        tax_number_hint:          'Only needed when the buyer wants the invoice in a company’s name.',
        buyer_snapshot_hint:      'The buyer details are a snapshot taken at the moment of issuing. Later changes to the guest profile never change the document.',
        note:                     'Note',
        lines:                    'Lines',
        source_ref:               'bill',
        not_subject_to_vat:       'Not subject to VAT',
        description:              'Description',
        quantity:                 'Quantity',
        unit_price:               'Unit price',
        tax_rate:                 'VAT rate',
        amount:                   'Amount',
        tax_recap:                'VAT recapitulation',
        net:                      'Net',
        tax:                      'VAT',
        gross:                    'Gross',
        total_net:                'Total net',
        total_tax:                'Total VAT',
        total_gross:              'Total gross',
        payments:                 'Payments',
        payments_hint:            'These payments belong to the folio the invoice was issued from, not to the invoice itself.',
        payments_total:           'Payments total',
        issue:                    'Issue invoice',
        issue_irreversible_title: 'Issuing is final',
        issue_irreversible_hint:  'An issued invoice cannot be changed or deleted. A correction means a storno with a credit note and a second invoice, so check the buyer and the lines now.',
        issue_preview:            'Invoice preview',
        issue_preview_hint:       'This is how the invoice will read. The lines are taken from the folio and cannot be changed here.',
        confirm_issue:            'Issue an invoice for {buyer} in the amount of {amount}? This cannot be undone.',
        issued:                   'The invoice has been issued',
        issue_failed:             'The invoice could not be issued. Nothing was issued and nothing was fiscalised — fix the cause and try again.',
        folio_not_open:           'The folio is not open, so no invoice can be issued from it.',
        folio_nothing_to_invoice: 'This folio has no lines to put on an invoice. It is empty, or every line on it has been reversed in full — reversed pairs are not printed on the invoice.',
        folio_not_positive:       'The folio total is not greater than zero.',
        omitted_reversed_pairs:   'Reversed pairs left out: {count}',
        storno:                   'Storno',
        storno_create:            'Create credit note',
        storno_explanation_title: 'A storno does not delete the invoice',
        storno_explanation:       'Invoice {number} stays valid and unchanged. A new document is created beside it — a credit note with the amounts negated, its own number from the same series and today’s business date.',
        storno_pos_title:         'The credit note is not sent to the POS',
        storno_pos_warning:       'The Imprion POS External API has no storno call, so the credit note is not fiscalised. Somebody has to make the correction by hand in the POS back office, or it does not get done.',
        original_invoice:         'Original invoice',
        stays_valid:              'Stays valid',
        credit_note_amount:       'Credit note amount',
        credit_note_date_hint:    'Dated with today’s business date, not the original invoice’s.',
        storno_full: 'Whole document',
        storno_partial: 'Part of it',
        partial_amount: 'Credit note for the chosen: {amount}.',
        partial_needs_lines: 'Pick at least one line.',
        archive_pdf: 'Archived PDF',
        archive_missing: 'This document has no archive — it was issued before the archive existed.',
        storno_reason:            'Storno reason',
        storno_reason_hint:       'The reason is written on the credit note and is the first thing an audit reads. Say what happened.',
        confirm_storno:           'Create a credit note for invoice {number}? The invoice stays valid and the credit note is final.',
        storno_created:           'The credit note has been created',
        storno_failed:            'The credit note could not be created',
        storno_of_link:           'Open the original invoice',
        cancelled_by_title:       'Cancelled by credit note {number}',
        cancelled_by_hint:        'The invoice stays a valid document and is not changed — the credit note is a document of its own that cancels it out.',
        credit_note_title:        'Credit note for invoice {number}',
        credit_note_hint:         'This document is a credit note: its amounts are negated and cancel out the original invoice. A credit note cannot itself be stornoed — undoing one means a new invoice.',
        open_credit_note:         'Open credit note',
        open_original:            'Open original invoice',
        fiscal:                   'Fiscalisation',
        fiscal_confirmed:         'Confirmed by FURS',
        fiscal_pending:           'Awaiting FURS',
        fiscal_pending_hint:      'The bill is issued and fiscalised — the ZOI is computed — but FURS has not answered yet. This is a lawful state, as the confirmation may arrive within 48 hours, and never an error. There is nothing to do.',
        fiscal_none:              'Not fiscalised',
        provider_imprion_pos:     'Imprion POS',
        provider_furs:            'Tax authority (direct)',
        zoi:                      'ZOI',
        eor:                      'EOR',
        confirmed_at:             'Confirmed at',
        bill_number:              'POS bill number',
        business_unit:            'Business unit',
        cash_register:            'Cash register',

        // Prepayments: the kind of document, the pro forma, the deduction, two refusals.
        kind:                     'Kind',
        kind_final:               'Invoice',
        kind_advance:             'Advance invoice',
        kind_all:                 'All kinds',
        by_proforma:              'Against pro forma {number}',
        advance_deduction_tag:    'Prepayment deducted',
        advance_deductions_hint:  'The negative lines take off a prepayment already received, VAT and all, rate by rate. The amount due is therefore already net of them.',
        advance_already_consumed: 'This prepayment has already been deducted by invoice {number}. Credit that invoice first; the prepayment is then available again.',
        advance_already_consumed_unknown: 'This prepayment has already been deducted by an issued invoice. Credit that invoice first; the prepayment is then available again.',
        advance_exceeds_total:    'The prepayments received come to more than the stay. The guest has overpaid — issue a partial credit note against the advance invoice and refund the difference; an invoice for a negative amount cannot be issued.',
    },
    invoice_status: {
        issued:    'Issued',
        cancelled: 'Credit note',
    },
    // When the hotel fiscalises itself: what the tax authority needs to know about the
    // business premises and the device before this hotel may issue an invoice.
    certificate: {
        title: 'Digital certificates',
        hint: 'What this system signs with in the company’s name. A certificate belongs to the company rather than to a hotel — the authority issues one per taxpayer and the same one signs for every establishment.',
        none: 'No certificate has been uploaded.',
        no_permission: 'You do not have permission for certificates.',
        upload: 'Upload certificate',
        upload_failed: 'The certificate could not be uploaded.',
        uploaded: 'The certificate has been uploaded.',
        deactivate: 'Retire',
        deactivated: 'The certificate has been retired.',
        retired: 'Retired',
        purpose: 'Purpose',
        purpose_hint: 'The fiscalisation one is issued by the tax authority itself. The reporting one is a qualified certificate from a commercial authority, registered in the company’s AJPES profile.',
        purpose_fiscalisation: 'Fiscalisation (FURS)',
        purpose_reporting: 'Reporting (AJPES)',
        label: 'Name',
        label_hint: 'Your own name for it — “FURS till”, “Halcom, director” — so that whoever replaces one knows which is which.',
        file: 'File',
        file_hint: 'The PKCS#12 (.p12 or .pfx) as issued by the certificate authority.',
        file_password: 'File password',
        file_password_hint: 'It opens the file and is not stored — it protected the transport only.',
        portal_username: 'Portal username',
        portal_hint: 'The account this certificate signs in with. A fiscalisation certificate has none.',
        portal_password: 'Portal password',
        sealed: 'The certificate is sealed',
        sealed_hint: 'The material and the passwords are sealed and no screen returns them. Only what is written on the face of the certificate is shown: who it belongs to, who issued it, and when it stops working.',
        valid_until: 'Valid until {date}',
    },
    fiscal: {
        moved_hint: 'Fiscalisation is set up under Settings (the gear) → Finance and compliance → Tills, beside the counters that issue the receipts and the certificates that sign them.',
        moved_open: 'Open Tills',
        title:                            'Fiscalisation',
        hint:                             'When the hotel reports invoices itself, the PMS signs them and sends them to the tax authority. The certificate belongs to the company and is uploaded once, in the certificate settings.',
        settings_hint:                    'Leave empty when the hotel does not report its own invoices — the point of sale does it instead.',
        settings:                         'Property settings',
        certificate:                      'Certificate',
        premises:                         'Business premises',
        tax_number:                       'Taxpayer tax number',
        tax_number_help:                  'Eight digits. Must match the certificate, or the authority refuses the message.',
        business_premise_id:              'Business premises identifier',
        business_premise_id_help:         'Written once and never changed — it is part of every protective mark this hotel has ever computed.',
        electronic_device_id:             'Electronic device identifier',
        electronic_device_id_help:        'This hotel\'s till. It is part of every protective mark as well.',
        cadastral_number:                 'Cadastral number',
        building_number:                  'Building number',
        building_section_number:          'Building section number',
        software_supplier_tax_number:     'Software supplier tax number',
        software_supplier_tax_number_help: 'Ours, not the hotel\'s. The authority asks for it when the premises is registered.',
        register_premises:                'Register premises',
        premises_registered:              'The business premises has been registered.',
        premises_failed:                  'The business premises could not be registered.',
        premises_missing_hint:            'Until the premises is registered, every invoice from this hotel is refused. Registering is a one-off act.',
        certificate_missing_hint:         'Upload the company certificate (purpose: fiscalisation) in the certificate settings.',
        unconfirmed:                      'Unconfirmed invoices',
        unconfirmed_hint:                 'The invoices are issued and valid — the protective mark is computed — but the authority has not answered yet. The system keeps sending them; the law allows 48 hours. If the number stops falling, check the connection.',
    },

    registration: {
        stay_title: 'Guest filings',
        stay_hint: 'What was reported to eTurizem for this stay. If a filing was refused, correct the guest and file again.',
        retry: 'File again',
        retry_queued: 'The filing is queued.',
        retry_failed: 'The filing could not be started again.',
        retry_rebuilds: 'This filing never reached eTurizem — trying again will take the guest as they are now.',
        retry_keeps_snapshot: 'This filing was already submitted — trying again sends the same snapshot. To change the details, file a new registration.',
        filed_at: 'Filed {at}',
        serial: 'Book no.',
        package: 'package',
        reporting:      'AJPES/eTurizem reporting',
        reporting_settings_hint: 'Without these two the hotel cannot file a guest. Both come from the register of accommodation establishments.',
        facility_id:    'Establishment number (idNO)',
        facility_id_help: 'From the register of accommodation establishments. Zero means this hotel is not registered and does not report.',
        serial_start:   'Last serial used this year',
        serial_start_help: 'If the guest book was kept elsewhere this year — the AJPES web application, paper, another system — enter the last number used. Our first filing takes the next one. Changing it later does not renumber what has been filed.',
        status:         'Status',
        reported_at:    'Registered',
        registered_by:  'Filed by',
        note:           'Note',
        attempts:       'Submissions made: {count}',
        report_hint:    'What the hotel told the state. A refused row can be fixed right here — open the guest, correct the detail and send it again; the guest’s stay still does the same.',
        edit_guest:     'Edit guest',
        resend:         'Send again',
        guest_load_failed: 'The guest could not be opened.',
        window:             'The period reads',
        window_arrivals:    'Registrations in the period',
        window_departures:  'Departures in the period',
        window_arrivals_help:   'Guests whose eTurizem registration was filed within the chosen period.',
        window_departures_help: 'Guests whose departure was filed within the chosen period — newest first.',
        departure_reported: 'Checked out',
        still_registered:   'still registered',
        sent_hint:      'The system took it',
        pending_hint:   'Waiting in the queue',
        failed_hint:    'Needs looking at',
        // The „today“ strip at the top of the screen: what the state is still owed on
        // the hotel day the house is working.
        outstanding_failed:         'Refused today',
        outstanding_pending:        'Queued today',
        outstanding_unregistered:   'In house, not filed',
        outstanding_departures_due: 'Departures not reported',
        // The two panels that name what the register has no row for.
        unregistered_panel_hint:  'These people are in the house and the state has not been told. File them here — the button checks the details and sends the filing to eTurizem. The deadline is twelve hours after arrival.',
        unregistered_panel_empty: 'Nobody is unfiled — everyone who has arrived is with eTurizem.',
        unregistered_nameless:    'Guest with no name',
        unregistered_stay:        '{arrival} – {departure} · {nights} nights',
        unregistered_arrived:     'arrived {at}',
        file_guest:               'File',
        open_reservation:         'Open the booking',
        // Filing from the „in house, not filed“ panel: the button that sends, and the
        // button that goes for the missing detail. `missing` decides which is drawn.
        file_ajpes:               'File with AJPES',
        filed_ok:                 'Filed with eTurizem — {name}',
        complete_data:            'Complete the details',
        missing_prefix:           'Missing',
        file_incomplete:          'The filing cannot be sent — the guest is missing: {fields}. Complete the guest and try again.',
        // The field names eTurizem requires. The keys come from the service
        // (DataStructures.RegisteredGuest.Missing); the words are here.
        missing: {
            first_name:      'first name',
            last_name:       'last name',
            nationality:     'nationality',
            document_type:   'document type',
            document_number: 'document number',
            date_of_birth:   'date of birth',
            sex:             'sex',
        },
        departures_due_panel_hint:  'The state still has these guests as present. A departure is the same filing sent again with the date of departure; start it on the booking. The deadline is twelve hours after departure.',
        departures_due_panel_empty: 'Every departure has been reported.',
        departures_due_capped:      'Showing {shown} of {total} — the most recent departures first.',
        departures_due_left:        'left {on}',
    },
    /**
     * Reporting — one house's own access to AJPES eTurizem (docs/ETURIZEM.md § 4.3).
     *
     * Its own namespace rather than part of `registration`, because this is not about a
     * guest's filing but about the house's credentials: who reports, with which
     * certificate, and whether the connection works. `eturizem_error` below explains a
     * refusal of one filing.
     */
    eturizem: {
        title: 'Reporting',
        hint: 'The user name, password and digital certificate this property reports to AJPES eTurizem with. AJPES grants the reporting right per accommodation establishment, which is why these are per property.',
        no_permission: 'These settings need the permission to manage digital certificates.',

        environment_title: 'This property reports with the installation\u2019s credentials',
        environment_hint: 'The user name and certificate were set at installation (environment variables) and filings are going through. Fill the fields below in only if this property should report with its own AJPES account — for example because its establishment\u2019s reporting right is granted to a different user.',

        nowhere_title: 'Nothing is being filed',
        nowhere_hint: 'This property has no credentials of its own and neither has the installation. Guest filings are queuing up and will be submitted once a user name and a certificate are in place.',

        username: 'AJPES user name',
        username_description: 'The AJPES portal account this property reports with (uName in the service call).',
        username_help: 'Empty means the property reports with the installation\u2019s credentials. Use a dedicated account rather than a receptionist\u2019s own. The account must hold the reporting right for this property\u2019s establishment number in the eTurizem application, or AJPES refuses with error 41397.',

        password: 'AJPES password',
        password_description: 'The same account\u2019s password (pwd in the service call). It is stored encrypted and is never shown again.',
        password_help: 'An empty box means „leave it alone“, never „clear it“. Use „Remove password“ to take it away.',
        password_set: 'set',
        set: 'set',
        clear_password: 'Remove password',
        clear_password_confirm: 'Really remove the stored AJPES password? Until a new one is entered this property cannot report with its own account.',

        base_url: 'Service address (optional)',
        base_url_description: 'Empty means the address set for the whole installation — normally the live AJPES service.',
        base_url_help: 'Fill this in only if this property should report to a different address, such as the AJPES test service while the rest of the installation is live.',
        base_url_placeholder: 'as set for the installation',

        certificate: 'Qualified digital certificate (KDP)',
        certificate_description: 'The eTurizem web service wants the certificate on every call, not only at setup. It must be registered in the user\u2019s profile on the AJPES portal.',
        certificate_none: 'No certificate has been loaded for this property yet.',
        certificate_file: 'Certificate file',
        certificate_file_description: 'A .p12 or .pfx as the authority issued it, and a .pem if the certificate has already been converted.',
        certificate_file_help: 'If the file cannot be read as it is, convert it with: openssl pkcs12 -legacy -in kdp.p12 -out kdp.pem -nodes and upload the .pem.',
        certificate_password: 'File password',
        certificate_password_description: 'What opens the .p12. It is not stored — it only protected the file on its way here.',
        certificate_password_help: 'A converted .pem usually needs no password.',
        certificate_upload: 'Upload certificate',
        certificate_uploaded: 'The certificate is stored.',
        certificate_upload_failed: 'The certificate could not be stored.',
        certificate_delete: 'Remove certificate',
        certificate_delete_confirm: 'Really remove this property\u2019s certificate? Until a new one is loaded, filings with its own account will not go through.',
        certificate_deleted: 'The certificate has been removed.',
        valid_until: 'Valid until {date}',

        sealed: 'The password and the certificate are encrypted',
        sealed_hint: 'Both are stored encrypted with the installation\u2019s own key and no route in the portal returns either. What stays on screen is what is written on the certificate — who it belongs to, who issued it, and when it expires.',

        check: 'Test connection',
        check_hint: 'The test reads the country codelist — it files nothing and changes nothing. It proves the user name, the password and the certificate; it cannot prove the right to one establishment number (error 41397), which only a real filing shows.',
        check_ok: 'The connection works',
        check_failed: 'The connection does not work',
        last_check: 'Last test',
        never_checked: 'The connection has not been tested yet.',
    },
    eturizem_error: {
        why:               'Why the filing failed',
        answer:            'The system answered',
        generic:           'eTurizem refused the registration.',
        generic_hint:      'Read the answer below, correct the detail it names, and file the guest again.',
        birth:             'The guest\'s date of birth is impossible for eTurizem — before 1800, in the future, or over 120 years ago.',
        birth_hint:        'Correct the date of birth on the guest\'s stay and file again. It is usually a mistyped year.',
        birth_missing:     'The guest has no date of birth, and eTurizem requires one.',
        birth_missing_hint: 'Enter the date of birth on the guest\'s stay and file again.',
        sex:               'The guest\'s sex is not written the way eTurizem knows it — it takes male or female only.',
        sex_hint:          'Correct the sex on the guest\'s stay and file again.',
        country:           'The guest\'s nationality is not a valid country code in the eTurizem codebook.',
        country_hint:      'Correct the nationality on the guest\'s stay (a two-letter code, SI, DE …) and file again.',
        document_type:     'The document type is not one eTurizem knows.',
        document_type_hint: 'Correct the document type on the guest (identity card = I, passport = P) and send it again.',
        document_number:   'The document number is too short — eTurizem requires at least two characters.',
        document_number_hint: 'Enter the full document number on the guest\'s stay and file again.',
        name:              'The guest\'s first or last name is too short or too long for eTurizem.',
        name_hint:         'Correct the name on the guest\'s stay and file again.',
        arrival_missing:   'The registration has no time of arrival, and eTurizem requires one.',
        arrival_missing_hint: 'Check the arrival on the reservation and file again.',
        dates:             'The arrival and departure contradict each other, or fall outside what eTurizem accepts.',
        dates_hint:        'Correct the arrival and departure on the reservation and file again.',
        date_window:       'The arrival or departure is outside the period in which eTurizem still accepts filings.',
        date_window_hint:  'The filing is too late or too early. Check the dates on the reservation; if they are right, ask AJPES about filing for that date.',
        tourist_tax:       'The tourist-tax detail is not acceptable — either the exemption reason or the amount.',
        tourist_tax_hint:  'Check the tourist tax on the guest and the property\'s tax settings, then file again.',
        credentials:       'eTurizem did not accept the property\'s username or password.',
        credentials_hint:  'Correct the user name and password in Settings (the gear) → Property and rooms → Properties → open a property → Property details tab → Reporting, then press „Test connection“. If that card is empty the property reports with the installation\u2019s credentials, which the system administrator sets. Until they are right, no filing will go through.',
        authorisation:     'The user has no authorisation for this establishment.',
        authorisation_hint: 'Authorisation for an establishment is arranged with AJPES. Check as well that the property settings carry the right establishment number.',
        establishment:     'The establishment does not exist in the register, is not active, or has been deleted.',
        establishment_hint: 'Check the establishment number in Settings (the gear) → Property and rooms → Properties → open a property → Property details tab → Reporting and its state in the RNO register.',
        certificate:       'The property\'s digital certificate is not registered, is not valid yet, or has expired.',
        certificate_hint:  'Load a valid certificate in Settings (the gear) → Property and rooms → Properties → open a property → Property details tab → Reporting; the card shows who it belongs to and when it expires. It must also be registered in the user\u2019s profile on the AJPES portal. A card with no certificate of its own uses the installation\u2019s. Nothing will file until you do.',
        serial_conflict:   'A record with this serial number was filed this year by another user.',
        serial_conflict_hint: 'The serial number has already been used at AJPES. Send it again — the filing takes the next number. If it keeps happening, raise “Last serial used this year” in the property\'s reporting settings.',
        already_filed:     'This record was filed before; eTurizem will not take it twice.',
        already_filed_hint: 'The guest is most likely already registered. Check the guest book on eTurizem; if they are, nothing needs filing again.',
        monthly_window:    'The monthly report can only be filed within a set period.',
        monthly_window_hint: 'Wait for the filing window and try again.',
        too_many:          'The package held too many records.',
        too_many_hint:     'File again; the system will send a smaller package.',
        transient:         'eTurizem had a temporary processing error.',
        transient_hint:    'This usually clears by itself — the registration is queued for another attempt. File again if it persists.',
        not_configured:    'Guest reporting is not set up for this property.',
        not_configured_hint: 'Enter the credentials and establishment number in Settings (the gear) → Property and rooms → Properties → open a property → Property details tab → Reporting.',
        our_fault:         'The filing was refused because of a fault in our system, not because of the guest\'s details.',
        our_fault_hint:    'Please report this error to us — there is nothing to correct on the hotel\'s side.',
    },
    registration_status: {
        pending:   'Queued',
        sent:      'Filed',
        confirmed: 'Confirmed',
        failed:    'Not filed',
        cancelled: 'Withdrawn',
    },
    partner: {
        partner_marker: 'partner',
        overview_count: 'ours: {count}',
        overview_no_free: 'Nothing free at the partner on this day.',
        overview_unavailable: 'The partner is not answering — free times are unknown.',
        overview_free: 'Free {from}–{to}',
        legend_free: 'free at the partner (live)',
        legend: "a partner's facility (our guests only)",
        other_area: 'Other',
        partners: 'Partners',
        partner: 'Partner',
        add: 'Connect a partner',
        edit: 'Edit partner',
        connection_hint: 'A facility another company runs in Rezervacije. The partner issues the key.',
        name: 'Partner name',
        key: 'Partner key',
        key_hint: 'The "rk_…" key the partner issued to this hotel. It is checked with the partner before it is saved.',
        key_keep_hint: 'The key {prefix}… is held — leave empty to keep it, or type a new one.',
        active: 'Connection is on',
        saved: 'Partner saved.',
        book: 'Book at partner',
        book_hint: 'Free times are read from the partner right now.',
        service: 'Service',
        day: 'Day',
        day_hint: 'A day of the partner\'s calendar.',
        slot: 'Free time',
        reading_slots: 'Reading free times from the partner …',
        no_slots: 'The partner has no free time for this service on this day.',
        slots_failed: 'The free times could not be read.',
        pick_slot: 'Pick a time',
        guest: 'Guest',
        guest_hint: 'The room of a guest in the house.',
        guest_placeholder: 'Room or surname',
        price_line: 'Partner price {price} · {minutes} min',
        booked: 'Booked at the partner, code {code}.',
        none: 'No partners connected',
        none_hint: 'A spa, thermal baths or golf club another company runs in Rezervacije can be booked by the desk straight from here — with a key the partner issues.',
        refresh: 'Refresh offer',
        refreshed: 'The partner\'s offer was refreshed.',
        refresh_failed: 'The offer could not be refreshed.',
        inactive: 'The connection to this partner is switched off.',
        connection_trouble: 'The connection to the partner is not working',
        our_guests: 'Our guests at the partner',
        no_bookings: 'Our guests have no bookings at this partner on this day.',
        booked_by_partner: 'booked by the partner',
        cancelled_from_room_screen: 'cancelled on the room screen',
        on_room: 'On the room',
        cancel: 'Cancel at partner',
        cancel_confirm: 'Cancel "{service}" at {time} with the partner?',
        cancel_failed: 'The cancellation failed.',
        cancelled: 'The partner booking was cancelled.',
        offer: 'Partner\'s offer',
        minutes: '{minutes} min',
        synced_at: 'Offer read {at}',
        at_partners: 'At partners',
        none_for_guest: 'The guests of this reservation have nothing booked at the partners.',
    },
    facility: {
        spots_total: '{count} places',
        duration: 'Duration (from – to)',
        pay_now: 'Immediate payment',
        pay_now_hint: 'After saving the till opens: cash, card, or to the room.',
        full: 'Full',
        price_unit: 'Price per',
        price_unit_hint: 'What the price is for — a parking space by the day, a hall by the hour, a massage by the treatment.',
        price_unit_hour: 'hour',
        price_unit_day: 'day',
        price_unit_night: 'night',
        price_unit_person: 'person',
        price_unit_use: 'use',
        price_unit_item: 'item',
        price_unit_treatment: 'treatment',
        type_choose: 'Choose …',
        type_search: 'Find a kind — sauna, hall, charging point …',
        type_no_match: 'Nothing matches.',
        type_unknown: 'Unknown kind',
        setup_tab: 'Facilities',
        setup_title: 'What the hotel has',
        setup_hint: 'The pool, the terrace, the hall, the charging point — and what the hotel wants to do with each: sell it by the slot, advertise it, put it on the website. This is the setting up; the working view (diary, prices, bookings) is under Facilities.',
        setup_empty: 'Nothing has been entered yet.',
        setup_empty_hint: 'Add the first one — you pick it from the catalogue and everything else follows the type.',
        setup_hours_hint: 'When it is open. An unticked day is a shut day; for a place that is booked, it is also when it can be booked at all.',
        other_group: 'Other',
        type: 'What it is',
        type_hint: 'From the catalogue — sauna, meeting room, charging point \u2026 The choice decides which fields this facility has.',
        class: 'How it is sold',
        class_hint: 'What this is: a place sold by the slot, a thing taken and brought back, work rather than a place, or an area simply open to guests.',
        class_unit: 'Accommodation unit',
        class_venue: 'Bookable space',
        class_resource: 'Bookable resource',
        class_service: 'Service',
        class_area: 'Open area',
        class_operational: 'Back of house',
        class_equipment: 'Equipment',
        status_open: 'Open',
        status_seasonal: 'Seasonal',
        status_maintenance: 'Under maintenance',
        status_closed: 'Closed',
        status_planned: 'Planned',
        uses: 'What we want to do with it',
        uses_hint: 'What is ticked opens the matching work elsewhere: bookings in the diary, prices in the price list, description and photos for the web and for posts.',
        use_booking: 'Bookings',
        use_pricing: 'Prices',
        use_website: 'Website',
        use_social: 'Social media',
        use_channels: 'Channels (OTA)',
        accessibility: 'Accessibility',
        access_step_free: 'Step-free',
        access_lift: 'Lift',
        access_accessible_wc: 'Accessible toilet',
        access_pool_lift: 'Pool lift',
        access_hearing_loop: 'Hearing loop',
        access_braille: 'Braille signage',
        access_assistance_dog: 'Assistance dogs welcome',
        location: 'Location',
        floor: 'Floor',
        capacity_people: 'Capacity (people)',
        capacity_short: '{count} people',
        bookable: 'Bookable',
        bookable_hint: 'A guest takes a slot of it.',
        chargeable: 'Chargeable',
        chargeable_hint: 'Using it costs something.',
        min_minutes: 'Shortest booking (min)',
        max_minutes: 'Longest booking (min)',
        duration_hint: 'Zero means no limit.',
        preparation_minutes: 'Preparation (min)',
        preparation_hint: 'Time before and after a booking when the place is taken but not sold.',
        teardown_minutes: 'Teardown (min)',
        min_age: 'Age from',
        max_age: 'Age to',
        age_hint: 'Zero means no limit.',
        access_rules: 'Access rules',
        access_rules_hint: 'What the guest is told: swimming caps required, no glass by the pool, hotel guests only.',
        maintenance_interval: 'Service every (days)',
        maintenance_hint: 'Zero means nothing scheduled.',
        maintenance_notes: 'What has to be done',
        description_hint: 'For the website and for posts. Written in the language chosen above.',
        no_fields: 'This type has no extra fields.',
        photos_count: 'Photos: {count}',
        photos_after_save: 'Photographs can be added once the facility is saved.',
        tab_place: 'Where and how big',
        tab_selling: 'Selling',
        tab_details: 'Details',
        tab_content: 'Description and photos',
        description: 'What the hotel sells beside the room — wellness, bike hire, parking. The restaurant is not here: the hotel has one and advertises it, and the bill for the food is the point of sale’s.',
        add: 'Add a facility',
        edit: 'Edit the facility',
        facility: 'Facility',
        code_hint: 'A stable handle for exports and support — wellness, bikes, parking. Lower case, digits and underscore.',
        kind: 'Kind',
        kind_hint: 'The kind decides how the screens behave and nothing else; the mechanism underneath is one.',
        kind_wellness: 'Wellness',
        kind_hire: 'Hire',
        kind_rental: 'Rental',
        kind_other: 'Other',
        active_hint: 'An inactive facility stays on record but nothing new is sold from it.',
        inactive: 'inactive',
        empty: 'Nothing is set up yet.',
        empty_hint: 'Add a facility (wellness, bikes), then the services it sells and the resources that have a diary.',

        services: 'Services',
        service: 'Service',
        service_add: 'Add a service',
        service_edit: 'Edit the service',
        service_active_hint: 'An inactive service can no longer be sold; bookings already made stand.',
        no_services: 'No services.',
        price: 'Price',
        price_hint: 'The gross price of the service. A room’s rate plan is separate and the two never meet.',
        tax_rate: 'VAT rate',
        guest_cancel: 'Online cancellation (hours before start)',
        guest_cancel_hint: '0 means until the start itself; -1 means the guest cannot cancel through the portal and only the desk decides.',
        cells: 'Cells',
        cells_hint: 'How many of the resource’s cells this takes. A fifty-minute massage on a quarter-hour diary is 4 cells — an hour, with the turnaround in it.',

        resources: 'Resources',
        resource: 'Resource',
        resource_add: 'Add a resource',
        resource_edit: 'Edit the resource',
        resource_name_hint: 'The thing that has a diary: a therapist, a sauna, bike 07, parking space 3.',
        resource_active_hint: 'An inactive resource is not shown in the diary.',
        no_resources: 'This hotel has no resource with a diary yet.',
        no_resources_yet: 'No resources.',
        grid: 'Cell length',
        grid_hint: 'How long one cell is. It cannot be changed once the diary exists.',
        grid_locked: 'An existing resource keeps its cell length — for another one, make a new resource.',
        grid_daily: 'whole day',
        grid_minutes: '{minutes} min',
        capacity: 'Capacity per cell',
        capacity_hint: 'How many bookings one cell holds: 1 for a therapist, more for a group class.',
        hours: 'Opening hours',
        hours_hint: 'The diary exists only where the resource is open. An unticked day is a shut day, and nothing can be sold on it.',
        whole_day: 'all day',
        whole_week: 'Every day, all day',
        closed: 'shut',
        no_hours: 'no opening hours',
        publish_after_save: 'The calendar publishes itself when the resource is saved.',

        diary: 'Diary',
        time: 'Time',
        matrix_show: 'Show:',
        matrix_show_all: 'All',
        resource_kind: 'What this is',
        service_resources: 'Who or what gives this',
        service_resources_hint: 'Booking will offer only the ones ticked.',
        service_resources_all: 'Nothing ticked means every resource of this centre.',
        service_resources_none: 'This centre has no resources yet.',
        additional_resources: 'Resources the appointment also occupies',
        additional_resources_hint: 'On top of the primary resource above — a couples massage needs a second therapist for the same slot, not two consecutive appointments.',
        additional_resources_group: 'Group {n}',
        additional_resources_count: 'How many',
        additional_resources_pool_all: 'Any resource of this facility.',
        additional_resources_add_group: 'Add a resource group',
        resource_kind_hint: 'A person has a screen of their own and a day of their own; equipment and rooms do not.',
        resource_kind_person: 'A person',
        resource_kind_equipment: 'Equipment',
        resource_kind_space: 'A room',
        resource_account: 'Account',
        resource_account_hint: 'An appointment on this diary appears under \'My services\' for that account.',
        resource_account_no_access: 'Linking an account needs the permission to read accounts.',
        resource_account_none: 'No account',
        resource_account_bound: 'already bound: {name}',
        resource_account_conflict: 'This account is already bound to the resource \u00bb{name}\u00ab.',
        matrix_no_resources: 'This centre has no resource yet — nobody and nothing to book.',
        from: 'From',
        to: 'To',
        occupancy: 'Occupancy',
        occupancy_empty: 'Nothing to show for this period.',
        occupancy_rate: 'Occupancy',
        occupancy_cells: 'Slots',
        occupancy_bookings: 'Bookings',
        occupancy_revenue: 'Revenue',
        occupancy_where: 'How it was paid',
        occupancy_no_diary: 'no diary published',
        occupancy_blocked: '{count} closed',
        occupancy_completed: '{count} finished',
        occupancy_no_show: 'no-shows: {count}',
        occupancy_cancelled: '{count} cancelled',
        occupancy_free: 'free of charge: {count}',
        occupancy_today: 'Today',
        occupancy_week: 'Week',
        occupancy_month: 'Month',
        occupancy_all: 'All',
        occupancy_open_diary: 'Open diary',
        occupancy_badge_unsettled: 'unsettled',
        occupancy_badge_full: 'nearly full',
        occupancy_badge_quiet: 'no bookings',
        occupancy_badge_ok: 'fine',
        date: 'Date',
        previous_day: 'Back',
        next_day: 'Forward',
        free: 'free',
        view_day: 'Day',
        view_week: 'Week',
        day_column: 'Day',
        week_total: 'Total',
        week_cell: '{count} · {hours} h',
        today: 'today',
        workflow: 'How it is worked',
        workflow_hint: 'What the staff do with it: perform appointments, hand it over and take it back, or merely hold it for a guest.',
        workflow_default: 'As the catalogue says for this type',
        workflow_appointment: 'Appointment — started and finished by a person',
        workflow_handover: 'Handover — ticked out and ticked back in',
        workflow_held: 'Merely held — nobody performs it (parking)',
        publish: 'Publish the diary',
        publish_hint: 'The diary writes itself — when a resource is set up, when its hours change, and one day further every day. This is the repair, for when something looks missing.',
        published: 'Cells published: {cells}.',
        diary_empty: 'There are no cells for this day.',
        diary_empty_hint: 'The resource is shut that day, or the diary has not been published yet.',

        bookings: 'Bookings',
        catalogue: 'Catalogue',
        book: 'Book',
        booked_label: 'Booked',
        no_bookings: 'No bookings in the chosen period.',
        when: 'When',
        ends_at: 'Ends',
        status: 'Status',
        status_booked: 'Booked',
        status_completed: 'Done',
        status_cancelled: 'Cancelled',
        status_no_show: 'No-show',
        status_in_progress: 'Under way',
        reopen: 'Undo',
        reopen_taken: 'That hour is gone — somebody has taken it since. Make a new booking.',
        start: 'Start',
        completed: 'The service is finished',
        complete_title: 'Finish the service',
        complete_description: 'How is this one paid for?',
        complete_free_hint: 'This service has no price — it is finished without a charge.',
        complete_already_charged: 'This appointment is already on the guest\'s card. It will not be charged twice.',
        settlement: 'Settlement',
        settlement_hint: 'Where the money for this service goes.',
        settle_folio: 'On the room',
        settle_folio_room: 'On room {rooms}',
        settle_folio_hint: 'It goes on the guest\'s card and is paid at check-out.',
        settle_folio_no_stay: 'Not possible — this appointment has no stay behind it.',
        settle_paid: 'Immediate payment',
        settle_paid_hint: 'The guest paid at the till; nothing goes on a card.',
        settle_free: 'No charge',
        settle_free_hint: 'Included in a package, or given free.',
        settled_folio: 'On the room',
        settled_paid: 'Paid',
        settled_free: 'Free',
        settled_pending: 'Not settled',
        complete: 'Done',
        no_show: 'No-show',
        taken: 'Somebody else took that time while this was open. Choose another.',
        additional_resource_pick: 'Additional resource {n}',
        additional_resource_auto: 'Automatic (first free)',
        additional_resource_busy: 'busy',
        additional_resource_none_free: 'Nothing in this group is free for this slot.',
        reservation: 'Room reservation',
        reservation_hint: 'If the guest is in the hotel it goes on their card. Without one this is a walk-in who pays at the desk.',
        room: 'Room',
        room_hint: "The room of a guest in the house — the charge goes to that stay's folio. Empty means a guest without a reservation who pays at the desk.",
        room_guest: 'Guest in the room',
        room_payer: 'payer',
        lane_n: 'Lane {number}',
        walk_in: 'Walk-in',
        guest_name: 'Guest name',
        guest_name_hint: 'What the diary prints. The name stays as it was given when the booking was taken.',
        amount: 'Amount',
        amount_hint: 'The service’s price by default. If another was agreed, put it here rather than in a note.',
        charge: 'On the room',
        charged: 'on the card',
        not_charged: 'not charged yet',
        post_to_folio: 'Charge to the card now',
        post_to_folio_hint: 'A bike taken now is charged now; an appointment for next week when it happens.',
        post_needs_reservation: 'Charging to a card needs a room reservation.',
        source: 'Booking source',
        source_hint: 'Where the booking was taken. For the hotel\'s own numbers — how much the telephone brings in and how much the desk does.',
        source_desk: 'Reception',
        source_phone: 'Telephone call',
        source_walk_in: 'Walk-in',
        source_services: 'Service portal',
        source_hospitality: 'Imprion Hospitality',
        issue_invoice: 'Issue a fiscalised invoice',
        issue_invoice_hint: 'The guest pays now and is handed a receipt. Untick if you ring the sale into your own till.',
        payment_method: 'Payment method',
        buyer_name: 'Buyer on the invoice',
        buyer_name_hint: 'Optional. Empty means an invoice with no buyer named.',
        invoiced: 'Finished, invoice issued.',
        fiscal: 'Fiscalisation',
        fiscal_hint: 'A centre with a till of its own is a business premises of its own. Empty means it sells through the hotel\'s till.',
        fiscal_premise_id: 'Business premises id',
        fiscal_device_id: 'Electronic device id',
        fiscal_cadastral: 'Cadastral number',
        fiscal_building: 'Building',
        fiscal_building_section: 'Building section',
        fiscal_pos_unit: 'Point-of-sale business unit',
        fiscal_pos_register: 'Cash register (POS)',
        fiscal_pos_hint: 'For a hotel that fiscalises through Imprion POS: this centre\'s unit and register.',
        fiscal_registered: 'Registered with the authority on {date}',
        fiscal_not_registered: 'Not registered — invoices from this centre would be refused.',
        fiscal_register: 'Register the premises',
        fiscal_registered_now: 'The premises is registered.',
        fiscal_needs_premise: 'Fill in the premises and device ids and the land-register numbers first.',
        room_service: 'Room service',
        room_service_hint: "The guest orders from the restaurant's menu on the room screen. The menu is read live from the till — say only which till, what the hotel adds, and what may go up to the room.",
        room_service_no_pos: 'The hotel has no point of sale wired, so there is nothing to choose yet. Restaurants appear here once one is connected.',
        room_service_unit: 'Till (restaurant)',
        room_service_unit_hint: 'The till the menu is read from and the order is sent to.',
        room_service_unit_none: 'No till connected',
        room_service_table: 'Table on the till',
        room_service_table_hint: 'The table an order from a room appears under on the till, e.g. SOBE1. Kitchen and bar tickets are printed either way.',
        room_service_table_none: 'Do not show on the till',
        room_service_markup: 'Markup',
        room_service_markup_hint: "The percent the hotel adds to the till's menu prices for serving in the room.",
        room_service_categories: 'Menu categories',
        room_service_categories_hint: 'What of the menu may go up to the room. Empty offers the whole menu.',
        overview_search: 'Search facility, resource or guest',
        overview_groups: 'Groups',
        overview_new: 'New booking',
        overview_bookings: '{count} booking | {count} bookings',
        overview_no_resources: '{count} without resources',
        overview_unsettled: '{count} unsettled',
        overview_open: 'Open {from}–{to}',
        overview_none: 'No resources',
        overview_none_hint: 'no diary published',
        overview_setup: 'Set up',
        overview_taken: '{taken} of {total} taken',
        overview_meta_none: 'no resources',
        overview_meta_closed: 'no diary',
        overview_meta_open: 'open',
        overview_no_cell: 'Nothing free is left today — pick another day, or an hour on the diary.',
        overview_closed_then: 'The facility is closed at that hour.',
        overview_group_other: 'Other',
        legend_free: 'free',
        legend_busy: 'busy',
        legend_none: 'no resources',
        legend_closed: 'no diary',
        now_at: 'now {time}',
        desk_all: 'All facilities',
        desk_groups: 'Groups',
        desk_facilities_count: '{count} facilities',
        desk_setup: 'Set up facilities',
        desk_meta: '{count} resources · {from}–{to} · {grid} cells',
        desk_free_slots: '{count} free slots',
        desk_today: 'Today',
        desk_in_progress: 'In progress',
        desk_upcoming: 'Upcoming',
        desk_unsettled: 'Unsettled',
        desk_empty: 'Nothing booked for this day.',
        desk_quick: 'Quick booking',
    },
    maintenance: {
        stat_cancelled:            'Cancelled',
        in_repair:                 'Under repair ({count})',
        assign_not_live:           'The fault is no longer being worked on and cannot be assigned. Reload the list.',
        description:        'What is broken and who is mending it.',
        report:             'Report a fault',
        edit:               'Edit the fault',
        fault:              'Fault',
        area:               'Where in the room',
        area_hint:          'Bathroom, balcony, television — optional.',
        room_hint:          'Leave empty when the fault is not in a room: a lift, a corridor, reception.',
        title_hint:        'One line the fault is known by: “the shower mixer drips”.',
        severity:           'Severity',
        severity_hint:      'A blocking fault takes the room out of sale until it is mended.',
        severity_blocking:  'Blocks the room',
        severity_normal:    'Normal',
        severity_cosmetic:  'Cosmetic',
        status:             'Status',
        status_open:        'Reported',
        status_assigned:    'Assigned',
        status_in_progress: 'Being mended',
        status_resolved:    'Mended',
        status_closed:      'Closed',
        status_cancelled:   'Cancelled',
        status_duplicate:   'Duplicate',
        reported_at:        'Reported',
        resolved_at:        'Mended {at}',
        expected_resolved_by:      'Expected resolution',
        expected_resolved_by_hint: 'When the fault is expected to be resolved by - optional.',
        room_blocked: 'Room {room} cannot be closed: it is booked {dates}{who}.',
        room_blocked_open_reservation: 'Open the reservation',
        room_blocked_open_group: 'Open the groups list ({name})',
        save_without_block: 'Save without closing the room',
        expected_by:               'expected by {date}',
        overdue_by:                'overdue, expected by {date}',
        start:              'Start',
        resolve:            'Mended',
        close:              'Accept',
        resolution:         'What was done',
        resolution_hint:    'The next person reads this when the same tap drips in March — “washers replaced, second time this year” says more than “fixed”.',
        blocks_sale_short:  'Room not for sale',
        room_block_failed:  'Block FAILED',
        room_block_failed_hint: 'The room was already booked in that period, so the room could not be closed - it is still for sale. The system retries this automatically.',
        awaiting_move_short: 'Guest has to move first',
        no_room:            'Not tied to a room',
        count_open:         'Open',
        count_blocking:     'Blocking rooms',
        count_resolved:     'To accept',
        assigned_to: 'Assigned to',
        assign: 'Assign',
        assign_to: 'Assign to',
        assign_hint: 'Choose \'Nobody\' to put the fault back on the open list.',
        nobody: 'Nobody',
        reported_by: 'Reported by {name}',
        statistics: 'Statistics',
        statistics_hint: 'What broke in the chosen period, what was mended, and where it keeps happening.',
        stat_reported: 'Reported',
        stat_resolved: 'Resolved',
        stat_open: 'Open',
        stat_blocking: 'Blocking rooms',
        stat_average_hours: 'Average hours to repair',
        by_severity: 'By severity',
        by_status: 'By status',
        by_area: 'By location',
        by_person: 'By person',
        by_room: 'Rooms that keep breaking',
        stat_hours: 'h',
        stat_empty: 'No faults were reported in this period.',
        period_from: 'From',
        period_to: 'To',

        // Room status — several rooms at a time out of use, or back on sale.
        rooms_tab:               'Room status',
        rooms_hint:              'Which rooms are for sale and which are not. Several rooms at a time can be taken out of use or put back on sale.',
        rooms_search:            'Search by number',
        rooms_pick_floor:        'A whole floor:',
        rooms_whole_floor:       'All of {floor}',
        rooms_selected:          'No room selected | 1 room selected | {count} rooms selected',
        rooms_clear_selection:   'Clear the selection',
        rooms_select_all:        'Select every room shown',
        rooms_select_room:       'Select room {number}',
        rooms_block:             'Take out of use',
        rooms_release:           'Put back on sale',
        rooms_block_for:         'For 1 selected room | For {count} selected rooms',
        rooms_block_booked_hint: 'A room holding a reservation or a group block in that period is refused, and named below by its number.',
        rooms_reason_hint:       'The reason applies to every selected room: “leak on the third floor”, “bathrooms being redone”.',
        rooms_until_revoked:     'Empty means until it is revoked.',
        rooms_release_confirm:   'Put 1 room back on sale? Its status becomes “To prepare” and the block is removed. | Put {count} rooms back on sale? Their status becomes “To prepare” and the blocks are removed.',
        rooms_result_blocked:    'No room was closed | 1 room closed | {count} rooms closed',
        rooms_result_released:   'No room was put back on sale | 1 room put back on sale | {count} rooms put back on sale',
        rooms_result_refused:    '1 room refused — it holds a reservation or a group block | {count} rooms refused — they hold a reservation or a group block',
    },
    till: {
        title: 'My drawer',
        opening_float: 'Opening float',
        opening_float_hint: 'Cash counted into the drawer at the start of the shift.',
        open: 'Open drawer',
        opened_message: 'The drawer is open.',
        open_failed: 'The drawer could not be opened — one may already be open.',
        running: 'Open since {opened} · float {float} · expected now {expected}.',
        counted: 'Counted cash',
        counted_hint: 'Cash physically counted at close.',
        close: 'Close drawer',
        closed_message: 'The drawer is closed. The record is locked.',
        close_failed: 'The close could not be recorded.',
        difference_reason: 'Reason for the difference',
        needs_reason: 'A difference demands its reason.',
        difference_line: 'Difference between counted and expected: {amount}.',
        sessions: 'Drawer closes',
        opened: 'Opened',
        closed: 'Closed',
        expected: 'Expected',
        difference: 'Difference',
        still_open: 'still open',
    },
    finance: {
        title: 'Finance',
        tab_overview: 'Overview',
        tab_receivables: 'Open bills',
        vat_exempt_row: 'Outside VAT',
        tab_sales: 'Sales',
        tab_vat: 'VAT',
        vat_hint: 'The window\'s VAT from issued documents.',
        vat_hint_detail: 'Rows are summed from the documents\' own recapitulations, so this table can only agree with the papers it summarises. Credit notes subtract by themselves.',
        sales_hint: 'The window\'s posted revenue, cut two ways.',
        sales_hint_detail: 'By line source and by revenue group — the same charges both times, so the totals must agree.',
        sales_by_source: 'By source',
        sales_by_group: 'By revenue group',
        sales_group_desk: 'Front desk',
        sales_empty: 'No revenue in the window.',
        export_invoices: 'Export invoices (CSV)',
        export_hint: 'Every document of the window: number, dates, buyer, net, VAT, gross, paid. Semicolons, decimal comma.',
        tab_forecast: 'Forecast',
        tab_comparison: 'Comparison',
        charged: 'Posted',
        charged_hint: 'Folio lines in the window — including not yet invoiced',
        settled: 'Settled',
        settled_hint: 'Payments in the window, refunds deducted',
        receivables_open: 'Open receivables',
        receivables_open_hint: 'Everything open to date, not just the window',
        forecast_30: 'Forecast 30 days',
        forecast_30_hint: 'Value of booked nights over the next 30 days',
        needs_review_title: 'Card money needing manual review: {count}',
        needs_review_hint: 'Payments received in a wrong currency (recorded, not booked) or refunds Stripe failed after booking (the folio was compensated, but the guest needs an explanation). Check the Stripe dashboard and reconcile.',
        needs_review_open: 'See the records',
        review_title: 'Card payments for manual review',
        review_lead: 'Records where the automatic booking deliberately stopped. Reconciling writes down a decision — it moves no money.',
        review_empty: 'Nothing to review.',
        review_kind_currency_mismatch: 'Wrong currency',
        review_kind_refund_failed: 'Refund failed after booking',
        review_why_currency_mismatch: 'The payment arrived in a currency the hotel does not keep. It is recorded and not booked — the system cannot know the rate the hotel will actually be given.',
        review_why_refund_failed: 'Stripe reported the refund as failed only after the books had recorded it. The compensation row put the books right; the guest still has not had their money.',
        review_reference: 'Reference',
        review_raw_status: 'Raw status',
        review_reservation: 'Reservation',
        review_guest: 'Guest',
        review_reconcile: 'Mark as reconciled',
        review_reconcile_confirm: 'Save and mark',
        review_reconcile_failed: 'The reconciliation could not be saved.',
        review_reconciled: 'The record is marked as reconciled.',
        review_reconciled_by: 'Reconciled by {name} · {at}',
        review_note: 'Note (required)',
        review_note_hint: 'What actually happened to the money. In six months this will be the only record of it.',
        review_note_placeholder: 'E.g. refunded by bank transfer on 3 May, reference 1234, guest informed by email.',
        invoiced: 'Invoiced',
        invoiced_hint: 'Issued invoices in the window, credit notes deducted',
        gap_uninvoiced: 'Posted and not yet invoiced: {amount}.',
        gap_unpaid: 'Invoiced and not yet paid: {amount}.',
        gap_prepaid: 'Payments exceed invoices by {amount} — deposits and payments before issue.',
        by_drawer: 'By drawer',
        drawer: 'Drawer',
        drawer_unknown: '(deleted account)',
        events: 'Events',
        receivables_hint: 'Departures with an open balance — who approved them and why.',
        receivables_hint_detail: 'The record is written at an open-balance departure. "Remaining" is computed live from the folios: a payment arriving later simply settles the receivable.',
        open_invoices: 'Unpaid invoices',
        open_invoices_empty: 'Every issued invoice is paid.',
        departures_register: 'Departures with an open balance',
        due: 'Due',
        paid_column: 'Paid',
        overdue_days: 'Days over',
        aging_count: '{count} invoices',
        show_settled: 'Show settled too',
        receivables_empty: 'No open receivables.',
        debtor: 'Debtor',
        owed_at_departure: 'At departure',
        remaining: 'Remaining',
        approved_by: 'Approved by',
        reason: 'Reason',
        departed: 'Departed',
        settled_label: 'settled',
        forecast_hint: 'Value of booked stays by month, a year ahead.',
        forecast_hint_detail: 'Stays are split night by night, so a stay across a month boundary belongs to both — the columns add back up to the reservations. Cancellations and no-shows do not count.',
        forecast_empty: 'No future reservations.',
        forecast_total: 'Total',
        month: 'Month',
        booked_revenue: 'Booked',
        years_back: 'Years',
        year_total: 'Total',
    },
    report: {
        registrations_empty_title: 'This property has no eTurizem filings yet',
        registrations_empty_hint: 'A filing is born at guest check-in via "Check in and report". Also check that the right property is selected above.',
        registrations_window_empty_title: 'No filings between {from} and {to}',
        registrations_window_empty_hint: 'The property does have {count} eTurizem filings — widen the period (e.g. “This month”) to see them.',
        settlement: 'Cash-up',
        settlement_hint: 'Money by payment method — what was actually settled.',
        settlement_hint_detail: 'Counts payments by business date: cash in the drawer, cards, bank transfers, vouchers, deposits and OTA virtual cards. What was sold is the Performance report; this is what it was paid with.',
        settlement_net: 'Total',
        settlement_empty: 'No payments in the chosen window.',
        settlement_method_hint: '{count} payments',
        settlement_method_hint_refunds: 'received {received} · refunded {refunded} · {count} events',
        reports:               'Reports',
        daily:                 'Daily',
        occupancy:             'Occupancy',
        performance:           'Performance',
        business_date:         'Business date',
        business_date_hint:    'The report is read for a business date, not a calendar date. After midnight and before the night audit that is still yesterday.',
        current_business_date: 'Today',
        rooms_guests:          'Rooms: {rooms} · Guests: {guests}',
        stay:                  'Stay',
        stay_amount:           'Stay amount',
        night_count:           '1 night | {count} nights',
        period_from:           'Period from',
        period_to:             'Period to',
        period_hint:           'Both dates are included in the period.',
        day_count:             '1 day | {count} days',
        period_invalid:        'The period is not valid — the end date must be on or after the start date.',
        period_too_long:       'The period is too long. The maximum is {max} days.',
        this_month:            'This month',
        last_month:            'Last month',
        last_7_days:           'Last 7 days',
        last_30_days:          'Last 30 days',
        rooms_sold:            'Rooms sold',
        room_nights:           'Room nights',
        rooms_available:       'Rooms available',
        rooms_available_hint:  'Room nights that were sellable.',
        days:                  'Days',
        business_days:         'Business days in the period',
        weekday:               'Weekday',
        weekend:               'Weekend',
        no_inventory:          'Nothing sellable',
        period_average:        'Period average',
        chart_summary:         'Occupancy by day for {period}. The period average is {occupancy}.',
        room_revenue:          'Room revenue',
        revenue_hint:          'Accommodation revenue only',
        revenue_hint_detail:   'Only the price of the stay is counted. Services, POS and tourist tax are part of neither this figure, nor ADR, nor RevPAR.',
        adr:                   'ADR',
        adr_hint:              'Average daily rate — room revenue divided by the room nights sold.',
        revpar:                'RevPAR',
        revpar_hint:           'Revenue per available room — room revenue divided by the room nights available.',
        occupancy_hint:        'Room nights sold against room nights available.',
        by_room_type:          'By room type',
        by_source:             'By source',
        revenue_share:         'Revenue share',
    },
    settings: {
        appearance_hint: 'The theme and the language apply to this browser and your account only — not to the hotel.',
        hub_hint:  'Everything a house sets up once. Only the groups you have rights to are shown.',
        hub_empty: 'You have rights to none of the hotel settings. The look and the language of this browser are under Appearance.',
        tills_hint: 'Where the hotel sells over a counter, and what each counter may sell. Set up once — a seller does not need any of it mid-sale.',
        tills_no_property: 'Choose a property above first.',
        categories: 'Article categories',
        categories_hint: 'A category is free text on the article, so over a year the same kind gets typed three ways and the till shows three chips for one shelf. This corrects it on every article at once.',
        categories_empty: 'No article carries a category yet.',
        categories_count: '{count} articles',
        categories_uncategorised: 'With no category: {count} articles. At the till they sit under “All”.',
        category_rename: 'Rename category',
        category_rename_hint: 'The new name is written onto every article carrying the old one. Nothing else about the article is touched.',
        category_current: 'Current name',
        category_new: 'New name',
        category_new_hint: 'At most 60 characters. Empty takes the category off the articles.',
        category_merge: 'This will merge two categories',
        category_merge_hint: 'The category “{name}” already exists — the articles of both names end up under it.',
        category_clear: 'This will take the category away',
        category_clear_hint: 'The articles stay, simply without a category — at the till they sit under “All”.',
        category_renamed: 'Renamed on {count} articles.',
    },
    user: {
        users:                 'Users',
        access_hint:           'Accounts that can sign in to reception. What each may do is decided by the roles they hold. An account is never deleted, only deactivated — its name is on the work it did.',
        add:                   'Add user',
        edit:                  'Edit user',
        name:                  'Full name',
        username:              'Username',
        username_hint:         'This is what the user signs in with.',
        password:              'Password',
        new_password:          'New password',
        personnel_card:        'Personnel card',
        new_personnel_card:    'New personnel card',
        password_confirmation: 'Repeat password',
        password_hint:         'At least {count} characters.',
        password_too_short:    'The password must be at least {count} characters long',
        password_mismatch:     'The passwords do not match',
        till_pin: 'Till PIN',
        till_pin_action: 'Till PIN',
        till_pin_new: 'New PIN',
        till_pin_confirmation: 'Repeat the PIN',
        till_pin_hint: '{min} to {max} digits. Typed at the counter, and it says who sold.',
        till_pin_invalid: 'A PIN is {min} to {max} digits.',
        till_pin_mismatch: 'The two PINs do not match.',
        till_pin_clear: 'Remove the PIN',
        till_pin_cleared: 'The PIN has been removed.',
        tills: 'Tills',
        tills_hint: 'Which counters this person may work. Empty means none.',
        tills_none: 'No till',
        tax_number: 'Personal tax number',
        tax_number_hint: 'Eight digits. This person’s own number goes on every fiscal receipt they issue, as ZDavPR requires. The hotel’s number is NOT a substitute: without this, or the foreign-operator mark below, this person cannot issue an invoice.',
        tax_number_invalid: 'Not a tax number: eight digits, the first not zero, the last a check digit.',
        tax_number_placeholder: '12345678',
        foreign_operator: 'Foreign operator (has no Slovenian tax number)',
        foreign_operator_hint: 'Tick this only if the person genuinely has no Slovenian tax number. The receipt then carries the ForeignOperator declaration instead of a number, which is what ZDavPR requires. Ticking it wrongly is a false declaration to the tax authority.',
        operator_missing: 'This person cannot issue invoices',
        operator_missing_hint: 'ZDavPR requires the tax number of the individual who issues the invoice, or the foreign-operator declaration. Without one of the two, issuing through the hotel’s own fiscalisation will be refused.',
        change_password:       'Change password',
        password_changed:      'Password changed',
        last_password_change:  'Last password change',
        never:                 'Never',
        language_default:      'Whatever the browser uses',
        facilities: 'Centres covered',
        facilities_hint: 'What the account sees in the services portal. Empty means every centre.',
        facilities_all: 'Every centre',
        search: 'Find by name, username or role',
        language_hint:         'The interface language this user gets on signing in. With no choice, the browser decides.',
        you:                   'You',
        activate:              'Activate',
        deactivate:            'Deactivate',
        confirm_activate:      'Activate the account “{name}” again? It will be able to sign in once more.',
        confirm_deactivate:    'Deactivate the account “{name}”? It can no longer sign in — the attempt is refused exactly as a wrong password is. Its past work stays attributed to it.',
        activated:             'The account is active',
        deactivated:           'The account is deactivated',
        cannot_deactivate:     'This account cannot be deactivated — the last active account and your own have to stay switched on',
        username_taken:        'That username is already taken',
        email_hint: 'Where a rota notice goes. Blank is fine — most of a hotel’s staff never gave the house an address.',
        phone_hint: 'International form, e.g. +38641123456. Used for SMS and WhatsApp.',
        channels_hint: 'Which channels this person is told on. Nothing chosen means every channel the house has and this person has an address for.',
        channels_all: 'Every channel the house has',
        telegram_unpair: 'Unpair',
        telegram_will_unpair: 'The pairing will be removed on save.',
        viber_will_unpair: 'The Viber pairing will be removed on save.',
    },
    // How the house tells its own people something (docs/OBVESCANJE.md). Mail was
    // already here and stays under /mail; this page merely draws it alongside, because
    // the question is one — how does this hotel reach anybody — and answering half of it
    // on another screen is how a hotel ends up with e-mail configured and no idea that
    // its text messages go nowhere.
    notifications: {
        nav: 'Notifications',
        no_property: 'Choose a property first.',

        state_title: 'What the house can carry',
        state_hint: 'Green is a channel a message really leaves on. Grey means a setting below is missing.',

        channel_email: 'E-mail',
        channel_sms: 'SMS',
        channel_messaging: 'Messaging apps',
        channel_push: 'Phone app',
        channel_email_hint: 'Needs your e-mail address.',
        channel_sms_hint: 'Needs your telephone number.',
        channel_messaging_hint: 'Needs a WhatsApp number or a paired Viber on the person’s profile.',
        channel_push_hint: 'Needs a paired Imprion Sobe phone or watch.',

        mail_title: 'E-mail',
        mail_hint: 'The house’s SMTP server. The same settings carry receipts, booking confirmations and rota notices — one mailbox per house, not two.',
        mail_host: 'Server',
        mail_port: 'Port',
        mail_security: 'Security',
        mail_security_none: 'None (local network only)',
        mail_username: 'Username',
        mail_password: 'Password',
        mail_from: 'Sender address',
        mail_from_name: 'Sender name',
        mail_test: 'Send a test message',

        sms_title: 'SMS',
        sms_hint: 'The gateway the house puts a text message through. The contract is the hotel’s, not the product’s.',
        sms_provider: 'Provider',
        sms_provider_hint: 'Generic HTTP covers every gateway on this market: it is one call with a URL template.',
        provider_off: 'Off',
        provider_generic: 'Generic HTTP',
        sms_generic_title: 'Two placeholders',
        sms_generic_hint: '{to} is the recipient and {text} the message. They are URL-encoded in the address and JSON-escaped in a JSON body — nothing to set.',
        sms_endpoint: 'Endpoint',
        sms_endpoint_hint: 'e.g. https://api.gateway.com/send?to={to}&text={text}',
        sms_method: 'Method',
        sms_body: 'Request body',
        sms_body_hint: 'Sent as JSON when it is valid JSON, and as a form otherwise.',
        sms_from: 'Sender',
        sms_from_hint: 'What the recipient sees. Many gateways have their own and ignore this.',
        sms_token: 'Token',
        twilio_sid: 'Account SID',
        twilio_token: 'Auth Token',
        twilio_shared: 'This pair sends the WhatsApp messages too',
        twilio_shared_hint: 'SMS is off, but this house sends WhatsApp through Twilio — so the messaging card needs the Account SID and Auth Token as well. One account, one pair of boxes.',
        twilio_from_hint: 'A number or name Twilio has approved. Required.',
        test_number: 'Test number',
        test_number_hint: 'Blank sends to your own number.',

        messaging_title: 'Messaging apps',
        messaging_hint: 'One notification channel, carried by WhatsApp and Viber: the message goes through the first application the house has set up and the person has an address for.',
        telegram_soon: 'Telegram: soon.',
        messaging_order: 'One channel, the first application that fits',
        messaging_order_hint: 'A message goes Telegram → WhatsApp → Viber: the first the house has set up and the person has an address for. The test therefore sends one message, not three.',
        telegram: 'Telegram',
        telegram_hint: 'The house’s bot. Each employee pairs with it themselves, using a code from their own profile — a chat id is a number nobody knows by heart.',
        telegram_name: 'Bot name',
        telegram_name_hint: 'e.g. @hotel_test_bot. Shown to the person pairing.',
        telegram_token: 'Bot token',
        whatsapp: 'WhatsApp',
        whatsapp_provider: 'Provider',
        whatsapp_provider_hint: 'One platform, two doors. Meta is the direct one and needs a verified business; Twilio is a reseller in front of the same WhatsApp, with a sandbox that works the same afternoon. Moving between them is this selector and nothing else.',
        whatsapp_provider_meta: 'Meta Cloud API',
        whatsapp_provider_twilio: 'Twilio',
        whatsapp_twilio_credentials: 'The credentials are the Twilio pair from the SMS card',
        whatsapp_twilio_credentials_hint: 'A hotel has one Twilio account: the Account SID and Auth Token from the SMS card above send the WhatsApp messages too. Two boxes for one account would be two boxes, one of them always out of date. If SMS is off, fill the pair in there anyway.',
        whatsapp_twilio_credentials_missing: 'No Twilio credentials yet. Fill the Account SID and Auth Token into the SMS card above.',
        whatsapp_twilio_from: 'Sender (WhatsApp number)',
        whatsapp_twilio_from_hint: 'The sandbox number (+14155238886) or a number the hotel has registered with Twilio. The „whatsapp:“ prefix is optional — it is added for you.',
        whatsapp_twilio_service: 'Messaging Service SID (optional)',
        whatsapp_twilio_service_hint: 'If the house sends through a Twilio Messaging Service (MG…). One typed here wins over the number above.',
        whatsapp_twilio_sandbox: 'Sandbox: every recipient has to join first',
        whatsapp_twilio_sandbox_hint: 'Twilio’s sandbox delivers nothing to somebody who has not written to it first. That is Twilio’s rule rather than a setting, and it falls away on a registered number.',
        whatsapp_twilio_sandbox_word: 'Sandbox word',
        whatsapp_twilio_sandbox_word_hint: 'From Twilio → Messaging → Try it out → WhatsApp sandbox, e.g. „tiger-market“. Blank means this house is not on the sandbox.',
        whatsapp_twilio_join: 'Tell staff exactly this',
        whatsapp_twilio_join_sentence: 'Send „join {word}“ to {number}, and only then will you receive the hotel’s notifications.',
        whatsapp_twilio_content: 'Approved template (Content API)',
        whatsapp_twilio_content_hint: 'Twilio addresses a template by id rather than by name. Build it in Twilio → Content Template Builder, wait for WhatsApp’s approval and paste the id here.',
        whatsapp_twilio_content_sid: 'Content SID',
        whatsapp_twilio_content_sid_hint: 'e.g. HXxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx. Blank means the template is never used — on the sandbox that is the ordinary state.',
        whatsapp_twilio_content_sid_shift: 'Content SID for a shift change',
        whatsapp_twilio_content_sid_shift_hint: 'The template with the Potrjujem / Ne morem buttons. Optional: blank means a shift change also goes out on the template above, with no buttons.',
        whatsapp_twilio_buttons: 'What this template needs',
        whatsapp_twilio_buttons_hint: 'A body with one variable, {{1}}, as above, and two quick-reply buttons: „Potrjujem“ with the value ack and „Ne morem“ with the value decline. The values are fixed when the template is created and cannot be changed afterwards.',
        whatsapp_twilio_content_docs: 'Twilio’s template guide →',
        whatsapp_twilio_content_variable: 'The template needs one variable, {{1}}: the whole of the house’s sentence goes into it, on one line and up to 1024 characters. The same body as Meta’s, so moving between providers needs no second approval.',
        whatsapp_twilio_always_needs_content: '„Always the template“ cannot be saved without a Content SID — nothing would go out at all.',
        whatsapp_twilio_status: 'Delivery reports',
        whatsapp_twilio_status_hint: 'The address travels on every message, so there is nothing to configure at Twilio. Paste it only if you also want it set at the messaging-service level.',
        whatsapp_twilio_status_callback: 'Delivery report URL',
        whatsapp_twilio_status_none: 'This deployment has no public address, so there will be no delivery reports. Notifications work regardless.',
        whatsapp_twilio_inbound: 'Replies from staff',
        whatsapp_twilio_inbound_hint: 'This address has to be pasted in by hand. Twilio does not know it on its own: a delivery report travels on the message, while an incoming message goes wherever the sender points — without this, the buttons never leave the telephone.',
        whatsapp_twilio_inbound_url: 'Incoming message URL',
        whatsapp_twilio_inbound_where: 'Paste it into Twilio → Messaging → Senders → WhatsApp senders → pick the number → „When a message comes in“ (method POST).',
        whatsapp_twilio_inbound_none: 'This deployment has no public address, so replies from staff cannot be received. Notifications work regardless.',

        // The guest welcome and the portal link (docs/OBVESCANJE.md §10.9).
        guest_welcome: 'Guests',
        guest_welcome_hint: 'The guest welcome with the link to their own portal goes out as an APPROVED Twilio content template of the Call to action kind, with a dynamic URL button. The variables, in order: {1} the payer\'s name, {2} the house, {3} the arrival date, {4} the link token (the part after /r/).',
        guest_welcome_button_url: 'The button address in the template',
        guest_welcome_button_url_hint: 'In the Twilio Content Template Builder, give the "Odpri portal gosta" button exactly this address. A template built over a different base opens an empty page.',
        guest_welcome_no_portal: 'This deployment has no guest portal address (GUEST_PORTAL_URL), so no link can be built. Do not send the welcome until it is set.',
        guest_welcome_sid_sl: 'Content SID - the Slovenian template',
        guest_welcome_sid_sl_hint: 'The pms_gost_pozdrav template. A guest who speaks Slovenian gets this one.',
        guest_welcome_sid_en: 'Content SID - the English template',
        guest_welcome_sid_en_hint: 'The pms_guest_welcome template. Every guest who does not speak Slovenian gets this one.',
        guest_welcome_auto: 'On confirmation, send by WhatsApp first',
        guest_welcome_auto_hint: 'The portal link always goes to the guest on its own when a reservation becomes confirmed — once per reservation. On: WhatsApp first. Otherwise (or when WhatsApp cannot send) by e-mail if the payer has an address, then by SMS. Where the guest cannot be reached, reception sends it with the button on the reservation.',
        guest_welcome_not_ready: 'The automatic send is on and this house cannot send the welcome yet: it needs Twilio as its WhatsApp provider, the credentials saved on the SMS card, and at least one Content SID above.',

        // The templates PMS builds for the house (docs/OBVESCANJE.md §10.10).
        templates: 'WhatsApp templates',
        templates_hint: 'PMS can create the four house templates on your Twilio account and submit them to WhatsApp for approval — with the bodies, the buttons and this installation’s own address. A template that already exists under the same name is kept, and a Content SID you typed in yourself is never overwritten.',
        templates_build: 'Create the templates in Twilio',
        templates_refresh: 'Refresh',
        templates_built: 'The templates were created and submitted for approval.',
        templates_no_credentials: 'The templates are built on the house’s Twilio account — put the Account SID and Auth Token on the SMS card above.',
        templates_approval_hint: 'Meta approves the templates, usually within 48 hours. The category is Utility (transactional messages). Nothing can be sent through a template until it is approved.',
        template_name: 'Template',
        template_kind: 'Type',
        template_sid: 'Content SID',
        template_status: 'State',
        template_missing: 'Not created',
        template_unsubmitted: 'Created, not submitted',
        template_received: 'Submitted',
        template_pending: 'In review',
        template_approved: 'Approved',
        template_rejected: 'Rejected',
        template_kind_text: 'Text',
        template_kind_quick_reply: 'Quick reply (buttons)',
        template_kind_call_to_action: 'Call to action (link)',
        whatsapp_window: 'Free text only within 24 hours',
        whatsapp_window_hint: 'WhatsApp delivers free-form text only to somebody who wrote to the business in the last 24 hours. Outside that window it delivers an approved template and nothing else — set one up below.',
        whatsapp_number_id: 'Phone number id',
        whatsapp_number_id_hint: 'Meta’s id for the sending number, not the number itself.',
        whatsapp_token: 'Access token (Cloud API)',
        whatsapp_template: 'Approved template',
        whatsapp_template_hint: 'What reaches staff who have not written to the hotel in the last 24 hours. The template is approved by Meta rather than by this screen; what is typed here is only what it is called.',
        whatsapp_template_approval: 'Have it approved in Meta Business Manager',
        whatsapp_template_approval_hint: 'Category Utility (not Marketing — that one needs advertising consent), the same language as below, and a body with one variable. A template whose whole body is just „{{1}}“ is usually rejected.',
        whatsapp_template_body: 'Recommended template body',
        whatsapp_template_body_hint: 'Paste this into Meta Business Manager. The {{1}} variable carries the whole of the house’s message, on one line and up to 1024 characters.',
        whatsapp_template_body_example: 'Sporočilo hotela: {{1}}',
        whatsapp_template_docs: 'Meta’s template guidelines →',
        whatsapp_template_name: 'Template name',
        whatsapp_template_name_hint: 'Exactly as it is written in Meta Business Manager, e.g. rota_obvestilo.',
        whatsapp_template_language: 'Template language',
        whatsapp_template_language_hint: 'The language code the template was approved in — sl, en_US. Blank means sl.',
        whatsapp_template_mode: 'When to use the template',
        whatsapp_template_mode_hint: 'An empty template name above means the template is never used, whatever this says.',
        whatsapp_mode_auto: 'Automatic — free text first, the template on Meta’s refusal',
        whatsapp_mode_always: 'Always the template',
        whatsapp_mode_never: 'Never — free text only',
        whatsapp_webhook: 'Status webhook (optional)',
        whatsapp_webhook_hint: 'Where Meta says whether a message arrived, was read, or was refused. Notifications work without it — what is missing is the record of delivery.',
        whatsapp_webhook_url: 'Callback URL',
        whatsapp_webhook_url_hint: 'Paste it into Meta → WhatsApp → Configuration → Webhook and subscribe to the „messages“ field.',
        whatsapp_verify_token: 'Verify token',
        whatsapp_verify_token_hint: 'Any string, typed here and into Meta’s form. Not a secret — it is the proof that both ends were set up by the same person.',
        whatsapp_app_secret: 'App secret',
        viber: 'Viber',
        viber_hint: 'The house\'s bot. Each member of staff pairs with it themselves, using a code from their own profile — Viber hands the conversation id out through the webhook and nobody knows it by heart.',
        viber_sender: 'Sender name',
        viber_sender_hint: 'Viber requires one on every message; 28 characters at most.',
        viber_uri: 'Bot address (URI)',
        viber_uri_hint: 'The account\'s public URI from the Viber admin panel — e.g. hotel_test. The link your staff open is built from it.',
        viber_token: 'Bot token',
        viber_webhook: 'Webhook',
        viber_webhook_none: 'Webhook: not registered',
        viber_webhook_set: 'Webhook: registered',
        viber_webhook_failed: 'Webhook: failed',

        events_title: 'Events',
        events_hint: 'What the house sends at all. Nothing by default: a message on somebody’s telephone is a thing a hotel switches on deliberately.',
        event_rota_published: 'Rota published',
        event_rota_published_hint: 'One message per person per week, when the supervisor publishes.',
        event_rota_changed: 'Shift changed',
        event_rota_changed_hint: 'When a published shift moves — with the previous time and the new one.',
        event_rota_cancelled: 'Shift withdrawn',
        event_rota_cancelled_hint: 'When a published shift is taken away.',
        event_channels: 'Default channels',
        event_channels_hint: 'Nothing chosen means every channel the house has. A person’s own choice narrows it and never widens it.',
        event_channels_all: 'Every channel the house has',

        test: 'Test',
        test_sent: 'The test message has been sent.',
        test_sent_template: 'Sent through the approved template — the template works.',
        test_sent_text: 'Sent as free text. That proves you wrote to the hotel in the last 24 hours; everybody else needs the template.',
        // What became of a message this house handed to Twilio
        // (docs/OBVESCANJE.md §10.2). The states are Twilio’s own words rather than a
        // translation of a state we invented, so what is written here can be checked
        // against the console a hotelier is looking at.
        delivery_following: 'Following the delivery …',
        delivery_accepted: 'Accepted',
        delivery_queued: 'Queued',
        delivery_sent: 'Sent',
        delivery_delivered: 'Delivered',
        delivery_read: 'Read',
        delivery_failed: 'Not sent',
        delivery_undelivered: 'Not delivered',
        delivery_console: 'Details in the Twilio console: Monitor → Logs → Messaging',
        delivery_at: 'Time',
        delivery_to: 'To',
        delivery_purpose: 'Purpose',
        delivery_status: 'State',
        delivery_purpose_test: 'Test',
        delivery_purpose_notice: 'Notice',
        delivery_purpose_shift_change: 'Shift change',
        delivery_purpose_unknown: 'Unknown',
        // One line beside Twilio’s own words: what the hotel does about it. The English
        // sentence stays next to it, verbatim — it is the authority.
        delivery_error_21612: 'This destination will not take an alphanumeric sender (e.g. “ImprionPMS”). Use a Twilio number as the sender.',
        delivery_error_30003: 'The handset is switched off or out of range. Try again later.',
        delivery_error_30005: 'There is no such number — check the format (+386…) and the carrier.',
        delivery_error_30006: 'The number is a landline or does not take text messages.',
        delivery_error_30007: 'The carrier filtered the message (usually its content or an unregistered sender).',
        delivery_error_30008: 'The carrier did not say why. If it repeats, look in the Twilio console.',
        delivery_error_63016: 'Outside WhatsApp’s 24-hour window — free text does not go through and an approved template is needed.',
        deliveries_title: 'Recent messages',
        deliveries_hint: 'This house’s last ten messages through Twilio, SMS and WhatsApp together. Numbers are masked to their last three digits; records are kept for 30 days.',

        // Answers to a shift change by text message (docs/OBVESCANJE.md §11).
        sms_inbound: 'Staff answers (SMS)',
        sms_inbound_hint: 'You have to paste this address yourself. A delivery report travels on the message itself; an incoming message goes wherever the number points — without this, “DA” leaves the telephone and reaches nothing.',
        sms_inbound_url: 'Address for incoming messages',
        sms_inbound_where: 'Paste it into Twilio → Phone Numbers → pick the number → Messaging → “A message comes in” (method POST). The shift-change message then ends with “Odgovorite DA ali NE.”',
        sms_inbound_none: 'This installation has no public address, so answers by text message cannot be received. Sending goes on working.',
        sms_inbound_alphanumeric: 'The sender is not a telephone number, so nobody can reply to it. Enter a Twilio number instead of an alphanumeric name if you want answers.',
        secret_set: 'Stored',
        secret_hint: 'It never comes back. An empty field means “leave what is stored alone”.',
        secret_stored: 'Stored. An empty field keeps it; use the button to remove it.',
        clear_secret: 'Remove',
        secret_cleared: 'Removed.',
        saved: 'The settings have been saved.',
    },
    // One’s own profile: where the house reaches me, and on which channels. No
    // permission — docs/OSEBJE.md §13: self-service is the other side of being in
    // the record, not a right somebody grants.
    profile: {
        nav: 'My profile',
        contact_title: 'My notification details',
        contact_hint: 'Where the house should send a rota notice. These are yours and you edit them yourself.',
        email: 'E-mail',
        email_hint: 'Where a published rota and a changed shift are announced.',
        phone: 'Telephone',
        phone_hint: 'International form: +38641123456.',
        phone_invalid: 'The telephone must read +386\u2026 (8 to 15 digits).',
        channels: 'Channels',
        channels_hint: 'Nothing chosen means every channel the house has. A grey one is a channel the house has not set up.',
        channel_unavailable: 'The house has not set this channel up.',

        messaging_title: 'Messaging apps',
        messaging_hint: 'WhatsApp needs a number — fill it in only when it is not the same as the telephone above. Viber pairs with a code.',
        telegram_state_paired: 'Paired',
        telegram_state_unpaired: 'Not paired',
        telegram_no_bot: 'The house has no bot',
        telegram_no_bot_hint: 'Once it sets one up you will be able to pair here.',
        telegram_paired_hint: 'You are receiving notices through the bot {bot}.',
        telegram_unpair: 'Unpair',
        telegram_unpaired: 'The pairing has been removed.',
        telegram_get_code: 'Get a code',
        telegram_new_code: 'New code',
        telegram_step_code: 'Get a code below.',
        telegram_step_open: 'Open the bot {bot} in Telegram.',
        telegram_step_send: 'Send it the line below. The pairing is done within a minute.',
        telegram_code_expires: 'The code is valid until {at}.',

        whatsapp_number: 'WhatsApp number',
        whatsapp_number_hint: 'Only if it differs from the telephone above. Blank means the same number.',
        viber_no_bot: 'The house has not set Viber up (yet). You will be able to pair here once it has.',
        viber_paired_hint: 'You are receiving notices through the house\'s Viber bot.',
        viber_state_stale: 'Not working',
        viber_stale: 'The Viber pairing has stopped working',
        viber_stale_hint: 'Viber no longer delivers to this account — most likely the bot was removed. Get a new code and pair again.',
        viber_get_code: 'Get a code',
        viber_unpair: 'Unpair',
        viber_unpaired: 'The Viber pairing has been removed.',
        viber_open: 'Open the bot in Viber',
        viber_step_code: 'Get a code below.',
        viber_step_open: 'Open the house\'s bot in Viber — with the button below, or by finding it.',
        viber_step_send: 'If the conversation does not pair by itself, send it the code below. It is done at once.',
        pairing_new_code: 'New code',
        pairing_code_expires: 'The code is valid until {at}.',

        account_title: 'Account',
        account_hint: 'Who you are in the system.',
        account_managed_elsewhere: 'The name, the username and the permissions are managed by an administrator under Settings (the gear) → Users, roles and security → Users.',
        saved: 'Saved.',
    },
    // The bell in the top bar. Not the sidebar's "Reminders", which are dated notes
    // somebody writes for themselves: this is what the house is waiting on this account
    // to do, and the answers the house has given back.
    notification: {
        vacation_decision_issued: 'A leave decision has been issued \u2014 acknowledge it',
        title: 'Notifications',
        empty: 'Nothing is waiting.',
        waiting: 'Notifications: {count} waiting',
        action_failed: 'That could not be done. Try again.',

        bill_change_pending: 'A discount request is waiting for your decision',
        bill_change_approved: 'Your discount request has been approved',
        bill_change_rejected: 'Your discount request has been refused',
        decided_by: 'Decided by {name}, {when}',

        rota_change_mine: 'Your published shift has changed',
        rota_change_undelivered: 'A shift change has not been acknowledged',
        rota_change_declined:    'A shift change was declined',

        absence_request_pending: 'A request for leave is waiting for your decision',
        absence_approved: 'Your absence has been approved',
        absence_rejected: 'Your absence has been rejected',
    },
    bill_change: {
        // The wording follows the desk: "discount" and "removal" are the two words a
        // receptionist says out loud, and they name the two records. "Bill changes" is
        // the collective name and stands only where both kinds are shown together.
        panel: 'Bill changes',
        report: 'Discounts and removals',

        kind: 'Kind',
        kind_discount: 'Discount',
        kind_removal: 'Removal',

        discount: 'Discount',
        remove: 'Remove',
        discount_tooltip: 'Discount on this line (with a reason)',
        remove_tooltip: 'Take the line off the bill (with a reason)',
        give: 'Give discount',
        ask: 'Send for approval',

        mode: 'How',
        mode_percent: 'Percentage',
        mode_amount: 'Amount',
        percent: 'Discount (%)',
        amount: 'Discount (amount)',

        original: 'Line',
        comes_off: 'Off',
        resulting: 'To pay',
        total_column: 'Total',

        reason: 'Reason',
        reason_hint: 'Required. It is the first thing a manager reads a month later — "guest unhappy with the room" says something, "discount" does not.',

        discount_line: 'Line #{line}, {amount}',
        remove_line: 'Line #{line}, {amount}',
        remove_hint: 'The line stays on the card with its cancellation under it. The bill has to show that the car park was there and was taken off — a bill that never mentions it cannot be checked.',
        room_line_hint: 'The nights were slept and cannot be removed. A room that should not be charged is answered by shortening or cancelling the stay.',

        your_limit: 'Your limit: {limit}',
        no_limit: 'You cannot give a discount yourself — every one goes to a manager.',
        needs_approval: 'Over your limit',
        needs_approval_hint: 'This discount is {share} and your limit is {limit}. The request is stored and granted by somebody whose own limit covers it. Nothing comes off the bill until they do.',

        given: 'The discount is off the bill.',
        asked: 'The request has been sent for approval.',
        removed: 'The line has been removed.',
        discount_failed: 'The discount could not be given.',
        remove_failed: 'The line could not be removed.',

        pending_title: 'Waiting for approval',
        asked_by: 'Asked by {name}, {when}',
        asked_by_short: 'asked by {name}',
        approve: 'Approve',
        reject: 'Refuse',
        approved: 'The discount has been approved and taken off.',
        rejected: 'The request has been refused.',
        decision_failed: 'The decision could not be recorded.',
        decision_note: 'Why not?',
        reject_hint: 'The reason is required: a refusal with no reason is one the person who asked cannot act on.',
        over_your_limit: 'This request is over your limit — somebody with a higher one can decide it.',

        approved_by: 'Approved by',
        person_unknown: 'Unknown',
        empty: 'Nothing has come off this bill.',

        status_pending: 'Waiting for approval',
        status_applied: 'Applied',
        status_rejected: 'Refused',

        discounts_line: 'discount on line {line}',
        discounted_by_line: 'discounted: {line}',

        by_person: 'By person',
        by_reason: 'By reason',
        report_total: 'Total taken off',
        report_count: '{count} changes',
        report_changes: 'Changes',
        report_rows: 'The changes themselves',
        report_empty: 'Nothing came off a bill in this period.',
        report_empty_hint: 'Applied changes only: a request still waiting for approval has taken nothing off anybody\'s bill.',
        open_folio: 'Open the card',

        alert_title: 'Waiting for approval: {count} discount requests',
        alert_hint: 'Nothing comes off the bill until somebody whose limit covers it agrees.',
        alert_can_decide: 'Your limit covers the request — you can approve or refuse it here.',
    },
    role: {
        max_discount: 'Discount limit (%)',
        max_discount_hint: 'How far the holder of this role may discount a line of an open bill. 0 means every discount goes for approval.',
        max_discount_inactive: 'This role does not hold "Discount a line", so the limit does not apply yet. Tick it below (folio:discount).',
        max_discount_note: 'A discount over the limit is not refused — it is stored as a request and granted by somebody with a higher one. Holding several roles gives the most generous of them.',
        assignments_title: 'Roles and permissions',
        assignments_hint_short: 'What this account may do. Without a role it can sign in and do nothing.',
            assignments_failed_new_user: 'The roles could not be saved. The account exists — give it a role from the user list.',
        roles:                 'Roles',
        hint:                  'A role is a named bundle of permissions. The code never asks whether somebody is a receptionist — it asks whether they may issue an invoice. The default roles are not special cases: rename, change or delete them like any other.',
        add:                   'Add role',
        edit:                  'Edit role',
        name:                  'Role name',
        name_hint:             'What the hotel will call it — “Receptionist”, “Night receptionist”.',
        description:           'Description',
        description_hint:      'Who this role is for, and what it deliberately leaves out.',
        permissions:           'Permissions',
        permissions_count:     'Permissions',
        permissions_required:  'A role with no permission at all allows nothing — pick at least one',
        holders:               'Accounts',
        holders_title:         'Who holds {role}',
        holders_description:   'The accounts with this role, and the property they hold it in.',
        open_user: 'Open the account',
        holders_empty:         'Nobody holds this role.',
        holders_none:          'Nobody',
        no_permissions:        'No permissions',
        confirm_delete:        'Delete the role “{name}”? The accounts holding it lose the permissions it carried.',
        in_use:                'This role cannot be deleted — {count} account(s) still hold it. Give them another role first.',
        in_use_unknown:        'This role cannot be deleted while somebody still holds it. Give them another role first.',
        locked:                'This change cannot be saved — it would leave account management with no owner, or take it away from you',
        selected:              '{selected} of {total} selected',
        select_all:            'Everything in this group',
        legend:                'Read and write are separate everywhere. Dangerous actions carry their own permission even when they are “just” a write.',
        roles_held:            'Access',
        no_roles:              'No access',
        no_roles_assign:       'No roles — assign',
        unknown_role:          'Unknown role',
        unknown_property:      'Unknown property',
        assignments:           'Access for {name}',
        manage_assignments:    'Roles and access',
        assignments_hint:      'Each row is one role in one property. A maid works in one hotel, not in all of them — which is why the property is not taken for granted.',
        assignments_empty:     'This account holds no role. It can still sign in, but it will not see anything.',
        role_column:           'Role',
        property_column:       'Property',
        all_properties:        'All properties',
        select_role:           'Pick a role',
        select_property:       'Pick a property',
        add_assignment:        'Add a role',
        remove_assignment:     'Remove the row',
        duplicate_assignment:  'That role is already listed for that property',
        assignments_saved:     'Access saved',
        assignments_failed:    'The access could not be saved',
        assignments_locked:    'This cannot be saved — somebody has to keep account management, and you cannot take it from yourself',
        effective:             'What this allows',
        effective_hint:        'The sum of the permissions of every role picked — this is what the server actually checks.',
        effective_none:        'Nothing. With this set the account can sign in but cannot open a single screen.',
        no_properties:         'This tenant has no property yet. Roles can only be granted across all properties.',
        read_only:             'Changing roles and access needs the “Manage accounts, roles and access” permission. Here you can only read them.',
        editor_title:       'Roles and permissions',
        editor_hint:        'A role is a named bundle of permissions. What a role allows is edited here; who holds it is edited among the accounts.',
        pick_role:          'Pick a role',
        pick_hint:          'Pick a role from the list and its permissions open here.',
        search_permissions: 'Search a permission by name, description or code',
        search_none:        'No permission matches the search.',
        only_granted:       'Only the granted ones',
        sensitive_held:     'Sensitive: {count}',
        save_permissions:   'Save the permissions',
        unsaved:            'Unsaved changes',
        discard:            'Discard the changes',
        expand_all:         'Open every group',
        collapse_all:       'Close every group',
        managed_on_users:   'Roles are added and deleted on the Accounts screen — here only their permissions are edited.',
        open_permissions:   'Edit this role’s permissions',
        granted_by:         'Brought by:',
        granted_by_none:    'None of the roles picked brings this permission.',
        role_missing:       'That role does not exist any more — it may have been deleted.',
        count_permissions:  'Permissions: {count}',
        confirm_switch:     'The permission changes on this role are not saved. Discard them?',
    },
    permission: {
        sensitive:                              'Sensitive',
        sensitive_hint:                         'Reversal, credit note, cancellation, night audit and account management — these are what a hotel usually keeps to a smaller circle.',
        untranslated:                           'A new permission this screen cannot name yet.',
        code:                                   'Permission code',
        no_description:                         'No description yet.',
        module_off:                             'Module not enabled',
        module_off_hint:                        'The “{module}” module is not enabled for this hotel. A role may still hold the permission — until the module is switched on the server merely masks it, and never touches the role.',
        module_distribution:                    'Distribution',
        module_guest:                           'Guest',
        module_operations:                      'Operations',
        module_pos_link:                        'Dining (POS)',
        module_staff:                           'Staff and time',
        module_reports:                         'Reports',
        module_groups_events:                   'Groups, events and services',
        module_marketing:                       'Marketing and website',
        module_materials:                       'Materials and procurement',
        module_revenue:                         'Revenue',
        module_chains:                          'Chain',
        domain_property:                        'Properties and rooms',
        domain_guest:                           'Guests',
        domain_crm:                             'CRM — relationships',
        domain_sales:                           'Sales',
        domain_reservation:                     'Reservations',
        domain_rate:                            'Rates',
        domain_folio:                           'Guest folios',
        domain_invoice:                         'Invoices',
        domain_housekeeping:                    'Housekeeping',
        domain_retail:                          'The shop counter',
        domain_materials:                       'Materials: invoices',
        domain_stock:                           'The store room',
        domain_facility:                        'What the hotel offers',
        domain_dining:                          'Meals and door checks',
        domain_telemetry:                       'Room telemetry',
        domain_maintenance:                     'Maintenance',
        domain_compliance:                      'Guest registration',
        domain_channel:                         'Channels',
        domain_report:                          'Reports',
        domain_finance:                         'Finance',
        domain_night_audit:                     'Night audit',
        domain_chat:                            'Milo',
        domain_marketing:                       'Marketing',
        domain_staff:                           'Staff and time',
        domain_user:                            'Accounts and access',
        domain_certificate:                     'Digital certificates',
        property_read:                          'See properties, room types and rooms',
        property_read_desc:                     'The register of properties, room types, rooms and amenities, with nothing editable.',
        property_write:                         'Set up properties, room types and rooms',
        property_write_desc:                    'Creating and editing properties, room types, rooms and their amenities.',
        guest_read:                             'See the guest records',
        guest_read_desc:                        'The guest records and the companies that pay for them.',
        guest_write:                            'Enter and edit guests',
        guest_write_desc:                       'Entering and correcting a guest — the widest circle in the hotel, because everybody who takes a walk-in at the counter does it.',
        guest_merge:                            'Merge two profiles for one person',
        guest_merge_desc:                       'A merge cannot be undone: stays, folios, registrations and tourist-tax records move off one person and onto another.',
        guest_message:                          'Write to a guest from the hotel',
        guest_message_desc:                     'A message signed with the hotel’s name leaves the building and cannot be taken back — every one of them is the hotel speaking.',
        reservation_read:                       'See reservations and the room plan',
        reservation_read_desc:                  'Reservations, the chessboard, availability, offers and groups.',
        reservation_write:                      'Take reservations, check guests in and out',
        reservation_write_desc:                 'Taking a reservation, checking in and out, and rooming a stay.',
        reservation_cancel:                     'Cancel a reservation',
        reservation_cancel_desc:                'Cancelling a reservation or a group, and marking a no-show.',
        reservation_checkout_unpaid:            'Check out with money still owed',
        reservation_checkout_unpaid_desc:       'The one departure decision that costs the hotel real money — a hotel may allow it, but not invisibly, so it is recorded.',
        reservation_override_restrictions:      'Book past the rate plan’s restrictions',
        reservation_override_restrictions_desc: 'A date closed to arrival, a minimum stay, a stop-sell: a restriction is a commercial decision about a weekend, and whoever undoes one says why.',
        rate_read:                              'See rate plans and prices',
        rate_read_desc:                         'Rate plans, daily prices, extras and cancellation policies.',
        rate_write:                             'Set rate plans, prices and restrictions',
        rate_write_desc:                        'Setting prices, extras, cancellation policies and sales restrictions.',
        folio_read:                             'See a guest folio',
        folio_read_desc:                        'The charges and payments on a guest folio, and the check-out statement.',
        folio_post:                             'Post charges and payments to a folio',
        folio_post_desc:                        'Posting a charge or a payment, and moving a charge to another folio.',
        folio_reverse:                          'Reverse a posted charge',
        folio_reverse_desc:                     'Reversing a charge and refunding a payment — money goes back off the card.',
        folio_discount:                         'Discount a charge on a card',
        folio_discount_desc:                    'Taking money off a charge, with a reason. How far it reaches is the role\'s own discount ceiling — above it the request goes for approval.',
        folio_remove_line:                      'Remove a line from a card',
        folio_remove_line_desc:                 'Taking a charge off the bill with a reason — the car park, the breakfast. Carried out as a reversal and counted in the manager\'s review.',
        invoice_read:                           'See issued invoices',
        invoice_read_desc:                      'Issued invoices, their history, the document and its copies.',
        invoice_issue:                          'Issue an invoice',
        invoice_issue_desc:                     'Issuing an invoice, which is a tax document: it cannot be edited afterwards, only cancelled.',
        invoice_credit:                         'Issue a credit note',
        invoice_credit_desc:                    'Cancelling an issued invoice with a credit note.',
        housekeeping_read:                      'See the cleaning sheet',
        housekeeping_read_desc:                 'The cleaning sheet, the state of the rooms and the lost property.',
        housekeeping_work:                      'Mark a room cleaned',
        housekeeping_work_desc:                 'A maid says she has finished with a room.',
        housekeeping_inspect:                   'Sign off a room inspection',
        housekeeping_inspect_desc:              'A supervisor signs off that a cleaned room has been inspected.',
        retail_read:                            'See the tills and their takings',
        retail_read_desc:                       'Reading the counter is not the same authority as working it: the tills, the sales and the returns, without signing in to one.',
        retail_sell:                            'Ring up a sale',
        retail_sell_desc:                       'Signing in to a till, opening a shift and ringing up a sale at the counter.',
        retail_refund:                          'Hand money back',
        retail_refund_desc:                     'Taking goods back and handing money back — a supervisor’s act, not a seller’s.',
        retail_manage:                          'Set the tills up and read the shifts',
        retail_manage_desc:                     'Setting the tills up and reading every shift, not only one’s own.',
        retail_price_override:                  'Charge other than the shelf price',
        retail_price_override_desc:             'The shelf price is a commercial decision; a departure from it is recorded with a compulsory reason, because the difference is real money.',
        stock_read:                             'See the stock and the store rooms',
        stock_read_desc:                        'Articles, store rooms, suppliers, balances, shortages and what is about to expire.',
        stock_move:                             'Move stock',
        stock_move_desc:                        'Taking something off the shelf or moving it between store rooms — a housekeeper takes a bottle out of a minibar.',
        stock_post:                             'Post the paperwork behind the stock',
        stock_post_desc:                        'The paperwork behind the goods: the delivery note, the supplier invoice and their posting. A book-keeper’s job, not a storeman’s.',
        stock_inventory:                        'Post a stocktake',
        stock_inventory_desc:                   'The one posting that rewrites what the hotel believes it owns: every other document says what moved, this one says what is actually there.',
        stock_manage:                           'Set up the stock registers',
        stock_manage_desc:                      'The registers themselves — what the hotel keeps, rather than moving any of it.',
        materials_invoice:                      'Supplier invoices, matching and credit notes',
        materials_invoice_desc:                 'The accounting side of purchasing: the supplier invoice as a document of its own, the three-way match against the order and the delivery, posting onto the shelves, and the credit note. Not the same as stock:post — this right creates a payable, claims input VAT and ACCEPTS a supplier price, including one that differs within tolerance.',
        materials_procure:                      'Catalogue, contracts and purchase orders',
        materials_procure_desc:                 'The buying side: what each supplier charges, under which code, and until when the price holds, plus the agreements behind it. Not the same as stock:manage — this right decides what the house MAY PAY: activating a contract writes the prices every later order is raised against, and it allows a lapsed price onto an order.',
        materials_rules:                        'Requisition approval rules',
        materials_rules_desc:                   'Who has to agree to a requisition, from what amount, in how many rungs and by when. Not the same as materials:approve — this right does not answer the question, it sets it: somebody who could both approve and rewrite the ladder could approve anything by first lowering the rung under it.',
        facility_read:                          'See the facilities, their diary and their prices',
        facility_read_desc:                     'The wellness, the bike shed, the car park: what the hotel sells beside the room.',
        facility_book:                          'Book a facility for a guest',
        facility_book_desc:                     'One sale: the desk books a guest into a slot, and does not price it.',
        facility_work:                          'Give the service: start and finish their own appointments',
        facility_work_desc:                     'The therapist or the person handing out bikes sees the day, starts an appointment and finishes it — they take no bookings and set no price.',
        facility_manage:                        'Edit the facilities, their prices and their hours',
        facility_manage_desc:                   'The catalogue and the price list of what the hotel offers beside the room.',
        dining_read:                            'See the dining overview',
        dining_read_desc:                       'The morning at the dining room door, as reception reads it.',
        dining_work:                            'Work the dining room door',
        dining_work_desc:                       'Working the door: eligibility, dietary notes and recording a meal — and not setting the dining room up.',
        dining_override:                        'Let somebody in unpaid, or turn them away',
        dining_override_desc:                   'A free breakfast is money the hotel gives away, so both acts carry a compulsory reason.',
        dining_manage:                          'Set the dining room up',
        dining_manage_desc:                     'The restaurants, the meals, the hours, the price of an extra meal and the PIN over the dietary notes.',
        telemetry_read:                         'See what the rooms are doing',
        telemetry_read_desc:                    'A housekeeper has to see that a window is open and a do-not-disturb sign is on, without setting the temperature in a room where a guest is asleep.',
        telemetry_comfort:                      'Set a room’s heating',
        telemetry_comfort_desc:                 'The mode, the target temperature and “prepare for arrival”.',
        telemetry_automation:                   'Set the hotel’s room schedules and thresholds',
        telemetry_automation_desc:              'The schedules, the thresholds and the connection itself — including whether this hotel is shown simulated equipment at all.',
        maintenance_read:                       'See fault reports',
        maintenance_read_desc:                  'The fault reports and how far along they are.',
        maintenance_report:                     'Report a fault',
        maintenance_report_desc:                'Reporting a fault — the right of whoever notices one.',
        maintenance_work:                       'Work on a fault',
        maintenance_work_desc:                  'Taking a report on and working on it.',
        maintenance_close:                      'Close a fault report',
        maintenance_close_desc:                 'Confirming that the fault has been fixed.',
        compliance_read:                        'See guest registrations and tourist tax',
        compliance_read_desc:                   'What has been filed with the authority and how much tax has been charged.',
        compliance_write:                       'Register guests and charge the tourist tax',
        compliance_write_desc:                  'Filing the registration and charging the tax — the hotel’s legal obligation.',
        channel_read:                           'Read the channels',
        channel_read_desc:                      'The state of the connections with the portals, and what has arrived from them.',
        channel_manage:                         'Manage connections and mapping',
        channel_manage_desc:                    'Connecting a hotel to a portal and mapping its rooms and rates: done once, carefully.',
        channel_resolve:                        'Resolve bookings from the channels',
        channel_resolve_desc:                   'A booking that arrived from a channel and could not be placed; desk work under time pressure, because a guest is holding a confirmation.',
        report_read:                            'See reports and revenue',
        report_read_desc:                       'The occupancy and revenue reports of the hotel.',
        night_audit_run:                        'Run the night audit',
        night_audit_run_desc:                   'Closes the hotel’s business day and moves it on.',
        finance_read:                           'See finance and cash-ups',
        finance_read_desc:                      'The money reports of the hotel: the accountant reads these, and whoever reads occupancy does not.',
        finance_reconcile:                      'Mark card payments as reconciled',
        finance_reconcile_desc:                 'A write, not a read: it takes an item off the warning light for everybody, and the record of who decided that is the whole value of the act.',
        crm_read:                               'Relationship view (CRM)',
        crm_read_desc:                          'The relationship with a guest and a firm: the history, the segments and the funnel.',
        crm_write:                              'CRM editing (notes, tags, tasks, segments)',
        crm_write_desc:                         'The hotel’s own relationship file — all of it internal.',
        sales_manage:                           'Sales management (opportunities, contracts, contacts)',
        sales_manage_desc:                      'The pipeline and the corporate paper with the companies.',
        user_read:                              'See accounts and roles',
        user_read_desc:                         'The list of accounts, the roles, and who holds which.',
        user_manage:                            'Manage accounts, roles and access',
        user_manage_desc:                       'The key that hands out every other one: creating accounts, editing roles and granting access.',
        certificate_manage:                     'See and replace the digital certificates',
        certificate_manage_desc:                'A list of certificates names who signs for the company and when that ability lapses.',
        chat_use:                               'Open Milo at the desk',
        chat_use_desc:                          'Opens the door; what it may read through it is still gated by the caller’s own read permissions, tool by tool.',
        chat_write:                             'Have Milo prepare bulk changes',
        chat_write_desc:                        'The key to the proposal drawer, not to the data: every prepared change re-checks its own write permission at confirmation.',
        chat_admin:                             'See everybody’s threads with Milo',
        chat_admin_desc:                        'Oversight, not a side door: a thread contains only what its holder could read.',
        marketing_read:                         'See the marketing module',
        marketing_read_desc:                    'The offers, the campaigns and what is waiting.',
        marketing_write:                        'Edit offers and their content',
        marketing_write_desc:                   'Editing an offer and its content — a draft, never a publication.',
        marketing_ai:                           'Have the model draft text',
        marketing_ai_desc:                      'It spends money per use, and a draft carries the hotel’s voice.',
        marketing_approve:                      'Approve a draft',
        marketing_approve_desc:                 'The human half of “AI proposes, a person confirms” — the person who wrote a text is not automatically the person who signs it off.',
        marketing_publish:                      'Publish outside the hotel',
        marketing_publish_desc:                 'The moment something becomes visible outside the hotel; the only one of the five that editing cannot undo.',
        staff_read:                             'See who is on today',
        staff_read_desc:                        'The operational glance at the hotel, without the time record.',
        staff_schedule:                         'Draft and publish their own department’s schedule',
        staff_schedule_desc:                    'The scope is not a separate right: it comes from the scheduler’s own personnel card, so somebody who moves department takes their scope with them.',
        staff_time:                             'Read everybody’s time record',
        staff_time_desc:                        'Reading one’s own record is not this and is not granted at all: it is self-service, and the API narrows the answer to the signed-in person.',
        staff_clock:                            'Record clock-ins at a terminal',
        staff_clock_desc:                       'A right held by a DEVICE, never by a person: this terminal may record time for whoever it has just identified by PIN. Clocking oneself needs no permission at all.',
        staff_correct:                          'Carry out a correction to the record',
        staff_correct_desc:                     'Reading a record and changing one are not the same authority, and the second leaves a mark in a legal document.',
        staff_approve:                          'Decide on corrections, absences and overtime',
        staff_approve_desc:                     'Proposing a change and confirming it are two hands — which is the whole reason the record is worth anything in a dispute.',
        staff_manage:                           'Edit the personnel cards and the organisation',
        staff_manage_desc:                      'The most sensitive of the nine: a card is personal data reception has no reason to see, so it deliberately does not hide under “See accounts and roles”.',
        staff_report:                           'See their own department’s statistics',
        staff_report_desc:                      'The statistics of one’s own department, scoped the way the schedule is.',
        staff_oversee:                          'See every department’s schedule and statistics',
        staff_oversee_desc:                     'The director’s: oversight of the whole hotel, and nothing writable.',
    },
    // Staff and time (docs/OSEBJE.md). Module `staff`, sold as Imprion Workforce.
    // The working-time record (docs/OSEBJE.md §8, §9). Its own section rather than part
    // of `staff`: a rota is a promise the house makes, a record is what happened — and
    // this whole section moves to `staff-web` when that portal exists.
    staff_time: {
        scoped_to_person: 'Narrowed to one person: {name}',
        show_whole_house: 'Show the whole house',
        // My clock
        my_time:            'My clock',
        today_total:        'Today',
        of_which_break:     'of which break {minutes}',
        break_counts_hint:  'The break counts as working time and is never deducted.',
        first_in:           'arrived {at}',
        last_out:           'left {at}',
        day_open:           'The day is unfinished — no departure recorded.',
        stamped:            'Recorded: {kind}',
        my_record:          'My record',
        period_week:        'Week',
        period_month:       'Month',
        no_days:            'No days recorded in this period.',
        break_short:        'break {minutes}',
        open:               'Unfinished',
        excess_pending:     'Excess — awaiting classification',
        my_corrections:     'My correction requests',

        // Stamps
        kind_clock_in:      'Arrival',
        kind_clock_out:     'Departure',
        kind_break_start:   'Break',
        kind_break_end:     'End of break',
        stamp:              'Stamp',
        occurred_at:        'When it happened',
        received_at:        'Received by the server',
        source:             'Source',
        device:             'Device',
        zone:               'Time zone',
        corrected:          'Corrected',
        no_stamps:          'This day has no stamps.',
        source_personal_device: 'Personal device',
        source_kiosk:       'Kiosk',
        source_manual:      'Manual entry',

        // The record (manager)
        record:             'Time record',
        person:             'Person',
        no_record:          'No hours recorded in this period.',
        open_days:          'Unfinished days',
        open_days_hint:     'A day with no departure never closes by itself. Either the employee or a manager asks for a correction, and somebody else decides it.',
        previous_month:     'Previous month',
        this_month:         'This month',
        next_month:         'Next month',
        total_worked:       'Worked',
        total_break:        'Break',
        total_expected:     'Contracted',
        total_balance:      'Balance',
        excess:             'Excess',
        no_rounding_hint:   'No rounding: the cells print hours to one decimal, every total and every export carries minutes.',

        // Corrections
        corrections:        'Corrections',
        corrections_hint:   'A correction is a new record, never an edit of a stamp. The original stays visible.',
        no_corrections:     'No requests in this state.',
        correction_requested: 'Requested',
        correction_approved:  'Approved',
        correction_rejected:  'Rejected',
        all_states:         'All states',
        from_to:            'from {from} to {to}',
        missing_stamp_at:   'missing stamp at {at}',
        requested_by:       'Requested by {who}, {at}',
        decided_by:         'Decided by {who}, {at}',
        decision_reason:    'Reason: {reason}',
        not_your_own:       'You do not decide your own request. It goes to a holder of staff:approve in another department, or to the director.',
        approve:            'Approve',
        reject:             'Reject',
        reject_hint:        'A rejection stays visible to the person who asked and in the log.',
        reject_reason:      'Reason for rejecting',
        approved:           'The correction is approved.',
        rejected:           'The correction is rejected.',

        // Asking for a correction
        request_correction: 'Ask for a correction',
        correction_hint:    'You may ask; somebody else decides.',
        correction_what:    'What is being corrected',
        correction_mode_existing: 'A stamp that is there',
        correction_mode_missing:  'A missing stamp',
        correction_which_stamp:   'Which stamp',
        correction_no_stamps:     'This day has no stamp that could be corrected.',
        correction_kind:    'Kind of stamp',
        correction_date:    'Date',
        correction_time:    'Time',
        correction_reason:  'Reason',
        correction_send:    'Send the request',
        correction_sent:    'The request has been sent for a decision.',
        correction_decided_by_other: 'Somebody else decides — you cannot approve your own.',

        // Settings
        settings:           'Working-time record',
        settings_hint:      'What the house decides about the record. There is no rounding and there will not be one: content rounding of working time has no general legal safe harbour.',
        break_recording:    'Stamp breaks',
        break_recording_hint: 'Our own voluntary feature, not a legal requirement (ZEPDSV-B, 23 April 2025). An assumed break is a fiction the record asserts — which is why we offer it, and why it can be switched off.',
        excess_threshold:   'Excess threshold (minutes)',
        excess_threshold_hint: 'From how many minutes over the shift an excess becomes something to classify. 0 means never. The minutes count towards the balance either way — the threshold only decides whether anybody goes and looks.',

        // The kiosk PIN
        kiosk_pin:          'Kiosk PIN',
        kiosk_pin_action:   'Kiosk PIN',
        kiosk_pin_mine:     'My PIN',
        kiosk_pin_hint:     'Digits only, {min} to {max} of them. It is stored sealed and never shown back.',
        kiosk_pin_shared_warning: 'A shared terminal stays shareable: one person can stamp for another. That is why a stamp records the device it came from — a personal device is stronger evidence than a kiosk.',
        kiosk_pin_new:      'New PIN',
        kiosk_pin_confirmation: 'Repeat the PIN',
        kiosk_pin_invalid:  'The PIN must be {min} to {max} digits.',
        kiosk_pin_mismatch: 'The two PINs do not match.',
        kiosk_pin_clear:    'Take the PIN away',
        kiosk_pin_cleared:  'The PIN has been taken away.',

        // The kiosks themselves
        kiosks:             'Kiosks',
        kiosks_hint:        'The tablets in a corridor that staff stamp on with their own PIN. A pairing code is worth five minutes and one attempt.',
        kiosks_empty:       'This house has no kiosk yet.',
        kiosk_add:          'Add a kiosk',
        kiosk_rename:       'Rename the kiosk',
        kiosk_shared:       'Shared terminal',

        // The monthly record and its file
        not_payroll:        'Working-time record — not a payroll run.',
        not_payroll_hint:   'This screen carries quantities: when, how much, and which kind of absence. What a day is worth, who bears the allowance and which code it carries in the wage system are settled by accounting in its own program. The month is not frozen either — a correction changes it.',
        month_record:       'Monthly record',
        month_record_hint:  'By person, in the shape the export carries — the screen and the file are the same document read twice.',
        month_not_final:    'The month is computed on every read and is not closed: a correction changes a month that has already been read.',
        export_csv:         'Export CSV',
    },

    /*
     * Closing a month (docs/EVIDENCA-CASA.md § „Zaključevanje meseca“).
     *
     * A section of its own beside `staff_time`, because it answers a different question:
     * that one says WHAT the record holds and this one says whether anybody has signed it.
     */
    staff_month: {
        close:                'Close month',
        close_hint:           'You are closing {month}.',
        close_means:          'What closing means:',
        close_means_snapshot: 'The month is frozen: from now on the screen and the export answer a stored snapshot with a hash.',
        close_means_refused:  'Corrections, entering and approving absences, and stamps inside this month are refused until somebody reopens it.',
        close_means_rota:     'The rota stays editable: a shift is a plan and the record is the stamps.',
        close_means_reopen:   'Reopening needs the staff:manage permission and a written reason; the snapshot is never deleted.',
        close_writes_version: 'This close writes version {version}. The earlier ones are kept.',
        closed:               'The month is closed.',

        pending_title:       'Decide what is still waiting inside this month first',
        pending_corrections: 'Time corrections still waiting: {count}',
        pending_absences:    'Absence requests still waiting: {count}',

        reopen:                'Reopen',
        reopen_hint:           'You are reopening {month}.',
        reopen_keeps_snapshot: 'The snapshot is not deleted. The current version is marked reopened, and the next close writes one version more.',
        reopened:              'The month has been reopened.',
        reason:                'Reason',
        reason_hint:           'Why a closed month is being opened again. It goes into the audit trail and somebody will read it.',
        closed_version:        'Closed version',

        version_line:  'Version {version} · closed by {name}, {date}',
        reopened_line: 'Reopened by {name}, {date} · reason: {reason}',
        history:       'History ({count})',

        strip_open:        'The month is not closed',
        strip_open_hint:   'It is computed on every read; a correction changes it.',
        strip_closed:      'Closed {date} · version {version} · {name}',
        strip_closed_hint: 'The screen and the export answer the stored snapshot. Hash: {hash}',
        strip_reopened:    'Reopened {date} · {name} (version {version})',

        month_is_final: 'The month is closed: these are the stored figures from the snapshot, not a live computation.',
        badge_closed:   'Closed',
    },

    staff_absence: {
        // The kinds — OUR list, and provisional (docs/OSEBJE.md §10)
        kind_vacation:      'Leave',
        kind_sick_leave:    'Sick leave',
        kind_holiday:       'Public holiday',
        kind_training:      'Training',
        kind_business_trip: 'Business trip',
        kind_unexcused:     'Unexcused absence',
        kind_other:         'Other',
        provisional_kinds:  'The list of absence kinds is provisional.',
        provisional_kinds_hint: 'The names are ours rather than the law’s: the statute prescribes financial groups and not a catalogue of names. The final mapping to accounting codes is confirmed by accounting.',

        // Request states
        state_requested:    'Requested',
        state_approved:     'Approved',
        state_rejected:     'Rejected',
        state_withdrawn:    'Withdrawn',

        // Where a record came from
        source_request:     'Request',
        source_manager:     'Entered by a manager',
        source_calendar:    'Holiday calendar',

        // My clock → My absences
        my_absences:        'My absences',
        my_absences_hint:   'Your requests and what was decided about them. Refusals stay visible — a refusal that disappears is a refusal that did not happen.',
        no_my_requests:     'You have no requests for absence.',
        request_leave:      'Request leave',
        request_hint:       'You may ask for leave. Sick leave is reported and recorded, a public holiday comes off the calendar, and training and business trips are entered by a manager.',
        request_sent:       'The request has been sent for a decision.',
        send_request:       'Send request',
        decided_by_other:   'Somebody else decides your request — you cannot approve your own.',
        withdraw:           'Withdraw',
        withdrawn:          'The request has been withdrawn.',
        range_backwards:    'The end cannot be before the start.',
        range_too_long:     'A request may cover at most {days} days. A longer absence is entered by a manager.',

        // Manager
        requests:           'Requests for absence',
        requests_hint:      'Leave is asked for by the employee and decided by a manager. Nobody decides their own request.',
        no_requests:        'There are no requests in this state.',
        requested_at:       'Requested {at}',
        days_recorded:      'Days recorded: {count}',
        not_your_own:       'You do not decide your own request. It goes to a holder of staff:approve in another department, or to the director.',
        approved:           'The absence has been approved and recorded.',
        rejected:           'The absence has been rejected.',
        reject_hint:        'A refusal has to say why. It stays visible to the person who asked.',

        // Records
        recorded:           'Recorded absences',
        no_records:         'No absences were recorded in this month.',
        enter:              'Enter absence',
        enter_hint:         'Sick leave, training, a business trip, an unexcused absence — everything that is not asked for is entered by a manager.',
        person:             'Person',
        kind:               'Kind',
        from:               'From',
        to:                 'To',
        note:               'Note',
        absent:             'Absence',
        total_absence:      'Absence',
        employee_no:        'Number',
        working_days_only:  'A record is written only for days the person owed work. A rostered day off is not an absence.',
        never_deleted_hint: 'Recorded absences are never deleted or overwritten. A correction is a new record referring to the previous one, which stays visible.',
        supersede:          'Correct',
        supersede_hint:     'A correction is a new record. The previous one stays visible and marked — not struck through and not removed.',
        supersede_keeps_day: 'The day, the person and the minutes stay. The wrong DAYS are put right by entering the right ones and superseding the wrong ones.',
        current_record:     'The record now',
        new_kind:           'New kind',
        superseded:         'The record has been corrected by a new one.',

        // The holiday calendar
        calendars:          'Holiday calendar',
        calendars_hint:     'The days the house is shut. A personnel record refers to one, and the day view reads it as it goes — a correction here reaches every day.',
        no_calendars:       'This property has no holiday calendar yet.',
        add_calendar:       'Add calendar',
        edit_calendar:      'Edit calendar',
        calendar_name:      'Calendar name',
        holidays:           'Holidays',
        holiday_name:       'Holiday name',
        add_holiday:        'Add holiday',
        holiday_count:      'Holidays: {count}',
        seed_official:      'Add official holidays',
        seeded_country:     'The official {country} holidays have been added from {year} on. Whatever the house already had is untouched.',
        seed_is_a_starting_point: 'The official list is a starting point — the house owns the calendar',
        source:             'Source',
        source_url:         'Link to the source',
        confirm_delete_calendar: 'Delete the calendar “{name}”?',
        calendar_only_working_days: 'A holiday becomes an absence only where the person’s pattern or rota expected work. A holiday on a day off is not leave.',
    },

    /**
     * Coverage rules (docs/OSEBJE.md §11 „Pravila pokritosti“).
     *
     * This block is why the release exists. Reception had sixteen hours rostered and a
     * requirement of nought — housekeeping has a norm and the desk had nothing. There is
     * no norm for checking a guest in and we are not going to invent one: what a desk
     * costs is the house's own answer, and this is where it writes it down.
     */
    staff_coverage: {
        title:      'Coverage',
        title_hint: 'How much work each department has in a day. Housekeeping derives it from its norms and the departures; reception and desks like it do not — their day is the opening hours plus the guests arriving and leaving.',

        department:      'Department',
        rule:            'Rule',
        kind:            'How it is costed',
        no_rule:         'No rule',
        no_rule_line:    'This department’s requirement is nought and its shortfall is not a measurement.',
        add_rule:        'Set a rule',
        edit_rule:       'Edit rule',
        remove_rule:     'Remove rule',
        no_departments:  'This property has no departments yet. Add them under Staff → HR → Departments and posts tab.',

        kind_desk:       'Desk (opening hours + arrivals/departures)',
        kind_desk_hint:  'For reception, the concierge, a spa desk. The day costs what the desk is open for, plus the work the day’s arrivals and departures bring.',
        kind_none:       'From its module (housekeeping, for instance)',
        kind_none_hint:  'The module answers the requirement',
        kind_fixed:      'Fixed minutes per weekday',
        kind_fixed_hint: 'For a department that costs the same every week whatever the house is doing.',

        open_hours:     'Opening hours',
        open_from:      'Open from',
        open_to:        'Open to',
        span_from:      'From',
        span_to:        'To',
        add_span:       'Add a span',
        remove_span:    'Remove span',
        spans_hint:     'A split day is written as several spans (06:00–10:00, 11:30–14:30, 18:00–22:00, say) and they add up. Spans may not overlap.',
        clock_hint:     'A clock value as HH:MM. “00:00–24:00” is all day; “00:00–00:00” is shut. An end at or before the start wraps midnight (22:00–06:00 is eight hours).',
        min_staff_open: 'People on the desk',

        night:           'Night cover',
        night_from:      'Night from',
        night_to:        'Night to',
        min_staff_night: 'People at night',
        night_hint:      'The night is ADDED to the opening hours. If the desk is open around the clock and one person is enough overnight, leave “People at night” at 0 — a 1 means a night porter BESIDE the desk.',

        minutes_per_arrival:       'Minutes per arrival',
        minutes_per_departure:     'Minutes per departure',
        minutes_per_in_house_room: 'Minutes per occupied room',
        minutes_hint:              'Arrivals and departures are counted from that day’s own reservations, confirmed ones for future days included. It is the one number a clock on a wall can never produce.',
        in_house_hint:             'The standing load of a guest already in the house — the telephone, the bookings, the taxi. Nought by default: most houses do not count it as desk work.',

        fixed_week:      'Minutes per weekday',
        fixed_week_hint: 'Anything left blank is nought — the department needs nobody that day.',

        desk_summary:     'open {spans}, {people} on the desk',
        night_summary:    'night {from}–{to}, {people} on',
        movement_summary: 'arrival {arrival} min · departure {departure} min',
        in_house_summary: 'rooms in house {minutes} min',
        fixed_summary:    'fixed, {total} a week',

        term_desk:       'open {span} × {people}',
        term_desk_spans: 'open {spans} = {span} × {people}',
        term_fixed:      'fixed {minutes}',
        term_night:      'night {span} × {people}',
        term_arrivals:   '{count} arrivals × {minutes} min',
        term_departures: '{count} departures × {minutes} min',
        term_in_house:   '{count} rooms in house × {minutes} min',
        term_nothing:    'The rule asks for nobody on this day.',

        // The three sources of §11 closed on 2026-09-08: the dining room, the events and
        // the building's own upkeep.
        kind_dining:           'Dining room (sittings and covers)',
        kind_dining_hint:      'For a kitchen or a waiting brigade. The day costs what it costs to open each sitting, plus the work the covers of that day bring. The covers come from the dining module — out of the guests\u2019 board and the day\u2019s reservations — and are the very number the tablet at the dining room door judges by.',
        kind_events:           'Events (venues and participants)',
        kind_events_hint:      'For banqueting and conferences. An event is a venue booked — a meeting room, a conference or a banquet hall; a group is not one by itself, because its nights are already counted by housekeeping and by the desk.',
        kind_maintenance:      'Maintenance (rounds and work orders)',
        kind_maintenance_hint: 'For the maintenance department. The day is the rounds plus the open work orders that come due today or are already overdue — capped, because a backlog is not one day\u2019s work.',

        meal_breakfast: 'Breakfast',
        meal_lunch:     'Lunch',
        meal_dinner:    'Dinner',

        minutes_per_service: 'Minutes per sitting',
        minutes_per_cover:   'Minutes per cover',
        dining_hint:         'The minutes per sitting are what it costs to open the service at all — the brigade is there whether five people come down or ninety. A sitting this department does not staff is left at 0 and then costs nothing.',
        dining_covers_hint:  'Covers are counted from the board of the guests in the house and from the day\u2019s reservations, by the same rule as the tablet at the dining room door. Breakfast belongs to the morning AFTER a night, dinner to the night itself.',

        dining_summary:       '{meal} {service} min + {cover} min/head',
        dining_summary_empty: 'this department staffs no sitting',

        minutes_per_event:         'Minutes per event',
        minutes_per_participant:   'Minutes per participant',
        default_participants:      'Assumed participants',
        events_hint:               'The minutes per event are setup, service and teardown together — one figure, because the source counts events and not phases of them.',
        default_participants_hint: 'Used for an event that carries NO head count, and most do not: a hall booked for a seminar names a company and a window, and the number of people lives in an email. Only an event booked against a guest\u2019s own reservation can be counted. Zero is an honest answer — such an event then costs its own minutes and no more — and the breakdown always says how many events were estimated this way.',

        events_summary:               '{minutes} min per event',
        participant_summary:          '{minutes} min per participant',
        default_participants_summary: 'assumed {count} people',

        minutes_per_day:   'Minutes of rounds per day',
        max_issue_minutes: 'Daily ceiling on work orders (min)',
        minutes_blocking:  'Minutes per blocking fault',
        minutes_normal:    'Minutes per ordinary fault',
        minutes_cosmetic:  'Minutes per cosmetic fault',
        severity_blocking: 'blocking',
        severity_normal:   'ordinary',
        severity_cosmetic: 'cosmetic',
        maintenance_hint:  'A work order carries no estimate — whoever reports a burst pipe is a housekeeper with a telephone in a corridor — so the house prices it, by severity. The orders counted are the open ones due that day or already overdue; an order with no date is shown separately and counts for nothing, because an undated order is not due today.',
        cap_hint:          'The ceiling bounds the WORK ORDERS only; the rounds are outside it. 0 means the server\u2019s own default (4 h) and never \u201eno ceiling\u201c: without it a house with 300 open faults would read every single day that it needs 150 hours of maintenance — arithmetically correct and useful to nobody.',

        rounds_summary: 'rounds {minutes} min',
        cap_summary:    'ceiling {minutes}',

        term_meal:         '{meal} {services} × {service} min + {covers} covers × {cover} min',
        term_events:       '{count} events × {minutes} min',
        term_participants: '{count} participants × {minutes} min',
        term_assumed:      'of which {count} with no head count (assumed {participants})',
        term_no_events:    'No events on this day.',
        term_rounds:       'rounds {minutes}',
        term_issues:       '{count} {severity} × {minutes} min',
        term_capped:       'the orders would be {uncapped}, the day\u2019s ceiling is {cap}',
        term_undated:      '{count} orders with no date are not counted',

        example:      'Example',
        example_hint: 'With {arrivals} arrivals and {departures} departures: {sentence}',
        saved_hint:   'A rule takes effect at once — coverage is computed on every read and nothing is stored ahead of time.',
    },
    staff_vacation: {
        // Yearly leave entitlement (docs/OSEBJE-UI.md §5)
        title:            'Leave',
        title_hint:       'The yearly leave entitlement, person by person. A balance is a reading of the record; a decision is a personnel act and asks for the personnel key.',
        days_count:       '{count} days',

        my_vacation:      'My leave',
        my_balance:       'My leave',
        tab_vacation:     'Leave',
        balance:          'Leave balance',
        balance_line:     'Entitled {entitled} \u00b7 used {used} \u00b7 awaiting a decision {pending} \u00b7 remaining {remaining}',

        entitled:         'Entitled',
        carried_over:     'Carried over',
        used:             'Used',
        pending:          'Pending',
        remaining:        'Remaining',
        of_which_pending: 'Of which awaiting a decision: {days}',

        // Old (carried-over) and current-year leave \u2014 ZDR-1 article 162
        available:        'Available',
        old_leave:        'Carried-over leave ({year})',
        current_leave:    'Annual leave {year}',
        still_days:       '{days} left',
        still_of:         '{left} left of {total}',
        use_by:           'Use it by {date}.',
        expired_days:     '{days} lapsed \u2014 the deadline was {date}.',
        of_which_used:    'Of which used: {days}',
        not_issued_hint:  'No decision has been issued for this year yet.',
        bucket_old:       'Carried over',
        bucket_current:   'This year',
        usage_history:    'How it was used',
        no_usage:         'No leave has been recorded for this year.',
        requested_days:   'Working days requested: {days}',
        over_remaining:   'This is more than the {days} available. The decision is still the house\u2019s.',
        remaining_total:  'Remaining in total',
        people:           'People',
        with_decision:    'With a decision',
        acknowledged_count: 'Acknowledged',

        this_year:        'This year',
        previous_year:    'Previous year',
        next_year:        'Next year',

        no_balance:       'There is no leave figure for this year.',
        no_balance_hint:  'A balance appears once a decision has been issued and the person has a period of work in force.',
        no_balance_person: 'This person has no calculated balance for the year.',
        no_balances:      'Nobody has a leave balance for this year.',

        decision:         'Decision',
        decisions:        'Decisions',
        decisions_hint:   'Every decision carries the breakdown it was issued with. Changing a rule applies from now on and does not move a decision already made.',
        decision_for_year: 'Decision for {year}',
        decision_total:   'Entitled: {days}',
        decision_line:    'Year {year}: {days}',
        no_decisions:     'No decision has been issued for this person yet.',
        my_decisions:     'My decisions',
        my_decisions_hint: 'The yearly leave decisions the house has issued to you.',
        no_my_decisions:  'No decision has been issued to you yet.',

        issue:            'Issue',
        issue_for:        'Issue for {year}',
        issue_all:        'Issue decisions for {year}',
        issued:           'The decision has been issued.',
        issued_count:     'Decisions issued: {count}',
        issue_failed:     'Decisions refused: {count}',
        confirm_issue_all: 'Issue {year} decisions to everybody who has none? That is {count} people.',
        confirm_reissue:  '{name} already has a decision for {year}. Issue a new one?',
        overridden:       'Set by hand',
        version:          'Version {version}',
        prorated_months:  'Prorated: {months} full months of employment \u2192 {days}.',
        override_line:    'Set by hand: {days}. The house rules came to the full-year total above.',

        not_issued:       'Awaiting a decision',
        acknowledged:     'Acknowledged',
        not_acknowledged: 'Not acknowledged',
        acknowledge:      'I acknowledge',
        acknowledge_hint: 'You are acknowledging RECEIPT of the decision, not agreement with the number of days.',
        acknowledged_toast: 'Your acknowledgement has been recorded.',
        acknowledged_at:  'Acknowledged: {at}',
        issued_at:        'Issued by {who}, {at}',
        pdf:              'PDF',

        part_base:           'Base',
        part_tenure:         'Length of service',
        part_education:      'Education',
        part_responsibility: 'Position of responsibility',
        part_special:        'Special category',
        part_children:       'Children',
        part_full_year:      'Total (full year)',

        // Personnel card → Leave
        card_fields:      'What the entitlement rests on',
        card_fields_hint: 'The fields belong to the PERIOD of work. A degree finished is a new period, and last year\u2019s decision stays exactly as it was.',
        education_level:  'Education level',
        education_unset:  'Not set',
        prior_service_days: 'Prior service (days)',
        prior_service_days_hint: 'Service earned before this house. It counts into the tenure ladder.',
        prior_service_entered_on: 'As at',
        prior_service_entered_on_hint: 'The day the figure was counted from the papers. Without it the number is unreadable a year later.',
        prior_service_entered_on_required: 'Say which day the service was counted on.',
        responsible_position: 'Position of responsibility',
        special_category: 'Special category (disability, care, night work)',
        special_category_hint: 'What counts as a special category is settled by the collective agreement. This only records that it applies.',
        children:         'Children',
        add_child:        'Add a child',
        no_children:      'No children recorded.',
        child_birth_date: 'Date of birth',
        children_hint:    'The date of birth and nothing else. A child\u2019s name is not the house\u2019s to keep, and the age works itself out every year.',

        // Settings → Leave rules
        rules:            'Leave rules',
        rules_hint:       'What the yearly entitlement is made of. A change applies from now on and does not move a decision already issued.',
        base_days:        'Base (days)',
        base_days_hint:   'The statutory floor is four weeks \u2014 twenty days on a five-day week.',
        responsibility_days: 'Extra days for a position of responsibility',
        responsibility_days_hint: 'Who holds one is said on the personnel card.',
        special_days:     'Extra days for a special category',
        special_days_hint: 'Disability, care, night work \u2014 per the collective agreement.',
        child_days:       'Days per child',
        child_age_limit:  'A child counts up to the age of',
        child_age_limit_hint: 'Years. A child past it no longer counts.',
        proration:        'Proration',
        proration_hint:   'How a part year is measured.',
        proration_full_months: 'By completed months',
        tenure_tiers:     'Ladder by length of service',
        education_tiers:  'Ladder by education',
        add_tier:         'Add a rung',
        no_tiers:         'No rungs.',
        from_years:       'From years',
        extra_days:       'Extra days',
        level_prefix:     'Level',
        level_prefix_hint: 'Matched by prefix: \u201cVII\u201d covers VII/1 and VII/2.',
        tiers_are_highest: 'The HIGHEST rung reached applies; rungs are not added together.',
        carry_over_month: 'Carried-over leave expires (month)',
        carry_over_day:   'Carried-over leave expires (day)',
        carry_over_hint:  'Last year\u2019s remainder may be taken up to this day.',

        example:          'Worked example',
        example_tenure:   'Years of service',
        example_children: 'Number of children',
        example_line:     'Example: {years} years of service, {level}, {children} children \u2192 {days}',
        example_hint:     'The example issues nothing and records nothing \u2014 it only says what these settings would mean.',

        over_balance:     'This request goes past what is left of the year. The decision is still yours.',
    },
    staff_document: {
        expires_at:       'Valid until',
        expires_at_hint:  'Optional: the day the document stops being valid (a permit, a health certificate). Today warns thirty days ahead.',
        // Documents from templates (docs/OSEBJE-UI.md §5)
        documents:        'Documents',
        documents_hint:   'What the house has filed for this person. A withdrawn document stays on the list, struck through and with its reason.',
        no_documents:     'There is no document for this period yet.',
        tab_documents:    'Documents',
        document:         'Document',
        kind:             'Kind',
        kind_hint:        'What the document is filed under. The list ends in \u201cother\u201d \u2014 the paperwork a house keeps cannot be listed to the end.',
        kind_pogodba:     'Contract of employment',
        kind_aneks:       'Annexe',
        kind_m1:          'M-1 form',
        kind_nda:         'Confidentiality undertaking',
        kind_odlok:       'Decision',
        kind_drugo:       'Other',
        from_template:    'From a template',
        title_field:      'Title',
        file:             'File',
        file_hint:        'Upload a file as it stands \u2014 a scanned contract, a certificate.',
        upload:           'Upload',
        uploaded:         'The document has been uploaded.',
        download:         'Download',

        generate:         'Create from a template',
        generate_hint:    'The template is filled in from the card and the account. We only ask for what the card cannot answer.',
        create:           'Create',
        created:          'The document has been created.',
        template:         'Template',
        filled_automatically: 'Filled in for you',
        extra_values:     'What this template also asks for',
        no_extra_values:  'This template needs nothing else.',
        no_templates_hint: 'This house has no templates yet. Add one under Settings \u2192 Staff.',

        withdraw:         'Withdraw',
        withdraw_hint:    'The document stays in the register, marked as withdrawn.',
        withdraw_keeps_file: 'The file is not deleted. A withdrawal is the record that the document no longer stands.',
        withdrawn:        'The document has been withdrawn.',
        withdrawn_tag:    'Withdrawn',
        withdrawn_because: 'Withdrawn {at}: {reason}',
        reason:           'Reason for withdrawal',
        reason_hint:      '\u201cDeleted\u201d with nothing beside it is a fact with no author.',

        // Personal
        my_documents:     'My documents',
        my_documents_hint: 'What the house has filed about you. You read and download; the house files.',
        no_my_documents:  'Nothing has been filed for you yet.',

        // Settings → Document templates
        templates:        'Document templates',
        templates_hint:   'The .docx files this house makes its people\u2019s documents from.',
        add_template:     'Add a template',
        template_name:    'Template name',
        template_name_hint: 'What the picker will show. Empty takes the file name.',
        template_added:   'The template has been added.',
        docx_only:        '.docx only.',
        no_templates:     'This house has no templates yet.',
        no_placeholders:  'No {\u2026} field was found in this template.',
        placeholder_legend: 'Grey is filled in for you; blue is asked for when a document is made.',
        upload_failed:    'The template could not be uploaded.',
        confirm_delete_template: 'Delete the template \u201c{name}\u201d? Documents already made stay.',
    },
    staff: {
        // The staff module, arranged (docs/OSEBJE-UI.md)
        open_person:      'Open the personnel card',
        back_to_people:   'Personnel records',
        person_periods_hint: 'Every period this person has had, past ones included. A seasonal return is two periods, not one.',
        no_periods:       'This person has no period of work yet.',
        no_current_period: 'No period in force today',
        no_current_period_hint: 'No period of work is in force for this person today. Leave and documents hang off a period, so neither can be kept until there is one.',
        tab_details:      'Details',
        tab_employment:   'Employment',
        tab_record:       'Time record',
        contact:          'Contact',
        contact_hint:     'From the person\u2019s account. Edited on Accounts and on their own profile \u2014 a second box for the same number would be a second number.',
        no_account:       'No account was found for this person.',
        account_state:    'Account',
        card_fields:      'Personnel card',
        time_record:      'Working-time record',
        open_time_record: 'Open the time record',
        // General
        rota:            'Rota',
        employments:     'Personnel records',
        employments_hint: 'Dated periods of work. A change of department or of hours is a NEW period, never an edit of the old one — last January is still measured against last January.',
        coverage:        'Coverage',
        coverage_hint:   'Needed hours against rostered ones, by day and by department. Only the PMS knows the first number — a clock on a wall can never say what tomorrow needs.',
        no_property:     'Choose a property to see the rota.',
        whole_house:     'Whole hotel',
        all_departments: 'All departments',
        all_people:      'Everybody',
        unknown_person:     'Unknown person',
        unknown_department: 'Unknown department',
        unknown_position:   'Unknown post',
        unknown_property:   'Unknown property',

        // A read that did not happen — StaffLoadError.vue says so, instead of a screen
        // drawing an empty state that reads as "there is nothing".
        // A colleague who is here on loan from another house (docs/UPRAVA.md §39,
        // WP-G17). Without it the picker holds a name nobody recognises, and the natural
        // reaction to a stranger in a picker is not to choose them.
        loan_person: '{name} (on loan from {house})',
        load_failed: 'This could not be read.',
        try_again:   'Try again',
        unit_hours:   'h',
        unit_minutes: 'min',

        // Rota
        previous_week:      'Previous week',
        next_week:          'Next week',
        this_week:          'This week',
        copy_previous_week: 'Copy previous week',
        add_shift:          'Add shift',
        edit_shift:         'Edit shift',
        publish_week:       'Publish week',
        amend_week: 'Amend week',
        change_live: 'The change is in force now. The person still acknowledges it on their own rota — until then, expect them at the old hour.',
        nothing_to_publish: 'No unpublished shifts. An edit of a published shift takes effect the moment it is saved — the person only has to acknowledge it.',
        state_draft:     'Draft',
        state_published: 'Published',
        state_cancelled: 'Cancelled',
        state_none:      'No shifts',
        draft_week_title: 'Draft: {count} shifts are not published yet',
        draft_week_hint:  'This week is not visible to anybody yet. Publishing puts it on their own rota; only a CHANGE to an already published shift is notified.',
        rota_empty:      'Nobody is rostered this week.',
        rota_empty_hint: 'Add a shift with the button above, or copy the previous week.',
        person_line:           'obligation {weekly} · rostered {scheduled}',
        person_line_scheduled: 'rostered {scheduled}',
        scheduled:       'Rostered',
        required:        'Required',
        required_hint:   'From departures, meals and the other sources',
        scheduled_split: 'published {published} · draft {draft}',

        // The rota footer (docs/OSEBJE.md §7, §11). Coverage counts PUBLISHED shifts
        // only — a draft is not a promise — so this is two rows and not one: drawn as
        // one figure, a week held entirely in draft printed "Rostered 0 min" over a
        // full grid.
        published_row: 'Published',
        draft_row:     'Draft',
        coverage_draft_hint: 'Coverage counts published shifts only; a draft covers nothing until it is published.',
        publish_now:         'Publish',

        // The requirement per department, in each group's own band in the grid
        // (docs/OSEBJE.md §11). The footer adds the house up, and a house that adds up
        // hides a short housekeeping behind a covered kitchen — and what gets fixed is
        // ONE department, never the house. The colour is the footer's own.
        department_day:         '{published} / {required}',
        department_day_title:   '{required} needed · {published} published · {draft} in draft',
        department_day_no_rule: 'no requirement rule for this department',

        // The balance (docs/OSEBJE-UI.md §5). With three people the pair
        // "24 h / 17 h 15 min" is subtracted in the head; with twenty-five it is seven
        // subtractions per department, and a supervisor reading a wall of pairs does
        // none of them. So the difference is the first line and the pair is the second.
        //
        // A word and not a sign: "−3 h" in a grid already full of times is a minus the
        // eye skips, and the minus is the whole meaning. Zero gets its own word —
        // "covered" is an answer, "0 min" is a measurement of nothing.
        balance_short:   'short {missing}',
        balance_over:    'over {over}',
        balance_covered: 'covered',
        balance_row:     'Balance',
        balance_column:  'balance',
        week_column:     'Week',
        week_balance_title: 'Week: {required} needed · {published} published · {draft} in draft',
        balance_hint: 'Short = required − rostered (published + drafts); over = more rostered than required.',

        not_covered:      '{day}: {department} is not covered',
        not_covered_hint: '{required} is needed, {scheduled} is published — {missing} short.',
        not_covered_draft_line: '{draft} is in draft; even once published, {missing} is still missing.',
        covered_by_draft:      '{day}: {department} is covered only once published',
        covered_by_draft_hint: '{required} is needed, {published} is published and {draft} is in draft. The hours are rostered but nobody has been told — publish the week to make them count.',

        // The uncovered days are one panel and not a box per day: a week short in two
        // departments used to push the grid off the bottom of the screen. The four
        // sentences above are what one of its lines says on hover.
        //
        // The panel is TWO blocks and not one list. Its headline used to read
        // "Uncovered days", which meant `required > published` — the coverage rule
        // (§11), and the honest name for what the footer measures. But a hotelier plans
        // in drafts: a week she has just drafted end to end is a week she has already
        // solved, and the panel headlined it as seven uncovered days. What she is
        // actually asking is "what is short even counting what I have planned", so the
        // count is split by the ACT that closes the day — red means the hours do not
        // exist and somebody has to be rostered; amber means they exist and nobody has
        // been told, which is one press of publish.
        uncovered_even_with_drafts: 'Uncovered even with drafts: {count}',
        covered_pending_publish:    'Covered by drafts — awaiting publication: {count}',
        uncovered_missing:          '{missing} short',
        uncovered_awaiting:         '{missing} awaiting publication',
        all_covered:                'Every day is covered',
        all_covered_with_drafts:    'Every day is covered (drafts included)',
        uncovered_expand:           'Show',
        uncovered_collapse:         'Hide',
        recurring_shortfall: '{department}: the rota falls short on {days} days',
        recurring_weekday:   'Always the same weekday ({weekday}), {minutes} short in total. That is a staffing question, not a queue of overtime.',
        recurring_spread:    'The shortfall is spread across the week, {minutes} in total. That is a staffing question, not a queue of overtime.',
        confirm_publish: 'Publish this week? The week appears on the rota of the people named ({count} shifts).',
        published:       'Shifts published: {count}',
        confirm_copy_week: 'Copy the previous week into this one? What comes back are DRAFTS — publishing is its own step.',
        copied:            'Shifts copied: {count}',
        // Say the skipped ones out loud: "Shifts copied: 0" and nothing else reads as a
        // broken button rather than as a week that is already rostered.
        copied_with_skipped: 'Shifts copied: {count} · {skipped} were already on this week.',
        see_coverage:      'Open coverage',
        sources_incomplete: 'Careful: some requirement sources do not contribute — {sources}.',

        // Absences on the rota (docs/OSEBJE.md §10, §11). A recorded day is a fact and
        // comes off the coverage; a request is a question and takes nothing off it.
        absence_on_day:       'Approved absence: {kind}',
        absence_pending_chip: '{kind} · waiting',
        absence_pending_hint: 'This request is waiting for a decision. Open Absences.',
        open_absences:        'Absences',
        legend_published:      'Published shift',
        legend_draft:          'Draft',
        legend_absence:        'Approved absence',
        legend_absence_pending: 'Request awaiting a decision',
        // The two colours of the panel at the top, on their own line: the legend above
        // is about the CELLS.
        legend_uncovered:       'Uncovered even with drafts',
        legend_pending_publish: 'Covered by drafts, awaiting publication',
        legend_rule_warning:    'Shift with a rest or load warning',

        // The rota rules (docs/OSEBJE.md §7). Every warning sentence comes from the
        // server and is printed verbatim; these are only the headings around them.
        rule_warnings_title:  'This week has {count} warning(s)',
        rule_warnings_hint:   'Rest and load. None of it is forbidden — the shifts are marked on the grid and the sentence is on the cell.',
        shift_warning_hint:   'A warning, not a refusal. If this is what was agreed, press save again — the trail records that you knew.',
        save_despite_warning: 'Save despite the warning',
        pending_absences_title: '{department}: absence requests waiting for a decision',
        pending_absences_hint:  'People: {count} · days in this window: {days}. A request does NOT count towards coverage — until it is decided the hours are still rostered.',
        absent:              'Away',
        absent_pending_line: 'waiting: {names}',

        // Notices about a CHANGED published shift (§7). A first publication is NOT
        // notified — the week is the announcement; only a change to what somebody has
        // already read is an event of that kind.
        my_rota:            'My rota',
        my_rota_empty:      'You have no shift rostered this week.',
        my_rota_empty_hint: 'What you see here is published only. A supervisor\'s draft is not shown — until a week is published it is not a promise.',
        today:    'Today',
        free_day: 'Off',
        break_of: 'break {minutes}',
        my_changes_title: 'Changes you have not acknowledged: {count}',
        my_pending_title: 'Requests waiting for a decision: {count}',
        change_moved:     'From {previous} to {current}',
        change_withdrawn: 'The shift is withdrawn (it was {previous})',
        change_reason_line: 'Reason: {reason}',
        change_changed_at:  'Changed {at}',
        change_for_person:  '{name}: {change}',
        acknowledge:      'I understand',
        acknowledged:     'Receipt recorded',
        acknowledge_hint: 'Acknowledging records that you have seen the change, and when. Until you do, the scheduler is told that you do not know yet.',
        decline:        'I cannot',
        decline_note:   'Why can you not? (optional)',
        decline_hint:   'The scheduler will see that you cannot and will arrange cover. The change stays on the list until that is settled.',
        decline_send:   'Send',
        declined:       'Recorded: you cannot work it.',
        decline_failed: 'The answer could not be recorded.',
        not_told_title: 'Do not know about the change yet: {count}',
        not_told_hint:  'Delivery is recorded when the person acknowledges the change on their own rota — not when we write it. Until then, expect them at the old hour.',
        told_in_person:        'Told in person',
        told_in_person_done:   'Recorded: {name} was told in person.',
        told_in_person_failed: 'The note about telling them in person could not be saved.',
        notice_pending:   'Does not know yet',
        notice_sent:      'Sent, unconfirmed',
        notice_delivered: 'Acknowledged',
        notice_failed:    'Notice failed',
        notice_declined:  'Declined',
        declined_by:       '{name} declined the shift change',
        declined_by_noted: '{name} declined the shift change: {note}',
        declined_line:       'The shift change was declined',
        declined_line_noted: 'The shift change was declined: {note}',

        // Shift
        person:             'Person',
        person_placeholder: 'Choose a person',
        department:         'Department',
        position:           'Post',
        date:               'Date',
        starts:             'Starts',
        ends:               'Ends',
        break_minutes:      'Break (min)',
        break_hint:         'The break counts into working time and is not deducted.',
        overnight_hint:     'The shift ends the following day. Hours are counted into the calendar day they were worked in.',
        shift_length_hint:  'Shift length: {length}',
        shift_published_notice: 'This shift is published. Somebody has already arranged their week around it — a change has to reach them with a reason.',
        shift_on_absence:      '{name} has an approved absence that day: {kind}.',
        shift_on_absence_hint: 'You may still write the shift — the rota is the intention and attendance is the fact. Just know that coverage counts this person away that day, so these hours contribute nothing to it.',
        shift_on_pending:      '{name} has asked for {kind} that day and nobody has decided it.',
        shift_on_pending_hint: 'A request does not count towards coverage — the hours stay rostered until somebody decides. Approve it afterwards and this shift is left uncovered.',
        change_reason:      'Reason for the change',
        change_reason_hint: 'Recorded together with the previous and the new interval and the delivery state of the notice.',
        shift_added:        'Shift added',
        confirm_delete_shift: 'Delete this draft shift?',
        cancel_shift:         'Withdraw shift',
        cancel_needs_reason:  'Withdrawing a published shift needs a reason.',
        confirm_cancel_shift: 'Withdraw this published shift? The interval is kept, the person is told, and the post shows as uncovered.',
        shift_cancelled:      'Shift withdrawn',

        // Personnel record
        add_employment:  'New employment record',
        edit_employment: 'Edit period',
        edit_period_notice: 'This corrects a period; it does not change the arrangement.',
        edit_period_hint:   'A move to another department or a change of hours is a NEW period — use "End and open a new one".',
        section_person:       'Person',
        section_organisation: 'Organisation',
        section_basis:        'Legal ground',
        section_obligation:   'Obligation',
        section_validity:     'Validity',
        employee_no:        'Employee number',
        employee_no_hint:   'What accounting matches the export against its own records by.',

        // The accounting handles off the card (docs/EVIDENCA-CASA.md § „Payroll Connect“).
        // Not a second employee number: that one is ours, these two are theirs.
        payroll_code:      'Payroll code',
        payroll_code_hint: 'This person\'s code in the payroll program. Not a second employee number — ours says who this is here, this says which record the wage run updates. Only one person in a house may carry it at a time.',

        cost_centre:             'Cost centre',
        cost_centre_hint:        'For exceptions only. Empty means the department\'s own centre, which is the ordinary card.',
        cost_centre_placeholder: 'from the department',
        cost_centre_from_department: 'From the department',

        legal_entity:      'Company',
        legal_entity_hint: 'The company this contract is held by. Derived from the house\'s placement on the day the period begins; corrected in the group console, because it decides who files the payroll.',

        department_cost_centre_hint: 'The default cost centre for everybody in this department. Free text, because the codebook is accounting\'s and not ours. One person may override it on their own card.',
        employee_no_search: 'Search by name, number or department',
        search:             'Search',
        organisation:       'Organisation',
        home_property:      'Home property',
        home_property_hint: 'The hotel whose rota this person appears on.',
        work_properties:      'Properties worked in',
        work_properties_hint: 'Where somebody WORKS. Not access rights — those come from the account\'s roles.',
        works_in:             'works in {count} properties',
        department_hint:        'The home department — the one this person appears under on the rota.',
        work_departments:       'Also works in',
        work_departments_hint:  'The other departments this person WORKS in and may be rostered under. Not the same as heading a department.',
        works_also_in:          'also works in: {departments}',
        managed_departments:      'Rosters departments',
        managed_departments_hint: 'A head of several departments is the rule, not the exception. The scheduling scope comes from here.',
        rosters:                  'rosters: {departments}',
        manager:      'Manager',
        manager_hint: 'Empty means approvals go to every holder of staff:approve in this hotel.',
        manager_heads_hint:     'The heads of the chosen department are offered.',
        manager_approvers_hint: 'Nobody heads this department, so the holders of staff:approve are offered.',
        manager_approver:       '{name} (staff:approve)',
        manager_none: 'No manager',
        engagement_basis: 'Legal ground',
        basis_employment_contract:  'Contract of employment',
        basis_agency_worker:        'Agency worker',
        basis_student_work:         'Student work',
        basis_pensioner_temporary:  'Pensioner temporary work',
        basis_traineeship:          'Traineeship or apprenticeship',
        basis_service_contract:     'Service contract',
        basis_copyright_contract:   'Copyright contract',
        basis_short_term_family_work: 'Short-term family work',
        basis_self_employed:        'Self-employed contractor',
        basis_other:                'Other legal ground',
        contract_duration:   'Contract duration',
        duration_indefinite: 'Indefinite',
        duration_fixed_term: 'Fixed term',
        fixed_term_reason:   'Reason for the fixed term',
        working_time_type:   'Working time',
        time_full:           'Full time',
        time_part:           'Reduced time',
        insurance_basis_code:      'Insurance basis code',
        insurance_basis_code_hint: 'The official M-1 code, e.g. 001.',
        time_record_required:      'A working-time record is kept for this person',
        time_record_required_hint: 'Untick only where the law requires no record — and say why.',
        time_record_basis: 'The record is kept from',
        record_clock:      'Clock stamps',
        record_schedule:   'The rota',
        record_pattern:    'The work pattern',
        record_manual:     'Manual entry',
        record_kept:       'record from: {basis}',
        time_record_exemption:      'Exemption reason',
        time_record_exemption_hint: 'A managing person is an EXEMPTION from the record, not a kind of employment.',
        exempt_managing_person:     'Managing person',
        exempt_other:               'Another reason',
        record_exempt:              'no record: {reason}',
        weekly_minutes:        'Weekly obligation (min)',
        weekly_hours:          'Weekly obligation (h)',
        obligation:            'Obligation',
        per_week:              '{minutes} / week',
        reference_period:      'Reference period (months)',
        reference_period_hint: 'For unevenly distributed working time. It belongs to the person, not to the hotel.',
        reference_months:      'reference period: {months} months',
        work_pattern:  'Work pattern (minutes per day)',
        work_pattern_hours:  'Work pattern (hours per day)',
        no_pattern:    'no work pattern',
        pattern_total: 'Pattern totals {pattern} · weekly obligation {weekly}',
        day_monday:    'Mon',
        day_tuesday:   'Tue',
        day_wednesday: 'Wed',
        day_thursday:  'Thu',
        day_friday:    'Fri',
        day_saturday:  'Sat',
        day_sunday:    'Sun',
        valid_from:    'Valid from',
        valid_to:      'Valid to',
        valid_to_hint: 'Empty means an open period.',
        validity:      'Validity',
        open_ended:    'open',
        in_force:      'in force today',
        current_only:      'Only in force today',
        current_only_hint: 'Unticked also shows past periods — history, not duplicates.',
        confirm_delete_employment: 'Delete this period of {name}? For a departure use "End and open a new one" — the record of work stays.',

        // Ending a period
        end_period:        'End and open a new one',
        end_period_action: 'End the period',
        end_period_title:  'Closing and succeeding are one press.',
        end_period_hint:   'The server closes the old period first and opens the new one second — two separate presses would, on a failure, leave somebody with no period at all from tomorrow.',
        last_day:      'Last day of the period',
        last_day_hint: 'Inclusive. The next period starts the following day by default.',
        open_successor:      'Open a new period',
        open_successor_hint: 'A move to another department, a change of hours, a second season.',
        successor_section:   'New period',
        departure_title:     'With no successor this is a departure.',
        departure_hint:      'The period ends and nothing succeeds it. The past record stays untouched.',
        period_ended:     'Period ended',
        period_succeeded: 'Period ended, a new one opened',

        // Registers
        departments:      'Departments',
        departments_hint: 'A register. Free text would within half a year hold "Reception", "reception" and "Front desk" as three departments — and coverage would count three teams where the hotel has one.',
        positions:        'Posts',
        positions_hint:   'What somebody DOES. Not a role: what an account may open is decided by its roles and by nothing else.',
        add_department:   'Add department',
        edit_department:  'Edit department',
        add_position:     'Add post',
        edit_position:    'Edit post',
        no_departments:   'No departments yet.',
        no_positions:     'No posts yet.',
        position_cost:        'Cost per hour (average)',
        position_cost_failed: 'The post cost could not be saved',
        position_cost_hint:   'An AVERAGE for this post in this house, not anybody\'s pay. This system runs no payroll and the working-time record stays free of money — the chain head office uses this figure for the labour cost per sold room-night. Empty means "unknown" and the board says so.',
        position_cost_none:   'not set',
        name:         'Name',
        code:         'Code',
        code_hint:    'The stable handle for exports and support: lower-case letters, digits and underscores, starting with a letter.',
        code_invalid: 'The code may hold lower-case letters, digits and underscores, and must start with a letter.',
        default_department:      'Default department',
        default_department_hint: 'A default, not a constraint — a work period carries its own department.',
        no_default_department:   'No default department',
        offered:       'Still offered',
        offered_hint:  'A retired entry is still read by the rota and the reports; new periods are no longer offered it.',
        offered_short: 'In use',
        retired:       'Retired',
        confirm_delete_department: 'Delete the department {name}?',
        confirm_delete_position:   'Delete the post {name}?',

        // Org chart
        parent_department:      'Parent department',
        parent_department_hint: 'Where the department sits in the house. No parent means directly under the house.',
        no_parent_department:   '— none —',

        department_head:      'Department head',
        department_head_hint: 'Who leads the department. The name is printed on the org chart; it grants no rights.',
        no_department_head:   '— none —',

        org_chart:          'Org chart',
        org_chart_hint:     'Organisational structure: a tree of departments with employees and reporting lines by manager.',
        org_chart_back:     'Employees',
        org_chart_on:       'On',
        org_chart_horizontal: 'Horizontal',
        org_chart_vertical:   'Vertical',

        org_chart_by_departments:   'By departments',
        org_chart_edit_departments: 'Edit departments',
        org_chart_reporting_lines:  'Reporting lines (manager)',

        org_chart_people:               'people: {count}',
        org_chart_head_label:           'Head: {name}',
        org_chart_head_title:           'Department head',
        org_chart_set_head:             'Make head of department',
        org_chart_no_employees:         'No employees',
        org_chart_also_here:            'also:',
        org_chart_cycle:                '(cycle)',
        org_chart_unassigned_group:     'Unassigned ({count})',
        org_chart_unassigned_hint:      'Accounts with no personnel card on this day. Drag a person onto a department: a new card opens with the department filled in.',
        org_chart_no_department_group:  'No department ({count})',
        org_chart_no_people_on_record:  'No employees on record.',
        org_chart_footnote:             'The superior is first the „Manager\" field on the personnel card. Where it is empty, a head of department reports to the head of the department above, and everybody else to the head of their own department; such a line is marked „via department“. Whoever has nobody above them is at the top.',
        org_chart_via_department:       'via department {department}',
        org_chart_reports_to:           'Reports to: {name}',

        org_chart_drag_hint:      'Drag a department onto another department or onto the house. The star beside a name makes that person the head.',
        org_chart_drag_hint_more: 'The chart never moves a person — the home department lives on the personnel card. The same hierarchy, and the head, can also be set from the dialog on the Departments and posts screen.',

        // Coverage
        window_hint:  '31 days at most.',
        by_day:       'By day',
        people:       'People',
        shortfall:    'Shortfall',
        shortfall_hint: 'Negative means a surplus',
        short_days:      'Uncovered days',
        short_days_hint: 'Days where the rota does not meet the work',
        required_total:  'Required over the window',
        sources:      'Requirement sources',
        sources_hint:  'Every source says whether it contributes at all. A silent nought looks exactly like a quiet Tuesday — the worst thing this screen could show.',
        source:       'Source',
        contribution: 'Contribution',
        source_core:         'Core (guest arrivals and departures)',
        source_housekeeping: 'Housekeeping',
        source_dining:       'Meals',
        source_events:       'Events',
        source_maintenance:  'Maintenance',
        reason_contributing:  'Contributing',
        reason_not_licensed:  'Module not licensed',
        reason_not_built:     'Not built yet',
        reason_no_department: 'No department for this work',
        reason_no_rule:       'No coverage rule',
        no_sources:            'No requirement sources.',
        no_coverage_days:      'No coverage data for this window.',
        no_coverage_days_hint: 'Coverage needs departments, rostered shifts and a requirement source — departures for housekeeping, for instance.',
        // A department with no coverage rule (§11). This is the failure a hotelier
        // reported: reception has sixteen hours rostered and a requirement of nought,
        // because nobody had ever told the house what a reception desk costs.
        no_rule_title: '{department}: no coverage rule',
        no_rule_hint:  'No coverage rule for this department — set one under Settings (the gear) → Users, roles and security → Working-time record → Coverage tab. Until then the requirement is nought and the shortfall is not a measurement.',
        open_coverage_rules: 'Set a rule',
    },
    /**
     * The "module not enabled" screen (docs/MODULI.md §3.3). One page for every
     * module: it says the same sentence each time, and the module's name comes from
     * the address. No greyed-out "upgrade" buttons — a hotel that wants a module talks
     * to whoever signs its contracts.
     */
    module_off: {
        title:               'Module not enabled',
        description:         'The “{module}” module is not part of this hotel’s subscription, so this screen is not available.',
        planned_title:       'This module is in preparation',
        planned_description: 'The “{module}” module is in preparation and is not yet available for purchase.',
        contact:             'Contact your system administrator.',
        back:                'Back to the chessboard',
    },
    errors: {
        partner_not_configured: 'This installation is not set up to connect partners. Contact support.',
        partner_unavailable: 'The partner is not answering right now. Try again in a moment.',
        partner_refused: 'The partner refused: {reason}',
        partner_refused_plain: 'The partner refused the request.',
        on_save: 'The change could not be saved.',
        operation_in_progress: 'This sale is already being finished. Do not press again — look for it in today’s sales. If it is not there, tell a supervisor.',
        operation_mismatch: 'This till has lost track: the same attempt was started with different contents. Reload the screen and start the sale again.',
        operator_not_identified: 'The invoice cannot be issued: the person issuing it has neither a personal tax number nor a foreign-operator declaration. The law (ZDavPR) requires one of the two. Set it under Settings (the gear) → Users, roles and security → Users. Nothing was written — no invoice, no stock, no payment.',
        fields: {
            name:                     'property name',
            address:                  'address',
            night_audit_hour:         'night audit hour',
            currency:                 'currency (three letters, e.g. EUR)',
            language:                 'default language',
            housekeeping_norm:        'housekeeping norms',
            reporting:                'reporting details (AJPES)',
            fiscal_tax_number:        'fiscalisation tax number (8 digits)',
            fiscal_business_premise:  'business premise id',
            fiscal_electronic_device: 'electronic device id',
            fiscal_supplier_tax_number: 'software supplier tax number (8 digits)',
            fiscal_premises_numbers:  'premise cadastral details',
            payment_terms:            'payment terms (0-365 days)',
            legal_name:               'legal name',
            identity_tax_number:      'tax number',
            identity_vat_number:      'VAT ID',
            registration_number:      'registration number',
            iban:                     'IBAN',
            bic:                      'BIC',
            email:                    'email',
            phone:                    'phone',
            vat_exemption_note:       'VAT exemption note',
            legal_address:            'legal address',
            vat_rates:                'VAT rates',
            accommodation_tax_rate:   'accommodation VAT rate',
            amenities:                'amenities',
            document_scan:            'document scanning settings',
            local_events_url:         'local events source (must be an http/https URL)',
            yield:                    'dynamic pricing steps',
            timezone:                 'timezone',
        },
        generic_error: 'An error occurred',
        invalid_data:  'Invalid data',
        not_found:     'Not found',
        unauthorized:  'You are not allowed to do that',
        staff_not_employed: 'This person has no work period covering that day at this property. The personnel card needs putting right.',
        conflict:      'The record already exists or is taken',
        on_add:        'Error while adding',
        on_edit:       'Error while updating',
        on_delete:     'Error while deleting',
        on_load:       'Error while loading',
        // What a screen draws INSTEAD of its empty state when there is no answer
        // (AppLoadError.vue). An empty table with a zero under it reads as "there was
        // nothing"; this says the data could not be read.
        load_failed:   'This could not be read.',
        session_expired: 'The session has expired. Sign in again — nothing was done.',
        guest_already_exists: 'The hotel already has this guest — the same surname, given name and date of birth. Nothing was changed.',
        charge_reference_in_use: 'This document is already posted on a card at this property. Nothing was changed — find the existing line.',
        room_charge_already_posted: 'This room already has the night posted for that date. Nothing was changed — find the existing line.',
        module_not_licensed: 'This module is not enabled for this hotel',
    },
    success: {
        add:    'Successfully added',
        edit:   'Successfully updated',
        delete: 'Successfully deleted',
    },
    validation: {
        required:     'This field is required',
        email:        'Invalid email address',
        min:          'The value is too small',
        max:          'The value is too large',
        positive:     'The value must be greater than zero',
        date_order:   'Departure must be after arrival',
        invalid_date: 'Invalid date',
    },
    /**
     * What the room televisions show (docs/DISPLAY.md §9). Its own namespace and not
     * part of `display`: that one is the EQUIPMENT — the screens a hotel hangs and lets
     * in — and this is the CONTENT that is on them.
     */
    display_config: {
        theme: 'Screen theme',
        theme_hint: 'The ground everything else is drawn on.',
        theme_help: 'A light theme is light at three in the morning too, in a room where somebody is asleep. A hotel that wants a light look should take Automatic.',
        theme_dark: 'Dark',
        theme_light: 'Light',
        theme_auto: 'Automatic (light by day, dark at night)',
        maps_url: 'Google Maps link — becomes a QR code on the TV, a link in the guest portal',
        discount: 'Hotel-guest discount (e.g. 10% off lunch)',
        tab: 'Screen content',
        intro: 'What is written here is what the hotel says about itself. What is left empty the screen quietly leaves out — nothing is required.',
        read_only: 'Editing screen content needs the property:write permission.',
        stale: 'Somebody else saved these settings in the meantime',
        stale_hint: 'One hotel has one record, so the last save overwrites the previous one. Reload before saving again.',
        reload: 'Reload settings',
        saved: 'Screen settings saved',

        welcome: 'Welcome screen',
        welcome_hint: 'The first thing a guest sees walking into the room.',
        greeting: 'Greeting',
        greeting_hint: 'Write {name} where the guest\'s given name should go. Empty leaves the product\'s own wording.',
        empty_greeting: 'Greeting for an empty room',
        empty_greeting_hint: 'What it says with nobody in the room, and on a lobby panel. It cannot carry a name — there is nobody to name.',
        subtitle: 'Line under the greeting',
        show_departure: 'Show the departure date',
        show_room_number: 'Show the room number',
        show_weather: 'Show the weather',
        weather_off_hint: 'The weather is switched off below, so no panel will be drawn.',

        house: 'The hotel',
        house_hint: 'What a guest asks the desk in the first hour.',
        address: 'Address under the hotel name',
        wifi_network: 'Wi-fi network',
        wifi_password: 'Wi-fi password',
        wifi_password_hint: 'The guest network password is printed on the screen — that is the point. Do not put an internal password here.',
        reception_key: 'Reception key',
        reception_key_hint: 'The number written into the footer of several screens.',
        emergency: 'Emergency notice',
        house_photo: 'Photograph of the hotel',
        hours: 'Opening hours',
        hours_label: 'Breakfast',
        hours_value: '07.00 – 10.30',
        phone_keys: 'Room telephone keys',

        letter: 'Welcome letter',
        letter_hint: 'Where things are in this building. A guest reads it once, on arrival.',
        letter_intro: 'Opening paragraph',
        letter_lines: 'Lines',
        letter_signature: 'Signature',
        no_icon: 'No mark',

        local: 'The surroundings',
        local_hint: 'What is on in town and what is always there. Enter only what is true — the screen sends a guest walking to it.',
        local_qr:      'QR code for directions',
        local_qr_hint: 'A card with a Google Maps link also shows a QR code labelled "scan for directions". Switching it off keeps the link in the guest portal.',
        events: 'Events',
        event_time: '21.00',
        event_name: 'Event name',
        event_venue: 'Venue',
        event_price: 'Price',
        event_past: 'The date has passed — this event does not reach the screens.',
        distance: '8 minutes on foot',
        places: 'Places',
        place_name: 'Name',
        place_hours: 'Opening hours',
        place_note: 'Note',

        services: 'Services on the screen',
        services_hint: 'The price list stays in the Facilities module. Only what the screen does DIFFERENTLY is entered here.',
        no_catalogue: 'Editing services needs the facility:read permission.',
        no_services: 'The hotel has no services in its price list yet.',
        only_selected: 'Only the selected services on the screen',
        only_selected_hint: 'Switched off (the default) means the opposite: everything is on the screen except what is hidden here.',
        service_title: 'Shorter name',
        group_photo: 'Heading picture',

        booking: 'Booking from the screen',
        booking_hint: 'What a guest may ask for from the bed.',
        booking_enabled: 'Switch booking on',
        booking_facilities: 'Facilities',
        booking_facilities_hint: 'Empty means everything that can be booked.',
        booking_lead: 'Hours of notice',
        booking_note: 'What the confirmation says',
        booking_seam: 'This form configures the OFFER. Writing the booking itself from a television is not built yet — the guest rings the desk.',

        weather: 'Weather',
        weather_hint: 'The forecast over the hotel, from the public Open-Meteo service.',
        weather_enabled: 'Show the weather',
        weather_place: 'Town',
        weather_place_hint: 'Empty means the property\'s own town.',
        weather_days: 'Days',
        weather_hourly: 'Also offer the "Hourly weather (today)" slide',
        weather_hourly_hint: 'On, this adds today by the hour — from the current hour onwards — to the slide kinds a digital signage loop can carry. It changes nothing on the room screens.',
        weather_quiet: 'If no forecast can be had, the panel is simply not drawn — never dashes.',

        screens: 'Screens',
        screens_hint: 'Which screens are offered, in what order, under what name and over what picture.',
        screens_home_note: 'The welcome screen cannot be switched off — a television without it shows nothing at all.',
        background: 'Background',

        screen_home: 'Welcome',
        screen_letter: 'Letter',
        screen_program: 'The day',
        screen_services: 'Hotel services',
        screen_nearby: 'Services nearby',
        screen_local: 'Nearby',
        screen_house: 'The hotel',
        screen_bill: 'Bill',
        screen_booking: 'Booking',
        screen_tv: 'TV channels',
        screen_music: 'Music',
        screen_alarm: 'Alarm',
        screen_room_service: 'Room service',

        kind_sight: 'Sight',
        kind_restaurant: 'Restaurant',
        kind_activity: 'Activity',
        kind_shop: 'Shop',
        kind_other: 'Other',

        preview: 'How it will look',
        preview_note: 'An approximation: the layout, the wording and the pictures are real, the typeface is not. The real screen is pms-display.',
        preview_room: 'Room 205',
        preview_departure: 'Departure 13 Sep by 10.00',
        preview_wifi: 'Wi-fi',
        preview_hours: 'Opening hours',
        preview_empty_hours: 'No opening hours entered.',
        preview_phone: 'Room telephone',
        preview_empty_phone: 'No keys entered.',
        preview_empty_letter: 'The letter has not been written yet.',
        preview_this_week: 'This week',
        preview_always_open: 'Always open',
        preview_free: 'Free',
        preview_ask_desk: 'Ask at reception for more — key {key}.',
        preview_empty_local: 'Nothing has been entered about the surroundings. In this state the screen points a guest at the desk.',
        preview_empty_services: 'No services for the screen in the price list.',
        preview_not_configurable: 'This screen is drawn from data this form does not edit — the day\'s programme, the folio, the music.',

        picture_choose: 'Choose a picture',
        picture_change: 'Change',
        picture_clear: 'Remove',

        image_title: 'A picture for the screen',
        image_hint: 'Draw a new one, upload your own, or pick one from the hotel\'s library.',
        image_no_provider: 'This deployment draws no pictures',
        image_no_provider_hint: 'No image provider is configured. You can still upload your own photographs.',
        image_generate: 'Draw a picture',
        image_note: 'What should be in it',
        image_note_hint: 'A short direction, for example "the terrace, late afternoon". The rest is assembled from what is known about the hotel.',
        image_draw: 'Draw',
        image_drawing: 'Drawing takes the better part of a minute and costs the hotel money. Do not press again.',
        image_provider: 'Drawn by {provider} · {model}',
        image_failed: 'The picture could not be drawn.',
        image_upload: 'Upload your own photograph',
        image_upload_hint: 'Landscape, dark and calm works best — white text is laid over it.',
        image_upload_failed: 'The upload failed.',
        image_uploaded: 'Photograph uploaded',
        image_library: 'The hotel\'s library',
        image_library_empty: 'This hotel has no pictures for its screens yet.',
        image_clear: 'No picture',
        image_no_note: 'No description',
        image_confirm_delete: 'Remove this picture from the library?',

        /*
         * A film in the library (docs/DISPLAY.md §10.9). Its own keys rather than an
         * extension of `image_*`, because it is a different thing: a picture is drawn or
         * uploaded, a film is only uploaded — and the one thing that has to be said about
         * a film BEFORE a file is chosen is the codec.
         */
        video_title: 'A film for a slide',
        video_hint: 'Upload a film and choose it. It plays on the panel when the slide comes round.',
        video_codec: 'MP4 (H.264/AAC)',
        video_codec_hint: 'Up to {size} MB. Samsung and Safari play H.264 only — HEVC/H.265 stays black on the wall even though it uploads here.',
        video_upload: 'Upload a film',
        video_making_poster: 'Drawing the first frame …',
        video_sending: 'Sending … {percent} %',
        video_library: 'The hotel\'s library',
        video_library_empty: 'This hotel has no films yet.',
        video_clear: 'No film',
        video_no_name: 'No name',
        video_meta: '{length} · {size} MB',
        video_meta_no_length: 'length unknown · {size} MB',
        video_too_large: 'The film is too large — {size} MB at most.',
        video_upload_failed: 'The film could not be uploaded.',
        video_uploaded: 'Film uploaded',
        video_confirm_delete: 'Remove this film from the library? Slides that name it stop being shown.',
    },
    /** Settings → Screens: one menu entry for the room TVs and the signage panels. */
    screens: {
        nav: 'Screens',
        intro: 'The televisions in the rooms and the panels in the public areas — each with its own tabs.',
        rooms_tab: 'Room TVs',
        signage_tab: 'Digital signage',
    },
    /**
     * Digital signage — the panels in the public spaces (docs/DISPLAY.md §10).
     *
     * Its own namespace and part of neither `display` nor `display_config`, because it is
     * a third thing: `display` is the equipment, `display_config` is what the ROOM screens
     * show, and this is a loop that runs itself on a wall in the foyer — with a unit, the
     * slide, that exists nowhere else in the product.
     */
    signage: {
        nav: 'Digital signage',
        intro: 'What runs on the screens in the foyer, by the restaurant, at the lift. Room televisions are not affected.',
        no_property: 'Pick a property first.',
        read_only: 'Editing loops needs the property:write right.',

        loops_tab: 'Loops',
        devices_tab: 'Screens',

        loop: 'Loop',
        loop_hint: 'Its name, a note, and how long a slide stands by default.',
        loop_name: 'Loop name',
        loop_name_hint: 'How you will find it in the list — it is never on a wall.',
        loop_name_example: 'e.g. Foyer',
        loop_note: 'Note',
        loop_note_hint: 'For you and your colleagues. It never reaches a screen.',
        new_loop: 'New loop',
        delete_loop: 'Delete loop',
        no_loops: 'No loops',
        no_loops_hint: 'This hotel has no loop yet. Make the first one and give it a screen with no room.',
        name_off: '{name} (switched off)',
        active: 'Switched on',
        active_hint: 'A loop that is off does not run — the screen shows the ordinary lobby screens. Assignments are kept.',
        default_seconds: 'Default dwell (s)',
        default_seconds_hint: '0 means {seconds} s.',
        running_on: 'Running on {count} screens.',
        running_on_none: 'No screen is running this loop yet.',
        stale: 'Somebody else saved this loop in the meantime',
        stale_hint: 'Your save overwrote theirs. Reload and check what is in it now.',
        reload: 'Reload',
        saved: 'Loop saved',
        confirm_delete: 'Delete the loop {name}?',
        confirm_delete_running: '{count} screens are running the loop {name}. Delete it anyway?',

        slides: 'Slides',
        slides_hint: 'The order here is the order on the wall. Anything switched off or outside its dates never reaches a screen.',
        add_slide: 'Add slide',
        no_slides: 'This loop has no slides yet.',
        full: 'The loop is full — at most {count} slides.',
        slide_kind: 'Kind',
        slide_title: 'Heading',
        slide_body: 'Text',
        slide_picture: 'Background picture',
        slide_seconds: 'Dwell (s)',
        slide_seconds_hint: '0 = the default',
        slide_seconds_film: "0 = the film's length ({seconds} s)",
        slide_enabled: 'Switched on',
        slide_from: 'From',
        slide_to: 'Until',
        move_up: 'Move up',
        move_down: 'Move down',
        duplicate: 'Duplicate',
        remove_slide: 'Remove slide',

        slide_no_film: 'No film chosen yet',
        choose_film: 'Choose a film',
        change_film: 'Change the film',
        slide_muted: 'No sound',
        slide_loop_within: 'Repeat until the dwell is up',
        slide_sound_warning: 'Sound in a foyer is heard by everybody walking past — and a browser may refuse to autoplay with it on, in which case the panel mutes the film itself.',

        kind_poster: 'Poster',
        kind_welcome: 'Hotel welcome',
        kind_program: "The day's programme",
        kind_weather: 'Weather',
        kind_weather_hourly: 'Hourly weather (today)',
        kind_services: 'Services',
        kind_local: 'Nearby',
        kind_hours: 'Opening hours',
        kind_video: 'Video',

        derived_welcome: "The hotel's name and look. There is nothing to type here.",
        derived_program: "The published day. Edited under Settings (the gear) → Guest experience, Milo and screens → Screens → Room TVs → The day's programme tab.",
        derived_weather: 'The forecast for the hotel. Switched on under Settings (the gear) → Guest experience, Milo and screens → Screens → Room TVs → Screen content tab.',
        derived_weather_hourly: 'Today hour by hour, from the current hour onwards. The same town as the forecast; switched off under Settings (the gear) → Guest experience, Milo and screens → Screens → Room TVs → Screen content tab. Late in the evening, with nothing left of the day, the slide drops out.',
        derived_services: 'The price list from the Facilities module.',
        derived_local: 'Events and places from Screen content.',
        derived_hours: 'Hours and address from Screen content. The wi-fi and the telephone keys never reach a public wall.',

        previous_slide: 'Previous slide',
        next_slide: 'Next slide',
        preview_at: 'Slide {at} of {of}',
        preview_landscape: 'Landscape panel',
        preview_portrait: 'Portrait panel',
        preview_note: 'The preview is an approximation: the layout and the content are real, the screen\'s typeface is not.',
        preview_empty: 'This loop has no slides.',
        preview_welcome: 'Welcome',
        preview_blank: 'This poster has no heading, no text and no picture.',
        preview_dropped: 'There is nothing behind this right now — the screen will not show this slide.',
        preview_no_film: 'This slide has no film yet — the screen will not show it.',
        wall_shows: '{count} slides are running on the screens right now.',
        wall_unknown: 'What is running on the screens right now is not known.',

        place_sight: 'Sight',
        place_restaurant: 'Where to eat',
        place_activity: 'Activity',
        place_shop: 'Shopping',
        place_other: 'Other',

        devices: 'Screens and loops',
        devices_hint: 'Only a screen with NO room can be given a loop. A room television never loops — see docs/DISPLAY.md §10.4.',
        no_devices: 'This hotel has no screens enrolled yet.',
        device_public: 'Public space (no room)',
        device_in_room: 'Room {room}',
        device_seen: 'last seen {when}',
        device_never_seen: 'never heard from',
        unassigned: 'No loop',
        assigned: 'The screen was given a loop',
        cleared: 'The screen has no loop',
    },
    /**
     * Reminders — the desk's dated notes on a reservation. Overdue / today / upcoming are
     * the groups the standalone page reads them in; "overdue" on its own is the flag
     * beside a single reminder on a reservation.
     */
    reminder: {
        reminders: 'Reminders',
        add: 'Add reminder',
        edit: 'Edit reminder',
        delete: 'Delete reminder',
        empty: 'No reminders on this reservation.',
        open_empty: 'No open reminders.',
        group_empty: 'Nothing in this group.',
        text: 'Reminder',
        text_placeholder: 'Call the guest about the late arrival',
        due: 'Due',
        due_time: 'Time',
        time_optional: 'optional',
        mark_done: 'Mark as done',
        reopen: 'Reopen',
        confirm_delete: 'Delete this reminder? One that was acted on is better marked done — those are kept.',
        saved: 'Reminder saved',
        done_at: 'Done {when}',
        overdue_one: 'overdue',
        overdue: 'Overdue',
        today: 'Today',
        upcoming: 'Upcoming',
        all: 'All',
        refresh: 'Refresh',
        unknown_reservation: 'Unknown reservation',
    },

    /*
     * Transfers — the rides a hotel arranges for a guest.
     *
     * "Recorded" is the word to read twice: it means the hotel has NO provider
     * connected, the ride is written down, and nothing was sent to anybody. That is the
     * ordinary state of an ordinary hotel and not a fault — the only thing that would be
     * wrong is a receptionist believing a car has been ordered.
     */
    transfer: {
        title: 'Transfers',
        hint: 'Guest transfers: the airport pickup, the run to the station, the taxi at the door.',
        add: 'New transfer',
        arrange: 'Arrange transfer',
        record: 'Record',
        send: 'Send to provider',
        cancel: 'Cancel transfer',
        confirm_cancel: 'Cancel this transfer? This withdraws our record only — the provider has to be told separately.',
        cancelled_notice: 'The transfer is withdrawn in our records. Tell the provider yourself.',
        optional: 'optional',

        when: 'When',
        route: 'Route',
        contact: 'Contact',
        day: 'Date',
        time: 'Time',
        passengers: 'Passengers',
        pickup_place: 'Pickup',
        dropoff_place: 'Drop-off',
        place_hint: 'Write it plainly: "Terminal 2, arrivals", "the hotel", "the railway station".',
        flight_number: 'Flight or train',
        contact_name: 'Contact name',
        contact_phone: 'Contact phone',
        notes: 'Notes',
        needs_time: 'Enter the date and the time of the transfer.',

        kind: 'Kind',
        kind_all: 'All kinds',
        kind_airport: 'Airport',
        kind_station: 'Station',
        kind_taxi: 'Taxi',
        kind_other: 'Other',

        status_all: 'All statuses',
        status_recorded: 'Recorded',
        origin_guest: 'Asked for by the guest through Milo — confirm the time and the price',
        status_requested: 'Sent',
        status_confirmed: 'Confirmed',
        status_failed: 'Failed',
        status_cancelled: 'Cancelled',

        internal_only_title: 'Transfers are not sent anywhere',
        internal_only_hint: 'This hotel has no transfer provider connected. A transfer is only written down — the car still has to be ordered by telephone.',
        internal_only_hint_manager: 'This hotel has no transfer provider connected, or it is switched off. Transfers are only written down. Set the connection up under "Provider".',

        recorded_only: 'The transfer is recorded. It was not sent to anybody.',
        sent: 'The transfer was sent to the provider.',
        sent_with_reference: 'The transfer is confirmed, reference {reference}.',
        dispatch_failed: 'The transfer is recorded, but the provider did not accept it: {reason}',

        provider_button: 'Provider',
        provider_title: 'Transfer provider connection',
        provider_hint: 'Where this hotel sends its transfers. The key is stored sealed and is never shown back.',
        provider_kind: 'Kind of connection',
        provider_webhook: 'Generic outbound webhook (HTTP POST)',
        provider_active: 'The connection is switched on',
        provider_active_hint: 'A connection that is switched off means transfers are only written down.',
        base_url: 'Address (URL)',
        base_url_hint: 'The address your provider gave you. A transfer is POSTed to it with the JSON body below.',
        base_url_invalid: 'Enter a valid address starting with http:// or https://',
        api_key: 'Key',
        api_key_hint: 'If the endpoint needs one. It is sent in an Authorization: Bearer header.',
        api_key_set: 'A key is stored. Leave empty to keep it.',
        envelope: 'What the other end receives',
    },

    /* Mobile materials management (docs/MATERIALNO-MOBILNO.md, WP-M7). */
    mobile_stock: {
        title: 'Mobile store',
        lead: 'Three things you do standing beside the goods: receiving, stocktaking and issuing.',
        nothing_allowed: 'You have no rights for these flows. Ask the store manager.',
        back_to_hub: 'Back to the menu',

        receive: 'Receiving',
        receive_lead: 'Goods from a supplier, scanned, with tolerances.',
        count: 'Stocktake',
        count_lead: 'Count the shelves you were given.',
        issue: 'Issue',
        issue_lead: 'Goods leaving the store for a department or for use.',

        supplier: 'Supplier',
        supplier_help: 'Who the goods came from. Choosing one opens their open orders.',
        to_place: 'Receiving place',
        to_place_help: 'Where the goods physically go. The house default is offered first.',
        open_orders: 'Open orders',
        no_open_orders: 'This supplier has no open orders.',
        order_lines: '{count} lines',
        without_order: 'Receive without an order',

        scan_to_start: 'Scan the first code — the line adds itself.',
        start_scanning: 'Start scanning',
        edit_quantity: 'Edit quantity',
        received_of_ordered: 'Received {received} of {ordered} {unit}',
        not_ordered: 'not on the order',
        ordered_n: 'Ordered: {count} {unit}',
        nothing_counted: 'No line has a quantity.',

        unit_cost: 'Unit price (€)',
        unit_cost_help: 'Net purchase price without VAT. Filled in from the order where there is one.',
        lot: 'Lot',
        lot_help: 'The batch mark on the packaging. Required for tracked articles.',
        lot_required: 'Article “{item}” requires a lot.',
        expires_on: 'Expiry',
        expires_on_help: 'The date on the packaging. Leave empty where the goods have none.',

        delivery_note_only: 'Booked on the delivery note; the supplier invoice is entered later under Supplier invoices.',
        post_refused: 'Document {number} could not be posted.',

        finish_receipt: 'Finish receiving',
        receipt_posted: 'Receipt {number} is posted.',
        receipt_posted_help: 'The goods are on the shelf. Anything quarantined is named below.',
        receive_again: 'New receipt',

        from_place: 'From place',
        from_place_help: 'The shelf the goods leave.',
        reason: 'Reason',
        reason_help: 'Why the goods are leaving. It is written on the document.',
        reason_department: 'Department',
        reason_consumption: 'Consumption',
        cost_centre: 'Cost centre',
        cost_centre_help: 'Where the cost lands in the books. The telephone remembers the last one, because the same kitchen is stocked twenty times a morning.',
        no_cost_centre: 'No cost centre',
        issue_note: 'Note',
        issue_note_help: 'Whatever will say in a month why this issue was different. The department and the reason are fields now and need not be typed here.',
        on_hand: 'on hand: {quantity}',
        balances_failed: 'The stock on hand could not be read.',
        balances_failed_help: 'Without it we do not know what the room holds, so nothing can be issued. Try again.',
        balances_retry: 'Try again',

        /* The codebooks — the rooms, the suppliers, the article register — could not be
           read. Said before anything else, because every step stands on one of those
           three lists: an empty register would let the scanner start and answer
           "unknown barcode" for every carton in the yard. */
        codebooks_failed: 'The codebooks could not be read.',
        post_issue: 'Post the issue',
        issue_posted: 'Issue {number} is posted.',
        issue_posted_help: 'The stock in that place has gone down.',
        issue_again: 'New issue',

        backspace: 'Delete the last digit',
    },

    /* Stocktakes — the telephone in the store and the supervisor's screen. */
    counts: {
        title: 'Stocktakes',
        lead: 'Counting the stock: who counts what, the comparison with the book, and posting the differences.',
        empty: 'No stocktakes.',
        add: 'New stocktake',
        edit: 'Edit stocktake',
        open_desk: 'Open the stocktake desk',

        filter_status: 'Status',
        filter_status_help: 'All are shown by default. For a round in progress choose “Counting”.',
        filter_all: 'All',

        status_draft: 'Draft',
        status_counting: 'Counting',
        status_review: 'In review',
        status_posted: 'Posted',
        status_cancelled: 'Cancelled',

        name: 'Name',
        name_help: 'What the round is called in the list — “Kitchen, September”.',
        places: 'Places',
        places_help: 'Which shelves the round covers. They are fixed once it starts.',
        places_n: '{count} places',
        category: 'Category',
        category_help: 'A round may cover one category of article only. Empty covers everything.',
        every_category: 'Every category',
        blind: 'Blind count',
        blind_help: 'The counter is not shown the book figure. The shelf is counted, not confirmed.',
        blind_short: 'Blind',

        counters: 'Counters',
        counters_help: 'Who counts and which places. A place with no counter stays uncounted.',
        counters_n: '{count} counters',
        counter: 'Person',
        counter_places: 'Their places',
        counter_places_help: 'Only places this round covers.',
        add_counter: 'Add a counter',
        no_counters: 'Nobody is assigned yet.',

        start: 'Start counting',
        started: 'Counting has started. The book is frozen.',
        to_review: 'Send to review',
        in_review: 'The round is in review.',
        post: 'Post the differences',
        posted: 'The differences are posted.',
        cancel: 'Cancel the round',
        cancelled: 'The round is cancelled.',
        cancelled_by_desk: 'Cancelled at the desk.',
        confirm_post: 'Posted differences move stock and cannot be undone — only corrected with a new document. Continue?',
        confirm_cancel: 'A cancelled round cannot be resumed. Continue?',
        snapshot_at: 'Book frozen {at}',
        posted_documents: '{count} inventory documents were created.',
        movements_after_review_title: 'Stock moved on {count} rows after the review',
        movements_after_review_lead: 'Goods reached or left the counted rooms between the review and the posting. '
            + 'The posting accounted for them: what was booked is the difference against the frozen book, '
            + 'exactly as the review showed it — but the movement column on the rows above was already out of '
            + 'date when it was signed.',

        article: 'Article',
        place: 'Place',
        expected: 'Book',
        counted: 'Counted',
        second: 'Second count',
        diff: 'Difference',
        value: 'Value',
        moved_since_snapshot: 'Goods moved after the freeze — part of the difference is a real movement.',
        save_second: 'Save',
        second_saved: 'The second count is saved.',
        second_needed_title: 'Waiting for a second count: {count} rows',
        second_needed_lead: 'The round cannot be posted until these rows have been counted twice.',

        /* The rooms, the categories and the counters the new-round dialog is filled in
           with. Its own sentence rather than the house one, because it says WHAT is
           missing: the list of rounds below it may be perfectly fine. */
        reference_failed: 'The codebooks for a new round could not be read.',

        mine_lead: 'Rounds you are named as a counter of.',
        none_counting: 'No round is being counted right now.',
        no_places_for_me: 'You have no place assigned in this round.',
        counted_of: 'Counted {counted} of {total}',
        not_counted: 'not counted yet',
        expected_n: 'book {quantity} {unit}',
        item_added: '“{item}” was not on the list — it has been added.',
        entry_refused: 'The count could not be recorded.',
        queue_pending: 'sending: {count}',
        queue_offline: 'waiting for a connection: {count}',
        offline_title: 'No connection',
        offline_lead: 'The counted quantities are waiting and will be sent when the connection returns. They are kept '
            + 'on this device, so they survive a reload.',
        retry_now: 'Try now',
        submit: 'Submit the count',
        submitted: 'The count for this place is submitted.',
        still_sending: '{count} quantities have not been sent yet. Wait a moment.',
        confirm_incomplete: '{count} articles in this place have not been counted. Finish anyway?',
        leave_pending: '{count} entries have not been sent — stay and wait?',

        /* Entries left on the device (docs/MATERIALNO-MOBILNO.md §5.2). The title names
           the round, because every entry goes to its OWN round and not to the open one. */
        held_title: 'Unsent entries ({count}) — round {session}',
        held_lead: 'Quantities that never reached the service. They will be sent to their own round.',
        held_other: 'Another counter typed these on this device. Only they can send them; here they can only be discarded.',
        held_send: 'Send',
        held_discard: 'Discard',
        held_confirm_discard: 'Discard {count} unsent entries for round {session}? The counted quantities cannot be recovered.',
        refused_title: 'Refused entries: {count}',
        refused_discard: 'Discard',
        /* An entry the scale guard refused: the quantity stays in the queue, and cannot
           be sent until somebody types it again at the article's new scale. */
        refused_reenter: 'enter again',
    },

    /* Reading barcodes (docs/MATERIALNO-MOBILNO.md §3). */
    scanner: {
        mode_camera: 'Camera',
        mode_keyboard: 'Scanner',
        mode_manual: 'By hand',
        camera_hint: 'Hold the code inside the frame. It is read on its own.',
        camera_denied: 'Camera access was refused',
        camera_denied_help: 'Allow the camera for this page in the browser settings, or use a hand scanner or type the code.',
        camera_unsupported: 'This browser cannot read codes',
        camera_unsupported_help: 'The camera works in Chrome and on Android devices. Elsewhere use a hand scanner or type the code.',
        camera_failed: 'The camera could not be opened',
        camera_failed_help: 'The device may have no camera, or another application is using it. Use a hand scanner or type the code.',
        keyboard_hint: 'Scan with the gun — the code is read even when no field is focused.',
        manual_placeholder: 'Type the code',
        manual_submit: 'Confirm the code',
        unknown_code: 'Unknown code',
        find_item: 'Find an article',
        pick_item: 'Article',
        pick_item_help: 'Choose what you are holding. The code can be attached to it.',
        attach_code: 'Attach this code to the article',
        attach_code_help: 'From now on this code always means this article. Attach it only when you are sure.',
        code_attached: 'The code is attached.',
        use_item: 'Use this article',
    },
}
